import type React from 'react';
import { cn } from '../lib/utils';

interface IconWrapperProps extends React.HTMLAttributes<HTMLSpanElement> {}
function IconWrapper({ children, className, ...props }: IconWrapperProps) {
  return (
    <span className={cn('flex items-center justify-center', className)} {...props}>
      {children}
    </span>
  );
}

type IconProps = IconWrapperProps;

export function BangStroke(props: IconProps) {
  return (
    <IconWrapper {...props}>
      <svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' viewBox='0 0 10 10'>
        <defs>
          <clipPath id='yzdmtqyvla'>
            <path data-name='' d='M0 0h10v10H0z' />
          </clipPath>
        </defs>
        <g data-name=''>
          <g data-name=''>
            <path
              fill='currentColor'
              data-name=''
              d='M5 0a5.015 5.015 0 0 0-5 4.966 4.927 4.927 0 0 0 1.445 3.545A4.944 4.944 0 0 0 4.967 10H5A5 5 0 1 0 5 0m0 9.322h-.033a4.345 4.345 0 0 1-3.056-1.289A4.272 4.272 0 0 1 .678 4.978 4.328 4.328 0 1 1 5 9.322'
            />
            <path
              fill='currentColor'
              data-name=''
              d='M5 6.111a.375.375 0 0 0 .378-.378V2.622a.378.378 0 1 0-.756 0v3.111A.375.375 0 0 0 5 6.111'
            />
            <path
              fill='currentColor'
              data-name=''
              d='M5 6.844a.516.516 0 0 0-.511.511v.022a.511.511 0 0 0 1.022 0v-.022A.516.516 0 0 0 5 6.844'
            />
          </g>
        </g>
      </svg>
    </IconWrapper>
  );
}

export function JpVolume(props: IconProps) {
  return (
    <IconWrapper {...props}>
      <svg xmlns='http://www.w3.org/2000/svg' width='16' height='17' viewBox='0 0 16 17' fill='none'>
        <path
          d='M8.29981 3.05658C8.18615 3.00823 8.06148 2.99039 7.93852 3.0049C7.81556 3.01941 7.69872 3.06575 7.59992 3.13917L4.25447 5.7408H1.69989C1.51426 5.7408 1.33625 5.81331 1.20499 5.94238C1.07374 6.07146 1 6.24652 1 6.42906V10.5586C1 10.7412 1.07374 10.9162 1.20499 11.0453C1.33625 11.1744 1.51426 11.2469 1.69989 11.2469H4.25447L7.56493 13.8485C7.68806 13.9457 7.84099 13.999 7.99886 13.9999C8.1034 14.0016 8.20676 13.978 8.29981 13.9311C8.41891 13.8753 8.51955 13.7876 8.59014 13.678C8.66072 13.5684 8.69837 13.4414 8.69874 13.3117V3.67602C8.69837 3.54629 8.66072 3.41931 8.59014 3.30971C8.51955 3.20011 8.41891 3.11236 8.29981 3.05658ZM7.29897 11.8801L4.93336 10.0218C4.81022 9.92462 4.6573 9.87126 4.49943 9.87036H2.39977V7.11731H4.49943C4.6573 7.11641 4.81022 7.06305 4.93336 6.9659L7.29897 5.1076V11.8801ZM13.36 4.59828C13.2282 4.46868 13.0494 4.39587 12.8631 4.39587C12.6767 4.39587 12.4979 4.46868 12.3661 4.59828C12.2344 4.72789 12.1603 4.90366 12.1603 5.08695C12.1603 5.27023 12.2344 5.44601 12.3661 5.57561C12.7783 5.98027 13.1003 6.4648 13.3118 6.99842C13.5232 7.53204 13.6195 8.10309 13.5945 8.67527C13.5695 9.24745 13.4237 9.80827 13.1665 10.3221C12.9092 10.8359 12.5461 11.2914 12.1002 11.6598C11.9919 11.7509 11.9144 11.8723 11.8782 12.0078C11.8419 12.1433 11.8486 12.2865 11.8973 12.4181C11.946 12.5498 12.0344 12.6638 12.1507 12.7447C12.267 12.8257 12.4056 12.8698 12.5481 12.8712C12.7116 12.8715 12.8701 12.8155 12.996 12.7129C13.5916 12.2223 14.0768 11.6153 14.4209 10.9304C14.765 10.2454 14.9603 9.49757 14.9946 8.73436C15.0288 7.97115 14.9011 7.20929 14.6197 6.49722C14.3383 5.78516 13.9093 5.13847 13.36 4.59828ZM11.3793 6.54606C11.314 6.48189 11.2366 6.43098 11.1513 6.39625C11.0661 6.36152 10.9747 6.34365 10.8824 6.34365C10.7901 6.34365 10.6987 6.36152 10.6135 6.39625C10.5282 6.43098 10.4507 6.48189 10.3855 6.54606C10.3202 6.61023 10.2684 6.68641 10.2331 6.77026C10.1978 6.85411 10.1796 6.94397 10.1796 7.03472C10.1796 7.12548 10.1978 7.21534 10.2331 7.29919C10.2684 7.38303 10.3202 7.45922 10.3855 7.52339C10.6483 7.78035 10.7968 8.12935 10.7984 8.49383C10.7986 8.69436 10.7542 8.8925 10.6683 9.07439C10.5825 9.25628 10.4573 9.41754 10.3015 9.54687C10.2306 9.60465 10.172 9.67561 10.1291 9.75569C10.0861 9.83577 10.0597 9.92339 10.0512 10.0135C10.0428 10.1037 10.0525 10.1946 10.0798 10.281C10.1072 10.3675 10.1516 10.4478 10.2105 10.5173C10.2697 10.5865 10.3423 10.6435 10.424 10.6851C10.5056 10.7267 10.5949 10.7521 10.6865 10.7598C10.7782 10.7674 10.8704 10.7573 10.9581 10.7298C11.0458 10.7024 11.127 10.6583 11.1973 10.5999C11.5103 10.3419 11.762 10.0197 11.9349 9.65585C12.1078 9.29203 12.1976 8.89542 12.1982 8.49383C12.1942 7.76435 11.9003 7.06532 11.3793 6.54606Z'
          fill='#999999'
        />
      </svg>
    </IconWrapper>
  );
}

export function JpLang(props: IconProps) {
  return (
    <IconWrapper {...props}>
      <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none'>
        <path
          d='M9.75 3C10.13 3 10.45 3.28 10.5 3.66V7.5H14.25C14.63 7.5 14.95 7.78 15 8.16V14.25C15 14.63 14.72 14.95 14.34 15H8.25C7.87 15 7.55 14.72 7.5 14.34V10.5H3.75C3.37 10.5 3.05 10.22 3 9.84V3.75C3 3.37 3.28 3.05 3.66 3H9.75ZM11.05 8.25L10 8.62L10.18 8.78L10.28 8.88C10.37 8.98 10.45 9.07 10.5 9.15L10.56 9.23L10.6 9.28L10.63 9.34H8.49V10.31H9.39L9.52 10.71L9.6 10.9L9.68 11.12C9.88 11.61 10.17 12.05 10.52 12.45C10.15 12.69 9.68 12.91 9.12 13.1L8.87 13.18L8.61 13.26L8.28 13.36L8.82 14.22L9.12 14.12L9.42 14.03C10.17 13.77 10.79 13.46 11.28 13.12C11.71 13.42 12.24 13.7 12.87 13.93L13.15 14.03L13.43 14.12L13.74 14.22L14.28 13.36L13.94 13.26L13.75 13.2L13.5 13.12C12.99 12.95 12.5 12.73 12.05 12.45C12.38 12.07 12.65 11.64 12.85 11.18L12.95 10.95L13.03 10.7L13.16 10.31H14.06V9.34H11.77L11.69 9.17C11.59 8.92 11.45 8.69 11.28 8.48L11.19 8.37L11.09 8.26L11.05 8.25ZM12.06 10.32L12.03 10.42L11.97 10.58L11.89 10.78C11.73 11.16 11.52 11.51 11.25 11.81C11.03 11.55 10.84 11.27 10.7 10.96L10.61 10.77L10.53 10.57L10.47 10.41L10.44 10.31H12.06V10.32ZM9.75 3.75H3.75V9.75H7.5V8.12H5.87L5.57 9H4.5L6.2 4.5H7.31L8.43 7.5H9.75V3.75ZM6.75 5.56L6.19 7.2H7.31L6.75 5.56Z'
          fill='black'
        />
      </svg>
    </IconWrapper>
  );
}

export function MissionNoti(props: IconProps) {
  return (
    <IconWrapper {...props}>
      <svg width='1em' height='1.1em' viewBox='0 0 10 11' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g id='&#234;&#183;&#184;&#235;&#163;&#185; 1802'>
          <g id='Clip path group'>
            <mask
              id='mask0_8349_44170'
              style={{ maskType: 'luminance' }}
              maskUnits='userSpaceOnUse'
              x='0'
              y='0'
              width='1em'
              height='1.1em'
            >
              <g id='clip-path'>
                <path
                  id='&#236;&#130;&#172;&#234;&#176;&#129;&#237;&#152;&#149; 749'
                  d='M10 0.5H0V10.5H10V0.5Z'
                  fill='white'
                />
              </g>
            </mask>
            <g mask='url(#mask0_8349_44170)'>
              <g id='&#234;&#183;&#184;&#235;&#163;&#185; 1801'>
                <path
                  id='&#237;&#140;&#168;&#236;&#138;&#164; 1288'
                  d='M4.99998 0.5C3.68097 0.503882 2.41659 1.02726 1.48072 1.95676C0.544859 2.88626 0.012867 4.14704 -1.50627e-05 5.466C-0.00786406 6.12342 0.115942 6.77575 0.36411 7.38458C0.612278 7.99341 0.979787 8.54641 1.44499 9.011C1.90378 9.48061 2.4515 9.85413 3.0562 10.1098C3.6609 10.3654 4.31047 10.4981 4.96698 10.5H4.99998C6.32607 10.5 7.59784 9.97322 8.53552 9.03553C9.4732 8.09785 9.99998 6.82608 9.99998 5.5C9.99998 4.17392 9.4732 2.90215 8.53552 1.96447C7.59784 1.02678 6.32607 0.5 4.99998 0.5ZM4.99998 9.822H4.96698C3.81795 9.81333 2.71913 9.34985 1.91098 8.533C1.51348 8.13074 1.19981 7.65356 0.98815 7.12914C0.776493 6.60471 0.671066 6.04348 0.677985 5.478C0.681149 4.62244 0.937819 3.787 1.41557 3.07725C1.89332 2.36749 2.57072 1.81525 3.36218 1.49031C4.15364 1.16536 5.02365 1.08228 5.86231 1.25157C6.70096 1.42086 7.47063 1.83491 8.07407 2.44142C8.67752 3.04794 9.08766 3.8197 9.25268 4.6592C9.41771 5.4987 9.33021 6.36829 9.00125 7.15809C8.67229 7.94789 8.11663 8.62247 7.40445 9.09661C6.69228 9.57075 5.85555 9.82318 4.99998 9.822Z'
                  fill='#1A73E8'
                />
                <path
                  id='&#237;&#140;&#168;&#236;&#138;&#164; 1289'
                  d='M4.99996 6.61114C5.04971 6.61154 5.09904 6.60204 5.14509 6.58318C5.19113 6.56433 5.23296 6.5365 5.26814 6.50132C5.30332 6.46614 5.33115 6.42431 5.35 6.37827C5.36886 6.33222 5.37836 6.28289 5.37796 6.23314V3.12214C5.37796 3.0725 5.36818 3.02335 5.34919 2.97749C5.33019 2.93163 5.30235 2.88995 5.26725 2.85485C5.23215 2.81975 5.19048 2.79191 5.14461 2.77291C5.09875 2.75392 5.0496 2.74414 4.99996 2.74414C4.95032 2.74414 4.90117 2.75392 4.85531 2.77291C4.80944 2.79191 4.76777 2.81975 4.73267 2.85485C4.69757 2.88995 4.66973 2.93163 4.65073 2.97749C4.63174 3.02335 4.62196 3.0725 4.62196 3.12214V6.23314C4.62156 6.28289 4.63106 6.33222 4.64992 6.37827C4.66877 6.42431 4.6966 6.46614 4.73178 6.50132C4.76696 6.5365 4.80879 6.56433 4.85483 6.58318C4.90088 6.60204 4.95021 6.61154 4.99996 6.61114Z'
                  fill='#1A73E8'
                />
                <path
                  id='&#237;&#140;&#168;&#236;&#138;&#164; 1290'
                  d='M5.00001 7.34424C4.86489 7.34554 4.73567 7.3998 4.64012 7.49535C4.54457 7.5909 4.49032 7.72012 4.48901 7.85524V7.87724C4.48901 8.01276 4.54285 8.14274 4.63868 8.23857C4.73451 8.3344 4.86449 8.38824 5.00001 8.38824C5.13554 8.38824 5.26551 8.3344 5.36135 8.23857C5.45718 8.14274 5.51101 8.01276 5.51101 7.87724V7.85524C5.50971 7.72012 5.45545 7.5909 5.3599 7.49535C5.26435 7.3998 5.13514 7.34554 5.00001 7.34424Z'
                  fill='#1A73E8'
                />
              </g>
            </g>
          </g>
        </g>
      </svg>
    </IconWrapper>
  );
}

export function IcoStreamCopy(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ ...style, color: 'var(--baseFg)' }} {...rest}>
      <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 40 40'>
        <g>
          <rect width='40' height='40' fill='none' opacity='0.2' />
          <rect x='2' y='2' width='36' height='36' fill='none' opacity='0.2' />
          <rect
            x='13.67'
            y='13.7'
            width='20.83'
            height='20.8'
            rx='2'
            ry='2'
            fill='none'
            stroke='currentColor'
            strokeWidth='3'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M9.02,26.3h-1.76c-.97,0-1.76-.9-1.76-2V7.5c0-1.1,.9-2,2-2H24.33c1.1,0,2,.73,2,1.62v1.62'
            fill='none'
            stroke='currentColor'
            strokeWidth='3'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
      </svg>
    </IconWrapper>
  );
}

export function IcoAdult(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ color: 'var(--colorIco01)', fontSize: 28, ...style }} {...rest}>
      <svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' viewBox='0 0 28 28' fill='none'>
        <path
          d='M14 0C6.26802 0 0 6.26799 0 14C0 21.732 6.26802 28 14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0ZM14 25.4545C7.67383 25.4545 2.54546 20.3261 2.54546 14C2.54546 7.67386 7.67383 2.54544 14 2.54544C20.3262 2.54544 25.4545 7.67382 25.4545 14C25.4545 20.3262 20.3262 25.4545 14 25.4545Z'
          fill='currentColor'
        />
        <path
          d='M8.24731 8.02856C7.56273 8.02856 7.00586 8.58543 7.00586 9.26999C7.00586 9.95484 7.56273 10.5117 8.24731 10.5117C8.57374 10.5117 8.57935 10.5869 8.58243 10.6215V18.7299C8.58243 19.4145 9.1393 19.9714 9.82388 19.9714C10.5087 19.9714 11.0656 19.4145 11.0656 18.7299V10.6215C11.0656 9.57904 10.3151 8.02856 8.24731 8.02856Z'
          fill='currentColor'
        />
        <path
          d='M16.5983 8.02857C14.1746 8.02857 12.2031 10 12.2031 12.4234C12.2031 14.5591 13.735 16.342 15.7576 16.7356L14.8179 17.9828C14.6184 18.2478 14.5339 18.5745 14.5802 18.9031C14.6265 19.2315 14.7977 19.5223 15.0627 19.7219C15.2796 19.8852 15.5376 19.9714 15.809 19.9714C16.2031 19.9714 16.5649 19.7915 16.8018 19.4774L20.0655 15.1449C20.1052 15.0922 20.1368 15.0354 20.1672 14.9783C20.6848 14.2574 20.9932 13.3766 20.9932 12.4234C20.9932 10 19.0217 8.02857 16.5983 8.02857ZM16.5983 14.3351C15.544 14.3351 14.6863 13.4774 14.6863 12.4234C14.6863 11.3695 15.544 10.5117 16.5983 10.5117C17.6522 10.5117 18.51 11.3694 18.51 12.4234C18.51 13.4774 17.6522 14.3351 16.5983 14.3351Z'
          fill='currentColor'
        />
      </svg>
    </IconWrapper>
  );
}

export function IconSupportNotice(props: IconProps) {
  return (
    <IconWrapper {...props}>
      <svg xmlns='http://www.w3.org/2000/svg' width='24' height='18' viewBox='0 0 24 18' fill='none'>
        <g clipPath='url(#clip0_2135_37223)'>
          <path
            d='M15.66 6.69H15.68V5.93C15.68 2.94 13.37 0.5 10.53 0.5H7.39C4.55 0.5 2.24 2.94 2.24 5.93V6.69C0.97 6.89 0 7.9 0 9.13V10.75C0 12.12 1.21 13.23 2.68 13.23C2.74 13.23 2.81 13.23 2.87 13.21C3.55 14.54 4.74 15.54 6.17 15.91C6.17 15.96 6.15 16.01 6.15 16.07C6.15 16.92 6.81 17.6 7.61 17.6H10.75C11.55 17.6 12.21 16.92 12.21 16.07C12.21 15.22 11.55 14.54 10.75 14.54H7.61C7.39 14.54 7.19 14.59 7 14.69C6.94 14.66 6.89 14.64 6.84 14.63C4.97 14.35 3.56 12.64 3.56 10.64V5.95C3.56 3.73 5.28 1.92 7.38 1.92H10.52C12.62 1.92 14.34 3.72 14.34 5.95V12.53C14.34 12.91 14.64 13.23 15 13.23C15.02 13.23 15.03 13.23 15.05 13.23C15.11 13.23 15.17 13.23 15.22 13.23C16.7 13.23 17.9 12.12 17.9 10.75V9.13C17.9 7.91 16.93 6.89 15.66 6.69Z'
            fill='white'
          />
          <path
            d='M22.8798 7.91016H20.8798C20.2598 7.91016 19.7598 8.44016 19.7598 9.09016C19.7598 9.74016 20.2598 10.2702 20.8798 10.2702H22.8798C23.4998 10.2702 23.9998 9.74016 23.9998 9.09016C23.9998 8.44016 23.4998 7.91016 22.8798 7.91016Z'
            fill='white'
          />
          <path
            d='M22.4806 15.1297C22.8206 14.5797 22.6706 13.8497 22.1606 13.4897L20.4906 12.3397C19.9706 11.9797 19.2806 12.1397 18.9406 12.6797C18.6006 13.2197 18.7506 13.9597 19.2606 14.3197L20.9306 15.4697C21.1206 15.5997 21.3306 15.6597 21.5406 15.6597C21.9106 15.6597 22.2606 15.4697 22.4806 15.1197V15.1297Z'
            fill='white'
          />
          <path
            d='M20.4892 5.86088L22.1592 4.71088C22.6792 4.35088 22.8192 3.62088 22.4792 3.07088C22.1392 2.52088 21.4492 2.37088 20.9292 2.73088L19.2592 3.88088C18.7392 4.24088 18.5992 4.97088 18.9392 5.52088C19.1492 5.87088 19.5092 6.06088 19.8792 6.06088C20.0892 6.06088 20.2992 6.00088 20.4892 5.87088V5.86088Z'
            fill='white'
          />
        </g>
      </svg>
    </IconWrapper>
  );
}

export function Bookmark(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ ...style, color: 'var(--colorIco21)' }} {...rest}>
      <svg xmlns='http://www.w3.org/2000/svg' width='2.8em' height='2.8em' viewBox='0 0 28 28' fill='none'>
        <path
          d='M22.6538 26.6011C22.29 26.6011 21.9106 26.4771 21.5522 26.2319L14.4487 21.3823C14.2349 21.2358 13.7651 21.2358 13.5513 21.3823L6.44775 26.2319C5.84326 26.645 5.18066 26.7143 4.63086 26.4243C4.08106 26.1343 3.76562 25.5474 3.76562 24.8149V3.70947C3.76562 2.43603 4.80176 1.3999 6.07569 1.3999H21.9243C23.1982 1.3999 24.2344 2.43603 24.2344 3.70947V24.8149C24.2344 25.5474 23.9189 26.1343 23.3691 26.4243C23.1455 26.5425 22.9028 26.6011 22.6538 26.6011ZM14 19.1714C14.5835 19.1714 15.167 19.3306 15.6323 19.6479L22.1348 24.0864V3.70947C22.1348 3.59619 22.0381 3.49951 21.9243 3.49951H6.07568C5.96191 3.49951 5.86523 3.59619 5.86523 3.70947V24.0845L12.3677 19.648C12.833 19.3306 13.4165 19.1714 14 19.1714Z'
          fill='currentColor'
        />
      </svg>
    </IconWrapper>
  );
}

export function TinyRedHeart(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ ...style }} {...rest}>
      <svg width='9' height='10' viewBox='0 0 9 10' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_7550_108847)'>
          <path
            d='M4.48642 9.09468C4.41279 9.09468 4.33506 9.07423 4.2696 9.03741L3.93824 8.85332C3.05869 8.3665 2.0605 7.81422 1.11958 6.61967C-0.713157 4.30011 0.199122 2.406 0.317759 2.181C0.403669 2.00509 0.947763 0.974174 2.31005 0.91281C3.30823 0.863719 4.06506 1.506 4.48642 1.98055C4.90779 1.506 5.65234 0.86781 6.6628 0.91281C8.02508 0.970083 8.56918 2.00509 8.65509 2.17691C8.77373 2.40191 9.686 4.29602 7.85736 6.61558C6.91644 7.81013 5.91825 8.36241 5.0387 8.84923L4.70733 9.03332C4.64188 9.07014 4.56415 9.09059 4.49052 9.09059L4.48642 9.09468ZM2.40414 1.79236C2.40414 1.79236 2.36732 1.79236 2.34686 1.79236C1.45504 1.82918 1.12776 2.52464 1.11549 2.55328C1.1114 2.56555 1.10322 2.58191 1.09504 2.59419C1.06231 2.65146 0.280941 4.13647 1.81095 6.07557C2.64141 7.13104 3.51687 7.61377 4.36779 8.08422L4.49052 8.15377L4.61324 8.08422C5.46007 7.61377 6.33553 7.13104 7.17008 6.07557C8.70009 4.13238 7.91872 2.65146 7.8819 2.59009C7.87372 2.57782 7.86554 2.56146 7.86145 2.54919C7.84917 2.52464 7.5219 1.82918 6.63007 1.78827C5.59098 1.75554 4.87506 2.91737 4.86688 2.92964C4.78506 3.06055 4.64597 3.14237 4.49052 3.14237C4.33506 3.14237 4.19188 3.06055 4.11415 2.92964C4.10597 2.91737 3.40642 1.78827 2.41232 1.78827L2.40414 1.79236Z'
            fill='#FF6B5E'
          />
        </g>
        <defs>
          <clipPath id='clip0_7550_108847'>
            <rect width='9' height='8.18187' fill='white' transform='translate(0 0.910156)' />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  );
}

export function IcoNoticeP(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ fontSize: 22, ...style }} {...rest}>
      <svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1.27em' viewBox='0 0 22 28' fill='none'>
        <path
          d='M21.3337 2.95556C21.3337 1.32222 20.0145 0 18.4022 0C17.245 0 16.2499 0.676667 15.7716 1.65667C14.329 0.948889 12.7167 0.552222 11.0041 0.552222C9.29148 0.552222 7.67916 0.948889 6.23657 1.65667C5.75828 0.676667 4.76312 0 3.60596 0C1.98593 0 0.67448 1.33 0.67448 2.95556C0.67448 3.97444 1.18363 4.87667 1.96279 5.40556C0.790196 7.15556 0.111328 9.26333 0.111328 11.5344V23.9167C0.126757 26.18 1.94736 28.0078 4.19225 28.0078C6.43714 28.0078 8.25774 26.18 8.27317 23.9167V22.1667C9.1449 22.3922 10.0552 22.5167 10.9964 22.5167C17.0136 22.5167 21.8891 17.6011 21.8891 11.5344C21.8891 9.26333 21.2102 7.15556 20.0376 5.40556C20.8168 4.87667 21.326 3.97444 21.326 2.95556H21.3337ZM11.0041 14.2722C9.49976 14.2722 8.28089 13.0433 8.28089 11.5267C8.28089 10.01 9.49976 8.78111 11.0041 8.78111C12.5084 8.78111 13.7273 10.01 13.7273 11.5267C13.7273 13.0433 12.5084 14.2722 11.0041 14.2722Z'
          fill='#152348'
        />
      </svg>
    </IconWrapper>
  );
}

export function MissionIconWhite(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ fontSize: 28, ...style }} {...rest}>
      <svg width='1em' height='1em' viewBox='0 0 28 28' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_7055_10340)'>
          <mask
            id='mask0_7055_10340'
            style={{ maskType: 'luminance' }}
            maskUnits='userSpaceOnUse'
            x='0'
            y='0'
            width='1em'
            height='1em'
          >
            <path d='M28 0H0V28H28V0Z' fill='white' />
          </mask>
          <g mask='url(#mask0_7055_10340)'>
            <path
              d='M27.1719 6.65209C27.3063 6.51814 27.4043 6.35205 27.4566 6.16958C27.5088 5.98712 27.5136 5.79433 27.4704 5.60952C27.4272 5.4247 27.3375 5.25397 27.2099 5.11354C27.0822 4.97311 26.9208 4.86762 26.7409 4.8071L24.0909 3.90709L23.1909 1.2561C23.13 1.0762 23.0243 0.914798 22.8837 0.78717C22.7431 0.659543 22.5722 0.569911 22.3873 0.526756C22.2023 0.483601 22.0095 0.488352 21.8269 0.540559C21.6443 0.592765 21.478 0.6907 21.3439 0.825095L19.9769 2.2001C17.1376 0.74489 13.8722 0.351125 10.7684 1.0897C7.66461 1.82827 4.92648 3.65066 3.04701 6.22873C1.16753 8.8068 0.270198 11.9712 0.516572 15.1521C0.762946 18.333 2.13684 21.3214 4.39088 23.5794C6.64492 25.8373 9.63101 27.2163 12.8115 27.4681C15.992 27.72 19.1579 26.8281 21.7392 24.953C24.3205 23.078 26.1476 20.343 26.8915 17.2405C27.6354 14.138 27.2472 10.8718 25.7969 8.03009L27.1719 6.65209ZM21.6579 3.6751L22.1579 5.14809C22.1655 5.16721 22.1742 5.18591 22.1839 5.20409C22.1989 5.24342 22.2163 5.28182 22.2359 5.31909C22.2529 5.34809 22.2719 5.3781 22.2899 5.4051C22.3079 5.4321 22.3329 5.46809 22.3549 5.49509C22.3769 5.52209 22.4049 5.5501 22.4309 5.5771C22.4569 5.60409 22.4789 5.62509 22.5059 5.64709C22.5377 5.6722 22.5711 5.69525 22.6059 5.71609C22.6319 5.7331 22.6579 5.75009 22.6869 5.7681C22.7254 5.78857 22.7651 5.80661 22.8059 5.82209C22.8238 5.83139 22.8421 5.83973 22.8609 5.8471L24.3329 6.3471L22.5629 8.11809L20.3009 7.70909L19.8939 5.44609L21.6579 3.6751ZM18.4229 14.1191C18.4246 15.1253 18.0932 16.1037 17.4803 16.9016C16.8675 17.6996 16.0076 18.2722 15.0351 18.53C14.0625 18.7878 13.032 18.7164 12.1043 18.3268C11.1766 17.9373 10.404 17.2515 9.90711 16.3766C9.41021 15.5017 9.21697 14.4869 9.35756 13.4906C9.49815 12.4943 9.96466 11.5726 10.6843 10.8694C11.4038 10.1662 12.336 9.72098 13.3353 9.60334C14.3345 9.48569 15.3446 9.70221 16.2079 10.2191L13.1299 13.3001C13.0263 13.4036 12.9442 13.5266 12.8881 13.6619C12.8321 13.7972 12.8033 13.9422 12.8033 14.0886C12.8033 14.235 12.8321 14.38 12.8881 14.5153C12.9442 14.6506 13.0263 14.7735 13.1299 14.8771C13.2334 14.9806 13.3563 15.0628 13.4916 15.1188C13.6269 15.1749 13.7719 15.2037 13.9184 15.2037C14.0648 15.2037 14.2098 15.1749 14.3451 15.1188C14.4804 15.0628 14.6033 14.9806 14.7069 14.8771L17.7839 11.8001C18.2023 12.5023 18.4231 13.3046 18.4229 14.1221M21.7639 22.0101C20.3303 23.4432 18.5333 24.4586 16.566 24.9471C14.5988 25.4357 12.5355 25.379 10.5981 24.7831C8.6606 24.1872 6.92213 23.0746 5.56946 21.5649C4.21678 20.0552 3.30104 18.2055 2.92062 16.2144C2.54021 14.2234 2.7095 12.1664 3.41032 10.2643C4.11113 8.3623 5.31698 6.68717 6.89827 5.41895C8.47957 4.15073 10.3766 3.33735 12.3854 3.06623C14.3942 2.7951 16.4389 3.07647 18.2999 3.8801L17.8999 4.2801C17.7728 4.40762 17.6783 4.56393 17.6245 4.73575C17.5707 4.90758 17.5592 5.08986 17.5909 5.2671L18.1349 8.29209L17.8169 8.6101C16.4321 7.62041 14.7258 7.18752 13.0367 7.39733C11.3476 7.60715 9.79914 8.44433 8.69858 9.74273C7.59802 11.0411 7.02582 12.7059 7.09556 14.4065C7.1653 16.1072 7.87187 17.7194 9.07504 18.9234C10.2782 20.1273 11.89 20.8349 13.5907 20.9057C15.2913 20.9765 16.9564 20.4054 18.2555 19.3057C19.5546 18.2059 20.3927 16.658 20.6036 14.969C20.8145 13.28 20.3827 11.5735 19.3939 10.1881L19.7119 9.8691L22.7369 10.4141C22.8029 10.4254 22.8698 10.4311 22.9369 10.4311C23.0835 10.431 23.2286 10.402 23.364 10.3457C23.4994 10.2894 23.6224 10.207 23.7259 10.1031L24.1259 9.7091C25.0108 11.7591 25.2596 14.0277 24.8401 16.2208C24.4206 18.4139 23.352 20.4304 21.7729 22.0091'
              fill='white'
            />
          </g>
        </g>
      </svg>
    </IconWrapper>
  );
}

export function VolumeOn(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ ...style }} {...rest}>
      <svg xmlns='http://www.w3.org/2000/svg' width='19' height='15' viewBox='0 0 19 15' fill='none'>
        <g clipPath='url(#clip0_7886_36859)'>
          <path
            d='M16.4088 12.9616C16.2322 12.9616 16.0561 12.8952 15.9203 12.7617C15.6449 12.4919 15.6409 12.05 15.9107 11.7748C16.8728 10.7936 17.4476 9.19536 17.4476 7.49994C17.4476 5.80424 16.8728 4.20624 15.9107 3.22534C15.6409 2.95016 15.6449 2.50827 15.9198 2.23848C16.1952 1.96841 16.636 1.9721 16.9069 2.24785C18.1377 3.50223 18.8437 5.4166 18.8437 7.49994C18.8437 9.58328 18.1377 11.4976 16.9069 12.7523C16.7706 12.8917 16.5894 12.9616 16.4088 12.9616Z'
            fill='white'
          />
          <path
            d='M14.017 11.3439C13.7915 11.3439 13.57 11.2346 13.4354 11.0324C13.2218 10.7115 13.3087 10.2784 13.6296 10.0649C14.0971 9.75388 14.5997 8.81871 14.5997 7.49986C14.5997 6.18102 14.0971 5.24585 13.6302 4.93516C13.3087 4.72189 13.2218 4.28852 13.4354 3.96761C13.6489 3.64614 14.0829 3.55952 14.4026 3.77308C15.3705 4.41632 15.9958 5.87943 15.9958 7.49986C15.9958 9.1203 15.3705 10.5831 14.4032 11.2269C14.2839 11.3062 14.1499 11.3439 14.017 11.3439Z'
            fill='white'
          />
          <path
            d='M11.4482 1.68405C11.3584 0.520836 10.4741 0 9.63744 0C9.19953 0 8.83204 0.131205 8.72981 0.171528L3.74183 3.80516H2.05949C0.924101 3.80516 0 4.68212 0 5.76014V9.23986C0 10.3179 0.924101 11.1948 2.05949 11.1948H3.74184L8.57192 14.7416L8.72471 14.8265C8.79684 14.8554 9.17909 15 9.63745 15C10.4741 15 11.3584 14.4792 11.4504 13.2623L11.451 7.50014L11.4482 1.68405Z'
            fill='white'
          />
        </g>
      </svg>
    </IconWrapper>
  );
}

export function VolumeOff(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ ...style }} {...rest}>
      <svg xmlns='http://www.w3.org/2000/svg' width='19' height='15' viewBox='0 0 19 15' fill='none'>
        <path
          d='M11.4481 1.68405C11.3584 0.520836 10.4741 0 9.63744 0C9.19953 0 8.83204 0.131205 8.72981 0.171528L3.74183 3.80516H2.05949C0.924101 3.80516 0 4.68212 0 5.76014V9.23986C0 10.3179 0.924101 11.1948 2.05949 11.1948H3.74184L8.57192 14.7416L8.72471 14.8265C8.79684 14.8554 9.17909 15 9.63745 15C10.4741 15 11.3584 14.4792 11.4504 13.2623L11.451 7.50014L11.4481 1.68405Z'
          fill='white'
        />
        <path
          d='M18.1472 9.94513C17.9682 9.94513 17.7899 9.87697 17.6536 9.74066L14.1049 6.19165C13.8322 5.91902 13.8322 5.47713 14.1049 5.2045C14.3786 4.93159 14.8205 4.93272 15.092 5.2045L18.6407 8.75351C18.9134 9.02614 18.9134 9.46803 18.6407 9.74066C18.5044 9.87698 18.3255 9.94513 18.1472 9.94513Z'
          fill='white'
        />
        <path
          d='M14.5984 9.9451C14.4201 9.9451 14.2412 9.87694 14.1049 9.74063C13.8322 9.468 13.8322 9.02611 14.1049 8.75348L17.6536 5.20447C17.9262 4.93184 18.3681 4.93184 18.6407 5.20447C18.9134 5.4771 18.9134 5.91899 18.6407 6.19162L15.092 9.74063C14.9557 9.87694 14.7768 9.9451 14.5984 9.9451Z'
          fill='white'
        />
      </svg>
    </IconWrapper>
  );
}

export function Pause(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ ...style }} {...rest}>
      <svg xmlns='http://www.w3.org/2000/svg' width='14' height='16' viewBox='0 0 14 16' fill='none'>
        <g clipPath='url(#clip0_7886_7249)'>
          <path
            d='M2.62005 0H2.02063C0.904667 0 0 0.904667 0 2.02063V13.9794C0 15.0953 0.904667 16 2.02063 16H2.62005C3.73601 16 4.64068 15.0953 4.64068 13.9794V2.02063C4.64068 0.904667 3.73601 0 2.62005 0Z'
            fill='white'
          />
          <path
            d='M11.9794 0H11.38C10.264 0 9.35938 0.904667 9.35938 2.02063V13.9794C9.35938 15.0953 10.264 16 11.38 16H11.9794C13.0954 16 14.0001 15.0953 14.0001 13.9794V2.02063C14.0001 0.904667 13.0954 0 11.9794 0Z'
            fill='white'
          />
        </g>
      </svg>
    </IconWrapper>
  );
}

export function IcoPlayerPlay(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ ...style }} {...rest}>
      <svg xmlns='http://www.w3.org/2000/svg' width='15' height='16' viewBox='0 0 15 16' fill='none'>
        <path
          d='M13.6717 6.33252L3.6964 0.294708C3.07698 -0.0798892 2.29649 -0.0990558 1.65742 0.246808C1.01938 0.592754 0.623047 1.25004 0.623047 1.96202V14.0375C0.623047 14.7495 1.01938 15.4069 1.65742 15.7527C1.96196 15.9185 2.29842 16 2.6349 16C3.00381 16 3.37221 15.9013 3.69588 15.7048L13.6717 9.66712C14.2675 9.30778 14.623 8.68393 14.623 7.99981C14.623 7.31557 14.2674 6.69186 13.6717 6.33252Z'
          fill='white'
        />
      </svg>
    </IconWrapper>
  );
}

export function IcoDownload(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ color: 'var(--colorIco01)', ...style }} {...rest}>
      <svg xmlns='http://www.w3.org/2000/svg' width='16' height='14' viewBox='0 0 16 14' fill='none'>
        <rect y='11.5' width='16' height='2' fill='currentColor' />
        <rect x='6.96387' y='0.5' width='2' height='9' fill='currentColor' />
        <rect x='11.5139' y='4.5' width='2' height='7.02355' transform='rotate(45 11.5139 4.5)' fill='currentColor' />
        <rect
          x='9.37842'
          y='9.46436'
          width='2'
          height='7.02046'
          transform='rotate(135 9.37842 9.46436)'
          fill='currentColor'
        />
      </svg>
    </IconWrapper>
  );
}

export function CloseFill(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper {...rest} style={{ color: 'var(--colorFg11)', ...style }}>
      <svg width='1.7em' height='1.8em' viewBox='0 0 17 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <circle cx='8.5' cy='9' r='8.5' fill='currentColor' />
        <rect
          x='4.78125'
          y='6.0249'
          width='1.05182'
          height='9.46637'
          transform='rotate(-45 4.78125 6.0249)'
          fill='white'
        />
        <rect
          x='5.5249'
          y='12.7188'
          width='1.05182'
          height='9.46637'
          transform='rotate(-135 5.5249 12.7188)'
          fill='white'
        />
      </svg>
    </IconWrapper>
  );
}

export function Bang(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ color: 'var(--colorBg02)', ...style }} {...rest}>
      <svg width='1em' height='1em' viewBox='0 0 86 86' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_320_1481)'>
          <path
            d='M43 86C66.7482 86 86 66.7482 86 43C86 19.2518 66.7482 0 43 0C19.2518 0 0 19.2518 0 43C0 66.7482 19.2518 86 43 86Z'
            fill='#C0C0C0'
          />
          <path
            d='M43.0002 22.3793C41.0665 22.3793 39.4941 23.9517 39.4941 25.8846V46.8816C39.4941 48.8146 41.0665 50.3869 43.0002 50.3869C44.9331 50.3869 46.5055 48.8146 46.5055 46.8816V25.8846C46.5055 23.9517 44.9331 22.3793 43.0002 22.3793Z'
            fill='currentColor'
          />
          <path
            d='M43.0005 63.6207C45.3653 63.6207 47.2823 61.7037 47.2823 59.3389C47.2823 56.9741 45.3653 55.0571 43.0005 55.0571C40.6358 55.0571 38.7188 56.9741 38.7188 59.3389C38.7188 61.7037 40.6358 63.6207 43.0005 63.6207Z'
            fill='currentColor'
          />
        </g>
      </svg>
    </IconWrapper>
  );
}

export function ArrowUp(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ color: 'gray', ...style }} {...rest}>
      <svg width='2.4em' height='1.4em' viewBox='0 0 24 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M23.7008 12.775C23.7008 13.0437 23.6056 13.3123 23.4151 13.5174C23.0343 13.9275 22.4173 13.9275 22.0364 13.5174L12.0008 2.70977L1.96513 13.5174C1.58427 13.9275 0.967272 13.9275 0.586423 13.5174C0.205574 13.1072 0.20556 12.4428 0.586423 12.0326L11.3114 0.482604C11.6923 0.0724491 12.3093 0.0724491 12.6901 0.482604L23.4151 12.0326C23.6056 12.2377 23.7008 12.5063 23.7008 12.775Z'
          fill='currentColor'
          stroke='currentColor'
          strokeWidth='0.5'
        />
      </svg>
    </IconWrapper>
  );
}

export function MissionIconBlack(props: IconProps) {
  return (
    <IconWrapper {...props}>
      <svg width='4em' height='4em' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g id='ico_live_side_menu_mission'>
          <path
            id='Vector'
            d='M36.5883 10.7477C36.9317 10.4043 37.0737 9.9079 36.9632 9.4353C36.8527 8.96185 36.5059 8.57935 36.046 8.42295L32.7089 7.29244L31.5784 3.95448C31.4228 3.49463 31.0403 3.14783 30.5677 3.03648C30.0951 2.92682 29.5979 3.06793 29.2553 3.41218L27.5264 5.14108C21.0537 1.81502 13.1393 3.01523 7.9279 8.22745C1.35737 14.8005 1.35737 25.497 7.9279 32.0701C11.2132 35.357 15.5295 37.0001 19.8449 37.0001C24.1604 37.0001 28.4759 35.357 31.7611 32.0701C36.9649 26.8655 38.1668 18.9511 34.8552 12.4809L36.5883 10.7477ZM29.6429 6.99749L30.2711 8.85305C30.2796 8.8777 30.2932 8.89895 30.3034 8.9236C30.3229 8.9729 30.3442 9.02135 30.3688 9.0681C30.3901 9.10635 30.4139 9.1429 30.4377 9.1786C30.4632 9.21685 30.4895 9.25425 30.5184 9.2908C30.5482 9.3265 30.5805 9.35965 30.6136 9.3928C30.6442 9.4234 30.6748 9.45315 30.7088 9.4812C30.7462 9.51265 30.787 9.5407 30.8278 9.5679C30.8618 9.59 30.895 9.6121 30.9315 9.63165C30.98 9.658 31.0301 9.6801 31.0811 9.7005C31.1049 9.70985 31.1253 9.72345 31.1491 9.7311L33.0039 10.3593L30.7751 12.5888L27.9268 12.0763L27.4151 9.22705L29.6429 6.99749ZM25.5706 20.1487C25.5706 21.6788 24.9747 23.117 23.8935 24.199C21.6606 26.432 18.0285 26.4311 15.7955 24.199C13.5634 21.9661 13.5634 18.3323 15.7955 16.0985C16.9124 14.9824 18.3787 14.424 19.8449 14.424C20.8633 14.424 21.879 14.6994 22.78 15.2383L18.9023 19.1168C18.354 19.6651 18.354 20.5542 18.9023 21.1033C19.1768 21.3779 19.5364 21.5147 19.8959 21.5147C20.2546 21.5147 20.6142 21.3779 20.8888 21.1033L24.7639 17.2264C25.2858 18.1028 25.5706 19.1024 25.5706 20.1487ZM29.7755 30.0836C24.299 35.5619 15.3901 35.561 9.9135 30.0836C4.43863 24.6053 4.43863 15.6922 9.9135 10.2139C14.036 6.09139 20.1858 4.99063 25.4116 7.25674L24.9093 7.7591C24.5837 8.08465 24.4384 8.54875 24.52 9.00095L25.2059 12.8115L24.8047 13.2127C21.4727 10.8268 16.8002 11.12 13.8099 14.112C10.4822 17.4406 10.4822 22.8569 13.8099 26.1855C15.4742 27.8506 17.6587 28.6828 19.8449 28.6819C22.0303 28.6819 24.2157 27.8498 25.8791 26.1855C27.4916 24.5739 28.379 22.4293 28.379 20.1487C28.379 18.3476 27.818 16.6357 26.7903 15.2L27.1915 14.7988L31.0004 15.4839C31.0828 15.4992 31.1661 15.5069 31.2486 15.5069C31.6183 15.5069 31.9762 15.3607 32.2423 15.0946L32.7395 14.5974C34.9937 19.8215 33.8896 25.967 29.7755 30.0836Z'
            fill='currentColor'
          />
        </g>
      </svg>
    </IconWrapper>
  );
}
export function MyMenu_19Certi(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper {...rest} style={{ color: 'var(--colorIco01)', ...style }}>
      <svg width='2em' height='2em' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_379_4422)'>
          <path
            d='M18.0259 6.72608L18.0163 6.70159C16.1975 2.28425 11.1216 0.168002 6.70023 1.98441C2.28533 3.80307 0.169575 8.87879 1.98373 13.2993C3.32815 16.56 6.47943 18.6668 10.0122 18.6668C11.1409 18.6668 12.2461 18.4476 13.2971 18.0154C17.7083 16.2019 19.8256 11.1417 18.0259 6.72608ZM12.7123 16.5939C11.8484 16.9496 10.9399 17.1299 10.0122 17.1299C7.10431 17.1299 4.51085 15.3968 3.40512 12.7145C1.91235 9.07789 3.65284 4.90203 7.28481 3.40596C8.14976 3.05053 9.059 2.87038 9.98755 2.87038C12.897 2.87038 15.4905 4.60428 16.595 7.28738C18.0891 10.9247 16.3474 15.0995 12.7123 16.5939Z'
            fill='currentColor'
          />
          <path
            d='M6.44025 6.3042C6.01654 6.3042 5.67188 6.64886 5.67188 7.07255C5.67188 7.49643 6.01654 7.84109 6.44025 7.84109C6.64228 7.84109 6.64575 7.88764 6.64766 7.90901V12.9276C6.64766 13.3513 6.99232 13.6959 7.41603 13.6959C7.83991 13.6959 8.18457 13.3513 8.18457 12.9276V7.90901C8.18457 7.26382 7.72005 6.3042 6.44025 6.3042Z'
            fill='currentColor'
          />
          <path
            d='M11.609 6.30421C10.1089 6.30421 8.88867 7.52441 8.88867 9.0243C8.88867 10.3461 9.83682 11.4496 11.0886 11.6932L10.507 12.4651C10.3835 12.6291 10.3313 12.8313 10.3599 13.0348C10.3886 13.238 10.4945 13.418 10.6585 13.5415C10.7928 13.6426 10.9525 13.6959 11.1205 13.6959C11.3644 13.6959 11.5883 13.5846 11.7349 13.3902L13.7549 10.7087C13.7795 10.6761 13.799 10.6409 13.8179 10.6056C14.1382 10.1594 14.3291 9.61427 14.3291 9.02429C14.3291 7.52439 13.1089 6.30421 11.609 6.30421ZM11.609 10.2075C10.9565 10.2075 10.4256 9.67661 10.4256 9.0243C10.4256 8.37199 10.9565 7.8411 11.609 7.8411C12.2613 7.8411 12.7922 8.37198 12.7922 9.0243C12.7922 9.67662 12.2613 10.2075 11.609 10.2075Z'
            fill='currentColor'
          />
        </g>
        <defs>
          <clipPath id='clip0_379_4422'>
            <rect width='2em' height='2em' fill='white' />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  );
}
export function MyMenuAdhart(props: IconProps) {
  return (
    <IconWrapper
      {...props}
      style={{
        color: 'var(--colorIco01)',
      }}
    >
      <svg width='2em' height='2em' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_379_4193)'>
          <path
            d='M10.0003 18.3332C7.87102 17.0993 5.50033 15.9691 3.26885 13.07C-0.629455 8.00534 1.59453 4.0067 1.59453 4.0067C1.59453 4.0067 2.52924 1.78769 5.19505 1.67026C8.11466 1.54164 10.0003 4.7622 10.0003 4.7622C10.0003 4.7622 11.8859 1.54164 14.8055 1.67026C17.4713 1.78769 18.406 4.0067 18.406 4.0067C18.406 4.0067 20.63 8.00534 16.7317 13.07C14.5002 15.9691 12.1295 17.0993 10.0003 18.3332Z'
            stroke='currentColor'
            strokeWidth='1.333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M6.66834 6.41553H8.05218L9.94544 12.378H8.71234L8.29895 10.8492H6.3898L5.97642 12.378H4.7832L6.66834 6.41553ZM6.64433 9.92387H8.04442L7.86932 9.27213C7.68645 8.65253 7.52724 7.96864 7.36026 7.32475H7.32036C7.16927 7.9765 6.99452 8.65253 6.81942 9.27213L6.64433 9.92387Z'
            fill='currentColor'
          />
          <path
            d='M10.6895 6.41553H12.3042C14.1018 6.41553 15.2156 7.36511 15.2156 9.37677C15.2156 11.3802 14.1018 12.378 12.3677 12.378H10.6895V6.41553ZM12.2325 11.4206C13.3304 11.4206 14.0142 10.8249 14.0142 9.37676C14.0142 7.92043 13.3304 7.37332 12.2325 7.37332H11.8668V11.4206H12.2325Z'
            fill='currentColor'
          />
        </g>
        <defs>
          <clipPath id='clip0_379_4193'>
            <rect width='2em' height='2em' fill='white' />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  );
}
export function MyMenuAppSet(props: IconProps) {
  return (
    <IconWrapper
      {...props}
      style={{
        color: 'var(--colorIco01)',
      }}
    >
      <svg width='2em' height='2em' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_379_4248)'>
          <path
            d='M13.5448 15.1517C14.4292 15.1517 15.1462 14.4495 15.1462 13.5832C15.1462 12.7169 14.4292 12.0146 13.5448 12.0146C12.6603 12.0146 11.9434 12.7169 11.9434 13.5832C11.9434 14.4495 12.6603 15.1517 13.5448 15.1517Z'
            stroke='currentColor'
            strokeWidth='1.333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M10.1628 9.72999L10.2107 9.69542L11.859 8.72886C11.9873 8.65498 12.1583 8.68315 12.2557 8.7936L12.9145 9.53842C12.9443 9.57234 13.0168 9.60185 13.0601 9.59881L14.0053 9.59897C14.0543 9.60231 14.1167 9.57846 14.1507 9.54809L14.8422 8.76187C14.9416 8.67301 15.0966 8.65551 15.2108 8.72171L16.8643 9.68171C16.9912 9.75445 17.0541 9.92061 17.0077 10.0614L16.6967 11.0104C16.6843 11.0489 16.6961 11.1243 16.7216 11.1576C16.7284 11.1669 16.8856 11.3781 16.9918 11.5634C17.0979 11.7471 17.2025 11.9925 17.2069 12.0033C17.2231 12.0412 17.281 12.09 17.3206 12.0985L18.2914 12.2964C18.4342 12.3248 18.5467 12.4632 18.5468 12.6103L18.5499 14.5357C18.5506 14.6777 18.4361 14.8221 18.2959 14.8506L17.3224 15.0522C17.2966 15.0574 17.2192 15.1094 17.2017 15.1492L16.7301 15.9805C16.7006 16.0253 16.6894 16.1047 16.703 16.1455L17.023 17.0918C17.0617 17.2101 17.0223 17.3517 16.9278 17.4361L16.882 17.4701L15.231 18.4372C15.105 18.5116 14.9306 18.4833 14.8332 18.3721L14.1759 17.6247C14.1471 17.5918 14.0739 17.5623 14.0293 17.5646L13.0741 17.5638C13.0304 17.5608 12.9683 17.5806 12.9315 17.6135L12.249 18.4057C12.1506 18.4936 11.997 18.5105 11.8824 18.4459L10.2265 17.4848C10.0998 17.4107 10.0373 17.2442 10.0835 17.1054L10.3952 16.1572C10.4087 16.1171 10.3964 16.0427 10.3717 16.0093C10.3642 16.0001 10.2047 15.7864 10.0978 15.6016C9.99152 15.4162 9.88818 15.1715 9.88342 15.1618C9.86767 15.123 9.80936 15.0751 9.7693 15.0676L8.79966 14.8688C8.65711 14.84 8.54705 14.7064 8.54464 14.5583L8.54102 12.6315C8.54094 12.4888 8.6554 12.3451 8.79464 12.3175L9.76601 12.1114C9.79615 12.1055 9.86976 12.0563 9.88834 12.0149L10.3578 11.1869C10.3883 11.1424 10.3991 11.0633 10.3846 11.0215L10.069 10.0738C10.0293 9.95569 10.0679 9.81476 10.1628 9.72999Z'
            stroke='currentColor'
            strokeWidth='1.333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M9.41971 15.5041H2.11784C1.75117 15.5041 1.45117 15.2041 1.45117 14.8374V2.18132C1.45117 1.81465 1.75117 1.51465 2.11784 1.51465H11.5703C11.937 1.51465 12.237 1.81465 12.237 2.18132V8.40367'
            stroke='currentColor'
            strokeWidth='1.333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M5.32031 3.81299H8.3692'
            stroke='currentColor'
            strokeWidth='1.333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
        <defs>
          <clipPath id='clip0_379_4248'>
            <rect width='2em' height='2em' fill='white' />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  );
}
export function MyMenuAsk(props: IconProps) {
  return (
    <IconWrapper
      {...props}
      style={{
        color: 'var(--colorIco01)',
      }}
    >
      <svg width='2em' height='2em' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_379_4223)'>
          <path
            d='M16.0801 8.23769C16.1548 8.23103 16.2279 8.21875 16.3053 8.21875C17.4248 8.21875 18.3323 8.9741 18.3323 9.90605V11.4433C18.3323 12.3752 17.4248 13.1306 16.3053 13.1306C16.2279 13.1306 16.0801 13.1117 16.0801 13.1117'
            stroke='currentColor'
            strokeWidth='1.3333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M3.91824 8.23769C3.84352 8.23103 3.77044 8.21875 3.69303 8.21875C2.57352 8.21875 1.66602 8.9741 1.66602 9.90605V11.4433C1.66602 12.3752 2.57352 13.1306 3.69303 13.1306C3.77044 13.1306 3.84352 13.1183 3.91824 13.1117L4.2647 13.0627'
            stroke='currentColor'
            strokeWidth='1.3333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M12.9268 16.5052C12.9268 17.1266 12.4227 17.6301 11.8007 17.6301H8.64757C8.02553 17.6301 7.52148 17.1266 7.52148 16.5052C7.52148 15.8839 8.02554 15.3804 8.64757 15.3804H11.8007C12.4227 15.3804 12.9268 15.8839 12.9268 16.5052Z'
            stroke='currentColor'
            strokeWidth='1.3333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M7.78371 15.7854C5.5983 15.4756 3.91797 13.5991 3.91797 11.3309V6.86902C3.91797 4.38422 5.9345 2.36963 8.42251 2.36963H11.5756C14.0637 2.36963 16.0802 4.38422 16.0802 6.86902V13.1307'
            stroke='currentColor'
            strokeWidth='1.3333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
        <defs>
          <clipPath id='clip0_379_4223'>
            <rect width='2em' height='2em' fill='white' />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  );
}
export function MyMenuBjNotice(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper
      {...rest}
      style={{
        color: 'var(--colorIco01)',
        fontSize: 20,
        ...style,
      }}
    >
      <svg width='1em' height='1em' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_379_4288)'>
          <path
            d='M16.6544 16.8808C16.4434 16.8808 16.2258 16.845 16.0094 16.7716L3.52681 12.5574C2.4835 12.2055 1.66602 11.0669 1.66602 9.96504V9.64417C1.66602 8.54228 2.4835 7.40369 3.52704 7.05176L16.0094 2.83758C16.5914 2.63997 17.1819 2.71243 17.6291 3.03283C18.0763 3.35371 18.3327 3.89007 18.3327 4.505V15.1042C18.3327 15.7192 18.0763 16.2555 17.6291 16.5764C17.3482 16.7778 17.0108 16.8808 16.6544 16.8808ZM16.6554 4.17283C16.6015 4.17283 16.5387 4.18412 16.4719 4.2067L3.9893 8.42089C3.52964 8.57615 3.11137 9.15909 3.11137 9.64417V9.96504C3.11137 10.4501 3.52964 11.0331 3.98907 11.1883L16.4719 15.4025C16.6057 15.4477 16.7231 15.4481 16.7864 15.402C16.8497 15.3569 16.8873 15.2454 16.8873 15.1042V4.505C16.8873 4.36385 16.8497 4.25235 16.7864 4.20718C16.7547 4.18413 16.7095 4.17283 16.6554 4.17283Z'
            fill='currentColor'
          />
          <path
            d='M7.04579 17.2721C5.74111 17.2721 4.67969 16.2107 4.67969 14.906V12.9888C4.67969 12.5898 5.00315 12.2661 5.40236 12.2661C5.80157 12.2661 6.12503 12.5898 6.12503 12.9888V14.906C6.12503 15.4137 6.53813 15.8268 7.04579 15.8268C7.55345 15.8268 7.96654 15.4137 7.96654 14.906V14.1391C7.96654 13.7402 8.29 13.4165 8.68921 13.4165C9.08843 13.4165 9.41189 13.7402 9.41189 14.1391V14.906C9.41189 16.2107 8.35046 17.2721 7.04579 17.2721Z'
            fill='currentColor'
          />
          <path d='M6.12503 7.63965H4.67969V12.8593H6.12503V7.63965Z' fill='currentColor' />
        </g>
        <defs>
          <clipPath id='clip0_379_4288'>
            <rect width='2em' height='2em' fill='white' />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  );
}
export function MyMenuBlacklist(props: IconProps) {
  return (
    <IconWrapper
      {...props}
      style={{
        color: 'var(--colorIco01)',
      }}
    >
      <svg width='2em' height='2em' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_379_4347)'>
          <path
            d='M8.91863 10.2539C11.2209 10.2539 13.0873 8.33157 13.0873 5.96022C13.0873 3.58886 11.2209 1.6665 8.91863 1.6665C6.61636 1.6665 4.75 3.58886 4.75 5.96022C4.75 8.33157 6.61636 10.2539 8.91863 10.2539Z'
            stroke='currentColor'
            strokeWidth='1.333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M7.61312 10.2134C7.61312 10.2134 2.49887 12.6119 2.17773 18.3331'
            stroke='currentColor'
            strokeWidth='1.333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M14.218 18.3336C16.2089 18.3336 17.8228 16.6712 17.8228 14.6206C17.8228 12.57 16.2089 10.9077 14.218 10.9077C12.2272 10.9077 10.6133 12.57 10.6133 14.6206C10.6133 16.6712 12.2272 18.3336 14.218 18.3336Z'
            stroke='currentColor'
            strokeWidth='1.333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M12.0508 12.498L16.6794 17.1266'
            stroke='currentColor'
            strokeWidth='1.333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
        <defs>
          <clipPath id='clip0_379_4347'>
            <rect width='2em' height='2em' fill='white' />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  );
}
export function MyMenuBroadcastApp(props: IconProps) {
  return (
    <IconWrapper
      {...props}
      style={{
        color: 'var(--colorIco01)',
      }}
    >
      <svg width='2em' height='2em' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_582_3286)'>
          <path
            d='M3.88477 10.0234V17.5485'
            stroke='currentColor'
            strokeWidth='1.333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M3.88477 2.49854V5.9189'
            stroke='currentColor'
            strokeWidth='1.333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M3.8843 10.0235C5.01773 10.0235 5.93656 9.10465 5.93656 7.97121C5.93656 6.83778 5.01773 5.91895 3.8843 5.91895C2.75086 5.91895 1.83203 6.83778 1.83203 7.97121C1.83203 9.10465 2.75086 10.0235 3.8843 10.0235Z'
            stroke='currentColor'
            strokeWidth='1.333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M16.1309 9.37744V17.5484'
            stroke='currentColor'
            strokeWidth='1.333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M16.1309 2.49854V5.23487'
            stroke='currentColor'
            strokeWidth='1.333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M16.1304 9.3394C17.2638 9.3394 18.1827 8.42057 18.1827 7.28713C18.1827 6.15369 17.2638 5.23486 16.1304 5.23486C14.997 5.23486 14.0781 6.15369 14.0781 7.28713C14.0781 8.42057 14.997 9.3394 16.1304 9.3394Z'
            stroke='currentColor'
            strokeWidth='1.333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M10.0078 14.8125V17.5487'
            stroke='currentColor'
            strokeWidth='1.333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M10.0078 2.49854V10.7077'
            stroke='currentColor'
            strokeWidth='1.333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M10.0073 14.8121C11.1408 14.8121 12.0596 13.8932 12.0596 12.7598C12.0596 11.6264 11.1408 10.7075 10.0073 10.7075C8.87391 10.7075 7.95508 11.6264 7.95508 12.7598C7.95508 13.8932 8.87391 14.8121 10.0073 14.8121Z'
            stroke='currentColor'
            strokeWidth='1.333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
        <defs>
          <clipPath id='clip0_582_3286'>
            <rect width='2em' height='2em' fill='white' />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  );
}
export function MyMenuBroadcastGuide(props: IconProps) {
  return (
    <IconWrapper
      {...props}
      style={{
        color: 'var(--colorIco01)',
      }}
    >
      <svg width='2em' height='2em' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_379_4235)'>
          <path
            d='M7.99935 2.95117H2.99935C2.26297 2.95117 1.66602 3.54813 1.66602 4.28451V14.3899C1.66602 15.1262 2.26297 15.7232 2.99935 15.7232H8.45887C9.30967 15.7232 9.99935 16.1987 9.99935 17.0489V4.95117C9.99935 3.84661 9.10392 2.95117 7.99935 2.95117Z'
            stroke='currentColor'
            strokeWidth='1.3333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M12 2.95117H17C17.7364 2.95117 18.3333 3.54813 18.3333 4.28451V14.3899C18.3333 15.1262 17.7364 15.7232 17 15.7232H11.5405C10.6897 15.7232 10 16.1987 10 17.0489V4.95117C10 3.84661 10.8954 2.95117 12 2.95117Z'
            stroke='currentColor'
            strokeWidth='1.3333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M4.05273 6.15527H7.67318'
            stroke='currentColor'
            strokeWidth='1.3333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M4.05273 9.35938H7.67318'
            stroke='currentColor'
            strokeWidth='1.3333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M4.0625 12.563H7.67537'
            stroke='currentColor'
            strokeWidth='1.3333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M15.9486 6.15527H12.3281'
            stroke='currentColor'
            strokeWidth='1.3333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M15.9486 9.35938H12.3281'
            stroke='currentColor'
            strokeWidth='1.3333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M15.9371 12.563H12.3242'
            stroke='currentColor'
            strokeWidth='1.3333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
        <defs>
          <clipPath id='clip0_379_4235'>
            <rect width='2em' height='2em' fill='white' />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  );
}
export function MyMenuBroadcastHistory(props: IconProps) {
  return (
    <IconWrapper
      {...props}
      style={{
        color: 'var(--colorIco01)',
      }}
    >
      <svg width='2em' height='2em' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_1782_5546)'>
          <path
            d='M9.99962 1.6665C5.40511 1.6665 1.66797 5.40478 1.66797 10C1.66797 14.5953 5.40511 18.3332 9.99962 18.3332C14.5941 18.3332 18.3317 14.5952 18.3317 10C18.3317 5.40483 14.594 1.6665 9.99962 1.6665Z'
            stroke='currentColor'
            strokeWidth='1.333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M10 18.333H18.3319'
            stroke='currentColor'
            strokeWidth='1.333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M11.7498 5.65703C11.7498 6.6221 10.9648 7.40715 9.99981 7.40715C9.03491 7.40715 8.25 6.6221 8.25 5.65703C8.25 4.69188 9.03491 3.90674 9.99981 3.90674C10.9648 3.90674 11.7498 4.69188 11.7498 5.65703Z'
            stroke='currentColor'
            strokeWidth='1.333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M11.7498 14.3426C11.7498 15.3076 10.9648 16.0927 9.99981 16.0927C9.03491 16.0927 8.25 15.3076 8.25 14.3426C8.25 13.3774 9.03491 12.5923 9.99981 12.5923C10.9648 12.5923 11.7498 13.3774 11.7498 14.3426Z'
            stroke='currentColor'
            strokeWidth='1.333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M5.65654 8.25C6.62161 8.25 7.40666 9.035 7.40666 9.99998C7.40666 10.9649 6.62161 11.7498 5.65654 11.7498C4.69139 11.7498 3.90625 10.9649 3.90625 9.99998C3.90625 9.035 4.69139 8.25 5.65654 8.25Z'
            stroke='currentColor'
            strokeWidth='1.333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M14.3421 8.25C15.3072 8.25 16.0922 9.035 16.0922 9.99998C16.0922 10.9649 15.3072 11.7498 14.3421 11.7498C13.3769 11.7498 12.5918 10.9649 12.5918 9.99998C12.5918 9.035 13.3769 8.25 14.3421 8.25Z'
            stroke='currentColor'
            strokeWidth='1.333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
        <defs>
          <clipPath id='clip0_1782_5546'>
            <rect width='2em' height='2em' fill='white' />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  );
}
export function MyMenuBroadcastSet(props: IconProps) {
  return (
    <IconWrapper
      {...props}
      style={{
        color: 'var(--colorIco01)',
      }}
    >
      <svg width='2em' height='2em' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M13.444 8.51514C13.4362 8.51514 13.4284 8.51579 13.4199 8.51644H13.4674C13.4596 8.51578 13.4518 8.51514 13.444 8.51514Z'
          fill='currentColor'
        />
        <path
          d='M17.9232 3.81315C17.4525 3.55338 16.8561 3.60677 16.2891 3.96159L13.9238 5.4436V4.01497C13.9238 2.76497 12.9069 1.74805 11.6576 1.74805H2.93229C1.68294 1.74804 0.666016 2.76497 0.666016 4.01497V12.4707C0.666016 13.72 1.68294 14.737 2.93229 14.737H7.4788C7.38972 14.5869 7.32682 14.4204 7.32682 14.2402L7.32543 13.4036H2.93229C2.41797 13.4036 1.99935 12.985 1.99935 12.4707V4.01497C1.99935 3.49999 2.41797 3.08137 2.93229 3.08137H11.6575C12.1719 3.08137 12.5905 3.49999 12.5905 4.01497V8.36275L12.7233 8.51692L13.2559 8.51627L13.7812 7.89387C13.8001 7.87174 13.8203 7.85091 13.8411 7.83137C13.866 7.80875 13.8971 7.79719 13.9238 7.77754V7.01765L16.9974 5.09179C17.1628 4.98763 17.2643 4.97851 17.2702 4.97395C17.2864 4.99088 17.3327 5.08137 17.3327 5.27734V11.1685L17.8769 11.2825C18.1854 11.3456 18.4307 11.5631 18.5603 11.8413C18.6226 11.6477 18.666 11.4402 18.666 11.2083V5.27734C18.666 4.60807 18.3952 4.07421 17.9232 3.81315Z'
          fill='currentColor'
        />
        <path
          d='M18.6628 12.2403C18.6604 12.0975 18.6188 11.9654 18.561 11.8414C18.4313 11.5631 18.1861 11.3456 17.8776 11.2826L17.3333 11.1686L17.1628 11.1328C17.1218 11.0449 17.0723 10.9453 17.0228 10.8574C16.9714 10.7676 16.9102 10.6712 16.8555 10.5892L17.0905 9.85809C17.2344 9.41864 17.0521 8.92775 16.6543 8.69012L14.9902 7.70444C14.6552 7.51267 14.2335 7.55006 13.9245 7.77756C13.8978 7.79722 13.8666 7.80877 13.8418 7.8314C13.821 7.85093 13.8008 7.87176 13.7819 7.8939L13.2565 8.51629L12.724 8.51694L12.5912 8.36277L12.2136 7.9245C11.9063 7.56382 11.3665 7.47593 10.9681 7.71942L9.31707 8.7064C9.29559 8.71942 9.27475 8.73309 9.25523 8.74806C9.2396 8.75978 9.17841 8.80731 9.16408 8.82098C8.87893 9.0801 8.76564 9.50067 8.88478 9.87502L9.13803 10.6387L8.86069 11.1413L8.10808 11.3008C7.65951 11.3945 7.32227 11.8145 7.32423 12.2761L7.3261 13.4037L7.32749 14.2403C7.32749 14.4204 7.39039 14.5869 7.47947 14.737C7.61919 14.9726 7.84035 15.1577 8.11395 15.2142L8.82749 15.3627C8.86915 15.4505 8.91733 15.5469 8.96746 15.6348C9.01759 15.7253 9.07814 15.8203 9.13413 15.9043L8.89975 16.6361C8.75457 17.0795 8.93947 17.5716 9.3366 17.8041L10.9922 18.7852C11.1432 18.8744 11.3132 18.918 11.4831 18.918C11.7227 18.918 11.9623 18.8314 12.1471 18.6634C12.1667 18.6452 12.1862 18.6257 12.2038 18.6048L12.7409 17.9811L13.2669 17.9805L13.78 18.5723C14.0898 18.9323 14.6113 19.0183 15.0241 18.7754L16.6725 17.7891C16.6927 17.7767 16.7122 17.7637 16.7311 17.7494L16.7787 17.7136C16.7956 17.7012 16.8112 17.6875 16.8268 17.6739C17.1126 17.4128 17.2253 16.9916 17.1055 16.6231L16.8555 15.8555L17.1315 15.3548L17.8802 15.1927C18.3288 15.1003 18.6667 14.6817 18.6667 14.2175L18.6628 12.2403ZM13.444 8.515C13.4518 8.515 13.4597 8.51565 13.4675 8.5163H13.4199C13.4284 8.51564 13.4362 8.515 13.444 8.515ZM12.5091 8.51565C12.5202 8.51565 12.5313 8.5163 12.543 8.51695H12.4733C12.4851 8.5163 12.4974 8.51565 12.5091 8.51565ZM16.6465 14.0957C16.3959 14.1446 16.1478 14.3425 16.0697 14.5248L15.6322 15.319C15.4851 15.5339 15.4427 15.8301 15.5228 16.0697L15.7559 16.7839L14.5957 17.4779L14.1296 16.9401C13.961 16.7455 13.6921 16.6289 13.4805 16.6485L12.5795 16.6498C12.3562 16.6315 12.1094 16.7194 11.9375 16.8776C11.9193 16.8946 11.9017 16.9128 11.8848 16.9323L11.4102 17.4831L10.2487 16.7949L10.4792 16.0749C10.5567 15.8301 10.5059 15.5287 10.3542 15.3262C10.3256 15.2858 10.2103 15.1263 10.1289 14.9811C10.0846 14.9024 10.0415 14.8122 10.0074 14.737C9.97896 14.6742 9.95654 14.6213 9.94795 14.5996C9.84639 14.3607 9.61006 14.1647 9.35551 14.11L8.66019 13.9655L8.65942 13.4037L8.65824 12.5469L9.34899 12.4011C9.56123 12.3587 9.83597 12.1778 9.92191 11.972L10.3711 11.1602C10.5085 10.946 10.5482 10.6576 10.4707 10.4219L10.2351 9.71096L11.3952 9.01695L11.8646 9.56252C12.03 9.75002 12.3028 9.8594 12.5111 9.84898L12.5912 9.84886L12.9215 9.84842L13.4173 9.84768C13.596 9.85826 13.771 9.79776 13.9245 9.7034C13.969 9.67605 14.0201 9.65978 14.0586 9.62438C14.0742 9.61026 14.0882 9.59463 14.1024 9.57917C14.1078 9.57323 14.114 9.56802 14.1192 9.56188L14.5827 9.0124L15.7409 9.69924L15.5098 10.4173C15.5058 10.4299 15.506 10.4439 15.5027 10.4567C15.4421 10.6916 15.4896 10.9697 15.6315 11.1647C15.638 11.1732 15.7728 11.3568 15.862 11.5137C15.9375 11.6478 16.0104 11.8184 16.0352 11.8763L16.043 11.8933C16.1452 12.1387 16.3848 12.336 16.6348 12.3841L17.3301 12.53L17.3307 12.829L17.3327 13.9473L16.6465 14.0957Z'
          fill='currentColor'
        />
        <path
          d='M13.8739 12.9413C13.9076 13.0377 13.9296 13.1398 13.9296 13.2476C13.9296 13.7111 13.5892 14.0941 13.1458 14.1667C12.7467 14.5173 12.2298 14.7372 11.6582 14.7372H11.2988C11.7148 15.2102 12.3173 15.5152 12.9954 15.5152C14.2461 15.5152 15.263 14.4983 15.263 13.2476C15.263 12.3288 14.7117 11.5397 13.9244 11.1836V12.4709C13.9244 12.6323 13.9061 12.7893 13.8739 12.9413Z'
          fill='currentColor'
        />
        <path
          d='M12.0658 13.3054C12.0646 13.2858 12.0599 13.2673 12.0599 13.2474C12.0599 12.8772 12.2778 12.5594 12.5905 12.4081V11.02C11.5327 11.2118 10.7266 12.1351 10.7266 13.2474C10.7266 13.3009 10.7387 13.351 10.7423 13.4036H11.6575C11.8046 13.4036 11.9419 13.3663 12.0658 13.3054Z'
          fill='currentColor'
        />
        <path
          d='M13.147 14.1666C13.0977 14.1747 13.0481 14.1818 12.9966 14.1818C12.5009 14.1818 12.0983 13.7932 12.0676 13.3057C11.9437 13.3665 11.8064 13.4039 11.6593 13.4039H10.7441C10.7797 13.9141 10.9815 14.375 11.3 14.7372H11.6593C12.231 14.7372 12.7478 14.5172 13.147 14.1666Z'
          fill='currentColor'
        />
        <path
          d='M12.5918 11.0199V12.408C12.7146 12.3485 12.8507 12.3123 12.9961 12.3123C13.4033 12.3123 13.747 12.5761 13.8746 12.9408C13.9068 12.7889 13.9251 12.6319 13.9251 12.4705V11.1832C13.6409 11.0546 13.3279 10.979 12.9961 10.979C12.8577 10.979 12.7235 10.996 12.5918 11.0199Z'
          fill='currentColor'
        />
      </svg>
    </IconWrapper>
  );
}
export function MyMenuChannel(props: IconProps) {
  return (
    <IconWrapper
      style={{
        color: 'var(--colorIco01)',
      }}
      {...props}
    >
      <svg width='2em' height='2em' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_379_4142)'>
          <g clipPath='url(#clip1_379_4142)'>
            <path
              d='M11.6173 6.26078L13.8232 3.07919C13.8722 2.97976 13.9213 2.83063 13.8722 2.7312C13.8722 2.6318 13.7742 2.48264 13.6762 2.43294C13.5781 2.38324 13.4801 2.33351 13.4311 2.33351C13.284 2.33351 13.1369 2.38324 13.0389 2.53237L10.4409 6.26079H9.46046L6.91146 2.53236C6.81341 2.38323 6.66636 2.3335 6.51928 2.3335C6.42126 2.3335 6.37223 2.38323 6.27418 2.43293C6.12713 2.53236 6.07812 2.63179 6.07812 2.73119C6.07812 2.88035 6.07812 2.97975 6.12713 3.07918L8.33301 6.26077L11.6173 6.26078Z'
              fill='currentColor'
            />
            <path
              d='M11.793 6.59425H8.15917L5.85351 3.26905C5.74609 3.05762 5.74609 2.89942 5.74609 2.73145C5.74609 2.57471 5.80566 2.34717 6.08984 2.15625L6.17578 2.10693C6.24805 2.06445 6.35742 2 6.52051 2C6.80469 2 7.04297 2.12402 7.19043 2.34961L9.6377 5.92725H10.2676L12.7666 2.34181C12.9746 2.02492 13.374 1.90382 13.8281 2.13624C14.0156 2.23097 14.168 2.44776 14.2002 2.65382C14.2695 2.87159 14.1846 3.10157 14.123 3.22657L11.793 6.59425ZM11.0801 5.92726H11.4434L13.5498 2.88917C13.5508 2.87989 13.5596 2.83985 13.5596 2.82862L13.5254 2.7588L13.54 2.73146C13.4717 2.70265 13.418 2.67287 13.3789 2.66066C13.3506 2.66701 13.3311 2.69582 13.3184 2.71486L11.0801 5.92726ZM8.5078 5.92726H8.83007L6.63671 2.72022C6.62109 2.69581 6.60155 2.667 6.5205 2.667L6.42675 2.72999C6.4121 2.84083 6.41308 2.90382 6.42675 2.93165L8.5078 5.92726Z'
              fill='currentColor'
            />
            <path
              d='M17.0596 18.958H2.99121C1.89355 18.958 1 18.0571 1 16.9492V7.60352C1 6.49561 1.89355 5.59473 2.99121 5.59473H17.0107C18.1084 5.59473 19.001 6.49561 19.001 7.60352V16.9492C19.001 17.6982 18.6172 18.3618 17.9746 18.7236C17.9258 18.7534 17.5635 18.958 17.0596 18.958ZM2.99121 6.92773C2.62207 6.92773 2.33398 7.22461 2.33398 7.60351V16.9492C2.33398 17.3281 2.62207 17.625 2.99121 17.625H17.0107C17.2022 17.625 17.3135 17.5659 17.3144 17.5654C17.5439 17.4355 17.667 17.2183 17.667 16.9492V7.60352C17.667 7.22461 17.3789 6.92774 17.0107 6.92774L2.99121 6.92773ZM8.72656 14.7822C8.21386 14.7822 7.76465 14.3315 7.76465 13.8174V10.7353C7.76465 10.6636 7.77637 10.5923 7.79883 10.5244C7.94141 10.0972 8.43848 9.58349 9.09668 9.84326C9.16016 9.86084 9.22168 9.88769 9.27832 9.92383L11.6318 11.415C11.9238 11.5605 12.1387 11.9023 12.1387 12.2764C12.1387 12.6206 11.958 12.9316 11.665 13.0986L9.32228 14.6006C9.09669 14.7822 8.85058 14.7822 8.72656 14.7822ZM9.09863 11.3872V13.1606L10.4912 12.2676L9.09863 11.3872ZM10.9336 12.5474C10.9463 12.5566 10.959 12.5649 10.9726 12.5718L10.9336 12.5474Z'
              fill='currentColor'
            />
          </g>
        </g>
        <defs>
          <clipPath id='clip0_379_4142'>
            <rect width='2em' height='2em' fill='white' />
          </clipPath>
          <clipPath id='clip1_379_4142'>
            <rect width='18.001' height='16.958' fill='white' transform='translate(1 2)' />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  );
}
export function MyMenuCouponUp(props: IconProps) {
  return (
    <IconWrapper
      {...props}
      style={{
        color: 'var(--colorIco01)',
      }}
    >
      <svg width='2em' height='2em' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_379_4000)'>
          <path
            d='M1.66602 6.00301V7.42857C3.21038 7.42857 4.46234 8.57984 4.46234 10C4.46234 11.4202 3.21038 12.5714 1.66602 12.5714V13.997C1.66602 15.1032 2.56279 16 3.66902 16H16.3297C17.4359 16 18.3327 15.1032 18.3327 13.997V6.00301C18.3327 4.89678 17.4359 4 16.3297 4H3.66902C2.5628 4 1.66602 4.89677 1.66602 6.00301Z'
            stroke='currentColor'
            strokeWidth='1.3333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M7.42578 5.77881V7.11214'
            stroke='currentColor'
            strokeWidth='1.3333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M7.42578 9.3335V10.6668'
            stroke='currentColor'
            strokeWidth='1.3333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M7.42578 12.8882V14.2215'
            stroke='currentColor'
            strokeWidth='1.3333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
        <defs>
          <clipPath id='clip0_379_4000'>
            <rect width='2em' height='2em' fill='white' />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  );
}

export function MyMenuChannelHome(props: IconProps) {
  return (
    <IconWrapper
      {...props}
      style={{
        color: 'var(--colorIco01)',
      }}
    >
      <svg xmlns='http://www.w3.org/2000/svg' width='18' height='17' viewBox='0 0 18 17' fill='none'>
        <g clipPath='url(#clip0_7954_50194)'>
          <path
            d='M10.6183 4.2609L12.8242 1.07931C12.8732 0.979878 12.9222 0.830748 12.8732 0.731318C12.8732 0.631918 12.7752 0.482758 12.6771 0.433058C12.5791 0.383358 12.4811 0.333628 12.432 0.333628C12.285 0.333628 12.1379 0.383358 12.0399 0.532488L9.44183 4.26091H8.46144L5.91244 0.532478C5.81439 0.383348 5.66734 0.333618 5.52026 0.333618C5.42224 0.333618 5.37321 0.383348 5.27516 0.433048C5.12811 0.532478 5.0791 0.631908 5.0791 0.731308C5.0791 0.880468 5.0791 0.979868 5.12811 1.0793L7.33399 4.26089L10.6183 4.2609Z'
            fill='currentColor'
          />
          <path
            d='M10.793 4.59425H7.15917L4.85351 1.26905C4.74609 1.05762 4.74609 0.89942 4.74609 0.73145C4.74609 0.57471 4.80566 0.34717 5.08984 0.15625L5.17578 0.10693C5.24805 0.06445 5.35742 0 5.52051 0C5.80469 0 6.04297 0.12402 6.19043 0.34961L8.6377 3.92725H9.26758L11.7666 0.34181C11.9746 0.02492 12.374 -0.09618 12.8281 0.13624C13.0156 0.23097 13.168 0.44776 13.2002 0.65382C13.2695 0.87159 13.1846 1.10157 13.123 1.22657L10.793 4.59425ZM10.0801 3.92726H10.4434L12.5498 0.88917C12.5508 0.87989 12.5596 0.83985 12.5596 0.82862L12.5254 0.7588L12.54 0.73146C12.4717 0.70265 12.418 0.67287 12.3789 0.66066C12.3506 0.66701 12.3311 0.69582 12.3184 0.71486L10.0801 3.92726ZM7.5078 3.92726H7.83007L5.63671 0.72022C5.62109 0.69581 5.60155 0.667 5.5205 0.667L5.42675 0.72999C5.4121 0.84083 5.41308 0.90382 5.42675 0.93165L7.5078 3.92726Z'
            fill='currentColor'
          />
          <path
            d='M16.0596 16.958H1.99121C0.89355 16.958 0 16.0571 0 14.9492V5.60352C0 4.49561 0.89355 3.59473 1.99121 3.59473H16.0107C17.1084 3.59473 18.001 4.49561 18.001 5.60352V14.9492C18.001 15.6982 17.6172 16.3618 16.9746 16.7236C16.9258 16.7534 16.5635 16.958 16.0596 16.958ZM1.99121 4.92773C1.62207 4.92773 1.33398 5.22461 1.33398 5.60351V14.9492C1.33398 15.3281 1.62207 15.625 1.99121 15.625H16.0107C16.2022 15.625 16.3135 15.5659 16.3144 15.5654C16.5439 15.4355 16.667 15.2183 16.667 14.9492V5.60352C16.667 5.22461 16.3789 4.92774 16.0107 4.92774L1.99121 4.92773ZM7.72656 12.7822C7.21386 12.7822 6.76465 12.3315 6.76465 11.8174V8.73535C6.76465 8.66357 6.77637 8.59228 6.79883 8.52441C6.94141 8.09716 7.43848 7.58349 8.09668 7.84326C8.16016 7.86084 8.22168 7.88769 8.27832 7.92383L10.6318 9.41504C10.9238 9.56055 11.1387 9.90234 11.1387 10.2764C11.1387 10.6206 10.958 10.9316 10.665 11.0986L8.32228 12.6006C8.09669 12.7822 7.85058 12.7822 7.72656 12.7822ZM8.09863 9.3872V11.1606L9.49121 10.2676L8.09863 9.3872ZM9.93359 10.5474C9.94629 10.5566 9.95898 10.5649 9.97265 10.5718L9.93359 10.5474Z'
            fill='currentColor'
          />
        </g>
        <defs>
          <clipPath id='clip0_7954_50194'>
            <rect width='18.001' height='16.958' fill='white' />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  );
}

export function MyMenuEvent(props: IconProps) {
  return (
    <IconWrapper
      {...props}
      style={{
        color: 'var(--colorIco01)',
      }}
    >
      <svg width='2em' height='2em' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_379_4165)'>
          <path
            d='M6.72012 4.86719L6.27539 5.91953L8.76309 6.8989L6.72012 4.86719Z'
            stroke='currentColor'
            strokeWidth='1.333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M15.2157 13.3156L8.7634 6.8988L6.2757 5.91943L4.82227 9.35883L15.0495 13.3851L15.2157 13.3156Z'
            stroke='currentColor'
            strokeWidth='1.333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M1.91602 16.2377L5.1648 17.5167L10.1074 15.4509L3.36944 12.7983L1.91602 16.2377Z'
            stroke='currentColor'
            strokeWidth='1.333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M2.149 18.7768L5.16384 17.5167L1.91505 16.2378L1.22881 17.8617C0.984868 18.4389 1.56855 19.0194 2.149 18.7768Z'
            stroke='currentColor'
            strokeWidth='1.333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M10.1071 15.4509L15.0498 13.3851L4.82263 9.35889L3.36914 12.7983L10.1071 15.4509Z'
            stroke='currentColor'
            strokeWidth='1.333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M16.5468 3.27969C17.1336 3.27969 17.6093 2.80664 17.6093 2.2231C17.6093 1.63956 17.1336 1.1665 16.5468 1.1665C15.96 1.1665 15.4844 1.63956 15.4844 2.2231C15.4844 2.80664 15.96 3.27969 16.5468 3.27969Z'
            fill='currentColor'
            stroke='currentColor'
            strokeWidth='1.333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M15.5293 8.01059L17.1799 6.36914L18.8304 8.01059L17.1799 9.65205L15.5293 8.01059Z'
            stroke='currentColor'
            strokeWidth='1.333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M10.9668 1.46094V3.98591'
            stroke='currentColor'
            strokeWidth='1.333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
        <defs>
          <clipPath id='clip0_379_4165'>
            <rect width='2em' height='2em' fill='white' />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  );
}
export function MyMenuExchange(props: IconProps) {
  return (
    <IconWrapper
      {...props}
      style={{
        color: 'var(--colorIco01)',
      }}
    >
      <svg width='2em' height='2em' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_379_4152)'>
          <path
            d='M19.8259 3.49996L17.671 1.34521C17.5618 1.23622 17.4154 1.17627 17.2582 1.17627C17.101 1.17627 16.9546 1.23622 16.8454 1.34521C16.6221 1.56906 16.6221 1.94692 16.8454 2.1706L18.0011 3.33287H14.447C14.1199 3.33287 13.8633 3.5893 13.8633 3.91644C13.8633 4.24374 14.1199 4.50017 14.447 4.50017H18.0005L16.8454 5.65488C16.7366 5.76386 16.6765 5.91047 16.6765 6.06766C16.6765 6.22468 16.7366 6.37128 16.8454 6.48027C16.9583 6.59278 17.1061 6.65492 17.2619 6.65492C17.4177 6.65492 17.5655 6.59279 17.6784 6.48027L19.8259 4.33274C19.9367 4.22157 20.0002 4.06993 20.0002 3.91644C20.0002 3.75254 19.9377 3.60408 19.8259 3.49996Z'
            fill='currentColor'
          />
          <path
            d='M11.2582 10.708L10.5201 13.9571C10.5073 14.0273 10.4867 14.0687 10.4577 14.0817C10.429 14.0945 10.3731 14.1009 10.2901 14.1009H9.45627C9.3731 14.1009 9.32056 14.0928 9.29822 14.0768C9.27568 14.0609 9.25823 14.0209 9.24547 13.9571L8.54586 10.708H7.93239L7.24235 13.9571C7.22959 14.0209 7.21193 14.0609 7.1896 14.0768C7.16726 14.0928 7.11451 14.1009 7.03155 14.1009H6.18814C6.09859 14.1009 6.04265 14.0928 6.02031 14.0768C5.99797 14.0609 5.98053 14.0209 5.96777 13.9571L5.22008 10.708H4.14673C4.07015 10.708 4.01889 10.6969 3.99336 10.6745C3.96784 10.6521 3.95508 10.5995 3.95508 10.5163V9.78799C3.95508 9.70503 3.96784 9.65228 3.99336 9.62984C4.01889 9.6075 4.07015 9.59623 4.14673 9.59623H4.971L4.47261 7.3153C4.45346 7.21948 4.45496 7.15566 4.47729 7.12365C4.49962 7.09174 4.56833 7.07568 4.68341 7.07568H5.45024C5.51406 7.07568 5.56192 7.08047 5.59382 7.09004C5.62573 7.09962 5.64806 7.1428 5.66104 7.21948L6.169 9.59623H7.08899L7.56823 7.21948C7.58099 7.14918 7.60333 7.1077 7.63524 7.09483C7.66714 7.08218 7.7182 7.07568 7.7886 7.07568H8.68008C8.75028 7.07568 8.80133 7.08217 8.83324 7.09483C8.86514 7.1077 8.88748 7.14918 8.90046 7.21948L9.39884 9.59623H10.338L10.8364 7.21948C10.8491 7.14918 10.8683 7.1077 10.8938 7.09483C10.9193 7.08218 10.9706 7.07568 11.0472 7.07568H11.8236C11.9257 7.07568 11.9848 7.09004 12.0008 7.11876C12.0167 7.14758 12.0152 7.2132 11.9961 7.3153L11.5264 9.59623H12.3124C12.4017 9.59623 12.4577 9.6092 12.48 9.63462C12.5023 9.66026 12.5136 9.7113 12.5136 9.78799V10.5163C12.5136 10.593 12.5023 10.6443 12.48 10.6697C12.4577 10.6953 12.4017 10.708 12.3124 10.708H11.2582ZM6.64824 12.136L6.88776 10.708H6.40852L6.64824 12.136ZM8.12405 9.59624H8.38292L8.2487 8.8008L8.12405 9.59624ZM9.8683 12.1456L10.108 10.708H9.61921L9.8683 12.1456Z'
            fill='currentColor'
          />
          <path
            d='M8.23539 18.8234C3.69425 18.8234 0 15.1292 0 10.5882C0 6.04729 3.69425 2.35303 8.23539 2.35303C12.7762 2.35303 16.4706 6.04728 16.4706 10.5882C16.4706 15.1292 12.7762 18.8234 8.23539 18.8234ZM8.23539 3.73443C4.45639 3.73444 1.38159 6.80905 1.38159 10.5882C1.38159 14.3674 4.45639 17.4418 8.23538 17.4418C12.0144 17.4418 15.0888 14.3672 15.0888 10.5882C15.0888 6.80924 12.0144 3.73443 8.23539 3.73443Z'
            fill='currentColor'
          />
        </g>
        <defs>
          <clipPath id='clip0_379_4152'>
            <rect width='2em' height='2em' fill='white' />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  );
}
export function MyMenuFanGrade(props: IconProps) {
  return (
    <IconWrapper
      {...props}
      style={{
        color: 'var(--colorIco01)',
      }}
    >
      <svg width='2em' height='2em' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_379_4294)'>
          <path
            d='M13.2627 8.32355L10.5825 3.66803C10.3261 3.22263 9.68336 3.22264 9.42695 3.66805L6.7452 8.32669L2.91204 5.67053C2.43525 5.34015 1.79318 5.73417 1.87182 6.30889L3.10286 15.3048C3.23587 16.0915 3.90149 16.6659 4.67986 16.6656L15.3205 16.662C16.0984 16.6617 16.7634 16.0876 16.8964 15.3013L18.1273 6.30973C18.206 5.73488 17.5637 5.34084 17.0869 5.67148L13.2627 8.32355Z'
            stroke='currentColor'
            strokeWidth='1.333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
        <defs>
          <clipPath id='clip0_379_4294'>
            <rect width='2em' height='2em' fill='white' />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  );
}
export function MyMenuFaq(props: IconProps) {
  return (
    <IconWrapper
      {...props}
      style={{
        color: 'var(--colorIco01)',
      }}
    >
      <svg width='2em' height='2em' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_379_4202)'>
          <path
            d='M9.99935 1.6665C14.5946 1.6665 18.3327 5.40458 18.3327 9.99984C18.3327 14.5948 14.5946 18.3332 9.99935 18.3332C5.4044 18.3332 1.66602 14.5948 1.66602 9.99984C1.66602 5.40458 5.4044 1.6665 9.99935 1.6665Z'
            stroke='currentColor'
            strokeWidth='1.333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M9.99838 15.198C10.5562 15.198 11.0085 14.7436 11.0085 14.183C11.0085 13.6224 10.5562 13.168 9.99838 13.168C9.44052 13.168 8.98828 13.6224 8.98828 14.183C8.98828 14.7436 9.44052 15.198 9.99838 15.198Z'
            fill='currentColor'
          />
          <path
            d='M7.85156 7.71454C7.85156 6.52718 8.81833 5.55566 10 5.55566C11.1817 5.55566 12.1484 6.52718 12.1484 7.71454C12.1484 8.52957 11.6117 9.12249 11.0251 9.61013C10 10.4622 10 10.7239 10 11.3127V11.8361'
            stroke='currentColor'
            strokeWidth='1.333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
        <defs>
          <clipPath id='clip0_379_4202'>
            <rect width='2em' height='2em' fill='white' />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  );
}
export function MyMenuGiftDetail(props: IconProps) {
  return (
    <IconWrapper
      {...props}
      style={{
        color: 'var(--colorIco01)',
      }}
    >
      <svg width='2em' height='2em' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_379_4098)'>
          <path
            d='M10.8999 15.9477H3.69727C2.59727 15.9477 1.69727 15.0477 1.69727 13.9477V4.01904C1.69727 2.91904 2.59727 2.01904 3.69727 2.01904H12.6418C13.7418 2.01904 14.6418 2.91904 14.6418 4.01904V10.138'
            stroke='currentColor'
            strokeWidth='1.3333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M4.52539 5.57959H10.6941'
            stroke='currentColor'
            strokeWidth='1.3333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M4.52539 8.42822H7.64929'
            stroke='currentColor'
            strokeWidth='1.3333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M13.9104 17.9813C12.8759 17.3935 11.7241 16.8551 10.6399 15.474C8.74587 13.0612 9.82642 11.1563 9.82642 11.1563C9.82642 11.1563 10.2806 10.0992 11.5758 10.0433C12.9943 9.98202 13.9104 11.5163 13.9104 11.5163C13.9104 11.5163 14.8266 9.98202 16.2451 10.0433C17.5403 10.0992 17.9945 11.1563 17.9945 11.1563C17.9945 11.1563 19.075 13.0612 17.181 15.474C16.0968 16.8551 14.945 17.3935 13.9104 17.9813Z'
            stroke='currentColor'
            strokeWidth='1.3333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
        <defs>
          <clipPath id='clip0_379_4098'>
            <rect width='2em' height='2em' fill='white' />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  );
}
export function MyMenuHartInfor(props: IconProps) {
  return (
    <IconWrapper
      {...props}
      style={{
        color: 'var(--colorIco01)',
      }}
    >
      <svg width='2em' height='2em' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_379_4279)'>
          <path
            d='M4.72266 13.1989C4.88245 12.9282 5.7661 11.7583 7.27104 11.7583H12.0926C13.0902 11.7727 13.919 12.7656 14.0223 13.7073'
            stroke='currentColor'
            strokeWidth='1.333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M9.03906 14.6329H11.7376C12.252 14.6329 12.7542 14.4895 13.1774 14.2216L16.5799 12.0679C17.2762 11.6272 18.2684 11.8675 18.7329 12.5283C19.1973 13.1891 19.05 14.1507 18.3536 14.5914L14.385 17.615C13.9829 17.8695 13.513 18.0107 13.0298 18.0221H4.72266'
            stroke='currentColor'
            strokeWidth='1.333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M3.17095 11.6021H2.33333C1.59695 11.6021 1 12.199 1 12.9354V17.1474C1 17.8838 1.59695 18.4807 2.33333 18.4807H3.17095C3.90733 18.4807 4.50428 17.8838 4.50428 17.1474V12.9354C4.50428 12.199 3.90733 11.6021 3.17095 11.6021Z'
            stroke='currentColor'
            strokeWidth='1.333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M10.0001 9.30199C8.98447 8.72583 7.85371 8.19809 6.78934 6.84435C4.92994 4.47944 5.99073 2.61228 5.99073 2.61228C5.99073 2.61228 6.43657 1.57612 7.70809 1.52128C9.10067 1.46122 10.0001 2.96506 10.0001 2.96506C10.0001 2.96506 10.8994 1.46122 12.292 1.52128C13.5636 1.57612 14.0094 2.61228 14.0094 2.61228C14.0094 2.61228 15.0702 4.47944 13.2108 6.84435C12.1464 8.19808 11.0157 8.72583 10.0001 9.30199Z'
            stroke='currentColor'
            strokeWidth='1.333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
        <defs>
          <clipPath id='clip0_379_4279'>
            <rect width='2em' height='2em' fill='white' />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  );
}
export function MyMenuItemDetail(props: IconProps) {
  return (
    <IconWrapper
      {...props}
      style={{
        color: 'var(--colorIco01)',
      }}
    >
      <svg width='2em' height='2em' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_379_4015)'>
          <path
            d='M17.2615 16.5242C17.3221 17.6225 16.4717 18.5211 15.3717 18.5211H4.62927C3.52927 18.5211 2.67881 17.6225 2.73937 16.5242L3.18967 8.35732C3.25023 7.25898 4.19977 6.36035 5.29977 6.36035H14.7011C15.8011 6.36035 16.7507 7.25898 16.8112 8.35732L17.2615 16.5242Z'
            stroke='currentColor'
            strokeWidth='1.3333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M7.00586 7.57246V4.72317C7.00586 3.04958 8.34677 1.69287 10.0008 1.69287C11.6549 1.69287 12.9958 3.04959 12.9958 4.72317V7.57246'
            stroke='currentColor'
            strokeWidth='1.3333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
        <defs>
          <clipPath id='clip0_379_4015'>
            <rect width='2em' height='2em' fill='white' />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  );
}
export function MyMenuLawConsult(props: IconProps) {
  return (
    <IconWrapper
      {...props}
      style={{
        color: 'var(--colorIco01)',
      }}
    >
      <svg width='2em' height='2em' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_379_4213)'>
          <path
            d='M17.9429 4.75738L11.0509 1.53458C10.3836 1.22154 9.61753 1.22154 8.95112 1.53458L2.05864 4.75738C1.4889 5.02338 1.19761 5.6144 1.33406 6.22765C1.47051 6.84176 1.98464 7.25402 2.61341 7.25402H17.3882C18.0169 7.25402 18.5311 6.84176 18.6675 6.22765C18.804 5.6144 18.5127 5.02338 17.9429 4.75738ZM17.898 6.05659C17.854 6.25417 17.697 6.46543 17.3881 6.46543H2.61341C2.30459 6.46543 2.14761 6.25417 2.10355 6.05659C2.05992 5.85901 2.11253 5.60157 2.39227 5.4707L9.28476 2.24791C9.51189 2.14185 9.75655 2.08882 10.0008 2.08882C10.245 2.08882 10.4893 2.14185 10.7168 2.24791L17.6093 5.47071C17.889 5.60157 17.9416 5.85901 17.898 6.05659Z'
            fill='currentColor'
            stroke='currentColor'
            strokeWidth='0.6'
            strokeMiterlimit='10'
          />
          <path
            d='M2.11133 15.8948C2.11133 16.112 2.28798 16.2891 2.5057 16.2891H17.4935C17.7112 16.2891 17.8878 16.112 17.8878 15.8948C17.8878 15.6775 17.7112 15.5005 17.4935 15.5005H2.5057C2.28798 15.5005 2.11133 15.6775 2.11133 15.8948Z'
            fill='currentColor'
            stroke='currentColor'
            strokeWidth='0.6'
            strokeMiterlimit='10'
          />
          <path
            d='M18.0451 17.542H1.95296C1.73524 17.542 1.55859 17.719 1.55859 17.9363C1.55859 18.1535 1.73524 18.3306 1.95296 18.3306H18.0451C18.2628 18.3306 18.4395 18.1535 18.4395 17.9363C18.4395 17.719 18.2628 17.542 18.0451 17.542Z'
            fill='currentColor'
            stroke='currentColor'
            strokeWidth='0.6'
            strokeMiterlimit='10'
          />
          <path
            d='M3.61101 13.8166V8.93873C3.61101 8.72148 3.43436 8.54443 3.21664 8.54443C2.99892 8.54443 2.82227 8.72148 2.82227 8.93873V13.8166C2.82227 14.0339 2.99892 14.2109 3.21664 14.2109C3.43436 14.2109 3.61101 14.0339 3.61101 13.8166Z'
            fill='currentColor'
            stroke='currentColor'
            strokeWidth='0.6'
            strokeMiterlimit='10'
          />
          <path
            d='M8.13249 13.8166V8.93873C8.13249 8.72148 7.95584 8.54443 7.73812 8.54443C7.5204 8.54443 7.34375 8.72148 7.34375 8.93873V13.8166C7.34375 14.0339 7.5204 14.2109 7.73812 14.2109C7.95584 14.2109 8.13249 14.0339 8.13249 13.8166Z'
            fill='currentColor'
            stroke='currentColor'
            strokeWidth='0.6'
            strokeMiterlimit='10'
          />
          <path
            d='M12.6559 13.8166V8.93873C12.6559 8.72148 12.4793 8.54443 12.2616 8.54443C12.0438 8.54443 11.8672 8.72148 11.8672 8.93873V13.8166C11.8672 14.0339 12.0438 14.2109 12.2616 14.2109C12.4793 14.2109 12.6559 14.0339 12.6559 13.8166Z'
            fill='currentColor'
            stroke='currentColor'
            strokeWidth='0.6'
            strokeMiterlimit='10'
          />
          <path
            d='M17.1774 13.8166V8.93873C17.1774 8.72148 17.0008 8.54443 16.783 8.54443C16.5653 8.54443 16.3887 8.72148 16.3887 8.93873V13.8166C16.3887 14.0339 16.5653 14.2109 16.783 14.2109C17.0008 14.2109 17.1774 14.0339 17.1774 13.8166Z'
            fill='currentColor'
            stroke='currentColor'
            strokeWidth='0.6'
            strokeMiterlimit='10'
          />
        </g>
        <defs>
          <clipPath id='clip0_379_4213'>
            <rect width='18' height='17.6304' fill='white' transform='translate(1 1)' />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  );
}
export function MyMenuLogout(props: IconProps) {
  return (
    <IconWrapper
      {...props}
      style={{
        color: 'var(--colorIco01)',
      }}
    >
      <svg width='2em' height='2em' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_379_4258)'>
          <path
            d='M12.6952 14.2624V15.167C12.6952 16.3608 11.7376 17.3375 10.5672 17.3375H3.79402C2.62361 17.3375 1.66602 16.3608 1.66602 15.167V4.83305C1.66602 3.63931 2.62361 2.6626 3.79402 2.6626H10.5672C11.7376 2.6626 12.6952 3.63932 12.6952 4.83305V5.66713'
            stroke='currentColor'
            strokeWidth='1.333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M15.5137 7.12451L18.3328 9.99987L15.5137 12.8752'
            stroke='currentColor'
            strokeWidth='1.333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M18.333 10H7.66797'
            stroke='currentColor'
            strokeWidth='1.333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
        <defs>
          <clipPath id='clip0_379_4258'>
            <rect width='2em' height='2em' fill='white' />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  );
}
export function MyMenuMemModify(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper
      style={{
        color: 'var(--colorIco01)',
        ...style,
      }}
      {...rest}
    >
      <svg width='2em' height='2em' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_379_4377)'>
          <path
            d='M16.9091 4.96241L12.4091 1.17956C12.1364 0.906098 11.6364 0.951678 11.3636 1.27071L1.77273 12.4825C1.68182 12.5737 1.59091 12.7104 1.59091 12.8927L1 18.1796C1 18.5898 1.27273 18.9544 1.63636 19C1.72727 19 1.86363 19 1.90909 18.9544L7.04547 17.496C7.18183 17.4504 7.3182 17.3592 7.40911 17.2681L16.9546 6.05625C17.2273 5.69164 17.1818 5.23587 16.9091 4.96241ZM15.3636 5.64606L13.4545 7.87931L10.0454 5.00798L11.9545 2.72916L15.3636 5.64606ZM2.5909 17.1769L3.04545 13.2118L9.09091 6.10183L12.5 8.97316L6.45454 16.0831L2.5909 17.1769Z'
            fill='currentColor'
          />
          <path
            d='M18.3182 17.6328H10.1818C9.81819 17.6328 9.5 17.9518 9.5 18.3165C9.5 18.6811 9.81819 19.0001 10.1818 19.0001H18.3182C18.6818 19.0001 19 18.6811 19 18.3165C18.9546 17.9063 18.6818 17.6328 18.3182 17.6328Z'
            fill='currentColor'
          />
        </g>
      </svg>
    </IconWrapper>
  );
}
export function MyMenuMessage({ style, ...rest }: IconProps) {
  return (
    <IconWrapper
      {...rest}
      style={{
        color: 'var(--colorIco01)',
        ...style,
      }}
    >
      <svg width='2em' height='2em' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_379_4412)'>
          <path
            d='M4.54297 1.73486L15.429 11.6433'
            stroke='currentColor'
            strokeWidth='1.46429'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M9.97656 6.6813L15.2388 1.8916'
            stroke='currentColor'
            strokeWidth='1.46429'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M9.97752 6.68115L3.2489 12.8349C2.80587 13.2382 2.7817 13.8816 3.22473 14.2848L6.88177 17.9629C7.3248 18.3662 8.04311 18.3662 8.48614 17.9629L15.4293 11.6433L9.97752 6.68115Z'
            stroke='currentColor'
            strokeWidth='1.46429'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M16.7606 12.8416L15.4283 11.6431L9.97656 16.6052L11.4565 17.9522C11.8995 18.3555 12.6178 18.3555 13.0608 17.9522L16.7606 14.3019C17.2036 13.8987 17.2036 13.2448 16.7606 12.8416Z'
            stroke='currentColor'
            strokeWidth='1.46429'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M4.54297 11.6433V1.73486H15.429V11.6433'
            stroke='currentColor'
            strokeWidth='1.46429'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
      </svg>
    </IconWrapper>
  );
}
export function MyMenuMissionlist(props: IconProps) {
  return (
    <IconWrapper
      {...props}
      style={{
        color: 'var(--colorIco01)',
      }}
    >
      <svg width='2em' height='2em' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_4976_58479)'>
          <path
            d='M9.12872 15.9395H3.69819C2.59876 15.9395 1.69922 15.04 1.69922 13.9405V4.01899C1.69922 2.91956 2.59876 2.02002 3.69819 2.02002H12.6402C13.7397 2.02002 14.6392 2.91956 14.6392 4.01899V9.11636'
            stroke='currentColor'
            strokeWidth='1.33'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M4.5293 8.43018H7.6532'
            stroke='currentColor'
            strokeWidth='1.3333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M4.5293 5.58008H10.698'
            stroke='currentColor'
            strokeWidth='1.3333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <g clipPath='url(#clip1_4976_58479)'>
            <path
              d='M18.8413 12.0847L19.523 11.403C19.523 11.403 19.5826 11.3008 19.5656 11.2411C19.5485 11.1815 19.5059 11.1389 19.4548 11.1133L18.279 10.7129L17.8785 9.53704C17.8615 9.47739 17.8103 9.43479 17.7507 9.42627C17.7337 9.42627 17.7251 9.42627 17.7081 9.42627C17.6655 9.42627 17.6144 9.44331 17.5888 9.47739L16.9072 10.159L16.7367 10.0738C16.0295 9.70745 15.2371 9.52 14.4447 9.52C13.107 9.52 11.8374 10.0397 10.8917 10.994C8.93194 12.9538 8.93194 16.1404 10.8917 18.1002C11.8374 19.0459 13.0985 19.5742 14.4447 19.5742C15.791 19.5742 17.052 19.0545 17.9978 18.1002C19.5485 16.5494 19.9149 14.2063 18.918 12.2551L18.8328 12.0847H18.8413ZM17.6484 9.92046L17.9722 10.8833L17.9978 10.9344L18.0148 10.9685L18.0404 10.9855L18.066 11.0026H18.0915L19.0799 11.3519L17.9807 12.4511L16.7623 12.2295L16.5408 11.0111L17.6399 9.90342L17.6484 9.92046ZM17.7677 17.8531C16.8816 18.7392 15.7143 19.2249 14.4618 19.2249C13.2092 19.2249 12.0334 18.7392 11.1558 17.8531C9.31537 16.0297 9.31537 13.0645 11.1388 11.2326C12.0249 10.3465 13.2007 9.86082 14.4447 9.86082C15.0838 9.86082 15.7143 9.98862 16.3022 10.2442L16.6601 10.3976L16.2255 10.8322C16.2255 10.8322 16.1659 10.9259 16.1744 10.9855L16.413 12.3232L16.0295 12.7067L15.8421 12.5789C15.4331 12.2806 14.9474 12.1273 14.4362 12.1273C13.7886 12.1273 13.1837 12.3744 12.7321 12.8345C11.7948 13.7803 11.7948 15.3054 12.7321 16.2512C13.1837 16.7028 13.7972 16.9584 14.4362 16.9584C15.0752 16.9584 15.6887 16.7113 16.1403 16.2512C16.6004 15.7996 16.8475 15.1861 16.8475 14.5471C16.8475 14.0444 16.6941 13.5587 16.3959 13.1497L16.2681 12.9623L16.6515 12.5789L17.9893 12.8174C17.9893 12.8174 18.0063 12.8174 18.0233 12.8174C18.066 12.8174 18.1171 12.8004 18.1426 12.7663L18.5772 12.3318L18.7306 12.6896C19.4974 14.4619 19.1055 16.4813 17.7422 17.8531H17.7677ZM14.351 14.6579C14.351 14.6579 14.4277 14.709 14.4788 14.709C14.5299 14.709 14.5725 14.692 14.5981 14.6579L16.0551 13.2009L16.234 13.4991C16.4215 13.8229 16.5237 14.1807 16.5237 14.5556C16.5237 15.1095 16.3107 15.6292 15.9188 16.0126C15.5268 16.3961 15.0071 16.6176 14.4618 16.6176C13.9165 16.6176 13.3882 16.4046 13.0048 16.0126C12.1953 15.2032 12.1953 13.8995 13.0048 13.0901C13.3967 12.6982 13.9165 12.4851 14.4618 12.4851C14.8367 12.4851 15.2031 12.5874 15.5183 12.7748L15.8165 12.9538L14.3595 14.4108C14.2914 14.4789 14.2914 14.5897 14.3595 14.6579H14.351Z'
              fill='currentColor'
            />
            <path
              d='M14.453 20C12.996 20 11.6241 19.4291 10.5932 18.4067C8.47155 16.2765 8.47155 12.8172 10.5932 10.6871C11.6241 9.65608 12.996 9.08521 14.453 9.08521C15.2709 9.08521 16.0974 9.27266 16.8302 9.63904L17.2903 9.17893C17.4011 9.06816 17.5544 9 17.7163 9H17.8356C18.0486 9.05964 18.219 9.21301 18.2787 9.40899L18.611 10.3803L19.5823 10.7126C19.7783 10.7808 19.9317 10.9427 19.9743 11.1472C20.0169 11.3517 19.9572 11.5647 19.8124 11.7095L19.3523 12.1696C20.3662 14.2657 19.9487 16.7537 18.2957 18.4067C17.2647 19.4376 15.9014 20 14.4359 20H14.453ZM14.453 10.2951C13.3197 10.2951 12.2547 10.7382 11.4452 11.5391C9.78371 13.2006 9.78371 15.9016 11.4452 17.5546C12.2461 18.3555 13.3197 18.7986 14.453 18.7986C15.5862 18.7986 16.6598 18.3555 17.4607 17.5546C18.6451 16.3703 19.02 14.6406 18.4491 13.0813C18.3383 13.1836 18.1935 13.2432 18.0401 13.2432H17.9379L16.8643 13.0387C17.1454 13.4903 17.2988 14.0015 17.2988 14.5383C17.2988 15.2967 17.0006 16.0124 16.4638 16.5492C15.3902 17.6228 13.5157 17.6228 12.4506 16.5492C11.3856 15.4756 11.343 13.6352 12.4506 12.5275C13.3623 11.6158 14.879 11.4539 15.9611 12.127L15.7651 11.062C15.731 10.8745 15.7907 10.6785 15.9185 10.5422C15.4499 10.3633 14.9557 10.2781 14.4444 10.2781L14.453 10.2951ZM14.453 12.9109C14.0184 12.9109 13.6009 13.0813 13.2942 13.3881C12.6551 14.0271 12.6551 15.0666 13.2942 15.7057C13.9162 16.3191 14.9983 16.3191 15.6118 15.7057C15.9185 15.3989 16.0889 14.9814 16.0889 14.5469C16.0889 14.3253 16.0463 14.1038 15.9526 13.8908L14.8875 14.9558C14.666 15.1774 14.2655 15.1859 14.044 14.9558C13.9332 14.8451 13.865 14.6917 13.865 14.5298C13.865 14.3679 13.9247 14.2146 14.044 14.1038L15.109 13.0387C14.9045 12.945 14.683 12.9024 14.453 12.9024V12.9109ZM17.1284 11.8799L17.8356 12.0077L18.2957 11.5476L17.6396 11.1898L17.563 11.0364L17.4607 10.7211L17.0006 11.1813L17.1284 11.8885V11.8799Z'
              fill='currentColor'
            />
          </g>
        </g>
        <defs>
          <clipPath id='clip0_4976_58479'>
            <rect width='2em' height='2em' fill='white' />
          </clipPath>
          <clipPath id='clip1_4976_58479'>
            <rect width='11' height='11' fill='white' transform='translate(9 9)' />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  );
}
export function MyMenuMyheart(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper {...rest} style={{ color: 'var(--colorIco01)', ...style }}>
      <svg width='2em' height='2em' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_379_4401)'>
          <path
            d='M10 18.1187C9.85237 18.1187 9.70473 18.0814 9.57192 18.007C9.35418 17.8848 9.13301 17.7639 8.91014 17.6416C7.14823 16.676 5.15148 15.5813 3.26759 13.2135C-0.401019 8.60267 1.42587 4.84429 1.66756 4.39455C1.83457 4.04599 2.92786 2.00135 5.64625 1.88564C7.64927 1.799 9.15981 3.06528 10 4.00865C10.8402 3.06528 12.3696 1.79814 14.3538 1.88564C17.0722 2.00135 18.1654 4.04599 18.3325 4.39455C18.5742 4.84429 20.401 8.60267 16.7324 13.2138C14.8485 15.5813 12.8518 16.676 11.0899 17.6416C10.867 17.7639 10.6458 17.8848 10.4281 18.007C10.2953 18.0814 10.1476 18.1187 10 18.1187ZM5.83435 3.63273C5.79673 3.63273 5.75854 3.63359 5.72035 3.63501C3.89346 3.71282 3.25733 5.12645 3.25104 5.1407C3.23851 5.17034 3.22369 5.19941 3.20773 5.22763C3.14275 5.34448 1.57977 8.27976 4.63789 12.1234C6.30176 14.2153 8.05568 15.1766 9.75204 16.106C9.83469 16.1516 9.91734 16.197 10 16.2423C10.0827 16.197 10.1653 16.1516 10.248 16.106C11.9443 15.1766 13.6983 14.2153 15.3621 12.1237C18.4579 8.23217 16.8094 5.25728 16.7923 5.22764C16.7763 5.19942 16.7615 5.17035 16.749 5.14071C16.725 5.08998 16.0712 3.7114 14.2797 3.63502C12.2014 3.5632 10.7621 5.88001 10.7479 5.90338C10.5883 6.16302 10.305 6.32234 10.0006 6.32234H9.99829C9.69276 6.32148 9.4089 6.16245 9.251 5.90139C9.23789 5.8803 7.83623 3.63273 5.83435 3.63273Z'
            fill='currentColor'
          />
        </g>
      </svg>
    </IconWrapper>
  );
}
export function MyMenuMypage(props: IconProps) {
  return (
    <IconWrapper
      {...props}
      style={{
        color: 'var(--colorIco01)',
      }}
    >
      <svg width='2em' height='2em' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_5005_15894)'>
          <g clipPath='url(#clip1_5005_15894)'>
            <path
              d='M11.1526 10.4497C12.8887 9.86826 14.1381 8.21877 14.1381 6.33836C14.1381 3.94661 12.1918 1.99609 9.79588 1.99609C7.4 1.99609 5.45773 3.94661 5.45773 6.34249C5.45773 8.25589 6.68247 9.88063 8.43505 10.4538C5.27629 11.093 3 13.8971 3 17.3445C3 17.7074 3.29278 18.0002 3.65567 18.0002C4.01856 18.0002 4.31134 17.7074 4.31134 17.3445C4.31134 14.0786 6.6701 11.6167 9.79588 11.6167C12.9217 11.6167 15.2804 14.0786 15.2804 17.3445C15.2804 17.7074 15.5732 18.0002 15.9361 18.0002C16.299 18.0002 16.5918 17.7074 16.5918 17.3445C16.5918 13.893 14.3113 11.0889 11.1485 10.4497H11.1526ZM9.79588 3.31156C11.466 3.31156 12.8227 4.66826 12.8227 6.33836C12.8227 8.00847 11.466 9.36517 9.79588 9.36517C8.12577 9.36517 6.76907 8.00847 6.76907 6.33836C6.76907 4.66826 8.12577 3.31156 9.79588 3.31156Z'
              fill='currentColor'
            />
          </g>
        </g>
        <defs>
          <clipPath id='clip0_5005_15894'>
            <rect width='2em' height='2em' fill='white' />
          </clipPath>
          <clipPath id='clip1_5005_15894'>
            <rect width='13.5918' height='16' fill='white' transform='translate(3 2)' />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  );
}
export function MyMenuNotice(props: IconProps) {
  return (
    <IconWrapper
      {...props}
      style={{
        color: 'var(--colorIco01)',
      }}
    >
      <svg width='2em' height='2em' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_379_4174)'>
          <path
            d='M6.18945 10.4575H13.8107'
            stroke='currentColor'
            strokeWidth='1.333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M6.18945 13.8232H13.8107'
            stroke='currentColor'
            strokeWidth='1.333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M17.3412 7.39243V16.3332C17.3412 17.4377 16.4458 18.3332 15.3412 18.3332H4.66016C3.55559 18.3332 2.66016 17.4377 2.66016 16.3332V3.6665C2.66016 2.56194 3.55559 1.6665 4.66016 1.6665H11.4075L17.3412 7.39243Z'
            stroke='currentColor'
            strokeWidth='1.333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M17.3419 7.39243H13.4082C12.3036 7.39243 11.4082 6.497 11.4082 5.39243V1.6665L17.3419 7.39243Z'
            stroke='currentColor'
            strokeWidth='1.333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
        <defs>
          <clipPath id='clip0_379_4174'>
            <rect width='2em' height='2em' fill='white' />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  );
}
export function MyMenuPayDetail(props: IconProps) {
  return (
    <IconWrapper
      {...props}
      style={{
        color: 'var(--colorIco01)',
      }}
    >
      <svg width='2em' height='2em' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_379_4009)'>
          <path
            d='M16.9438 13.8854V16.356C16.9438 17.0894 16.3438 17.6894 15.6105 17.6894H3.0549C2.28784 17.6894 1.66602 17.0634 1.66602 16.2913V3.70906C1.66602 2.93696 2.28784 2.31104 3.0549 2.31104H14.2216C14.9549 2.31104 15.5549 2.90121 15.5549 3.62253V4.93402'
            stroke='currentColor'
            strokeWidth='1.3333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M18.3331 12.1635C18.3331 12.8968 17.7331 13.4968 16.9998 13.4968H13.472C12.3214 13.4968 11.3887 12.558 11.3887 11.3998C11.3887 10.2416 12.3214 9.30273 13.472 9.30273H16.9998C17.7331 9.30273 18.3331 9.90273 18.3331 10.6361V12.1635Z'
            stroke='currentColor'
            strokeWidth='1.3333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M1.66602 3.70898C1.66602 4.48109 2.28784 5.10701 3.0549 5.10701H15.6105C16.3438 5.10701 16.9438 5.70701 16.9438 6.44034V9.30278'
            stroke='currentColor'
            strokeWidth='1.3333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
        <defs>
          <clipPath id='clip0_379_4009'>
            <rect width='2em' height='2em' fill='white' />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  );
}
export function MyMenuReportCenter(props: IconProps) {
  return (
    <IconWrapper
      {...props}
      style={{
        color: 'var(--colorIco01)',
      }}
    >
      <svg width='2em' height='2em' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_379_4240)'>
          <path
            d='M2.5957 18.3332V2.29155C2.5957 1.94634 2.87466 1.6665 3.21877 1.6665H16.6201C17.3535 1.6665 17.6208 2.16585 17.2143 2.77616L14.7697 6.44582C14.6297 6.65604 14.6297 6.93018 14.7697 7.1404L17.2143 10.8101C17.6208 11.4204 17.3535 11.9197 16.6201 11.9197H2.5957'
            stroke='currentColor'
            strokeWidth='1.333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
        <defs>
          <clipPath id='clip0_379_4240'>
            <rect width='2em' height='2em' fill='white' />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  );
}
export function MyMenuSignature(props: IconProps) {
  return (
    <IconWrapper
      {...props}
      style={{
        color: 'var(--colorIco01)',
      }}
    >
      <svg width='2em' height='2em' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_379_4104)'>
          <path
            d='M14.0409 12.7056C12.4055 14.798 10.6906 15.7551 9.0324 16.6802C8.92367 16.7408 8.8156 16.8006 8.70818 16.8612C8.60076 16.8006 8.49333 16.7408 8.38461 16.6802C6.72576 15.7551 5.01059 14.7987 3.37517 12.7056C0.321139 8.7987 1.90643 5.79936 1.97316 5.67761C1.98357 5.65873 1.99529 5.63529 2.00376 5.61641C2.03143 5.55391 2.70331 4.09362 4.55519 4.01354C4.59491 4.01159 4.63397 4.01094 4.67303 4.01094C6.71373 4.01094 8.1216 6.31562 8.13527 6.33776C8.25507 6.53958 8.47251 6.66262 8.70689 6.66328H8.70884C8.94257 6.66328 9.16001 6.53958 9.28045 6.33906C9.29543 6.31562 10.7479 3.91978 12.8612 4.01354C13.3228 4.03352 13.7108 4.13939 14.034 4.28775L15.176 3.40103C14.6173 3.02452 13.877 2.72301 12.9191 2.68151C10.9289 2.59883 9.46535 3.95495 8.70819 4.8664C7.95167 3.9543 6.47674 2.59687 4.49757 2.68151C1.94223 2.79219 0.934746 4.75312 0.795752 5.05195C0.586119 5.44583 -1.16974 9.05651 2.32473 13.5266C4.12583 15.8319 6.04347 16.9016 7.73553 17.8449C7.95168 17.9654 8.16652 18.0852 8.37811 18.2056C8.48033 18.2642 8.59426 18.2935 8.70819 18.2935C8.82213 18.2935 8.93606 18.2642 9.03892 18.2056C9.25051 18.0852 9.4647 17.9654 9.6815 17.8443C11.3736 16.9009 13.2902 15.8313 15.0917 13.5272C16.6089 11.5862 17.135 9.8083 17.2289 8.38435L15.6599 9.60294C15.4045 10.5333 14.9199 11.5812 14.0409 12.7056Z'
            fill='currentColor'
          />
          <path
            d='M9.61386 11.0127L10.2994 8.87602L15.1095 5.14087C14.8913 4.86271 14.5471 4.52307 14.0341 4.2876L9.31894 7.94893C9.21282 8.03161 9.13404 8.14424 9.09302 8.27185L8.04745 11.529C7.98039 11.738 8.02076 11.9665 8.15487 12.1403C8.28117 12.3044 8.47648 12.3995 8.68222 12.3995C8.69458 12.3995 8.70696 12.3988 8.71932 12.3982L12.1132 12.2074C12.2486 12.2002 12.3782 12.1514 12.4849 12.0687L15.66 9.60278C15.8523 8.9021 15.9183 8.2662 15.9044 7.72481L11.8313 10.8884L9.61386 11.0127Z'
            fill='currentColor'
          />
          <path
            d='M19.6858 5.63684L17.3382 2.57109C17.2301 2.43046 17.0706 2.33801 16.8942 2.31523C16.719 2.29635 16.5413 2.34127 16.4 2.44999L15.1758 3.40063C15.6088 3.69246 15.9298 4.02811 16.161 4.32389L16.6878 3.91483L18.2249 5.92199L17.1535 6.75415C17.2298 7.22103 17.2693 7.76924 17.2287 8.38395L19.5654 6.56913C19.8551 6.34452 19.9085 5.92786 19.6858 5.63684Z'
            fill='currentColor'
          />
          <path
            d='M17.154 6.75439L15.9045 7.72481C15.9185 8.26619 15.8525 8.9021 15.6602 9.60279L17.2292 8.3842C17.2697 7.76949 17.2302 7.22127 17.154 6.75439Z'
            fill='currentColor'
          />
          <path
            d='M15.1086 5.14087L16.1604 4.32414C15.9292 4.02837 15.6082 3.69271 15.1752 3.40088L14.0332 4.2876C14.5462 4.52307 14.8904 4.86271 15.1086 5.14087Z'
            fill='currentColor'
          />
        </g>
        <defs>
          <clipPath id='clip0_379_4104'>
            <rect width='2em' height='2em' fill='white' />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  );
}
export function MyMenuStore(props: IconProps) {
  return (
    <IconWrapper
      {...props}
      style={{
        color: 'var(--colorIco01)',
      }}
    >
      <svg width='2em' height='2em' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_379_3991)'>
          <path
            d='M10.0047 10.396C11.5715 10.396 12.57 9.22716 12.57 7.66631L12.4988 2.16602H7.51058L7.43945 7.66631C7.43931 9.32438 8.43791 10.396 10.0047 10.396Z'
            stroke='currentColor'
            strokeWidth='1.3333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M4.58797 10.396C5.99886 10.396 7.26809 9.28986 7.40848 7.93791L7.45974 6.12274L7.50782 2.16602H4.1936C3.1881 2.16602 2.33872 2.90856 2.20854 3.90559C2.1645 4.24289 1.76746 7.39467 1.76746 7.39467C1.59605 9.0454 2.86527 10.396 4.58797 10.396Z'
            stroke='currentColor'
            strokeWidth='1.3333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M15.412 10.396C14.0011 10.396 12.7319 9.28986 12.5915 7.93791L12.5508 6.14383L12.4922 2.16602H15.8064C16.8119 2.16602 17.6613 2.90856 17.7915 3.90559C17.8355 4.24289 18.2325 7.39467 18.2325 7.39467C18.404 9.0454 17.1347 10.396 15.412 10.396Z'
            stroke='currentColor'
            strokeWidth='1.3333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M17.5011 9.44434V15.9587C17.5011 17.0587 16.6011 17.9587 15.5011 17.9587H4.5C3.4 17.9587 2.5 17.0587 2.5 15.9587V9.44434'
            stroke='currentColor'
            strokeWidth='1.3333'
            strokeLinejoin='round'
          />
        </g>
        <defs>
          <clipPath id='clip0_379_3991'>
            <rect width='2em' height='2em' fill='white' />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  );
}
export function MyMenuSub(props: IconProps) {
  return (
    <IconWrapper
      {...props}
      style={{
        color: 'var(--colorIco01)',
      }}
    >
      <svg width='2em' height='2em' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_5567_62271)'>
          <path
            d='M8.04859 13.9215C7.81779 13.9215 7.57694 13.8513 7.37624 13.7007C7.02501 13.4499 6.85441 13.0184 6.92466 12.5969L7.19561 11.0515L6.06164 9.95765C5.75055 9.65659 5.64016 9.21505 5.77062 8.79357C5.90108 8.38213 6.25231 8.08108 6.69385 8.02087L8.25933 7.79006L8.96179 6.38514C9.15246 5.99377 9.54383 5.75293 9.97534 5.75293C10.4068 5.75293 10.7982 5.99377 10.9889 6.38514L11.6913 7.79006L13.2568 8.02087C13.6883 8.08108 14.0396 8.38213 14.1801 8.79357C14.3105 9.20501 14.2001 9.64656 13.889 9.95765L12.7551 11.0515L13.026 12.5969C13.0963 13.0284 12.9257 13.4499 12.5744 13.7007C12.2232 13.9617 11.7616 13.9918 11.3803 13.7911L9.97534 13.0585L8.57042 13.7911C8.39982 13.8814 8.21919 13.9215 8.03856 13.9215H8.04859ZM7.28592 9.29533L8.32958 10.2988C8.52024 10.4795 8.60052 10.7404 8.56038 10.9913L8.30951 12.4263L9.61407 11.7439C9.83485 11.6235 10.1158 11.6235 10.3366 11.7439L11.6412 12.4263L11.3903 10.9913C11.3401 10.7404 11.4304 10.4795 11.6211 10.2988L12.6647 9.29533L11.2197 9.08459C10.9688 9.04445 10.748 8.89392 10.6377 8.66312L9.98537 7.34851L9.33309 8.66312C9.21267 8.89392 8.99189 9.05449 8.74102 9.09463L7.29596 9.30536L7.28592 9.29533Z'
            fill='currentColor'
          />
          <path
            d='M17.9127 18.2268H2.14752C0.943302 18.2268 0 17.2032 0 15.8986V4.32815C0 3.02358 0.943302 2 2.14752 2H17.8625C19.0667 2 20.01 3.02358 20.01 4.32815V15.8986C20.01 16.7617 19.5986 17.5243 18.9162 17.9458C18.8761 17.9759 18.4747 18.2368 17.9127 18.2368V18.2268ZM2.14752 3.33467C1.70597 3.33467 1.33467 3.77622 1.33467 4.32815V15.8986C1.33467 16.4506 1.69594 16.8921 2.14752 16.8921H17.9127C18.0733 16.8921 18.1937 16.8118 18.2037 16.8118C18.5048 16.6312 18.6754 16.29 18.6754 15.8986V4.32815C18.6754 3.76618 18.3241 3.33467 17.8625 3.33467H2.14752Z'
            fill='currentColor'
          />
        </g>
        <defs>
          <clipPath id='clip0_5567_62271'>
            <rect width='2em' height='16.2268' fill='white' transform='translate(0 2)' />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  );
}
export function MyMenuSubList(props: IconProps) {
  return (
    <IconWrapper
      {...props}
      style={{
        color: 'var(--colorIco01)',
      }}
    >
      <svg width='2em' height='2em' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M7.00315 15.9395H3.69819C2.59876 15.9395 1.69922 15.04 1.69922 13.9405V4.01899C1.69922 2.91956 2.59876 2.02002 3.69819 2.02002H12.6402C13.7397 2.02002 14.6392 2.91956 14.6392 4.01899V9.26295'
          stroke='currentColor'
          strokeWidth='1.33'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M4.5293 8.43018H7.6532'
          stroke='currentColor'
          strokeWidth='1.3333'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M4.5293 5.58008H10.698'
          stroke='currentColor'
          strokeWidth='1.3333'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M13.3558 12.2458L13.8221 13.1832C13.8316 13.2023 13.85 13.2155 13.8712 13.2186L14.9138 13.3689C15.1298 13.4001 15.2161 13.6635 15.0598 13.8147L14.3054 14.5444C14.29 14.5593 14.283 14.5807 14.2866 14.6017L14.4647 15.632C14.5016 15.8455 14.2757 16.0083 14.0825 15.9075L13.15 15.4211C13.131 15.4111 13.1083 15.4111 13.0893 15.4211L12.1567 15.9075C11.9635 16.0083 11.7376 15.8455 11.7745 15.632L11.9526 14.6017C11.9563 14.5807 11.9492 14.5593 11.9339 14.5444L11.1794 13.8147C11.0231 13.6635 11.1094 13.4001 11.3254 13.3689L12.368 13.2186C12.3893 13.2155 12.4076 13.2023 12.4171 13.1832L12.8834 12.2458C12.98 12.0515 13.2592 12.0515 13.3558 12.2458Z'
          stroke='currentColor'
        />
        <path
          d='M17.7046 10H8.19302C7.69449 10 7.29883 10.4036 7.29883 10.91V17.2485C7.29883 17.7549 7.69449 18.1585 8.19302 18.1585H17.7363C17.9658 18.1585 18.132 18.0556 18.132 18.0556C18.4327 17.8894 18.5988 17.5808 18.5988 17.2485V10.91C18.5988 10.4036 18.2032 10 17.7046 10Z'
          stroke='currentColor'
          strokeWidth='1.33'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </IconWrapper>
  );
}
export function MyMenuSubSet(props: IconProps) {
  return (
    <IconWrapper
      {...props}
      style={{
        color: 'var(--colorIco01)',
      }}
    >
      <svg width='2em' height='2em' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M14 12.1226C12.9 12.1226 12 13.0026 12 14.0926C12 15.1826 12.9 16.0626 14 16.0626C15.1 16.0626 16 15.1826 16 14.0926C16 13.0026 15.1 12.1226 14 12.1226ZM14 14.8926C13.54 14.8926 13.17 14.5326 13.17 14.0926C13.17 13.6526 13.54 13.2926 14 13.2926C14.46 13.2926 14.83 13.6526 14.83 14.0926C14.83 14.5326 14.46 14.8926 14 14.8926Z'
          fill='currentColor'
        />
        <path
          d='M19 13.2324C19 12.8224 18.7 12.4624 18.31 12.3824L17.68 12.2524C17.64 12.1724 17.6 12.0924 17.56 12.0224C17.52 11.9424 17.46 11.8624 17.42 11.7924L17.62 11.1724C17.75 10.7824 17.58 10.3524 17.23 10.1424L15.77 9.29238C15.45 9.10238 15.04 9.15238 14.71 9.45238L14.24 9.99238H13.76L13.31 9.48238C13.04 9.17238 12.58 9.10238 12.22 9.31238L10.72 10.1924L10.68 10.2224C10.68 10.2224 10.65 10.2424 10.63 10.2624C10.37 10.4924 10.27 10.8624 10.38 11.1924L10.6 11.8524L10.36 12.2724L9.7 12.4124C9.3 12.4924 9 12.8524 9 13.2624V14.9724C9 15.3824 9.3 15.7324 9.7 15.8124L10.33 15.9424C10.37 16.0224 10.41 16.1024 10.45 16.1824C10.49 16.2624 10.55 16.3424 10.59 16.4024L10.38 17.0224C10.25 17.4124 10.41 17.8424 10.77 18.0524L12.24 18.9024C12.36 18.9724 12.5 19.0124 12.65 19.0124C12.87 19.0124 13.1 18.9224 13.3 18.7424L13.76 18.2024H14.24L14.69 18.7124C14.96 19.0224 15.43 19.1024 15.78 18.8924L17.29 18.0024C17.29 18.0024 17.36 17.9524 17.37 17.9424C17.63 17.7124 17.73 17.3424 17.62 17.0124L17.4 16.3624L17.64 15.9324L18.3 15.7924C18.7 15.7124 19 15.3424 18.99 14.9424V13.2424L19 13.2324ZM14.38 9.98238C14.38 9.98238 14.39 9.98238 14.4 9.98238H14.36C14.36 9.98238 14.37 9.98238 14.38 9.98238ZM13.56 9.98238C13.56 9.98238 13.59 9.98238 13.6 9.98238H13.52C13.52 9.98238 13.55 9.98238 13.56 9.98238ZM17.21 14.8124C17.03 14.8524 16.79 15.0124 16.71 15.1824L16.31 15.8824C16.19 16.0724 16.15 16.3324 16.22 16.5424L16.42 17.1424L15.4 17.7424L14.99 17.2724C14.84 17.1124 14.6 17.0124 14.42 17.0224H13.62C13.41 17.0124 13.21 17.0824 13 17.2724L12.59 17.7524L11.56 17.1524L11.76 16.5524C11.83 16.3424 11.79 16.0724 11.65 15.8824C11.63 15.8524 11.53 15.7124 11.45 15.5924C11.38 15.4624 11.31 15.3024 11.29 15.2724C11.2 15.0524 10.98 14.8824 10.76 14.8424L10.15 14.7124V13.5124L10.75 13.3824C10.93 13.3524 11.17 13.2024 11.26 13.0124L11.65 12.3224C11.78 12.1324 11.82 11.8624 11.75 11.6524L11.55 11.0524L12.57 10.4524L12.98 10.9224C13.13 11.0924 13.37 11.1924 13.55 11.1724H14.34C14.54 11.1824 14.75 11.1124 14.95 10.9324L15.37 10.4524L16.4 11.0524L16.2 11.6524C16.13 11.8724 16.17 12.1424 16.31 12.3224C16.32 12.3324 16.43 12.4924 16.51 12.6224C16.58 12.7524 16.66 12.9224 16.67 12.9424C16.76 13.1524 16.97 13.3224 17.19 13.3724L17.8 13.5024V14.7124L17.18 14.8424L17.21 14.8124Z'
          fill='currentColor'
        />
        <path
          d='M3.67016 1.66992H2.99016C2.25016 1.66992 1.66016 2.25447 1.66016 2.97542V12.0944C1.66016 12.8251 2.25016 13.3999 2.99016 13.3999H9.48016'
          stroke='currentColor'
          strokeWidth='1.33'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M17.4699 11.6699V3.00326C17.4699 2.25699 16.916 1.66992 16.2214 1.66992H3.66992'
          stroke='currentColor'
          strokeWidth='1.33'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M9.85922 4.80416L10.5122 6.11703C10.5256 6.14379 10.5513 6.16233 10.581 6.16663L12.0412 6.37715C12.3439 6.42079 12.4647 6.78978 12.2457 7.00157L11.1891 8.0235C11.1676 8.04432 11.1577 8.07433 11.1628 8.10374L11.4123 9.54672C11.464 9.84577 11.1476 10.0738 10.8769 9.93263L9.57089 9.25135C9.54427 9.23746 9.51248 9.23746 9.48586 9.25135L8.17982 9.93263C7.90915 10.0738 7.5928 9.84577 7.64449 9.54672L7.89392 8.10374C7.89901 8.07433 7.88918 8.04432 7.86765 8.0235L6.81104 7.00157C6.59206 6.78978 6.7129 6.42078 7.01552 6.37715L8.47571 6.16662C8.50547 6.16233 8.5312 6.14379 8.54451 6.11703L9.19753 4.80416C9.33286 4.53208 9.72389 4.53208 9.85922 4.80416Z'
          stroke='currentColor'
          strokeWidth='1.33'
        />
      </svg>
    </IconWrapper>
  );
}

export function MyMenuDarkMode(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper
      {...rest}
      style={{
        color: 'var(--colorIco01)',
        ...style,
      }}
    >
      <svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' viewBox='0 0 24 24' fill='none'>
        <path
          d='M17.0872 14.903C12.243 14.903 8.31595 11.0135 8.31595 6.2157C8.31595 5.21616 8.48979 4.25803 8.80547 3.36546C8.96013 2.92818 8.53358 2.50606 8.10708 2.68833C4.54548 4.21045 2.05078 7.71425 2.05078 11.8004C2.05078 17.2836 6.53884 21.7287 12.0751 21.7287C16.6116 21.7287 20.4349 18.741 21.6695 14.6456C21.8025 14.2047 21.3399 13.8268 20.9253 14.0273C19.7661 14.5877 18.4641 14.903 17.0872 14.903Z'
          stroke='currentColor'
          strokeWidth='2.1'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </IconWrapper>
  );
}

export function MyMenuLightMode(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper
      {...rest}
      style={{
        color: 'var(--colorIco01)',
        ...style,
      }}
    >
      <svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' viewBox='0 0 24 24' fill='none'>
        <path
          d='M11.9988 17.9524C15.2849 17.9524 17.9488 15.2885 17.9488 12.0024C17.9488 8.71633 15.2849 6.05243 11.9988 6.05243C8.71273 6.05243 6.04883 8.71633 6.04883 12.0024C6.04883 15.2885 8.71273 17.9524 11.9988 17.9524Z'
          stroke='currentColor'
          strokeWidth='2.1'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M4.21289 19.6454L5.25069 18.6076'
          stroke='currentColor'
          strokeWidth='2.1'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M19.688 19.7326L18.6602 18.7048'
          stroke='currentColor'
          strokeWidth='2.1'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M4.21094 4.25479L5.25228 5.29613'
          stroke='currentColor'
          strokeWidth='2.1'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M19.6896 4.1676L18.6582 5.19901'
          stroke='currentColor'
          strokeWidth='2.1'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M12 1.05243V2.51917'
          stroke='currentColor'
          strokeWidth='2.1'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M12 22.9524V21.5068'
          stroke='currentColor'
          strokeWidth='2.1'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M22.9513 12.0024H21.498'
          stroke='currentColor'
          strokeWidth='2.1'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M1.05078 12.0024L2.51002 12.0024'
          stroke='currentColor'
          strokeWidth='2.1'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </IconWrapper>
  );
}

// live--------------------------------------------------------
export function LiveBookmarkSW22(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper {...rest} style={{ color: 'var(--colorIco07)', ...style }}>
      <svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1.125em' viewBox='0 0 16 18' fill='none'>
        <path
          d='M14.3258 16.1462C14.3258 16.6907 13.9579 16.885 13.5082 16.578L8.81839 13.376C8.3687 13.069 7.63285 13.069 7.18317 13.376L2.49339 16.578C2.0437 16.885 1.67578 16.6907 1.67578 16.1462V1.85377C1.67578 1.30927 2.12128 0.86377 2.66578 0.86377H13.3358C13.8803 0.86377 14.3258 1.30927 14.3258 1.85377V16.1462Z'
          stroke='currentColor'
          strokeWidth='1.43'
          strokeLinejoin='round'
        />
      </svg>
    </IconWrapper>
  );
}

export function LiveBookmarkOnSW22(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper {...rest} style={{ ...style }}>
      <svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1.125em' viewBox='0 0 16 18' fill='none'>
        <path
          d='M14.3258 16.1462C14.3258 16.6907 13.9579 16.885 13.5082 16.578L8.81839 13.376C8.3687 13.069 7.63285 13.069 7.18317 13.376L2.49339 16.578C2.0437 16.885 1.67578 16.6907 1.67578 16.1462V1.85377C1.67578 1.30927 2.12128 0.86377 2.66578 0.86377H13.3358C13.8803 0.86377 14.3258 1.30927 14.3258 1.85377V16.1462Z'
          fill='#FDBD39'
        />
        <path
          d='M14.3258 16.1462C14.3258 16.6907 13.9579 16.885 13.5082 16.578L8.81839 13.376C8.3687 13.069 7.63285 13.069 7.18317 13.376L2.49339 16.578C2.0437 16.885 1.67578 16.6907 1.67578 16.1462V1.85377C1.67578 1.30927 2.12128 0.86377 2.66578 0.86377H13.3358C13.8803 0.86377 14.3258 1.30927 14.3258 1.85377V16.1462Z'
          stroke='#FDBD39'
          strokeWidth='1.65'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </IconWrapper>
  );
}

export function LiveBottomMenuFullscreen(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper {...rest} style={{ color: 'var(--colorIco07)', ...style }}>
      <svg width='22' height='22' viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_320_3100)'>
          <path
            d='M6.98351 19.2499H2.6582V14.9722'
            stroke='currentColor'
            strokeWidth='1.65'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M15.0156 2.75H19.3409V7.02778'
            stroke='currentColor'
            strokeWidth='1.65'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M19.3409 14.9722V19.2499H15.0156'
            stroke='currentColor'
            strokeWidth='1.65'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M2.6582 7.02778V2.75H6.98351'
            stroke='currentColor'
            strokeWidth='1.65'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
        <defs>
          <clipPath id='clip0_320_3100'>
            <rect width='22' height='22' fill='white' />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  );
}
export function LiveBottomMenuFullscreenOn(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper {...rest} style={{ color: 'var(--colorIco07)', ...style }}>
      <svg width='22' height='22' viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_320_3090)'>
          <path
            d='M3.41602 14.6111H7.34812V18.5'
            stroke='currentColor'
            strokeWidth='1.65'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M18.5825 7.38889H14.6504L14.6504 3.5'
            stroke='currentColor'
            strokeWidth='1.65'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M14.6504 18.5L14.6504 14.6111H18.5825'
            stroke='currentColor'
            strokeWidth='1.65'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M7.34812 3.5V7.38889H3.41602'
            stroke='currentColor'
            strokeWidth='1.65'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
        <defs>
          <clipPath id='clip0_320_3090'>
            <rect width='22' height='22' fill='white' />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  );
}
export function LiveBottomMenuGiftranking(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper {...rest} style={{ color: 'var(--colorIco07)', ...style }}>
      <svg width='22' height='22' viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_320_3074)'>
          <path
            d='M11.8657 16.3638C11.8657 16.7788 11.5675 17.077 11.1654 17.077C10.7633 17.077 10.4652 16.7788 10.4652 16.3638V12.7843H10.1992C9.92035 12.7843 9.73242 12.5636 9.73242 12.2654C9.73242 11.9022 9.97878 11.7661 10.0954 11.7272C10.2836 11.6624 10.4327 11.4938 10.5299 11.351C10.6856 11.0981 10.8995 11.027 11.2302 11.027C11.6389 11.027 11.8657 11.2797 11.8657 11.6429L11.8657 16.3638Z'
            fill='currentColor'
          />
          <path
            d='M17.341 14.0349C17.341 15.3431 16.9515 16.5429 16.2811 17.5443C15.3027 18.9878 13.7536 20.0072 11.9508 20.2688C11.6428 20.3229 11.3257 20.35 10.9996 20.35C10.6735 20.35 10.3564 20.3229 10.0484 20.2688C8.24565 20.0072 6.69652 18.9878 5.71811 17.5443C5.04774 16.5429 4.6582 15.3431 4.6582 14.0349C4.6582 10.5436 7.49372 7.71985 10.9996 7.71985C14.5055 7.71985 17.341 10.5436 17.341 14.0349Z'
            stroke='currentColor'
            strokeWidth='1.65'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M4.23242 5.50907V2.20002C4.23242 1.89752 4.47992 1.65002 4.78242 1.65002H17.2162C17.5187 1.65002 17.7662 1.89752 17.7662 2.20002V5.50907'
            stroke='currentColor'
            strokeWidth='1.65'
            strokeMiterlimit='10'
            strokeLinecap='round'
          />
          <path
            d='M8.74414 1.65002V5.99837'
            stroke='currentColor'
            strokeWidth='1.65'
            strokeMiterlimit='10'
            strokeLinecap='round'
          />
          <path
            d='M13.2559 1.65002V5.99837'
            stroke='currentColor'
            strokeWidth='1.65'
            strokeMiterlimit='10'
            strokeLinecap='round'
          />
          <path
            d='M4.23242 5.50903L10.9993 7.4053L17.7662 5.50903'
            stroke='currentColor'
            strokeWidth='1.65'
            strokeLinejoin='round'
          />
        </g>
        <defs>
          <clipPath id='clip0_320_3074'>
            <rect width='22' height='22' fill='white' />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  );
}
export function LiveBottomVote(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper {...rest} style={{ color: 'var(--colorIco07)', ...style }}>
      <svg width='22' height='22' viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_320_3084)'>
          <path
            d='M8.41992 14.355L10.5795 16.5049L13.8758 13.0189'
            stroke='currentColor'
            strokeWidth='1.46667'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M14.0921 5.57131L10.6561 2.14683C10.3594 1.85112 9.87837 1.85112 9.58167 2.14683L6.93347 4.78611C6.63676 5.08182 6.63676 5.56126 6.93347 5.85696L9.79448 8.70833H12.0189L14.0921 6.64216C14.3888 6.34646 14.3888 5.86702 14.0921 5.57131Z'
            stroke='currentColor'
            strokeWidth='1.46667'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M17.5335 8.70825H4.46472C3.6547 8.70825 2.99805 9.3649 2.99805 10.1749V18.6083C2.99805 19.4183 3.6547 20.075 4.46472 20.075H17.5335C18.3435 20.075 19.0001 19.4183 19.0001 18.6083V10.1749C19.0001 9.3649 18.3435 8.70825 17.5335 8.70825Z'
            stroke='currentColor'
            strokeWidth='1.46667'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
        <defs>
          <clipPath id='clip0_320_3084'>
            <rect width='22' height='22' fill='white' />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  );
}
export function LiveGift(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper {...rest} style={{ color: 'var(--colorIco07)', fontSize: 22, ...style }}>
      <svg width='1em' height='1em' viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_320_3068)'>
          <path
            d='M20.1571 4.31748H17.5157C17.6244 4.03795 17.6821 3.73849 17.6821 3.43576C17.6821 2.14787 16.6342 1.09998 15.3463 1.09998C13.9194 1.09998 12.9846 1.83595 12.4055 2.38957C12.1543 2.62982 11.9211 2.88107 11.6956 3.12409C11.4601 3.37787 11.2337 3.62187 10.9996 3.84061C10.7655 3.62187 10.5391 3.37788 10.3035 3.12409C10.0782 2.88106 9.84492 2.62982 9.59379 2.38957C9.01468 1.83596 8.07991 1.09998 6.65291 1.09998C5.36502 1.09998 4.31713 2.14787 4.31713 3.43576C4.31713 3.73849 4.3749 4.03807 4.48354 4.3176L1.86545 4.31808L1.83052 4.31723C1.81505 4.31723 1.7881 4.3182 1.77263 4.31965C1.38712 4.35578 1.09781 4.67507 1.09962 5.05997V9.51497C1.09962 9.92441 1.43268 10.2575 1.84212 10.2575H2.58462V20.1575C2.58462 20.5669 2.91768 20.9 3.32712 20.9H18.6721C19.0816 20.9 19.4146 20.5669 19.4146 20.1575V10.2575H20.1571C20.5666 10.2575 20.8996 9.92442 20.8996 9.51498V5.05998C20.8996 4.65054 20.5666 4.31748 20.1571 4.31748ZM10.2571 5.80248V8.77248H2.58463V5.80248H10.2571ZM6.41931 4.31748C6.07598 4.20219 5.80213 3.81499 5.80213 3.43576C5.80213 2.95079 6.16794 2.58498 6.65291 2.58498C7.4794 2.58498 7.99603 2.9201 8.56149 3.4609C8.76536 3.65583 8.96537 3.87263 9.1771 4.10225C9.24296 4.17367 9.30931 4.24546 9.37638 4.31748H6.41931ZM10.2571 10.2575V19.415H4.06963V10.2575H10.2571ZM19.4146 5.80248V8.77248H11.7421V5.80248H19.4146ZM15.3463 2.58498C15.8313 2.58498 16.1971 2.95079 16.1971 3.43576C16.1971 3.81523 15.9229 4.20279 15.5801 4.31748H12.6229C12.6899 4.24545 12.7563 4.17367 12.8222 4.10225C13.0339 3.87264 13.2339 3.65583 13.4378 3.4609C14.0032 2.9201 14.5199 2.58498 15.3463 2.58498ZM11.7421 19.415V10.2575H17.9296V19.415H11.7421Z'
            fill='currentColor'
          />
        </g>
        <defs>
          <clipPath id='clip0_320_3068'>
            <rect width='22' height='22' fill='white' />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  );
}
export function LiveMission(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper {...rest} style={{ color: 'var(--colorIco07)', fontSize: 20, ...style }}>
      <svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' viewBox='0 0 20 20' fill='none'>
        <mask
          id='mask0_8551_8727'
          style={{ maskType: 'luminance' }}
          maskUnits='userSpaceOnUse'
          x='0'
          y='0'
          width='20'
          height='20'
        >
          <path d='M20 0H0V20H20V0Z' fill='white' />
        </mask>
        <g mask='url(#mask0_8551_8727)'>
          <path
            d='M19.7569 4.55702C19.8564 4.45779 19.9289 4.33482 19.9676 4.19974C20.0063 4.06466 20.0099 3.92195 19.9781 3.78509C19.9462 3.64823 19.88 3.52176 19.7856 3.41763C19.6913 3.3135 19.572 3.23516 19.4389 3.19002L17.4759 2.52502L16.8109 0.561025C16.7659 0.427883 16.6876 0.308433 16.5835 0.213977C16.4795 0.119522 16.353 0.0531852 16.2161 0.0212453C16.0793 -0.0106946 15.9365 -0.00718124 15.8014 0.0314528C15.6662 0.0700868 15.5432 0.142564 15.4439 0.242025L14.4269 1.25902C12.3237 0.181135 9.9048 -0.110481 7.60571 0.436684C5.30661 0.983848 3.2784 2.33384 1.88625 4.24359C0.494101 6.15334 -0.170508 8.49736 0.0120898 10.8536C0.194688 13.2098 1.2125 15.4235 2.88225 17.096C4.552 18.7684 6.76399 19.7898 9.11993 19.9762C11.4759 20.1627 13.821 19.5019 15.733 18.1128C17.645 16.7238 18.9983 14.6977 19.5492 12.3995C20.1001 10.1013 19.8124 7.68195 18.7379 5.57702L19.7569 4.55702ZM15.6719 2.35102L16.0419 3.44202C16.0469 3.45702 16.0549 3.47002 16.0599 3.48402C16.0714 3.513 16.0845 3.54136 16.0989 3.56902C16.111 3.5914 16.1244 3.6131 16.1389 3.63402C16.1549 3.65702 16.1699 3.67902 16.1869 3.70002C16.2045 3.72097 16.2232 3.741 16.2429 3.76002C16.2606 3.77838 16.2793 3.79574 16.2989 3.81202C16.3209 3.83002 16.3449 3.84702 16.3689 3.86302C16.3929 3.87902 16.4089 3.88902 16.4299 3.90102C16.4585 3.91597 16.4878 3.92932 16.5179 3.94102C16.5319 3.94602 16.5439 3.95402 16.5579 3.95902L17.6489 4.32902L16.3379 5.64002L14.6629 5.34002L14.3629 3.66402L15.6719 2.35102ZM13.2719 10.087C13.2734 10.833 13.0277 11.5585 12.5733 12.1501C12.1189 12.7417 11.4813 13.1662 10.7602 13.3572C10.0391 13.5482 9.27499 13.4949 8.58731 13.2058C7.89964 12.9166 7.32711 12.4078 6.95915 11.7589C6.59119 11.11 6.44853 10.3574 6.55345 9.61886C6.65838 8.88028 7.00497 8.19725 7.5391 7.67648C8.07323 7.1557 8.76481 6.8265 9.5058 6.7403C10.2468 6.6541 10.9955 6.81576 11.6349 7.20002L9.35389 9.48002C9.27713 9.55672 9.21623 9.64778 9.17466 9.748C9.1331 9.84823 9.11168 9.95567 9.11163 10.0642C9.11159 10.1727 9.13291 10.2801 9.17439 10.3804C9.21587 10.4807 9.2767 10.5718 9.35339 10.6485C9.50827 10.8035 9.7184 10.8907 9.93753 10.8908C10.046 10.8908 10.1535 10.8695 10.2538 10.828C10.354 10.7865 10.4451 10.7257 10.5219 10.649L12.7999 8.36802C13.1105 8.8876 13.2743 9.4817 13.2739 10.087M15.7479 15.931C14.6858 16.9923 13.3547 17.7441 11.8974 18.1058C10.4402 18.4674 8.91196 18.4251 7.47694 17.9835C6.04191 17.5419 4.75433 16.7177 3.75253 15.5993C2.75073 14.481 2.07258 13.1108 1.79093 11.636C1.50928 10.1613 1.63479 8.63761 2.15396 7.2288C2.67313 5.81998 3.56635 4.57925 4.73765 3.6399C5.90894 2.70056 7.31404 2.09811 8.80199 1.89727C10.2899 1.69644 11.8045 1.90482 13.1829 2.50002L12.8829 2.80002C12.7884 2.89422 12.7182 3.00996 12.6783 3.1373C12.6384 3.26463 12.63 3.39974 12.6539 3.53102L13.0539 5.77202L12.8179 6.00802C11.7919 5.27451 10.5277 4.95355 9.27603 5.10883C8.02441 5.26411 6.87691 5.88428 6.06128 6.84626C5.24565 7.80825 4.8215 9.04172 4.87302 10.3019C4.92453 11.5621 5.44795 12.7568 6.33938 13.649C7.23082 14.5412 8.42511 15.0656 9.68523 15.1182C10.9453 15.1708 12.1792 14.7477 13.1419 13.9329C14.1045 13.1181 14.7257 11.9711 14.8821 10.7197C15.0384 9.46816 14.7185 8.20363 13.9859 7.17702L14.2219 6.94102L16.4619 7.34102C16.5104 7.34982 16.5596 7.35417 16.6089 7.35402C16.8279 7.35388 17.038 7.26685 17.1929 7.11202L17.4849 6.82002C18.1402 8.33824 18.3245 10.0183 18.0137 11.6425C17.7029 13.2666 16.9114 14.76 15.7419 15.929'
            fill='currentColor'
          />
        </g>
      </svg>
    </IconWrapper>
  );
}

export function LiveGiftRanking(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper {...rest} style={{ color: 'var(--colorIco07)', fontSize: 22, ...style }}>
      <svg width='1em' height='1em' viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_7055_10189)'>
          <path
            d='M11.8657 16.3638C11.8657 16.7788 11.5675 17.077 11.1654 17.077C10.7633 17.077 10.4652 16.7788 10.4652 16.3638V12.7843H10.1992C9.92035 12.7843 9.73242 12.5636 9.73242 12.2654C9.73242 11.9022 9.97878 11.7661 10.0954 11.7272C10.2836 11.6624 10.4327 11.4938 10.5299 11.351C10.6856 11.0981 10.8995 11.027 11.2302 11.027C11.6389 11.027 11.8657 11.2797 11.8657 11.6429L11.8657 16.3638Z'
            fill='currentColor'
          />
          <path
            d='M17.341 14.0349C17.341 15.3431 16.9515 16.5429 16.2811 17.5443C15.3027 18.9878 13.7536 20.0072 11.9508 20.2688C11.6428 20.3229 11.3257 20.35 10.9996 20.35C10.6735 20.35 10.3564 20.3229 10.0484 20.2688C8.24565 20.0072 6.69652 18.9878 5.71811 17.5443C5.04774 16.5429 4.6582 15.3431 4.6582 14.0349C4.6582 10.5436 7.49372 7.71985 10.9996 7.71985C14.5055 7.71985 17.341 10.5436 17.341 14.0349Z'
            stroke='currentColor'
            strokeWidth='1.65'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M4.23242 5.50907V2.20002C4.23242 1.89752 4.47992 1.65002 4.78242 1.65002H17.2162C17.5187 1.65002 17.7662 1.89752 17.7662 2.20002V5.50907'
            stroke='currentColor'
            strokeWidth='1.65'
            strokeMiterlimit='10'
            strokeLinecap='round'
          />
          <path
            d='M8.74414 1.65002V5.99837'
            stroke='currentColor'
            strokeWidth='1.65'
            strokeMiterlimit='10'
            strokeLinecap='round'
          />
          <path
            d='M13.2559 1.65002V5.99837'
            stroke='currentColor'
            strokeWidth='1.65'
            strokeMiterlimit='10'
            strokeLinecap='round'
          />
          <path
            d='M4.23242 5.50903L10.9993 7.4053L17.7662 5.50903'
            stroke='currentColor'
            strokeWidth='1.65'
            strokeLinejoin='round'
          />
        </g>
      </svg>
    </IconWrapper>
  );
}

export function LiveNote(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper {...rest} style={{ color: 'var(--colorIco07)', ...style }}>
      <svg width='22' height='22' viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_320_3044)'>
          <path
            d='M4.87695 1.65002L17.0957 12.8589'
            stroke='currentColor'
            strokeWidth='1.65'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M10.9766 7.24547L16.8831 1.82715'
            stroke='currentColor'
            strokeWidth='1.65'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M10.9763 7.24548L3.4239 14.2069C2.92664 14.6631 2.8995 15.3909 3.39677 15.8471L7.50152 20.0079C7.99878 20.4641 8.80504 20.4641 9.3023 20.0079L17.0954 12.8589L10.9763 7.24548Z'
            stroke='currentColor'
            strokeWidth='1.65'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M18.5911 14.2147L17.0957 12.8589L10.9766 18.4723L12.6376 19.9961C13.1349 20.4523 13.9412 20.4523 14.4384 19.9961L18.5911 15.8667C19.0884 15.4105 19.0884 14.6709 18.5911 14.2147Z'
            stroke='currentColor'
            strokeWidth='1.65'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M4.87695 12.8589V1.65002H17.0957V12.8589'
            stroke='currentColor'
            strokeWidth='1.65'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
        <defs>
          <clipPath id='clip0_320_3044'>
            <rect width='22' height='22' fill='white' />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  );
}
export function LiveRecommend(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper {...rest} style={{ color: 'var(--colorIco07)', fontSize: 22, ...style }}>
      <svg width='1em' height='1em' viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_320_3052)'>
          <path
            d='M19.4893 9.49364C19.7037 9.73012 19.8357 10.1866 19.7862 10.5001L18.4993 18.8705C18.4498 19.184 18.2904 19.6514 18.1474 19.8989C18.0044 20.1464 17.1025 20.3499 16.7835 20.3499H7.01069C6.69171 20.3499 6.42773 20.0859 6.42773 19.7669V10.4891C6.42773 10.1701 6.53222 9.66963 6.66421 9.37815L10.019 1.93166C10.151 1.64018 10.4644 1.56319 10.7174 1.75567L11.2784 2.19014C11.5314 2.38813 11.7348 2.8061 11.7348 3.12508V8.12974C11.7348 8.44872 11.9933 8.7127 12.3178 8.7127H18.2134C18.5323 8.7127 18.9668 8.90519 19.1813 9.14717L19.4948 9.49915L19.4893 9.49364Z'
            stroke='currentColor'
            strokeWidth='1.65'
            strokeMiterlimit='10'
          />
          <path
            d='M6.4284 9.90613H2.87567C2.5017 9.90613 2.19922 10.2086 2.19922 10.5826V19.6735C2.19922 20.0474 2.5072 20.3499 2.87567 20.3499H7.47425'
            stroke='currentColor'
            strokeWidth='1.65'
            strokeMiterlimit='10'
          />
        </g>
        <defs>
          <clipPath id='clip0_320_3052'>
            <rect width='22' height='22' fill='white' />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  );
}
export function LiveShareW22(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper {...rest} style={{ color: 'var(--colorIco07)', fontSize: 22, ...style }}>
      <svg width='1em' height='1em' viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_320_3059)'>
          <path
            d='M6.74696 13.5463C8.14541 13.5463 9.27908 12.4063 9.27908 11C9.27908 9.59375 8.14541 8.45374 6.74696 8.45374C5.34851 8.45374 4.21484 9.59375 4.21484 11C4.21484 12.4063 5.34851 13.5463 6.74696 13.5463Z'
            stroke='currentColor'
            strokeWidth='1.65'
            strokeMiterlimit='10'
          />
          <path
            d='M15.2548 7.8426C16.6532 7.8426 17.7869 6.70258 17.7869 5.2963C17.7869 3.89002 16.6532 2.75 15.2548 2.75C13.8563 2.75 12.7227 3.89002 12.7227 5.2963C12.7227 6.70258 13.8563 7.8426 15.2548 7.8426Z'
            stroke='currentColor'
            strokeWidth='1.65'
            strokeMiterlimit='10'
          />
          <path
            d='M15.2548 19.2499C16.6532 19.2499 17.7869 18.1099 17.7869 16.7036C17.7869 15.2974 16.6532 14.1573 15.2548 14.1573C13.8563 14.1573 12.7227 15.2974 12.7227 16.7036C12.7227 18.1099 13.8563 19.2499 15.2548 19.2499Z'
            stroke='currentColor'
            strokeWidth='1.65'
            strokeMiterlimit='10'
          />
          <path d='M8.57031 9.37032L12.9662 6.38574' stroke='currentColor' strokeWidth='1.65' strokeMiterlimit='10' />
          <path d='M12.9662 15.4815L8.57031 12.4969' stroke='currentColor' strokeWidth='1.65' strokeMiterlimit='10' />
        </g>
        <defs>
          <clipPath id='clip0_320_3059'>
            <rect width='22' height='22' fill='white' />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  );
}

export function LiveFanRanking(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper {...rest} style={{ color: 'var(--colorIco07)', ...style }}>
      <svg xmlns='http://www.w3.org/2000/svg' width='38' height='38' viewBox='0 0 38 38' fill='none'>
        <g clipPath='url(#clip0_1738_5235)'>
          <path
            d='M16.6924 21.0647C10.9678 21.0647 6.31055 16.4075 6.31055 10.6819C6.31055 4.95728 10.9678 0.300049 16.6924 0.300049C22.417 0.300049 27.0747 4.95728 27.0747 10.6819C27.0747 16.4075 22.417 21.0647 16.6924 21.0647ZM16.6924 3.30005C12.6221 3.30005 9.31055 6.61157 9.31055 10.6819C9.31055 14.7532 12.6221 18.0647 16.6924 18.0647C20.7632 18.0647 24.0747 14.7532 24.0747 10.6819C24.0747 6.61158 20.7632 3.30005 16.6924 3.30005Z'
            fill='currentColor'
          />
          <path
            d='M2.33165 37.7776C2.30235 37.7776 2.27306 37.7766 2.24376 37.7747C1.41661 37.7268 0.784776 37.0179 0.832626 36.1907C1.56066 23.597 12.8111 18.3333 13.2897 18.1155C14.0421 17.7708 14.9327 18.1048 15.2765 18.8587C15.6192 19.6126 15.2877 20.5003 14.5353 20.845C14.1217 21.0354 4.44933 25.6097 3.82775 36.3645C3.78136 37.1614 3.12022 37.7776 2.33165 37.7776Z'
            fill='currentColor'
          />
          <path
            d='M28.2751 37.7776C28.0221 37.7776 27.7692 37.7141 27.5412 37.5862L26.9425 37.2551C25.2819 36.344 23.3996 35.3128 21.5978 33.0481C18.089 28.6379 19.7257 24.929 20.0534 24.2903C20.5041 23.3118 21.8703 21.7024 24.2824 21.5989C26.0055 21.5208 27.3668 22.3899 28.2751 23.2356C29.1823 22.3899 30.5153 21.5198 32.2672 21.5989C34.6798 21.7024 36.0461 23.3118 36.4967 24.2903C36.8239 24.929 38.4606 28.638 34.9518 33.0481C33.1505 35.3128 31.2682 36.344 29.6076 37.2551L29.0089 37.5862C28.7809 37.7141 28.528 37.7776 28.2751 37.7776ZM24.4826 24.595C24.4582 24.595 24.4342 24.596 24.4103 24.5969C23.2511 24.6458 22.8122 25.4768 22.7658 25.5715C22.7511 25.6018 22.7204 25.6643 22.7033 25.6936C22.6637 25.7688 21.4821 28.0842 23.9455 31.1809C25.3376 32.9299 26.7658 33.7366 28.2751 34.5647C29.7843 33.7366 31.2126 32.9299 32.6042 31.1809C35.0675 28.0842 33.8864 25.7688 33.8346 25.6721C33.8166 25.6379 33.7873 25.5793 33.7716 25.5442C33.7379 25.4768 33.299 24.6457 32.1393 24.5969C30.7155 24.5325 29.5651 26.3098 29.5539 26.3274C29.279 26.7698 28.7555 27.01 28.2687 27.0393C27.7472 27.0364 27.2619 26.7659 26.9918 26.3196C26.985 26.3088 25.8805 24.595 24.4826 24.595Z'
            fill='currentColor'
          />
        </g>
        <defs>
          <clipPath id='clip0_1738_5235'>
            <rect width='36.3328' height='37.4775' fill='white' transform='translate(0.830078 0.300049)' />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  );
}

export function LiveRefresh(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ color: 'var(--colorIco31)', ...style }} {...rest}>
      <svg xmlns='http://www.w3.org/2000/svg' width='4.5em' height='4.8em' viewBox='0 0 45 48' fill='none'>
        <g clipPath='url(#clip0_320_1619)'>
          <path
            d='M30.8499 9.38673L32.0423 9.98454L29.6663 10.4112C28.684 10.5875 28.0303 11.5299 28.206 12.5167C28.3624 13.3953 29.1231 14.0123 29.9814 14.0123C30.0872 14.0123 30.1942 14.0029 30.3012 13.9837L38.5831 12.4966C39.134 12.3977 39.6078 12.048 39.8671 11.5497C40.1257 11.0515 40.1398 10.4608 39.9059 9.95043L36.2828 2.05587C35.8648 1.14621 34.7914 0.746312 33.8866 1.16806C32.9807 1.58774 32.5851 2.66546 33.0025 3.57571L34.1279 6.02792L32.8387 5.3816L32.8341 5.39094C28.8792 3.5189 24.5045 2.91274 20.1136 3.63944C14.3851 4.58871 9.36695 7.72291 5.98352 12.4652C-0.998094 22.2538 1.24593 35.9266 10.9859 42.9444C11.9086 43.6085 12.8874 44.2037 13.896 44.7133C23.3558 49.4918 35.1447 46.5702 41.3184 37.9174C41.8737 37.1392 42.3699 36.3304 42.8128 35.4993L42.7721 35.4788C42.7939 35.4408 42.8218 35.4085 42.8417 35.3688C43.3948 34.2634 42.9514 32.9168 41.8513 32.361C40.7512 31.8053 39.411 32.2507 38.8578 33.3561C38.8085 33.4549 38.7763 33.5572 38.7425 33.659C38.4284 34.226 38.0884 34.7819 37.7068 35.3167C35.02 39.0836 31.0274 41.5747 26.4638 42.3314C21.9004 43.0877 17.3231 42.019 13.5752 39.3161C5.82622 33.7323 4.04052 22.8537 9.5951 15.0659C12.2856 11.2935 16.2781 8.80017 20.8369 8.04482C24.2975 7.47185 27.7297 7.95655 30.8447 9.39713'
            fill='currentColor'
          />
        </g>
      </svg>
    </IconWrapper>
  );
}

export function SettingIcon(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ color: 'black', ...style }} {...rest}>
      <svg xmlns='http://www.w3.org/2000/svg' width='22' height='22' viewBox='0 0 22 22' fill='none'>
        <path
          d='M11.0065 14.9097C8.85156 14.9097 7.09766 13.1557 7.09766 11.0007C7.09766 8.84573 8.85156 7.0918 11.0065 7.0918C13.1615 7.0918 14.9154 8.84573 14.9154 11.0007C14.9154 13.1557 13.1615 14.9097 11.0065 14.9097ZM11.0065 8.74921C9.7652 8.74921 8.75505 9.7594 8.75505 11.0007C8.75505 12.2421 9.76521 13.2522 11.0065 13.2522C12.2478 13.2522 13.258 12.2421 13.258 11.0007C13.258 9.7594 12.2478 8.74921 11.0065 8.74921Z'
          fill='currentColor'
        />
        <path
          d='M8.07553 21.4508C7.83628 21.4508 7.60223 21.3889 7.39245 21.2676L4.19902 19.3755C3.61592 19.0271 3.34836 18.3064 3.55871 17.6609L4.08055 16.0416C3.95861 15.8659 3.78698 15.6093 3.65349 15.3735C3.5223 15.1401 3.39343 14.865 3.30675 14.6714L1.70714 14.3362C1.05412 14.2027 0.5687 13.6103 0.558297 12.929L0.550781 9.13333C0.550781 8.4491 1.04662 7.83535 1.70426 7.70301L3.34547 7.34702L4.07361 6.02998L3.53097 4.36562C3.35414 3.82759 3.51884 3.20577 3.94069 2.82088C3.96265 2.80123 3.98577 2.78216 4.01004 2.76482L4.10249 2.69721L7.3364 0.756602C7.93568 0.401775 8.6985 0.529491 9.15156 1.05307L10.275 2.3493L11.7111 2.34814L12.872 0.991797C13.4031 0.499417 14.0983 0.424877 14.6306 0.740411L17.8119 2.62611C18.3834 2.96071 18.6608 3.69812 18.4533 4.33959L17.9332 5.96061C18.0558 6.13861 18.2251 6.39346 18.3574 6.62867C18.4892 6.86157 18.6169 7.13202 18.7053 7.33024L20.3032 7.66311C20.9574 7.79488 21.4544 8.40919 21.4544 9.08996L21.4601 12.87C21.4642 13.5473 20.9707 14.1645 20.3119 14.3015L18.6631 14.65L17.9321 15.9728L18.4811 17.6308C18.6562 18.1769 18.4898 18.797 18.0696 19.1802C18.0506 19.1969 17.9436 19.2796 17.9234 19.2946L14.6728 21.2444C14.0874 21.5981 13.3049 21.4698 12.8547 20.9457L11.7353 19.6471H10.2843L9.14523 21.0063C8.82335 21.3051 8.44365 21.4508 8.07553 21.4508ZM5.18028 18.0313L8.05761 19.7361L9.19144 18.3815C9.50177 18.0885 9.84504 17.9637 10.1611 17.9926L11.937 17.9909C12.2312 17.9799 12.627 18.1411 12.8472 18.3989L13.9885 19.7234L16.8595 18.0059L16.2926 16.2936C16.1874 15.9676 16.2452 15.5544 16.4348 15.2597L17.3143 13.6739C17.4276 13.3994 17.8188 13.1307 18.1101 13.0735L19.8027 12.7152L19.7975 9.2501L18.0985 8.89584C17.7518 8.82014 17.4212 8.54274 17.2848 8.22027C17.2583 8.15439 17.0872 7.7487 16.9138 7.4424C16.7387 7.13092 16.4856 6.78129 16.4481 6.72869C16.2446 6.45592 16.173 6.03173 16.2764 5.7006L16.8318 3.97093L13.9539 2.26553L12.7975 3.61667C12.4924 3.90389 12.1526 4.02871 11.8342 4.00271L10.0722 4.00501C9.77629 4.01889 9.38737 3.8588 9.16199 3.59528L8.02065 2.27824L5.15314 3.99519L5.71312 5.7133C5.82349 6.0323 5.76397 6.45765 5.56055 6.75815L4.69544 8.32312C4.57235 8.61265 4.18284 8.86634 3.89622 8.92299L2.20819 9.28938L2.21454 12.7499L3.91181 13.1053C4.25278 13.1688 4.59719 13.4549 4.73242 13.7976C4.77923 13.9057 4.93527 14.2726 5.0965 14.5593C5.2716 14.8679 5.53166 15.2256 5.56227 15.2666C5.77436 15.5556 5.84198 15.9832 5.73333 16.3144L5.18028 18.0313ZM10.1438 19.6471H10.0982C10.1126 19.6483 10.1282 19.6483 10.1438 19.6471ZM11.9012 19.6471C11.9278 19.6483 11.9543 19.6483 11.9809 19.6471H11.9012ZM17.8749 16.0757L17.8552 16.1109C17.8587 16.1063 17.8668 16.0948 17.8749 16.0757ZM18.7995 14.4032L18.7244 14.539C18.7509 14.5032 18.7758 14.4587 18.7995 14.4032ZM3.27786 7.47012C3.25532 7.50248 3.23336 7.54063 3.21313 7.58744L3.27786 7.47012ZM4.14989 5.89244C4.14354 5.90054 4.13602 5.91325 4.12851 5.93059L4.14989 5.89244ZM10.0669 2.34817C10.0502 2.34817 10.0328 2.34875 10.0149 2.34989H10.1137C10.0987 2.34873 10.0831 2.34817 10.0669 2.34817ZM11.8665 2.34701L11.8422 2.34759H11.8902L11.8665 2.34701Z'
          fill='currentColor'
        />
      </svg>
    </IconWrapper>
  );
}

export function ArrowTop({ style, ...rest }: IconProps) {
  return (
    <IconWrapper {...rest} style={{ fontSize: 6, color: 'var(--baseFg)', ...style }}>
      <svg xmlns='http://www.w3.org/2000/svg' width='1.5em' height='1em' viewBox='0 0 6 4' fill='none'>
        <g clipPath='url(#clip0_7848_40092)'>
          <path
            d='M3.06482 0.158994C3.06482 0.158994 3.02203 0.15 2.99636 0.15C2.97069 0.15 2.95357 0.15 2.9279 0.158994C2.90223 0.158994 2.87656 0.158994 2.85944 0.176982C2.83377 0.185976 2.81665 0.203964 2.79954 0.221953C2.78242 0.230947 2.75675 0.239941 2.74819 0.257929L0.103964 3.10007C-0.041511 3.25298 -0.0329536 3.49582 0.121079 3.63972C0.266555 3.78363 0.506161 3.78363 0.651637 3.63073L3.00492 1.09438L5.34964 3.63073C5.49511 3.78363 5.72616 3.79262 5.8802 3.63972C5.95721 3.56777 6 3.45984 6 3.3609C6 3.26197 5.96577 3.17203 5.89731 3.09108L3.27875 0.266923C3.27875 0.266923 3.27875 0.266923 3.27875 0.257929C3.26164 0.239941 3.24452 0.230947 3.22741 0.221953C3.21029 0.203964 3.18462 0.19497 3.16751 0.176982C3.14183 0.167988 3.12472 0.167988 3.09905 0.158994L3.06482 0.158994Z'
            fill='currentColor'
          />
        </g>
      </svg>
    </IconWrapper>
  );
}

export function QualityClose(props: IconProps) {
  return (
    <IconWrapper {...props} style={{ color: 'var(--colorFg02)' }}>
      <svg width='28' height='28' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g id='btnClose '>
          <path
            id='after'
            d='M8 8L22 22'
            stroke='currentColor'
            strokeWidth='2'
            strokeMiterlimit='10'
            strokeLinecap='square'
          />
          <path
            id='before'
            d='M22 8L8 22'
            stroke='currentColor'
            strokeWidth='2'
            strokeMiterlimit='10'
            strokeLinecap='square'
          />
        </g>
      </svg>
    </IconWrapper>
  );
}

// base--------------------------------------
export function BaseRightArrow({ style, ...rest }: IconProps) {
  return (
    <IconWrapper {...rest} style={{ color: 'var(--colorFg05)', fontSize: 7, ...style }}>
      <svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1.714em' viewBox='0 0 7 12' fill='none'>
        <g clipPath='url(#clip0_111_1036)'>
          <path
            d='M6.97861 6.12701C6.97861 6.12701 6.99609 6.04144 6.99609 5.99009C6.99609 5.93875 6.99609 5.90452 6.97861 5.85318C6.97861 5.80183 6.97861 5.75049 6.94363 5.71626C6.92614 5.66491 6.89116 5.63068 6.85619 5.59645C6.8387 5.56222 6.82121 5.51088 6.78623 5.49377L1.25984 0.205304C0.962531 -0.0856465 0.490339 -0.0685318 0.210522 0.239534C-0.0692957 0.530485 -0.0692957 1.0097 0.22801 1.30065L5.15979 6.00721L0.22801 10.6967C-0.0692957 10.9876 -0.0867843 11.4497 0.210522 11.7578C0.35043 11.9118 0.560293 11.9974 0.752668 11.9974C0.945042 11.9974 1.11993 11.9289 1.27733 11.792L6.76874 6.55488C6.76874 6.55488 6.76874 6.55488 6.78623 6.55488C6.82121 6.52065 6.8387 6.48642 6.85619 6.45219C6.89116 6.41796 6.90865 6.36662 6.94363 6.33239C6.96112 6.28104 6.96112 6.24682 6.97861 6.19547V6.12701Z'
            fill='currentColor'
          />
        </g>
      </svg>
    </IconWrapper>
  );
}

export function MyMenuFixOn(props: IconProps) {
  return (
    <IconWrapper {...props} style={{ color: 'var(--primaryFg)' }}>
      <svg xmlns='http://www.w3.org/2000/svg' width='20' height='19' viewBox='0 0 20 19' fill='none'>
        <path
          d='M11.6542 17.2985L2.37158 8.01102C1.98834 7.62756 2.1987 6.97133 2.73345 6.88215L5.58704 6.40628C5.99832 6.3377 6.37788 6.14228 6.67264 5.84736L10.7589 1.75901C11.54 0.977465 12.8069 0.977465 13.588 1.75901L17.9052 6.07845C18.6857 6.85942 18.6857 8.12517 17.9052 8.90613L13.8172 12.9963C13.5226 13.291 13.3274 13.6704 13.259 14.0815L12.7833 16.9368C12.6942 17.4718 12.0376 17.6821 11.6542 17.2985Z'
          fill='currentColor'
          stroke='currentColor'
          strokeWidth='1.333'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M7.01345 12.6548L1.44531 18.2258'
          stroke='currentColor'
          strokeWidth='1.333'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </IconWrapper>
  );
}
export function MyMenuFix(props: IconProps) {
  return (
    <IconWrapper {...props} style={{ color: '#A8A8A8' }}>
      <svg xmlns='http://www.w3.org/2000/svg' width='20' height='19' viewBox='0 0 20 19' fill='none'>
        <path
          d='M11.6542 17.2985L2.37158 8.01102C1.98834 7.62756 2.1987 6.97133 2.73345 6.88215L5.58704 6.40628C5.99832 6.3377 6.37788 6.14228 6.67264 5.84736L10.7589 1.75901C11.54 0.977465 12.8069 0.977465 13.588 1.75901L17.9052 6.07845C18.6857 6.85942 18.6857 8.12517 17.9052 8.90613L13.8172 12.9963C13.5226 13.291 13.3274 13.6704 13.259 14.0815L12.7833 16.9368C12.6942 17.4718 12.0376 17.6821 11.6542 17.2985Z'
          stroke='currentColor'
          strokeWidth='1.333'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M7.01345 12.6548L1.44531 18.2258'
          stroke='currentColor'
          strokeWidth='1.333'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </IconWrapper>
  );
}

export function ChannelCalendar(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper {...rest} style={{ color: 'var(--colorIco19)', ...style }}>
      <svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' viewBox='0 0 34 34' fill='none'>
        <path
          d='M29.9272 33.0894H4.07275C2.07275 33.0894 0.445312 31.4614 0.445312 29.4614V8.69092C0.445312 6.69092 2.07275 5.06299 4.07275 5.06299H29.9272C31.9272 5.06299 33.5547 6.69092 33.5547 8.69092V29.4614C33.5547 31.4614 31.9272 33.0894 29.9272 33.0894ZM4.07275 8.17236C3.79199 8.17236 3.55468 8.40966 3.55468 8.69091V29.4614C3.55468 29.7427 3.79198 29.98 4.07275 29.98H29.9272C30.208 29.98 30.4453 29.7427 30.4453 29.4614V8.69092C30.4453 8.40967 30.208 8.17237 29.9272 8.17237L4.07275 8.17236Z'
          fill='currentColor'
        />
        <path
          d='M31.4834 16.478H2.51758C1.65918 16.478 0.962891 15.7817 0.962891 14.9233C0.962891 14.0649 1.65918 13.3687 2.51758 13.3687H31.4834C32.3418 13.3687 33.0381 14.0649 33.0381 14.9233C33.0381 15.7817 32.3418 16.478 31.4834 16.478Z'
          fill='currentColor'
        />
        <path
          d='M9.75781 7.39405C8.89941 7.39405 8.20312 6.69776 8.20312 5.83936V2.7251C8.20312 1.8667 8.89941 1.17041 9.75781 1.17041C10.6162 1.17041 11.3125 1.8667 11.3125 2.7251V5.83936C11.3125 6.69776 10.6162 7.39405 9.75781 7.39405Z'
          fill='currentColor'
        />
        <path
          d='M24.2402 7.13428C23.3818 7.13428 22.6855 6.43799 22.6855 5.57959V2.46533C22.6855 1.60693 23.3818 0.910645 24.2402 0.910645C25.0986 0.910645 25.7949 1.60693 25.7949 2.46533V5.57959C25.7949 6.43799 25.0986 7.13428 24.2402 7.13428Z'
          fill='currentColor'
        />
      </svg>
    </IconWrapper>
  );
}

export function IcoSnsFace({ style, ...rest }: IconProps) {
  return (
    <IconWrapper {...rest} style={{ color: 'var(--colorIco22)', fontSize: 20, ...style }}>
      <svg width='1em' height='1.8em' viewBox='0 0 20 36' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M12.982 36V19.5788H18.8784L19.7609 13.179H12.982V9.09288C12.982 7.24037 13.5313 5.97716 16.3746 5.97716L20 5.97592V0.2524C19.3722 0.17467 17.2209 0 14.7177 0C9.4899 0 5.91205 2.98267 5.91205 8.45939V13.179H0V19.5788H5.91205V36L12.982 36Z'
          fill='currentColor'
        />
      </svg>
    </IconWrapper>
  );
}
export function IcoSnsFaceColor({ style, ...rest }: IconProps) {
  return (
    <IconWrapper {...rest} style={{ ...style }}>
      <svg xmlns='http://www.w3.org/2000/svg' width='20' height='36' viewBox='0 0 20 36' fill='none'>
        <path
          d='M12.982 36V19.5788H18.8784L19.7609 13.179H12.982V9.09288C12.982 7.24037 13.5313 5.97716 16.3746 5.97716L20 5.97592V0.2524C19.3722 0.17467 17.2209 0 14.7177 0C9.4899 0 5.91205 2.98267 5.91205 8.45939V13.179H0V19.5788H5.91205V36L12.982 36Z'
          fill='#3B5998'
        />
      </svg>
    </IconWrapper>
  );
}
export function IcoSnsInsta(props: IconProps) {
  return (
    <IconWrapper {...props} style={{ color: 'var(--colorIco22)' }}>
      <svg width='4em' height='4em' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M26.3536 8.09235H13.647C10.5391 8.09235 8.01953 10.6117 8.01953 13.7198V26.4264C8.01953 29.5342 10.5391 32.0539 13.647 32.0539H26.3536C29.4618 32.0539 31.9815 29.5342 31.9815 26.4264V13.7198C31.9815 10.6117 29.4618 8.09235 26.3536 8.09235ZM20.0005 27.6938C15.7916 27.6938 12.3796 24.2821 12.3796 20.073C12.3796 15.864 15.7916 12.452 20.0005 12.452C24.2094 12.452 27.6215 15.8641 27.6215 20.073C27.6215 24.2819 24.2093 27.6938 20.0005 27.6938ZM27.8754 13.9379C26.895 13.9379 26.1001 13.1429 26.1001 12.1623C26.1001 11.1817 26.895 10.3868 27.8754 10.3868C28.856 10.3868 29.6509 11.1817 29.6509 12.1623C29.6509 13.1429 28.856 13.9379 27.8754 13.9379Z'
          fill='currentColor'
        />
        <path
          d='M40 9.06014C40 4.07706 35.9231 0 30.94 0H9.06004C4.07695 0 0 4.07706 0 9.06014V30.94C0 35.9229 4.07694 40 9.06004 40H30.94C35.923 40 40 35.9229 40 30.94V9.06014ZM34.6857 26.208C34.6857 30.8904 30.8902 34.6857 26.208 34.6857H13.7919C9.10974 34.6857 5.31429 30.8904 5.31429 26.208V13.7921C5.31429 9.10995 9.10975 5.31438 13.7919 5.31438H26.208C30.8902 5.31438 34.6857 9.10995 34.6857 13.7921V26.208Z'
          fill='currentColor'
        />
        <path
          d='M20.0008 15.1327C17.2724 15.1327 15.0605 17.3446 15.0605 20.073C15.0605 22.8015 17.2724 25.0134 20.0008 25.0134C22.729 25.0134 24.9407 22.8015 24.9407 20.073C24.9407 17.3446 22.729 15.1327 20.0008 15.1327Z'
          fill='currentColor'
        />
      </svg>
    </IconWrapper>
  );
}
export function IcoSnsInstaColor({ style, ...rest }: IconProps) {
  return (
    <IconWrapper {...rest} style={{ ...style }}>
      <svg
        width='40'
        height='41'
        viewBox='0 0 40 41'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        xmlnsXlink='http://www.w3.org/1999/xlink'
      >
        <g id='ico-sns-insta'>
          <path
            id='Vector'
            d='M26.3536 8.09235H13.647C10.5391 8.09235 8.01953 10.6117 8.01953 13.7198V26.4264C8.01953 29.5342 10.5391 32.0539 13.647 32.0539H26.3536C29.4618 32.0539 31.9815 29.5342 31.9815 26.4264V13.7198C31.9815 10.6117 29.4618 8.09235 26.3536 8.09235ZM20.0005 27.6938C15.7916 27.6938 12.3796 24.2821 12.3796 20.073C12.3796 15.864 15.7916 12.452 20.0005 12.452C24.2094 12.452 27.6215 15.8641 27.6215 20.073C27.6215 24.2819 24.2093 27.6938 20.0005 27.6938ZM27.8754 13.9379C26.895 13.9379 26.1001 13.1429 26.1001 12.1623C26.1001 11.1817 26.895 10.3868 27.8754 10.3868C28.856 10.3868 29.6509 11.1817 29.6509 12.1623C29.6509 13.1429 28.856 13.9379 27.8754 13.9379Z'
            fill='#A8A8A8'
          />
          <path
            id='Vector_2'
            d='M40 9.06014C40 4.07706 35.9231 0 30.94 0H9.06004C4.07695 0 0 4.07706 0 9.06014V30.94C0 35.9229 4.07694 40 9.06004 40H30.94C35.923 40 40 35.9229 40 30.94V9.06014ZM34.6857 26.208C34.6857 30.8904 30.8902 34.6857 26.208 34.6857H13.7919C9.10974 34.6857 5.31429 30.8904 5.31429 26.208V13.7921C5.31429 9.10995 9.10975 5.31438 13.7919 5.31438H26.208C30.8902 5.31438 34.6857 9.10995 34.6857 13.7921V26.208Z'
            fill='#A8A8A8'
          />
          <path
            id='Vector_3'
            d='M20.0008 15.1327C17.2724 15.1327 15.0605 17.3446 15.0605 20.073C15.0605 22.8015 17.2724 25.0134 20.0008 25.0134C22.729 25.0134 24.9407 22.8015 24.9407 20.073C24.9407 17.3446 22.729 15.1327 20.0008 15.1327Z'
            fill='#A8A8A8'
          />
          <rect id='Asset 133 1' width='40' height='41' fill='url(#pattern0_7055_10445)' />
          <g id='a'>
            <g id='Group'>
              <path
                id='Vector_4'
                d='M26.2159 5.32187H13.7998C9.11769 5.32187 5.32227 9.11747 5.32227 13.7995V26.2154C5.32227 30.8978 9.11769 34.6931 13.7998 34.6931H26.2159C30.898 34.6931 34.6936 30.8978 34.6936 26.2154V13.7995C34.6936 9.11746 30.898 5.32187 26.2159 5.32187ZM31.9888 26.4338C31.9888 29.5416 29.4691 32.0612 26.361 32.0612H13.6545C10.5465 32.0612 8.027 29.5416 8.027 26.4338V13.7273C8.027 10.6192 10.5465 8.09978 13.6545 8.09978H26.361C29.4691 8.09978 31.9888 10.6192 31.9888 13.7273L31.9888 26.4338Z'
                fill='white'
              />
              <path
                id='Vector_5'
                d='M20.0076 12.4595C15.7987 12.4595 12.3867 15.8716 12.3867 20.0805C12.3867 24.2894 15.7987 27.7013 20.0076 27.7013C24.2166 27.7013 27.6286 24.2894 27.6286 20.0805C27.6286 15.8716 24.2164 12.4595 20.0076 12.4595ZM20.0076 25.0208C17.2792 25.0208 15.0675 22.8089 15.0675 20.0805C15.0675 17.3521 17.2793 15.1402 20.0076 15.1402C22.7359 15.1402 24.9475 17.3521 24.9475 20.0805C24.9475 22.8089 22.7359 25.0208 20.0076 25.0208Z'
                fill='white'
              />
              <path
                id='Vector_6'
                d='M27.8826 10.3943C26.9023 10.3943 26.1074 11.1892 26.1074 12.1698C26.1074 13.1504 26.9023 13.9453 27.8826 13.9453C28.8632 13.9453 29.6582 13.1504 29.6582 12.1698C29.6582 11.1892 28.8632 10.3943 27.8826 10.3943Z'
                fill='white'
              />
            </g>
          </g>
        </g>
        <defs>
          <pattern id='pattern0_7055_10445' patternContentUnits='objectBoundingBox' width='1' height='1'>
            <use xlinkHref='#image0_7055_10445' transform='scale(0.025 0.0243902)' />
          </pattern>
          <image
            id='image0_7055_10445'
            data-name='Asset 133.png'
            width='40'
            height='41'
            xlinkHref='data:image/png;base64,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'
          />
        </defs>
      </svg>
    </IconWrapper>
  );
}
export function IcoSnsNaver({ style, ...rest }: IconProps) {
  return (
    <IconWrapper {...rest} style={{ color: 'var(--colorIco22)', ...style }}>
      <svg width='44' height='38' viewBox='0 0 44 38' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M24.608 14.9725C23.6501 14.9725 22.877 15.7648 22.877 16.7498C22.877 17.7304 23.6501 18.5227 24.608 18.5227C25.5634 18.5227 26.3384 17.7304 26.3384 16.7498C26.3384 15.7648 25.5634 14.9725 24.608 14.9725Z'
          fill='currentColor'
        />
        <path
          d='M9.17845 14.9725C8.22161 14.9725 7.44922 15.7648 7.44922 16.7498C7.44922 17.7304 8.2216 18.5227 9.17845 18.5227C10.1349 18.5227 10.9092 17.7304 10.9092 16.7498C10.9092 15.7648 10.1349 14.9725 9.17845 14.9725Z'
          fill='currentColor'
        />
        <path
          d='M37.0484 0H6.94671C3.10682 0 0 3.20944 0 7.16145V24.1476C0 28.0979 3.10682 31.3041 6.94671 31.3041H17.3179L20.8568 37.2164C20.8568 37.2164 20.893 37.2902 20.9699 37.3862C21.1775 37.7521 21.5593 38 22 38C22.4377 38 22.815 37.7521 23.0236 37.3946C23.113 37.2902 23.1444 37.2164 23.1444 37.2164L26.679 31.3041H37.0484C40.8864 31.3041 44 28.0979 44 24.1476V7.16145C44 3.20944 40.8864 0 37.0484 0ZM9.77392 20.9621C8.1515 20.9621 7.50969 19.7687 7.50969 19.7687V20.6707H4.78962V9.15162H7.47875V13.5396C8.57032 12.4453 9.77392 12.4453 9.77392 12.4453C13.4275 12.4453 13.5671 16.6532 13.5671 16.6532C13.5671 20.814 9.77392 20.9621 9.77392 20.9621ZM18.2593 13.2215V20.6707H15.6608V13.8524C15.6608 11.5002 14.4353 11.5571 14.4353 11.5571V8.88744C18.371 8.88744 18.2593 13.2215 18.2593 13.2215ZM29.1607 16.7498C29.1607 20.9538 24.6072 20.9621 24.6072 20.9621C20.0123 20.9621 20.1546 16.7498 20.1546 16.7498C20.1546 12.4851 24.6072 12.4851 24.6072 12.4851C29.3112 12.4851 29.1607 16.7498 29.1607 16.7498ZM39.2115 20.5657C39.2115 24.9273 35.2742 24.8834 35.2742 24.8834H34.2257V22.4348H34.877C36.7831 22.4348 36.5922 20.4138 36.5922 20.4138V19.7687C35.7527 20.8839 34.2257 20.8231 34.2257 20.8231C30.4801 20.8231 30.5209 16.7196 30.5209 16.7196C30.5209 12.3148 34.3302 12.4851 34.3302 12.4851C35.818 12.4851 36.5922 13.5396 36.5922 13.5396V12.7556H39.2115L39.2115 20.5657Z'
          fill='currentColor'
        />
        <path
          d='M34.9834 14.9725C34.0281 14.9725 33.252 15.7648 33.252 16.7498C33.252 17.7304 34.0281 18.5227 34.9834 18.5227C35.9403 18.5227 36.7131 17.7304 36.7131 16.7498C36.7131 15.7648 35.9403 14.9725 34.9834 14.9725Z'
          fill='currentColor'
        />
      </svg>
    </IconWrapper>
  );
}

export function IcoSnsNaverColor({ style, ...rest }: IconProps) {
  return (
    <IconWrapper {...rest} style={{ ...style }}>
      <svg xmlns='http://www.w3.org/2000/svg' width='44' height='38' viewBox='0 0 44 38' fill='none'>
        <path
          d='M24.608 14.9725C23.6501 14.9725 22.877 15.7648 22.877 16.7498C22.877 17.7304 23.6501 18.5227 24.608 18.5227C25.5634 18.5227 26.3384 17.7304 26.3384 16.7498C26.3384 15.7648 25.5634 14.9725 24.608 14.9725Z'
          fill='#1EC800'
        />
        <path
          d='M9.17845 14.9725C8.22161 14.9725 7.44922 15.7648 7.44922 16.7498C7.44922 17.7304 8.2216 18.5227 9.17845 18.5227C10.1349 18.5227 10.9092 17.7304 10.9092 16.7498C10.9092 15.7648 10.1349 14.9725 9.17845 14.9725Z'
          fill='#1EC800'
        />
        <path
          d='M37.0484 0H6.94671C3.10682 0 0 3.20944 0 7.16145V24.1476C0 28.0979 3.10682 31.3041 6.94671 31.3041H17.3179L20.8568 37.2164C20.8568 37.2164 20.893 37.2902 20.9699 37.3862C21.1775 37.7521 21.5593 38 22 38C22.4377 38 22.815 37.7521 23.0236 37.3946C23.113 37.2902 23.1444 37.2164 23.1444 37.2164L26.679 31.3041H37.0484C40.8864 31.3041 44 28.0979 44 24.1476V7.16145C44 3.20944 40.8864 0 37.0484 0ZM9.77392 20.9621C8.1515 20.9621 7.50969 19.7688 7.50969 19.7688V20.6707H4.78962V9.15162H7.47875V13.5396C8.57032 12.4454 9.77392 12.4453 9.77392 12.4453C13.4275 12.4453 13.5671 16.6532 13.5671 16.6532C13.5671 20.814 9.77392 20.9621 9.77392 20.9621ZM18.2593 13.2215V20.6707H15.6608V13.8523C15.6608 11.5002 14.4353 11.5571 14.4353 11.5571V8.88744C18.371 8.88744 18.2593 13.2215 18.2593 13.2215ZM29.1607 16.7498C29.1607 20.9538 24.6072 20.9621 24.6072 20.9621C20.0123 20.9621 20.1546 16.7498 20.1546 16.7498C20.1546 12.4851 24.6072 12.4851 24.6072 12.4851C29.3112 12.4851 29.1607 16.7498 29.1607 16.7498ZM39.2115 20.5657C39.2115 24.9273 35.2742 24.8834 35.2742 24.8834H34.2257V22.4348H34.877C36.7831 22.4348 36.5922 20.4138 36.5922 20.4138V19.7688C35.7527 20.8839 34.2257 20.8231 34.2257 20.8231C30.4801 20.8231 30.5209 16.7196 30.5209 16.7196C30.5209 12.3148 34.3302 12.485 34.3302 12.485C35.818 12.485 36.5922 13.5396 36.5922 13.5396V12.7556H39.2115L39.2115 20.5657Z'
          fill='#1EC800'
        />
        <path
          d='M34.9834 14.9725C34.0281 14.9725 33.252 15.7648 33.252 16.7498C33.252 17.7304 34.0281 18.5227 34.9834 18.5227C35.9403 18.5227 36.7131 17.7304 36.7131 16.7498C36.7131 15.7648 35.9403 14.9725 34.9834 14.9725Z'
          fill='#1EC800'
        />
      </svg>
    </IconWrapper>
  );
}

export function IcoSnsX(props: IconProps) {
  return (
    <IconWrapper {...props} style={{ color: 'var(--colorIco22)' }}>
      <svg width='32' height='29' viewBox='0 0 32 29' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_14954_13)'>
          <path
            d='M25.2019 0H30.1087L19.3887 12.2841L32 29H22.1254L14.3913 18.8619L5.54174 29H0.631901L12.0981 15.8608L0 0H10.1252L17.1162 9.26662L25.2019 0ZM23.4797 26.0554H26.1987L8.64785 2.78995H5.73013L23.4797 26.0554Z'
            fill='currentColor'
          />
        </g>
      </svg>
    </IconWrapper>
  );
}
export function IcoSnsXColor({ style, ...rest }: IconProps) {
  return (
    <IconWrapper {...rest} style={{ ...style }}>
      <svg width='32' height='29' viewBox='0 0 32 29' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_14954_15)'>
          <path
            d='M25.2019 0H30.1087L19.3887 12.2841L32 29H22.1254L14.3913 18.8619L5.54174 29H0.631901L12.0981 15.8608L0 0H10.1252L17.1162 9.26662L25.2019 0ZM23.4797 26.0554H26.1987L8.64785 2.78995H5.73013L23.4797 26.0554Z'
            fill='black'
          />
        </g>
      </svg>
    </IconWrapper>
  );
}
export function IcoSnsYou({ style, ...rest }: IconProps) {
  return (
    <IconWrapper {...rest} style={{ color: 'var(--colorIco22)', ...style }}>
      <svg width='44' height='32' viewBox='0 0 44 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M43.0806 4.99687C42.5746 3.03 41.0836 1.48099 39.1905 0.95524C35.7592 -2.38419e-07 22 0 22 0C22 0 8.24082 -2.38419e-07 4.80949 0.95524C2.91638 1.48099 1.42545 3.03 0.919418 4.99687C-1.66893e-06 8.56189 0 16 0 16C0 16 -1.66893e-06 23.4382 0.919418 27.0032C1.42545 28.97 2.91638 30.519 4.80949 31.0448C8.24082 32 22 32 22 32C22 32 35.7592 32 39.1905 31.0448C41.0836 30.519 42.5746 28.97 43.0806 27.0032C44 23.4381 44 16 44 16C44 16 44 8.56188 43.0806 4.99687ZM17.6 22.8572V9.14288L29.031 16.0002L17.6 22.8572Z'
          fill='currentColor'
        />
      </svg>
    </IconWrapper>
  );
}

export function IcoSnsYouColor({ style, ...rest }: IconProps) {
  return (
    <IconWrapper {...rest} style={{ ...style }}>
      <svg xmlns='http://www.w3.org/2000/svg' width='44' height='32' viewBox='0 0 44 32' fill='none'>
        <path
          d='M43.0806 4.99687C42.5746 3.03 41.0836 1.48099 39.1905 0.95524C35.7592 0 22 0 22 0C22 0 8.24082 0 4.80949 0.95524C2.91638 1.48099 1.42545 3.03 0.919418 4.99687C-1.66893e-06 8.56189 0 16 0 16C0 16 -1.66893e-06 23.4382 0.919418 27.0032C1.42545 28.97 2.91638 30.519 4.80949 31.0448C8.24082 32 22 32 22 32C22 32 35.7592 32 39.1905 31.0448C41.0836 30.519 42.5746 28.97 43.0806 27.0032C44 23.4381 44 16 44 16C44 16 44 8.56188 43.0806 4.99687ZM17.6 22.8572V9.14288L29.031 16.0002L17.6 22.8572Z'
          fill='#FF0000'
        />
      </svg>
    </IconWrapper>
  );
}

export function AlarmTimer(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ ...style }} {...rest}>
      <svg width='1.2em' height='1.3em' viewBox='0 0 12 13' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_5387_11293)'>
          <mask
            id='mask0_5387_11293'
            style={{ maskType: 'luminance' }}
            maskUnits='userSpaceOnUse'
            x='0'
            y='0'
            width='1.2em'
            height='1.3em'
          >
            <path d='M12 0.5H0V12.5H12V0.5Z' fill='white' />
          </mask>
          <g mask='url(#mask0_5387_11293)'>
            <path
              fillRule='evenodd'
              clipRule='evenodd'
              d='M6 1.78595C4.98284 1.78595 3.98852 2.08757 3.14278 2.65268C2.29705 3.21778 1.63787 4.02099 1.24862 4.96072C0.859372 5.90046 0.757526 6.93451 0.955965 7.93213C1.1544 8.92975 1.64421 9.84612 2.36345 10.5654C3.0827 11.2846 3.99906 11.7744 4.99668 11.9728C5.9943 12.1713 7.02836 12.0694 7.96809 11.6802C8.90782 11.2909 9.71103 10.6318 10.2761 9.78603C10.8412 8.94029 11.1429 7.94597 11.1429 6.92881C11.1429 5.56484 10.601 4.25673 9.63655 3.29226C8.67208 2.32779 7.36397 1.78595 6 1.78595ZM5.57143 3.92881V6.92881C5.57143 6.99534 5.58692 7.06096 5.61668 7.12047C5.64643 7.17998 5.68963 7.23175 5.74286 7.27167L7.45715 8.55738C7.54808 8.62558 7.66238 8.65486 7.7749 8.63879C7.88742 8.62271 7.98895 8.5626 8.05715 8.47167C8.12534 8.38073 8.15463 8.26643 8.13855 8.15391C8.12248 8.04139 8.06236 7.93986 7.97143 7.87167L6.42857 6.71452V3.92881C6.42857 3.81514 6.38342 3.70614 6.30305 3.62576C6.22268 3.54539 6.11367 3.50024 6 3.50024C5.88634 3.50024 5.77733 3.54539 5.69696 3.62576C5.61658 3.70614 5.57143 3.81514 5.57143 3.92881ZM8.72572 1.25795L11.2971 3.40081C11.3848 3.47035 11.4962 3.50286 11.6075 3.4914C11.7187 3.47993 11.8211 3.4254 11.8928 3.33945C11.9644 3.25349 11.9996 3.14294 11.9908 3.0314C11.982 2.91987 11.9299 2.81619 11.8457 2.74252L9.27429 0.599666C9.23128 0.562038 9.18118 0.533393 9.12693 0.515414C9.07269 0.497436 9.0154 0.490487 8.95842 0.494978C8.90145 0.499468 8.84596 0.515307 8.7952 0.541562C8.74444 0.567817 8.69945 0.603958 8.66286 0.647859C8.62628 0.69176 8.59884 0.742535 8.58217 0.797195C8.5655 0.851856 8.55993 0.909299 8.56579 0.966144C8.57164 1.02299 8.58881 1.07809 8.61627 1.1282C8.64374 1.17832 8.68095 1.22243 8.72572 1.25795ZM2.72572 0.599666L0.154289 2.74252C0.0700819 2.81619 0.0180216 2.91987 0.00923014 3.0314C0.000438635 3.14294 0.035613 3.25349 0.107239 3.33945C0.178864 3.4254 0.281262 3.47993 0.392556 3.4914C0.50385 3.50286 0.615215 3.47035 0.70286 3.40081L3.27429 1.25795C3.31906 1.22243 3.35627 1.17832 3.38373 1.1282C3.4112 1.07809 3.42836 1.02299 3.43422 0.966144C3.44008 0.909299 3.4345 0.851856 3.41783 0.797195C3.40116 0.742535 3.37373 0.69176 3.33714 0.647859C3.30056 0.603958 3.25556 0.567817 3.20481 0.541562C3.15405 0.515307 3.09855 0.499468 3.04158 0.494978C2.98461 0.490487 2.92732 0.497436 2.87307 0.515414C2.81883 0.533393 2.76873 0.562038 2.72572 0.599666Z'
              fill='#777777'
            />
          </g>
        </g>
      </svg>
    </IconWrapper>
  );
}

export function SearchBtn(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper {...rest} style={{ color: 'var(--colorIco01)', ...style }}>
      <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
        <path
          d='M19.3999 18.41L15.4299 14.45C16.8199 12.91 17.6699 10.89 17.6699 8.66C17.6799 3.89 13.7899 0 8.99995 0C4.20995 0 0.319946 3.89 0.319946 8.66C0.319946 13.43 4.20995 17.32 8.99995 17.32C10.8799 17.32 12.6199 16.71 14.0399 15.69L18.0799 19.72C18.2599 19.9 18.4999 19.99 18.7399 19.99C18.9799 19.99 19.2199 19.9 19.3999 19.72C19.7599 19.36 19.7599 18.77 19.3999 18.4V18.41ZM2.18995 8.66C2.18995 4.91 5.24995 1.86 9.00995 1.86C12.7699 1.86 15.8299 4.91 15.8299 8.66C15.8299 12.41 12.7699 15.46 9.00995 15.46C5.24995 15.46 2.18995 12.41 2.18995 8.66Z'
          fill='currentColor'
        />
      </svg>
    </IconWrapper>
  );
}

export function MyEditImg(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper {...rest} style={{ color: 'var(--colorIco39)', fontSize: 36, ...style }}>
      <svg width='1em' height='1em' viewBox='0 0 36 36' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_7055_10409)'>
          <path
            d='M18 35.5C27.665 35.5 35.5 27.665 35.5 18C35.5 8.33502 27.665 0.5 18 0.5C8.33502 0.5 0.5 8.33502 0.5 18C0.5 27.665 8.33502 35.5 18 35.5Z'
            fill='currentColor'
          />
          <path
            d='M17.9987 22.0444C19.3732 22.0444 20.4875 20.9301 20.4875 19.5555C20.4875 18.181 19.3732 17.0667 17.9987 17.0667C16.6241 17.0667 15.5098 18.181 15.5098 19.5555C15.5098 20.9301 16.6241 22.0444 17.9987 22.0444Z'
            stroke='white'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M22.9771 17.0666C23.1489 17.0666 23.2882 16.9273 23.2882 16.7554C23.2882 16.5836 23.1489 16.4443 22.9771 16.4443C22.8053 16.4443 22.666 16.5836 22.666 16.7554C22.666 16.9273 22.8053 17.0666 22.9771 17.0666Z'
            stroke='white'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M22.6663 13.3333H13.4885C11.3496 13.3333 9.59961 14.8888 9.59961 16.79V23.0123C9.59961 24.5333 11.2796 25.7777 13.3329 25.7777H22.5107C24.6496 25.7777 26.3996 24.2221 26.3996 22.3209V16.0987C26.3996 14.5777 24.7196 13.3333 22.6663 13.3333Z'
            stroke='white'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M12.7109 13.3333C12.7109 11.6178 13.9537 10.2222 15.4813 10.2222H20.5183C22.0459 10.2222 23.2887 11.6178 23.2887 13.3333'
            stroke='white'
            strokeWidth='1.5'
            strokeMiterlimit='10'
          />
        </g>
      </svg>
    </IconWrapper>
  );
}

export function IcoReport(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper {...rest} style={{ color: 'var(--colorIco22)', ...style }}>
      <svg xmlns='http://www.w3.org/2000/svg' width='54' height='54' viewBox='0 0 54 54' fill='none'>
        <g clipPath='url(#clip0_5022_58151)'>
          <path
            d='M45.0262 9.81836H8.97381C7.40781 9.81836 6.13635 11.1045 6.13635 12.6804V41.32C6.13635 42.8958 7.40781 44.182 8.97381 44.182H25.3309C25.8218 44.182 26.2145 43.7844 26.2145 43.2885C26.2145 42.7927 25.8169 42.3951 25.3309 42.3951H8.97381C8.38472 42.3951 7.90853 41.914 7.90853 41.32V19.1555H46.0964V21.5216C46.0964 22.0125 46.494 22.4151 46.98 22.4151C47.466 22.4151 47.8636 22.0175 47.8636 21.5216V12.6804C47.8636 11.0996 46.5922 9.81836 45.0262 9.81836ZM7.90853 17.3685V12.6804C7.90853 12.0864 8.38472 11.6053 8.97381 11.6053H45.0262C45.6153 11.6053 46.0914 12.0864 46.0914 12.6804V17.3685H7.90853Z'
            fill='currentColor'
          />
          <path
            d='M37.9865 24.334C32.562 24.334 28.1536 28.7865 28.1536 34.2602C28.1536 39.7338 32.5669 44.1863 37.9865 44.1863C43.4062 44.1863 47.8194 39.7338 47.8194 34.2602C47.8194 28.7865 43.4062 24.334 37.9865 24.334ZM37.9865 42.3945C33.5389 42.3945 29.9209 38.7422 29.9209 34.2553C29.9209 29.7683 33.5389 26.116 37.9865 26.116C42.4342 26.116 46.0522 29.7683 46.0522 34.2553C46.0522 38.7422 42.4342 42.3945 37.9865 42.3945Z'
            fill='currentColor'
          />
          <path
            d='M42.4096 29.7936C42.066 29.4451 41.5064 29.4451 41.1578 29.7936L37.9865 32.9944L34.8153 29.7936C34.4716 29.4451 33.912 29.4451 33.5635 29.7936C33.2198 30.1422 33.2198 30.7067 33.5635 31.0553L36.7347 34.256L33.5635 37.4567C33.2198 37.8053 33.2198 38.3698 33.5635 38.7184C33.7353 38.8951 33.9611 38.9785 34.1869 38.9785C34.4127 38.9785 34.6385 38.8902 34.8104 38.7184L37.9816 35.5176L41.1529 38.7184C41.3247 38.8951 41.5505 38.9785 41.7764 38.9785C42.0022 38.9785 42.228 38.8902 42.3998 38.7184C42.7435 38.3698 42.7435 37.8053 42.3998 37.4567L39.2285 34.256L42.3998 31.0553C42.7435 30.7067 42.7435 30.1422 42.3998 29.7936H42.4096Z'
            fill='currentColor'
          />
        </g>
        <defs>
          <clipPath id='clip0_5022_58151'>
            <rect width='54' height='54' fill='white' />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  );
}

export function IcoIllegal(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper {...rest} style={{ color: 'var(--colorIco22)', ...style }}>
      <svg xmlns='http://www.w3.org/2000/svg' width='54' height='54' viewBox='0 0 54 54' fill='none'>
        <g clipPath='url(#clip0_5022_58154)'>
          <path
            d='M25.4831 41.6345H16.6173C15.9988 41.6345 15.4931 41.1288 15.4931 40.5103V35.0219V18.7875V13.2992C15.4931 12.6806 15.9988 12.175 16.6173 12.175H45.2815C45.9 12.175 46.4057 12.6806 46.4057 13.2992V20.599C46.4057 21.1145 46.823 21.5268 47.3335 21.5268C47.844 21.5268 48.2613 21.1095 48.2613 20.599V13.2992C48.2613 11.6546 46.9211 10.3145 45.2766 10.3145H16.6124C14.9679 10.3145 13.6277 11.6546 13.6277 13.2992V15.361V17.2559L10.7755 15.7783C9.50896 15.1205 8.22278 15.0861 7.25078 15.6801C6.27387 16.2692 5.71423 17.4277 5.71423 18.8563V34.9532C5.71423 36.3817 6.27387 37.5354 7.24587 38.1294C8.22278 38.7234 9.50405 38.689 10.7706 38.0312L13.6228 36.5535V38.0901V40.5103C13.6228 42.1548 14.963 43.495 16.6075 43.495H25.4733C25.9888 43.495 26.4011 43.0777 26.4011 42.5672C26.4011 42.0566 25.9839 41.6394 25.4733 41.6394L25.4831 41.6345ZM9.92623 36.3768C9.24878 36.7254 8.63023 36.7843 8.22278 36.5339C7.81532 36.2885 7.5846 35.7092 7.5846 34.9483V18.8514C7.5846 18.0905 7.81532 17.5112 8.22769 17.2657C8.63514 17.0203 9.25369 17.0743 9.93114 17.4277L13.6375 19.3472V34.4574L9.93114 36.3768H9.92623Z'
            fill='currentColor'
          />
          <path
            d='M37.9424 23.0234C32.2429 23.0234 27.6088 27.6576 27.6088 33.3571C27.6088 39.0565 32.2429 43.6907 37.9424 43.6907C43.6419 43.6907 48.276 39.0565 48.276 33.3571C48.276 27.6576 43.6419 23.0234 37.9424 23.0234ZM37.9424 41.8302C33.2689 41.8302 29.4693 38.0305 29.4693 33.3571C29.4693 28.6836 33.2689 24.884 37.9424 24.884C42.6159 24.884 46.4155 28.6836 46.4155 33.3571C46.4155 38.0305 42.6159 41.8302 37.9424 41.8302Z'
            fill='currentColor'
          />
          <path
            d='M42.5864 28.708C42.2231 28.3447 41.634 28.3447 41.2708 28.708L37.9375 32.0413L34.6042 28.708C34.2409 28.3447 33.6518 28.3447 33.2886 28.708C32.9253 29.0713 32.9253 29.6604 33.2886 30.0236L36.6218 33.3569L33.2886 36.6902C32.9253 37.0535 32.9253 37.6425 33.2886 38.0058C33.4702 38.1875 33.7058 38.2807 33.9464 38.2807C34.1869 38.2807 34.4226 38.1875 34.6042 38.0058L37.9375 34.6725L41.2708 38.0058C41.4524 38.1875 41.688 38.2807 41.9286 38.2807C42.1691 38.2807 42.4047 38.1875 42.5864 38.0058C42.9497 37.6425 42.9497 37.0535 42.5864 36.6902L39.2531 33.3569L42.5864 30.0236C42.9497 29.6604 42.9497 29.0713 42.5864 28.708Z'
            fill='currentColor'
          />
        </g>
        <defs>
          <clipPath id='clip0_5022_58154'>
            <rect width='54' height='54' fill='white' />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  );
}

export function IcoFileImage(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper {...rest} style={{ color: 'var(--colorIco01)', ...style }}>
      <svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' viewBox='0 0 16 16' fill='none'>
        <mask
          id='mask0_5417_8453'
          style={{ maskType: 'luminance' }}
          maskUnits='userSpaceOnUse'
          x='0'
          y='0'
          width='16'
          height='16'
        >
          <path d='M16 0H0V16H16V0Z' fill='white' />
        </mask>
        <g mask='url(#mask0_5417_8453)'>
          <path
            d='M14.25 0H1.75C0.783333 0 0 0.783333 0 1.75V14.25C0 15.2167 0.783333 16 1.75 16H14.25C15.2167 16 16 15.2167 16 14.25V1.75C16 0.783333 15.2167 0 14.25 0ZM1.75 1.5H14.25C14.3867 1.5 14.5 1.61333 14.5 1.75V7.67333L13.0833 6.47667C12.8067 6.24 12.3967 6.24 12.1167 6.47667L9.86667 8.36L5.85 4.74333C5.56333 4.48667 5.13 4.48667 4.84667 4.74333L1.50333 7.76667V1.75C1.50333 1.61333 1.61667 1.5 1.75333 1.5M14.25 14.5H1.75C1.61333 14.5 1.5 14.3867 1.5 14.25V9.78667L5.34667 6.30667L9.34667 9.90333C9.62333 10.1533 10.0433 10.16 10.33 9.92L12.5967 8.02667L14.5 9.63667V14.25C14.5 14.3867 14.3867 14.5 14.25 14.5Z'
            fill='currentColor'
          />
          <path
            d='M11.1166 4.83008C11.8066 4.83008 12.3666 4.27008 12.3666 3.58008C12.3666 2.89008 11.8066 2.33008 11.1166 2.33008C10.4266 2.33008 9.86664 2.89008 9.86664 3.58008C9.86664 4.27008 10.4266 4.83008 11.1166 4.83008Z'
            fill='currentColor'
          />
        </g>
      </svg>
    </IconWrapper>
  );
}

export function IcoSideBarLive(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper {...rest} style={{ color: 'var(--colorIco21)', ...style }}>
      <svg xmlns='http://www.w3.org/2000/svg' width='40' height='30' viewBox='0 0 40 30' fill='none'>
        <path
          d='M2.05482 14.8878C2.07472 10.1478 3.94489 5.70958 7.32099 2.38946C7.52925 2.18259 7.64402 1.91648 7.64402 1.64019C7.64402 1.36483 7.52925 1.09872 7.32145 0.890457C7.11412 0.683127 6.84801 0.568817 6.57264 0.568817C6.29681 0.568817 6.03117 0.683127 5.82383 0.890927C2.06824 4.64607 0 9.65956 0 15.0081C0 20.3562 2.06824 25.3702 5.82384 29.1262C6.03488 29.3373 6.36022 29.4479 6.57265 29.4479C6.87625 29.4479 7.0933 29.3544 7.32146 29.1253C7.53064 28.9161 7.64588 28.65 7.64588 28.3765C7.64588 28.1025 7.53064 27.8364 7.32146 27.6272C3.90463 24.2095 2.034 19.6851 2.05482 14.8878Z'
          fill='currentColor'
        />
        <path
          d='M34.1892 0.783554C33.9921 0.634534 33.7445 0.552155 33.4918 0.552155C33.1859 0.552155 32.8971 0.672484 32.6786 0.890924C32.4708 1.09872 32.3565 1.36483 32.3565 1.64019C32.3565 1.91648 32.4713 2.18259 32.6791 2.38946C36.0959 5.80676 37.9666 10.3311 37.9457 15.1289C37.9258 19.8693 36.0557 24.3076 32.6791 27.6272C32.245 28.0613 32.245 28.6912 32.6791 29.1253C32.8906 29.3368 33.2159 29.4479 33.4279 29.4479C33.6403 29.4479 33.9657 29.3368 34.1776 29.1253C41.935 21.3674 41.9452 8.6576 34.1892 0.783554Z'
          fill='currentColor'
        />
        <path
          d='M12.7328 6.66804C12.7333 6.35982 12.6153 6.06548 12.4093 5.85953C12.2006 5.65173 11.9345 5.53696 11.6591 5.53696C11.3842 5.53696 11.1186 5.65173 10.9103 5.85953C5.86583 10.904 5.86583 19.1122 10.9103 24.1567C11.1315 24.3779 11.4541 24.4788 11.6601 24.4788C11.8716 24.4788 12.1969 24.3682 12.4093 24.1567C12.6167 23.9494 12.731 23.6833 12.731 23.4074C12.731 23.1316 12.6167 22.866 12.4089 22.6586C8.22377 18.4726 8.22377 11.6616 12.4089 7.47608C12.6148 7.27013 12.7328 6.97581 12.7328 6.66804Z'
          fill='currentColor'
        />
        <path
          d='M29.0897 5.85953C28.8824 5.65173 28.6163 5.53696 28.3409 5.53696C28.066 5.53696 27.7999 5.65127 27.5912 5.85907C27.1571 6.29364 27.1571 6.92397 27.5912 7.35807C29.6155 9.38142 30.7299 12.0772 30.7299 14.9489C30.7299 17.8201 29.6155 20.5163 27.5912 22.5402C27.3834 22.748 27.2691 23.0141 27.2691 23.2894C27.2691 23.5653 27.3834 23.8309 27.5912 24.0382C27.8032 24.2497 28.1285 24.3608 28.3409 24.3608C28.546 24.3608 28.8681 24.2595 29.0911 24.0378C31.5097 21.6752 32.8523 18.4907 32.8722 15.0697C32.893 11.5899 31.55 8.31884 29.0897 5.85953Z'
          fill='currentColor'
        />
        <path
          d='M20.0598 9.20462C16.8054 9.20462 14.2559 11.7537 14.2559 15.0081C14.2559 18.2625 16.8054 20.8121 20.0598 20.8121C23.3142 20.8121 25.8633 18.2625 25.8633 15.0081C25.8633 11.7537 23.3142 9.20462 20.0598 9.20462ZM20.0598 18.6688C17.9726 18.6688 16.3986 17.0953 16.3986 15.0081C16.3986 12.9209 17.9726 11.3474 20.0598 11.3474C22.1465 11.3474 23.7201 12.9209 23.7201 15.0081C23.7201 17.0953 22.1466 18.6688 20.0598 18.6688Z'
          fill='currentColor'
        />
      </svg>
    </IconWrapper>
  );
}

export function IcoSideBarRanking(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper {...rest} style={{ color: 'var(--colorIco21)', ...style }}>
      <svg xmlns='http://www.w3.org/2000/svg' width='40' height='36' viewBox='0 0 40 36' fill='none'>
        <path
          d='M33.9834 6.22426H33.6433V0.91247C33.6433 0.67268 33.5442 0.43809 33.371 0.26901C33.1983 0.0980101 32.9583 0 32.7125 0H7.28754C7.04224 0 6.80219 0.0975401 6.62946 0.2671C6.4563 0.43762 6.35669 0.67268 6.35669 0.91199V6.22425H6.0166C2.69971 6.22473 0.00049 8.86789 0 12.1159V13.3604C0.00049 16.6084 2.69971 19.2516 6.0166 19.2521H6.68719C8.00048 24.8634 13.1849 29.03 19.0682 29.2029V34.2374H11.1505C10.5051 34.2374 10 34.6244 10 35.1187C10 35.613 10.5051 36 11.1505 36H28.8496C29.4949 36 30 35.613 30 35.1187C30 34.6244 29.4949 34.2374 28.8496 34.2374H20.9309V29.2029C26.8147 29.03 31.999 24.8634 33.3118 19.2521H33.9824C37.2998 19.2511 39.9995 16.608 40 13.3604V12.1159C39.9995 8.86789 37.3003 6.22474 33.9834 6.22426ZM6.35622 17.4276H6.01612C4.90681 17.4272 3.86384 17.0042 3.07929 16.2363C2.29511 15.4685 1.86317 14.4472 1.86269 13.3604V12.1159C1.86318 11.0292 2.29511 10.0079 3.07881 9.24001C3.86384 8.47218 4.90682 8.04914 6.01614 8.04866H6.35622L6.35622 17.4276ZM31.7811 16.3804C31.7807 19.3195 30.6117 22.0836 28.4888 24.163C26.3654 26.2413 23.543 27.386 20.5412 27.3865H19.4588C16.457 27.386 13.6347 26.2413 11.5112 24.163C9.38881 22.0837 8.21987 19.3199 8.21938 16.3804V1.82399H31.7811V16.3804ZM38.1373 13.3604C38.1369 14.4472 37.7049 15.4684 36.9212 16.2363C36.1362 17.0042 35.0932 17.4272 33.9839 17.4276H33.6438V8.04819H33.9839C35.0932 8.04867 36.1362 8.4717 36.9207 9.23906C37.7049 10.0079 38.1368 11.0292 38.1373 12.1154L38.1373 13.3604Z'
          fill='currentColor'
        />
      </svg>
    </IconWrapper>
  );
}

export function IcoSideBarPick(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper {...rest} style={{ color: 'var(--colorIco21)', ...style }}>
      <svg xmlns='http://www.w3.org/2000/svg' width='40' height='38' viewBox='0 0 40 38' fill='none'>
        <path
          d='M39.9896 14.8686C40.0688 14.3215 39.6869 13.8118 39.1389 13.7322L26.5597 11.9525L20.8971 0.505808C20.8072 0.355198 20.6804 0.228388 20.5298 0.139958C20.369 0.0452183 20.1863 -0.00482178 20.0007 -0.00482178C19.6334 -0.00482178 19.2889 0.190978 19.0985 0.512608L13.5151 11.8981L0.86055 13.7321C0.6424 13.7642 0.438349 13.8677 0.285309 14.0246C0.0977693 14.2165 -0.00377278 14.4697 0.000107222 14.7374C0.00350722 15.0051 0.111359 15.2558 0.303269 15.4423L9.43146 24.2586L7.26941 36.8329C7.23249 37.0487 7.26844 37.2741 7.37047 37.4684C7.54489 37.7993 7.88597 38.0048 8.26056 38.0048C8.42235 38.0048 8.58316 37.965 8.72697 37.8897L19.9536 31.953L31.2724 37.8897C31.4158 37.965 31.5771 38.0048 31.7393 38.0048C31.7967 38.0048 31.853 37.9999 31.9094 37.9902C32.1742 37.945 32.4054 37.7993 32.5604 37.5802C32.7149 37.362 32.7752 37.0967 32.73 36.8329L30.5393 24.347L39.6961 15.4423C39.8536 15.2898 39.9576 15.0857 39.9896 14.8686ZM20.4671 29.9572C20.3233 29.8824 20.1615 29.8425 19.9997 29.8425C19.8379 29.8425 19.6761 29.8824 19.5323 29.9577L9.59422 35.1699L11.4924 24.1299C11.5478 23.8049 11.44 23.473 11.2034 23.2427L3.16348 15.4244L14.2744 13.8138C14.6019 13.7662 14.8847 13.5611 15.0314 13.2653L19.9997 3.22076L24.968 13.2653C25.1148 13.5611 25.3975 13.7662 25.725 13.8138L36.836 15.4244L28.7961 23.2427C28.5595 23.4735 28.4516 23.8053 28.507 24.1304L30.4052 35.1699L20.4671 29.9572Z'
          fill='currentColor'
        />
      </svg>
    </IconWrapper>
  );
}

export function JpBangStroke(props: any) {
  const { style, ...rest } = props;
  return (
    <IconWrapper {...rest} style={{ color: 'var(--colorBg07)', fontSize: 15, ...style }}>
      <svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1.06em' viewBox='0 0 15 16' fill='none'>
        <g clipPath='url(#clip0_2136_56452)'>
          <path
            d='M7.5 15.5C11.6421 15.5 15 12.1421 15 8C15 3.85786 11.6421 0.5 7.5 0.5C3.35786 0.5 0 3.85786 0 8C0 12.1421 3.35786 15.5 7.5 15.5Z'
            fill='currentColor'
          />
          <path d='M8.04803 6.31445H6.95312V11.7889H8.04803V6.31445Z' fill='white' />
          <path d='M8.04803 4.0957H6.95312V5.1906H8.04803V4.0957Z' fill='white' />
        </g>
      </svg>
    </IconWrapper>
  );
}

export function SupportNoticeSingle(props: any) {
  const { style, ...rest } = props;
  return (
    <IconWrapper {...rest} style={{ color: 'white', ...style }}>
      <svg xmlns='http://www.w3.org/2000/svg' width='11' height='11' viewBox='0 0 11 11' fill='none'>
        <g clipPath='url(#clip0_2136_77123)'>
          <path
            d='M9.24815 4.17076V3.77076C9.24815 2.18928 7.95926 0.900391 6.37407 0.900391H4.62222C3.04074 0.900391 1.75185 2.18928 1.75185 3.77076V4.17076C1.04444 4.27446 0.5 4.8078 0.5 5.45595V6.3115C0.5 7.03372 1.17037 7.61891 1.9963 7.61891C2.03333 7.61891 2.06667 7.61891 2.1037 7.6115C2.45556 8.25965 3.04815 8.75965 3.76667 8.98558C3.75926 9.03002 3.75185 9.07446 3.75185 9.12261C3.75185 9.67076 4.2 10.1189 4.74815 10.1189H6.5C7.04815 10.1189 7.4963 9.67076 7.4963 9.12261C7.4963 8.57446 7.04815 8.12632 6.5 8.12632H4.74815C4.52963 8.12632 4.32963 8.20039 4.16667 8.31891C3.2037 8.1078 2.49259 7.24854 2.49259 6.24854V3.77076C2.49259 2.59669 3.44815 1.64113 4.62593 1.64113H6.37778C7.55185 1.64113 8.51111 2.59669 8.51111 3.77076V7.24854C8.51111 7.45224 8.67778 7.61891 8.88148 7.61891C8.89259 7.61891 8.9 7.61521 8.91111 7.6115C8.94444 7.6115 8.98148 7.61891 9.00741 7.61891C9.83333 7.61891 10.5037 7.03372 10.5037 6.3115V5.45595C10.5037 4.8078 9.95926 4.27446 9.25185 4.17076H9.24815Z'
            fill='currentColor'
          />
        </g>
      </svg>
    </IconWrapper>
  );
}

export function IcoClose(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper {...rest} style={{ color: 'white', ...style }}>
      <svg xmlns='http://www.w3.org/2000/svg' width='1.2em' height='1.3em' viewBox='0 0 12 13' fill='none'>
        <g clipPath='url(#clip0_2050_48551)'>
          <path d='M1 1.5L11 11.5' stroke='currentColor' strokeWidth='2' strokeMiterlimit='10' strokeLinecap='square' />
          <path d='M11 1.5L1 11.5' stroke='currentColor' strokeWidth='2' strokeMiterlimit='10' strokeLinecap='square' />
        </g>
      </svg>
    </IconWrapper>
  );
}

export function IcoCloseThin(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper {...rest} style={{ color: 'white', fontSize: 34, ...style }}>
      <svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' viewBox='0 0 30 30' fill='none'>
        <path d='M9 21L21.0208 8.97918' stroke='currentColor' strokeLinecap='round' />
        <path d='M9 9L21.0208 21.0208' stroke='currentColor' strokeLinecap='round' />
      </svg>
    </IconWrapper>
  );
}

export function IcoAdultWarning(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper {...rest} style={{ fontSize: 10, ...style }}>
      <svg width='9.6em' height='9em' viewBox='0 0 96 90' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_7055_10179)'>
          <path
            d='M20.508 53.4388C17.749 52.2361 9.16202 57.4704 8.37033 67.964C7.56982 78.5716 15.031 79.5889 17.4671 77.167C19.9031 74.7452 18.7026 66.782 20.1076 63.0918C21.5127 59.4016 22.8614 54.4647 20.508 53.4388Z'
            fill='black'
          />
          <path
            d='M14.7875 79.0267C13.8447 79.0696 12.8591 78.8904 11.9572 78.4732C10.4569 77.7799 7.02811 75.3621 7.59111 67.9049C8.12818 60.7838 12.1341 55.9434 15.7038 53.7882C17.689 52.5898 19.6006 52.1905 20.8186 52.722C23.1358 53.7321 23.1419 57.3145 20.8361 63.3704C20.2907 64.8032 20.1598 67.0901 20.0332 69.3018C19.833 72.7998 19.644 76.1035 18.0161 77.722C17.2109 78.5228 16.0367 78.9695 14.7875 79.0267ZM19.464 54.0547C18.7463 54.0874 17.7121 54.4018 16.5097 55.1277C13.2737 57.0815 9.64031 61.4951 9.14771 68.023C8.80338 72.5854 10.0658 75.877 12.6112 77.0535C14.3232 77.8441 16.1069 77.4164 16.9162 76.6121C18.1195 75.4159 18.308 72.1202 18.4745 69.2123C18.614 66.7747 18.7458 64.4722 19.3774 62.8132C21.2203 57.9724 21.5263 54.7358 20.1956 54.1557C20.0166 54.0779 19.7689 54.0408 19.464 54.0547Z'
            fill='black'
          />
          <path
            d='M37.3081 79.8061C37.3081 87.6148 36.5409 88.8151 42.434 88.8151C48.3271 88.8151 47.5599 87.6148 47.5599 79.8061C47.5599 73.1611 45.2649 70.7971 42.434 70.7971C39.6024 70.7971 37.3081 73.1611 37.3081 79.8061Z'
            fill='black'
          />
          <path
            d='M37.5454 88.4606C36.4446 87.3445 36.4671 85.5181 36.508 82.2026C36.5168 81.483 36.5266 80.6868 36.5266 79.8062C36.5266 71.2874 40.2272 70.0153 42.4331 70.0153C44.639 70.0153 48.3396 71.2874 48.3396 79.8062C48.3396 80.6868 48.3493 81.483 48.3582 82.2026C48.399 85.5181 48.4216 87.3445 47.3208 88.4606C46.3834 89.4111 44.8189 89.5971 42.4331 89.5971C40.0473 89.5971 38.4827 89.4111 37.5454 88.4606ZM38.0878 79.8062C38.0878 80.6938 38.0781 81.4965 38.0689 82.2219C38.0344 85.0208 38.0137 86.7104 38.6562 87.3616C39.1328 87.8448 40.1915 88.0333 42.4331 88.0333C44.6746 88.0333 45.7333 87.8448 46.2099 87.3616C46.8524 86.7104 46.8317 85.0208 46.7972 82.2219C46.7881 81.4965 46.7784 80.6938 46.7784 79.8062C46.7784 76.053 46.0246 71.5791 42.4331 71.5791C38.8416 71.5791 38.0878 76.053 38.0878 79.8062Z'
            fill='black'
          />
          <path
            d='M29.4036 79.8061C29.4036 87.6148 30.1709 88.8151 24.2778 88.8151C18.3847 88.8151 19.1519 87.6148 19.1519 79.8061C19.1519 73.1611 21.4468 70.7971 24.2778 70.7971C27.1094 70.7971 29.4036 73.1611 29.4036 79.8061Z'
            fill='black'
          />
          <path
            d='M19.3911 88.4606C18.2903 87.3445 18.3128 85.5181 18.3537 82.2026C18.3626 81.483 18.3723 80.6868 18.3723 79.8062C18.3723 71.2874 22.0729 70.0153 24.2788 70.0153C26.4847 70.0153 30.1853 71.2874 30.1853 79.8062C30.1853 80.6868 30.195 81.483 30.2039 82.2026C30.2448 85.5181 30.2673 87.3445 29.1665 88.4606C28.2292 89.4111 26.6646 89.5971 24.2788 89.5971C21.893 89.5971 20.3284 89.4111 19.3911 88.4606ZM19.9336 79.8062C19.9336 80.6938 19.9238 81.4965 19.9147 82.2219C19.8802 85.0208 19.8594 86.7104 20.5019 87.3616C20.9785 87.8448 22.0373 88.0333 24.2788 88.0333C26.5203 88.0333 27.5791 87.8448 28.0556 87.3616C28.6981 86.7104 28.6774 85.0208 28.6429 82.2219C28.6338 81.4965 28.624 80.6938 28.624 79.8062C28.624 76.053 27.8702 71.5791 24.2788 71.5791C20.6874 71.5791 19.9336 76.053 19.9336 79.8062Z'
            fill='black'
          />
          <path
            d='M35.5626 80.585C45.2052 79.8212 52.4537 72.0276 51.7527 63.1775C51.0516 54.3274 42.6665 47.7722 33.0239 48.536C23.3813 49.2999 16.1328 57.0935 16.8338 65.9436C17.5349 74.7937 25.9201 81.3489 35.5626 80.585Z'
            fill='black'
          />
          <path
            d='M33.0496 48.5339C22.2651 49.3735 16.0745 56.1601 16.8318 65.9198C16.877 66.5026 16.9348 67.0655 17.0043 67.6103C22.0513 69.0874 51.8025 67.5108 51.8025 67.5108L51.8556 66.0589C51.8643 65.1538 51.8322 64.2036 51.7544 63.2011C50.868 51.777 45.4952 47.565 33.0496 48.5339Z'
            fill='white'
          />
          <path
            d='M29.2734 60.879C28.3596 60.2365 27.733 59.1608 27.7206 58.4866C27.7055 57.6633 29.2439 57.772 30.7796 57.7433C32.3152 57.7151 33.8488 57.5495 33.864 58.3728C33.8763 59.0469 33.2898 60.1452 32.4004 60.8208C33.7222 62.8712 34.6872 66.8441 34.709 68.0147C34.724 68.8344 32.1601 70.9692 31.0241 70.9901C29.8889 71.0116 27.2479 68.9734 27.2328 68.1537C27.2111 66.9831 28.029 62.9771 29.2734 60.879Z'
            fill='#F0CD9D'
          />
          <path
            d='M28.3311 70.3861C27.694 69.9031 26.6226 68.9726 26.6079 68.1653C26.5848 66.9252 27.3456 63.2673 28.4749 61.0373C27.678 60.3094 27.1103 59.2913 27.0958 58.4982C27.09 58.1843 27.1995 57.9028 27.4121 57.6841C27.9408 57.1406 28.9339 57.1334 30.1914 57.1242C30.3814 57.1228 30.5744 57.1214 30.7675 57.1178C30.9605 57.1143 31.1535 57.1086 31.3431 57.1028C32.601 57.0654 33.5937 57.0359 34.1417 57.5593C34.3625 57.7699 34.482 58.0473 34.4878 58.3612C34.5023 59.1543 33.9725 60.1928 33.2032 60.9495C34.414 63.1349 35.3098 66.7621 35.3329 68.0031C35.3562 69.2819 32.3866 71.5906 31.0354 71.6154C30.9553 71.617 30.8733 71.6122 30.7897 71.602C29.8771 71.4908 28.785 70.7303 28.3311 70.3861ZM31.3804 58.3534C31.1858 58.3592 30.9882 58.365 30.7906 58.3686C30.593 58.3722 30.3952 58.374 30.2003 58.3751C29.6048 58.3797 28.6313 58.3869 28.3481 58.5314C28.3931 58.9625 28.8504 59.8176 29.6315 60.3669C29.8989 60.5549 29.9765 60.9173 29.8096 61.1985C28.5954 63.2458 27.8376 67.1211 27.8537 68.1115C27.9835 68.6403 30.1656 70.3805 31.012 70.3646C31.8602 70.3489 33.9755 68.5284 34.0841 68.0262C34.0651 67.0045 33.1641 63.1594 31.8752 61.1601C31.6982 60.8854 31.7622 60.5199 32.0224 60.3225C32.7825 59.745 33.2082 58.8741 33.2374 58.4408C32.9486 58.3071 31.976 58.3356 31.3804 58.3534Z'
            fill='black'
          />
          <path
            d='M38.2792 8.2361C36.0955 7.40879 33.6411 6.9805 32.2786 6.828C30.2933 6.60598 28.502 6.6931 28.502 6.6931C29.1041 2.12 31.4373 0.798033 34.2206 0.804959C36.9418 0.811254 39.2248 2.08637 39.8677 6.42018C39.9876 7.23079 40.2871 8.99618 38.2792 8.2361Z'
            fill='black'
          />
          <path
            d='M39.1243 9.22543C38.789 9.22543 38.4126 9.14684 37.996 8.98929C36.0317 8.24529 33.7089 7.79812 32.1904 7.62798C30.2973 7.41667 28.5591 7.49656 28.5415 7.49719C28.2997 7.51166 28.0728 7.41324 27.9114 7.23806C27.7504 7.06261 27.675 6.82424 27.7061 6.5878C28.2815 2.21657 30.4668 0 34.1999 0H34.2234C37.8777 0.00848705 40.0445 2.12883 40.6635 6.30196L40.6704 6.3488C40.7687 7.00821 40.9514 8.23582 40.144 8.88832C39.8658 9.11315 39.5245 9.22543 39.1243 9.22543ZM38.5642 7.48304C38.882 7.60316 39.0618 7.62268 39.1277 7.61669C39.1999 7.38649 39.1114 6.79155 39.0806 6.58623L39.0737 6.53809C38.569 3.13665 37.0721 1.61659 34.2197 1.60999H34.1955C32.3696 1.60999 30.2358 2.12634 29.4557 5.87082C30.1856 5.87212 31.2426 5.902 32.3687 6.02805C33.9842 6.20886 36.4602 6.68622 38.5642 7.48304Z'
            fill='black'
          />
          <path
            d='M16.4442 15.5909C19.4298 21.4505 19.971 27.1603 17.6554 28.344C15.3392 29.5285 11.0401 25.7384 8.05457 19.8792C5.06967 14.0199 6.1361 11.4666 8.45265 10.2827C10.7682 9.09906 13.4587 9.73173 16.4442 15.5909Z'
            fill='black'
          />
          <path
            d='M16.7202 29.3646C15.503 29.3646 14.0765 28.6816 12.5743 27.3571C10.6866 25.6927 8.82683 23.167 7.33817 20.2451C5.8598 17.3433 5.24796 15.0491 5.46708 13.2312C5.66552 11.586 6.54671 10.3527 8.08692 9.56559C11.3452 7.89898 14.3976 9.80458 17.1594 15.2248C18.648 18.1467 19.5993 21.1369 19.8373 23.6446C20.0991 26.4046 19.4539 28.3281 18.0202 29.0608C17.6227 29.2639 17.1867 29.3646 16.7202 29.3646ZM10.325 10.5712C9.65502 10.5712 9.14358 10.8329 8.81743 10.9995C7.75411 11.5429 7.19658 12.3133 7.06284 13.424C6.88576 14.8934 7.45997 16.9421 8.76973 19.513C10.1686 22.2585 11.8972 24.615 13.6364 26.1486C15.1407 27.475 16.5063 28.0275 17.2893 27.6269C18.0723 27.2266 18.4267 25.7949 18.2371 23.7971C18.0177 21.4866 17.1267 18.7021 15.7278 15.9569C13.4728 11.5316 11.6083 10.5712 10.325 10.5712Z'
            fill='black'
          />
          <path
            d='M27.8174 6.08844C11.5159 8.10411 -1.65502 19.5838 1.87304 38.7181C3.56892 47.9152 10.7801 54.7741 22.434 54.8404C25.7492 54.8599 29.7154 54.4967 33.7219 54.0015C37.7284 53.5059 41.6639 52.892 44.8748 52.0657C56.1633 49.1627 61.4927 40.7535 60.9044 31.419C59.6814 11.9999 44.1189 4.0728 27.8174 6.08844Z'
            fill='white'
          />
          <path
            d='M22.3608 55.6457C21.1296 55.6457 19.1998 55.4467 19.1166 55.4379C9.51393 54.254 2.77808 48.0589 1.08314 38.8643C-0.437527 30.6174 1.02946 23.1561 5.32537 17.2874C10.1154 10.7439 18.0684 6.48279 27.7191 5.28943C37.3702 4.09607 46.1187 6.29189 52.3537 11.4725C57.9453 16.1186 61.1797 22.9985 61.7069 31.3683C62.2788 40.4444 57.4828 48.0004 48.8778 51.5808C48.853 51.5915 48.1033 51.91 46.9713 52.2889C46.55 52.4301 46.0951 52.2021 45.9545 51.7805C45.8138 51.3588 46.0411 50.9028 46.4621 50.762C47.5282 50.4051 48.2478 50.0997 48.2547 50.0969C56.2026 46.7898 60.6294 39.8275 60.1026 31.4696C59.6041 23.5539 56.5696 17.0673 51.3275 12.7118C45.4371 7.81735 37.1234 5.74886 27.9163 6.88751C18.7094 8.02581 11.147 12.0574 6.62162 18.2396C2.59413 23.7413 1.22535 30.7721 2.6635 38.5719C4.2247 47.0395 10.4429 52.7465 19.2978 53.8382C19.3021 53.8386 21.2922 54.0489 22.4283 54.0354H22.4343C22.8754 54.0354 23.2349 54.392 23.238 54.8344C23.2411 55.2791 22.8842 55.6423 22.4403 55.6454L22.3608 55.6457Z'
            fill='black'
          />
          <path
            d='M22.3317 43.3138C23.9356 43.5376 25.7567 42.7703 26.588 41.323C27.2002 40.2579 28.5213 39.9066 29.2571 40.8893C29.8718 41.7106 29.6075 43.1968 29.0524 44.0955C28.5376 44.9294 27.3584 45.8655 26.005 46.3759C24.6517 46.8865 23.5563 46.9608 22.4861 46.7567C21.4162 46.5523 20.5265 45.7143 20.5372 44.7432C20.5447 44.0185 21.2348 43.1603 22.3317 43.3138Z'
            fill='#B26B79'
          />
          <path
            d='M23.5756 47.5054C23.1715 47.5054 22.7707 47.4665 22.3663 47.3894C20.9435 47.1174 19.8811 45.9769 19.8947 44.736C19.9006 44.16 20.181 43.5773 20.6443 43.1776C21.1269 42.7613 21.7588 42.5836 22.4209 42.6761C23.8406 42.8741 25.36 42.1704 26.0312 41.0019C26.4757 40.2284 27.2423 39.7183 28.0323 39.6702C28.7103 39.6322 29.3448 39.9328 29.7718 40.5029C30.5745 41.5755 30.2822 43.3289 29.5997 44.4342C28.9766 45.4432 27.6549 46.4419 26.2321 46.9787C25.2963 47.3319 24.4295 47.5054 23.5756 47.5054ZM22.0803 43.9398C21.7968 43.9398 21.6022 44.0512 21.4832 44.1537C21.3014 44.3106 21.1828 44.5446 21.1806 44.7499C21.1737 45.3665 21.8002 45.97 22.6071 46.124C23.6368 46.3206 24.6153 46.2124 25.7788 45.7731C27.1064 45.2728 28.123 44.377 28.506 43.7568C28.954 43.0317 29.1611 41.8346 28.743 41.2755C28.5728 41.0487 28.3619 40.9409 28.1101 40.956C27.7519 40.9777 27.3736 41.2478 27.1457 41.6444C26.2089 43.2748 24.1921 44.2235 22.2433 43.9515C22.1858 43.9436 22.1315 43.9398 22.0803 43.9398Z'
            fill='#272425'
          />
          <path
            d='M7.29338 47.3451C7.27607 47.3451 7.25883 47.3442 7.24126 47.3422C6.97657 47.314 6.78479 47.0759 6.81337 46.8106L7.10435 44.0886C7.13261 43.8235 7.3681 43.6289 7.63523 43.66C7.89986 43.6883 8.0917 43.9264 8.06313 44.1918L7.77209 46.9137C7.74575 47.1611 7.53665 47.3451 7.29338 47.3451Z'
            fill='#D4708D'
          />
          <path
            d='M9.41056 47.3451C9.39331 47.3451 9.37601 47.3442 9.35845 47.3423C9.09382 47.314 8.90198 47.0759 8.93055 46.8106L9.2219 44.0886C9.25016 43.8232 9.4856 43.6289 9.75278 43.66C10.0174 43.6883 10.2092 43.9264 10.1807 44.1918L9.88933 46.9137C9.86294 47.1614 9.65383 47.3451 9.41056 47.3451Z'
            fill='#D4708D'
          />
          <path
            d='M11.8715 47.1102C11.8542 47.1102 11.837 47.1092 11.8194 47.1074C11.5548 47.0791 11.3629 46.841 11.3915 46.5756L11.6828 43.8537C11.7111 43.5883 11.9488 43.3962 12.2137 43.4251C12.4783 43.4534 12.6702 43.6914 12.6416 43.9569L12.3503 46.6788C12.3239 46.9266 12.1148 47.1102 11.8715 47.1102Z'
            fill='#D4708D'
          />
          <path
            d='M14.5121 46.3021C14.4949 46.3021 14.4776 46.3011 14.46 46.2992C14.1954 46.271 14.0035 46.0329 14.0321 45.7675L14.3231 43.0456C14.3514 42.7805 14.5888 42.5897 14.854 42.617C15.1187 42.6453 15.3105 42.8834 15.2819 43.1487L14.9909 45.8706C14.9646 46.1181 14.7554 46.3021 14.5121 46.3021Z'
            fill='#D4708D'
          />
          <path
            d='M33.5257 42.7421C33.512 42.7421 33.4981 42.7415 33.484 42.7403C33.2187 42.7176 33.0219 42.4836 33.0448 42.2179L33.3235 38.9492C33.3461 38.6835 33.5791 38.4816 33.845 38.5092C34.1103 38.5319 34.3072 38.7658 34.2842 39.0316L34.0054 42.3003C33.9841 42.5522 33.7734 42.7421 33.5257 42.7421Z'
            fill='#D4708D'
          />
          <path
            d='M36.3929 42.2877C36.379 42.2877 36.3652 42.2871 36.3514 42.2858C36.0858 42.2632 35.8893 42.0296 35.9119 41.7639L36.1901 38.4951C36.2127 38.2291 36.45 38.0294 36.7112 38.0549C36.9768 38.0775 37.1733 38.3111 37.1507 38.5768L36.8726 41.8456C36.8512 42.0975 36.6406 42.2877 36.3929 42.2877Z'
            fill='#D4708D'
          />
          <path
            d='M39.8343 40.84C39.8205 40.84 39.8067 40.8394 39.7925 40.8381C39.5273 40.8155 39.3305 40.5818 39.3534 40.3158L39.6318 37.0471C39.6544 36.7814 39.8845 36.5826 40.1533 36.6071C40.4186 36.6298 40.6154 36.8634 40.5925 37.1295L40.314 40.3982C40.2927 40.6498 40.082 40.84 39.8343 40.84Z'
            fill='#D4708D'
          />
          <path
            d='M43.3519 38.8472C43.3381 38.8472 43.3242 38.8466 43.3101 38.8454C43.0449 38.8227 42.848 38.5888 42.871 38.323L43.1497 35.0543C43.1723 34.7889 43.4034 34.5883 43.6711 34.6144C43.9364 34.637 44.1333 34.871 44.1104 35.1367L43.8316 38.4054C43.8102 38.6573 43.5996 38.8472 43.3519 38.8472Z'
            fill='#D4708D'
          />
          <path
            d='M47.4261 36.8445C47.4123 36.8445 47.3985 36.8439 47.3844 36.8426C47.1191 36.82 46.9223 36.586 46.9452 36.3203L47.2239 33.0516C47.2462 32.7855 47.4745 32.5881 47.7454 32.6117C48.0107 32.6343 48.2075 32.8682 48.1846 33.134L47.9058 36.4027C47.8845 36.6543 47.6738 36.8445 47.4261 36.8445Z'
            fill='#D4708D'
          />
          <path
            d='M17.5612 28.6609C17.2341 27.8518 17.6353 26.9263 18.4578 26.5927C19.2797 26.2594 20.2109 26.6449 20.538 27.4537'
            fill='white'
          />
          <path
            d='M17.5615 29.4662C17.2438 29.4662 16.9428 29.2763 16.8162 28.9631C16.5764 28.37 16.5852 27.7181 16.8414 27.1279C17.095 26.5427 17.5618 26.0877 18.1561 25.8465C19.3871 25.3466 20.7898 25.9321 21.2829 27.1515C21.4497 27.5634 21.2512 28.0329 20.8396 28.1999C20.4278 28.3659 19.96 28.1681 19.793 27.7559C19.6326 27.36 19.1692 27.1726 18.7595 27.3389C18.558 27.4207 18.4004 27.5735 18.3156 27.7691C18.2331 27.96 18.2296 28.1694 18.3062 28.3587C18.4729 28.771 18.2742 29.2401 17.8629 29.4071C17.764 29.447 17.662 29.4662 17.5615 29.4662Z'
            fill='#272425'
          />
          <path
            d='M19.9118 11.476C17.8637 11.476 17.3124 10.0808 17.2876 10.0151C17.1624 9.6824 17.33 9.31069 17.6621 9.18525C17.9902 9.06102 18.3553 9.22298 18.4853 9.54655C18.5107 9.60219 18.8909 10.3648 20.4496 10.1484C20.799 10.0975 21.1261 10.3449 21.1748 10.6974C21.2237 11.0496 20.9786 11.3748 20.6267 11.4238C20.3702 11.4597 20.1322 11.476 19.9118 11.476Z'
            fill='black'
          />
          <path d='M23.0898 9.42603C23.0898 9.42603 23.3887 10.0958 24.4398 10.3301L23.0898 9.42603Z' fill='black' />
          <path
            d='M24.4409 10.9741C24.3947 10.9741 24.3477 10.9691 24.3006 10.9587C22.9723 10.6628 22.5475 9.78768 22.5033 9.68895C22.3586 9.36413 22.5039 8.98331 22.8279 8.838C23.1475 8.6956 23.5205 8.83394 23.6705 9.14809C23.6893 9.18296 23.9056 9.55118 24.58 9.70149C24.9266 9.77888 25.1451 10.1229 25.0678 10.47C25.0013 10.77 24.7357 10.9741 24.4409 10.9741Z'
            fill='black'
          />
          <path d='M13.875 14.1573C13.875 14.1573 14.6077 13.6527 14.5431 12.9011L13.875 14.1573Z' fill='black' />
          <path
            d='M13.8761 14.8014C13.6714 14.8014 13.4704 14.7039 13.3455 14.5221C13.1455 14.2306 13.2178 13.8322 13.5069 13.6297C13.5213 13.619 13.9332 13.3083 13.9031 12.9565C13.8723 12.6021 14.1344 12.2901 14.4882 12.2596C14.8408 12.2254 15.1535 12.4914 15.1839 12.8458C15.2605 13.7338 14.6264 14.4215 14.2396 14.6881C14.1285 14.7646 14.0016 14.8014 13.8761 14.8014Z'
            fill='black'
          />
          <path
            d='M43.0477 22.7049C44.6859 30.7049 42.9391 36.5248 36.1386 37.9213C29.3394 39.3187 26.0656 33.2331 24.4275 25.2336C23.1002 18.7531 21.4169 13.0178 24.4401 10.3301C25.6418 10.6223 28.0698 10.8314 30.8589 10.6374C32.7468 10.5059 35.0492 10.5352 36.5625 11.7911C39.7062 14.4007 42.1719 18.4283 43.0477 22.7049Z'
            fill='black'
          />
          <path
            d='M34.2578 38.7661C31.7291 38.7661 29.5789 37.6737 27.8463 35.5034C26.0622 33.2682 24.7383 29.9511 23.7987 25.3632C23.6493 24.6343 23.4954 23.9148 23.3444 23.2079C22.1141 17.4528 21.0514 12.4822 24.0144 9.84835C24.1717 9.70872 24.3879 9.65432 24.5927 9.70434C25.7448 9.98419 28.114 10.183 30.8152 9.99491C32.7877 9.85684 35.2703 9.88166 36.9737 11.2952C40.2891 14.0473 42.7956 18.2641 43.6784 22.5753C44.5555 26.8587 44.446 30.3781 43.3529 33.0346C42.1414 35.9791 39.758 37.8357 36.2686 38.552C35.5741 38.6948 34.9036 38.7661 34.2578 38.7661ZM24.6397 11.0323C22.5313 13.2549 23.4935 17.755 24.6017 22.9384C24.7537 23.6485 24.9082 24.3717 25.0582 25.1041C25.9435 29.4272 27.2197 32.6554 28.8509 34.699C30.7254 37.0477 33.0671 37.8951 36.0102 37.2904C39.0551 36.665 41.1255 35.0682 42.1643 32.5441C43.1579 30.1287 43.2436 26.8619 42.4189 22.834C41.5929 18.8005 39.2504 14.8579 36.1531 12.287C34.8012 11.1643 32.6392 11.1593 30.9044 11.2798C28.1511 11.4713 25.8977 11.2798 24.6397 11.0323Z'
            fill='black'
          />
          <path
            d='M15.9092 29.5168C17.4789 37.2486 17.6176 40.6979 13.7324 42.5321C9.52999 44.5163 4.35189 41.2695 3.58777 32.8855C2.99885 26.422 5.39795 20.5496 8.18256 17.0902C9.69699 15.2083 11.9718 15.2337 13.8748 14.1573C15.7158 15.5916 14.3948 22.0542 15.9092 29.5168Z'
            fill='black'
          />
          <path
            d='M11.2663 43.7455C10.1738 43.7455 9.08569 43.4515 8.0641 42.866C5.23996 41.2478 3.37517 37.6312 2.94789 32.944C2.32193 26.0716 4.98317 20.0395 7.68271 16.6861C8.76734 15.3378 10.1637 14.8736 11.514 14.4246C12.2395 14.1834 12.9248 13.9554 13.5593 13.5966C13.7847 13.4683 14.0654 13.4897 14.27 13.6488C15.5063 14.612 15.5751 16.8572 15.6796 20.2561C15.7584 22.8255 15.8567 26.0229 16.5398 29.3885C18.1176 37.1612 18.3823 41.049 14.0069 43.1147C13.115 43.5358 12.189 43.7455 11.2663 43.7455ZM13.7294 14.9582C13.1298 15.2444 12.5164 15.4485 11.9193 15.6469C10.6912 16.0553 9.53146 16.4409 8.68384 17.4943C6.1422 20.6517 3.6373 26.3374 4.22877 32.8271C4.61713 37.0898 6.24769 40.3415 8.70239 41.7481C10.2124 42.6132 11.9014 42.6848 13.4588 41.9493C16.8302 40.3579 16.8707 37.4813 15.2797 29.6451C14.5749 26.172 14.4747 22.9139 14.3944 20.2957C14.3215 17.9226 14.2571 15.8333 13.7294 14.9582Z'
            fill='black'
          />
          <path
            d='M66.1746 89.1552C82.0155 89.1552 94.857 76.2925 94.857 60.4256C94.857 44.5586 82.0155 31.6959 66.1746 31.6959C50.3337 31.6959 37.4922 44.5586 37.4922 60.4256C37.4922 76.2925 50.3337 89.1552 66.1746 89.1552Z'
            fill='#D60000'
            stroke='black'
            strokeWidth='1.6881'
            strokeLinejoin='round'
          />
          <path
            d='M66.1745 83.163C78.7112 83.163 88.8743 72.9831 88.8743 60.4257C88.8743 47.8683 78.7112 37.6885 66.1745 37.6885C53.6377 37.6885 43.4746 47.8683 43.4746 60.4257C43.4746 72.9831 53.6377 83.163 66.1745 83.163Z'
            fill='white'
          />
          <path
            d='M53.5685 47.317C52.0681 47.317 50.8477 48.5394 50.8477 50.0422C50.8477 51.5456 52.0681 52.7681 53.5685 52.7681C54.2839 52.7681 54.2962 52.9332 54.3029 53.009V70.8091C54.3029 72.312 55.5234 73.5345 57.0237 73.5345C58.5247 73.5345 59.7451 72.312 59.7451 70.8091V53.009C59.7451 50.7206 58.1003 47.317 53.5685 47.317Z'
            fill='black'
          />
          <path
            d='M71.8689 47.3169C66.5571 47.3169 62.2363 51.6447 62.2363 56.9647C62.2363 61.6531 65.5937 65.5669 70.0264 66.4309L67.967 69.169C67.5296 69.7506 67.3445 70.4678 67.446 71.1893C67.5475 71.9102 67.9228 72.5485 68.5035 72.9866C68.9789 73.3452 69.5443 73.5344 70.1391 73.5344C71.0028 73.5344 71.7957 73.1395 72.3149 72.4499L79.4678 62.9389C79.5548 62.8233 79.624 62.6987 79.6907 62.5734C80.8251 60.9907 81.5009 59.0573 81.5009 56.9647C81.5009 51.6447 77.1802 47.3169 71.8689 47.3169ZM71.8689 61.1613C69.5584 61.1613 67.6786 59.2783 67.6786 56.9647C67.6786 54.651 69.5584 52.768 71.8689 52.768C74.1788 52.768 76.0587 54.6509 76.0587 56.9647C76.0587 59.2784 74.1788 61.1613 71.8689 61.1613Z'
            fill='black'
          />
          <path
            d='M67.793 27.2388C63.3994 24.9451 57.601 28.1811 58.8476 31.9415C60.0942 35.702 65.5029 35.4331 67.4117 35.3511C69.8647 35.2457 72.185 33.4763 71.7971 31.3871C71.4091 29.2978 69.2445 27.9966 67.793 27.2388Z'
            fill='black'
            stroke='black'
            strokeWidth='1.70371'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
      </svg>
    </IconWrapper>
  );
}

export function IcoCheck(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ color: 'var(--colorIco03)', ...style }} {...rest}>
      <svg xmlns='http://www.w3.org/2000/svg' width='3.8em' height='2.8em' viewBox='0 0 38 28' fill='none'>
        <g clipPath='url(#clip0_8602_6017)'>
          <path
            d='M14.0249 27.6748H14.0191C13.333 27.6729 12.6773 27.3897 12.2066 26.8907L0.681668 14.6758C-0.266082 13.6709 -0.219702 12.0889 0.784208 11.1416C1.78958 10.1934 3.37112 10.2393 4.31839 11.2442L14.0332 21.5411L33.8052 0.777386C34.7564 -0.223594 36.3394 -0.263634 37.3399 0.690476C38.3399 1.64263 38.3784 3.22466 37.4263 4.22466L15.8355 26.8985C15.3633 27.3946 14.709 27.6748 14.0249 27.6748Z'
            fill='currentColor'
          />
        </g>
        <defs>
          <clipPath id='clip0_8602_6017'>
            <rect width='38.1159' height='27.6748' fill='white' />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  );
}

export function IcoCircleCheck(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ color: 'var(--colorIco03)', ...style }} {...rest}>
      <svg width='1em' height='0.98em' viewBox='0 0 48 47' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_7055_10174)'>
          <path
            d='M24.1296 25.9478L15.9514 19.0044C14.8474 18.0669 13.1936 18.2027 12.2561 19.3052C11.319 20.4097 11.4538 22.064 12.5578 23.0005L22.7238 31.6323C23.2165 32.0513 23.8195 32.2564 24.4191 32.2564C25.1579 32.2564 25.8918 31.9458 26.4099 31.3423L40.7615 14.6211L43.9821 10.8687L47.0944 7.24269C48.0378 6.14308 47.9113 4.48781 46.8127 3.54542C45.715 2.60206 44.0583 2.72901 43.1159 3.82667L40.6381 6.71339L37.5844 10.2715L24.1296 25.9478Z'
            fill='currentColor'
          />
          <path
            d='M41.8549 17.1489C42.533 19.0796 42.9208 21.145 42.9208 23.3042C42.9208 33.5845 34.5573 41.9478 24.2772 41.9478C13.9971 41.9478 5.63355 33.5845 5.63355 23.3042C5.63355 13.0239 13.9971 4.66064 24.2772 4.66064C28.5974 4.66064 32.5684 6.15136 35.7332 8.62695L38.784 5.07226C34.8027 1.90039 29.7633 0 24.2772 0C11.4065 0 0.972656 10.4336 0.972656 23.3042C0.972656 36.1748 11.4065 46.6089 24.2772 46.6089C37.148 46.6089 47.5817 36.1748 47.5817 23.3042C47.5817 19.6728 46.7504 16.2358 45.2688 13.1719L41.8549 17.1489Z'
            fill='currentColor'
          />
        </g>
      </svg>
    </IconWrapper>
  );
}

export function IcoLive(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ color: 'var(--colorIco03)', ...style }} {...rest}>
      <svg width='1em' height='0.5em' viewBox='0 0 32 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g id='ico_live_w16'>
          <path
            id='Vector'
            opacity='0.7'
            d='M28.8 0H3.2C1.43269 0 0 1.43269 0 3.2V12.8C0 14.5673 1.43269 16 3.2 16H28.8C30.5673 16 32 14.5673 32 12.8V3.2C32 1.43269 30.5673 0 28.8 0Z'
            fill='#E20518'
          />
          <path
            id='Vector_2'
            d='M12.2578 11.9817C11.816 11.9817 11.4578 11.6235 11.4578 11.1817V4.83282C11.4578 4.39102 11.816 4.01837 12.2578 4.01837C12.6996 4.01837 13.0578 4.36212 13.0578 4.80392V11.1817C13.0578 11.6235 12.6996 11.9817 12.2578 11.9817Z'
            fill='white'
          />
          <g id='Group'>
            <path
              id='Vector_3'
              d='M25.6 11.9744H21.6949C21.2531 11.9744 20.8949 11.6162 20.8949 11.1744V4.82557C20.8949 4.38377 21.2531 4.02557 21.6949 4.02557H25.6C26.0418 4.02557 26.4 4.38377 26.4 4.82557C26.4 5.26737 26.0418 5.62557 25.6 5.62557H22.4949V10.3744H25.6C26.0418 10.3744 26.4 10.7326 26.4 11.1744C26.4 11.6162 26.0418 11.9744 25.6 11.9744Z'
              fill='white'
            />
            <path
              id='Vector_4'
              d='M25.1117 8.7998H21.6949C21.2531 8.7998 20.8949 8.4416 20.8949 7.9998C20.8949 7.558 21.2531 7.1998 21.6949 7.1998H25.1117C25.5535 7.1998 25.9117 7.558 25.9117 7.9998C25.9117 8.4416 25.5535 8.7998 25.1117 8.7998Z'
              fill='white'
            />
          </g>
          <path
            id='Vector_5'
            d='M10.3051 11.9744H9.32889C7.27263 11.9744 5.59998 9.90682 5.59998 7.36502V4.82557C5.59998 4.38377 5.95817 4.02557 6.39997 4.02557C6.84177 4.02557 7.19998 4.38377 7.19998 4.82557V7.36502C7.19998 8.99627 8.17497 10.3744 9.32889 10.3744H10.3051C10.7469 10.3744 11.1051 10.7326 11.1051 11.1744C11.1051 11.6162 10.7469 11.9744 10.3051 11.9744Z'
            fill='white'
          />
          <path
            id='Vector_6'
            d='M17.1391 11.9747C16.8145 11.9747 16.5219 11.7786 16.3988 11.4782L13.7953 5.12938C13.6277 4.72079 13.823 4.25321 14.232 4.08563C14.6398 3.91727 15.1082 4.11375 15.2758 4.52235L17.1391 9.0661L19.002 4.52235C19.1695 4.11376 19.6379 3.91844 20.0457 4.08563C20.4543 4.25321 20.65 4.7204 20.4824 5.12938L17.8793 11.4782C17.7562 11.7786 17.4637 11.9747 17.1391 11.9747Z'
            fill='white'
          />
        </g>
      </svg>
    </IconWrapper>
  );
}

export function IcoRec(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ ...style }} {...rest}>
      <svg xmlns='http://www.w3.org/2000/svg' width='1em' height='0.5em' viewBox='0 0 36 18' fill='none'>
        <g clipPath='url(#clip0_3063_27087)'>
          <path
            opacity='0.7'
            d='M32.4 0H3.6C1.61177 0 0 1.61177 0 3.6V14.4C0 16.3882 1.61177 18 3.6 18H32.4C34.3882 18 36 16.3882 36 14.4V3.6C36 1.61177 34.3882 0 32.4 0Z'
            fill='#0097A7'
          />
          <path
            d='M20.7434 13.4712H16.3502C15.8532 13.4712 15.4502 13.0683 15.4502 12.5712V5.42881C15.4502 4.93179 15.8532 4.52881 16.3502 4.52881H20.7434C21.2404 4.52881 21.6434 4.93179 21.6434 5.42881C21.6434 5.92583 21.2404 6.32881 20.7434 6.32881H17.2502V11.6712H20.7434C21.2404 11.6712 21.6434 12.0742 21.6434 12.5712C21.6434 13.0683 21.2404 13.4712 20.7434 13.4712Z'
            fill='white'
          />
          <path
            d='M20.1941 9.89985H16.3502C15.8532 9.89985 15.4502 9.49687 15.4502 8.99985C15.4502 8.50283 15.8532 8.09985 16.3502 8.09985H20.1941C20.6911 8.09985 21.0941 8.50283 21.0941 8.99985C21.0941 9.49687 20.6911 9.89985 20.1941 9.89985Z'
            fill='white'
          />
          <path
            d='M11.9397 9.77002H11.1551C10.6603 9.77002 10.2591 9.36877 10.2591 8.87394C10.2591 8.37911 10.6603 7.97786 11.1551 7.97786H11.9397C12.3959 7.97786 12.7672 7.60657 12.7672 7.15045C12.7672 6.69433 12.3959 6.32304 11.9397 6.32304H9.54314V12.5752C9.54314 13.07 9.14189 13.4713 8.64706 13.4713C8.15223 13.4713 7.75098 13.07 7.75098 12.5752V5.42696C7.75098 4.93213 8.15223 4.53088 8.64706 4.53088H11.9397C13.3842 4.53088 14.5593 5.70602 14.5593 7.15045C14.5593 8.59488 13.3842 9.77002 11.9397 9.77002Z'
            fill='white'
          />
          <path
            d='M13.7332 13.4712C13.277 13.4712 12.9068 13.1101 12.9068 12.6652C12.9068 10.0573 11.1995 9.78308 11.005 9.76734C10.5551 9.7315 10.2118 9.34859 10.2432 8.90885C10.2755 8.46824 10.6842 8.13866 11.1072 8.15964C12.301 8.22433 14.5595 9.29765 14.5595 12.6652C14.5595 13.1101 14.1894 13.4712 13.7332 13.4712Z'
            fill='white'
          />
          <path
            d='M27.3444 11.613H26.3949C24.9496 11.5909 23.7768 10.4278 23.7707 8.99114C23.7768 7.55512 24.9487 6.39254 26.3932 6.36947H27.3444C27.844 6.36947 28.249 5.95342 28.249 5.44025C28.249 4.92713 27.844 4.53186 27.3444 4.53186H26.3178C26.2902 4.53186 26.2512 4.53301 26.2009 4.53531C23.8172 4.65869 21.9067 6.59437 21.8979 8.9856L21.8984 8.99115L21.8979 8.99675C21.9067 11.3879 23.817 13.3234 26.2005 13.4469C26.2786 13.4538 26.2921 13.4554 26.3337 13.4554H27.3602C27.8598 13.4554 28.249 13.0553 28.249 12.5422C28.249 12.029 27.844 11.613 27.3444 11.613Z'
            fill='white'
          />
        </g>
      </svg>
    </IconWrapper>
  );
}

export function IcoChannelNotice(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ color: 'white', ...style }} {...rest}>
      <svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' viewBox='0 0 24 24' fill='none'>
        <path
          d='M2.5546 8.0287C1.69722 8.0287 1 8.6317 1 9.3666V20.833C1 22.0295 2.13062 23 3.51563 23H11.9859'
          stroke='currentColor'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M21.4171 8.0287C22.2745 8.0287 22.9717 8.6317 22.9717 9.3666V20.833C22.9717 22.0295 21.8411 23 20.4561 23H11.9858'
          stroke='currentColor'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M2 9.01075L10.0884 17.1683C11.1931 18.2861 13.0086 18.2754 14.1037 17.1468L22 9'
          stroke='currentColor'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M2.99744 9.197V4.24111C2.99744 2.45096 4.12806 1 5.51307 1H18.5058C19.9002 1 21.0214 2.45096 21.0214 4.24111V9.197'
          stroke='currentColor'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M8.00989 5.72978H16.0184'
          stroke='currentColor'
          strokeWidth='1.8'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M10.0073 9.74344H14.021'
          stroke='currentColor'
          strokeWidth='1.8'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </IconWrapper>
  );
}

export function ChannelBookmarkOff(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ ...style }} {...rest}>
      <svg xmlns='http://www.w3.org/2000/svg' width='28' height='28' viewBox='0 0 28 28' fill='none'>
        <path
          d='M22.6538 26.6011C22.29 26.6011 21.9106 26.4771 21.5522 26.2319L14.4487 21.3823C14.2349 21.2358 13.7651 21.2358 13.5513 21.3823L6.44775 26.2319C5.84326 26.645 5.18066 26.7143 4.63086 26.4243C4.08106 26.1343 3.76562 25.5474 3.76562 24.8149V3.70947C3.76562 2.43603 4.80176 1.3999 6.07569 1.3999H21.9243C23.1982 1.3999 24.2344 2.43603 24.2344 3.70947V24.8149C24.2344 25.5474 23.9189 26.1343 23.3691 26.4243C23.1455 26.5425 22.9028 26.6011 22.6538 26.6011ZM14 19.1714C14.5835 19.1714 15.167 19.3306 15.6323 19.6479L22.1348 24.0864V3.70947C22.1348 3.59619 22.0381 3.49951 21.9243 3.49951H6.07568C5.96191 3.49951 5.86523 3.59619 5.86523 3.70947V24.0845L12.3677 19.648C12.833 19.3306 13.4165 19.1714 14 19.1714Z'
          fill='white'
        />
      </svg>
    </IconWrapper>
  );
}

export function ChannelBookmarkOn(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ ...style }} {...rest}>
      <svg width='1em' height='1em' viewBox='0 0 28 28' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g id='ico_ch_bookmark'>
          <g id='Group'>
            <path
              id='Vector'
              d='M23.1855 24.8147C23.1855 25.5077 22.7172 25.755 22.1448 25.3643L15.0416 20.5155C14.4692 20.1247 13.5326 20.1247 12.9603 20.5155L5.85706 25.3643C5.2847 25.755 4.81641 25.5077 4.81641 24.8147V3.70971C4.81641 3.01671 5.38341 2.44971 6.07641 2.44971H21.9255C22.6185 2.44971 23.1855 3.01671 23.1855 3.70971L23.1855 24.8147Z'
              fill='#FDBD39'
            />
            <path
              id='Vector_2'
              d='M22.6538 26.6011C22.29 26.6011 21.9106 26.4771 21.5522 26.2319L14.4487 21.3823C14.2349 21.2358 13.7651 21.2358 13.5513 21.3823L6.44775 26.2319C5.84375 26.645 5.18016 26.7143 4.63085 26.4243C4.08105 26.1343 3.76562 25.5474 3.76562 24.8149V3.70947C3.76562 2.43603 4.80175 1.3999 6.07568 1.3999H21.9243C23.1982 1.3999 24.2344 2.43603 24.2344 3.70947V24.8149C24.2344 25.5474 23.9189 26.1343 23.3691 26.4243C23.1455 26.5425 22.9028 26.6011 22.6538 26.6011ZM14 19.1714C14.5835 19.1714 15.167 19.3306 15.6323 19.6479L22.1348 24.0864V3.70947C22.1348 3.59619 22.0381 3.49951 21.9243 3.49951H6.07568C5.96191 3.49951 5.86524 3.59619 5.86524 3.70947V24.0845L12.3677 19.648C12.833 19.3306 13.4165 19.1714 14 19.1714Z'
              fill='#FDBD39'
            />
          </g>
        </g>
      </svg>
    </IconWrapper>
  );
}

export function IcoDownCircle(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ color: 'var(--colorIco44)', ...style }} {...rest}>
      <svg width='1em' height='1em' viewBox='0 0 36 36' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <rect width='36' height='36' rx='18' fill='currentColor' />
        <g clipPath='url(#clip0_7400_82934)'>
          <mask
            id='mask0_7400_82934'
            style={{ maskType: 'luminance' }}
            maskUnits='userSpaceOnUse'
            x='12'
            y='16'
            width='12'
            height='7'
          >
            <path d='M24 16.0002H12V22.6209H24V16.0002Z' fill='white' />
          </mask>
          <g mask='url(#mask0_7400_82934)'>
            <path
              d='M18 22.6207C17.8412 22.6207 17.6824 22.5601 17.5612 22.4388L12.1818 17.0595C11.9394 16.8171 11.9394 16.4243 12.1818 16.1818C12.4243 15.9394 12.8171 15.9394 13.0595 16.1818L18.4388 21.5612C18.6813 21.8036 18.6813 22.1964 18.4388 22.4388C18.3176 22.5601 18.1588 22.6207 18 22.6207Z'
              fill='white'
            />
            <path
              d='M18.0001 22.6207C17.8413 22.6207 17.6825 22.5601 17.5612 22.4388C17.3188 22.1964 17.3188 21.8036 17.5612 21.5612L22.9405 16.1818C23.183 15.9394 23.5758 15.9394 23.8182 16.1818C24.0607 16.4243 24.0607 16.8171 23.8182 17.0595L18.4389 22.4388C18.3177 22.5601 18.1589 22.6207 18.0001 22.6207Z'
              fill='white'
            />
          </g>
        </g>
      </svg>
    </IconWrapper>
  );
}

export function IcoPayPhone(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ color: 'var(--colorIco19)', ...style }} {...rest}>
      <svg xmlns='http://www.w3.org/2000/svg' width='1.6em' height='2.0em' viewBox='0 0 32 40' fill='none'>
        <path
          d='M28.5 0H3.5C1.57031 0 0 1.57031 0 3.5V36.5C0 38.4297 1.57031 40 3.5 40H28.5C30.4297 40 32 38.4297 32 36.5V3.5C32 1.57031 30.4297 0 28.5 0ZM29 36.5C29 36.7754 28.7754 37 28.5 37H3.5C3.22461 37 3 36.7754 3 36.5V3.5C3 3.22461 3.22461 3 3.5 3H28.5C28.7754 3 29 3.22461 29 3.5V36.5Z'
          fill='currentColor'
        />
        <path
          d='M20.1602 6.06836H11.8398C11.0117 6.06836 10.3398 6.74024 10.3398 7.56836C10.3398 8.39648 11.0117 9.06836 11.8398 9.06836H20.1602C20.9883 9.06836 21.6602 8.39648 21.6602 7.56836C21.6602 6.74024 20.9883 6.06836 20.1602 6.06836Z'
          fill='currentColor'
        />
        <path
          d='M17.1094 30.21C17 30.1397 16.8896 30.0693 16.7695 30.0195C16.6396 29.9697 16.5195 29.9395 16.3896 29.9102C16.1299 29.8594 15.8701 29.8594 15.6094 29.9102C15.4795 29.9395 15.3496 29.9697 15.2295 30.0195C15.1094 30.0693 15 30.1397 14.8896 30.21C14.7803 30.2803 14.6797 30.3594 14.5898 30.46C14.21 30.8301 14 31.3398 14 31.8701C14 32 14.0098 32.1299 14.04 32.2598C14.0596 32.3897 14.0996 32.5195 14.1494 32.6397C14.2002 32.7598 14.2598 32.8701 14.3301 32.9795C14.4102 33.0898 14.4902 33.1895 14.5898 33.2803C14.7695 33.4697 14.9902 33.6201 15.2295 33.7197C15.4795 33.8193 15.7295 33.8701 16 33.8701C16.5303 33.8701 17.04 33.6602 17.4102 33.2803C17.5098 33.1895 17.5899 33.0898 17.6602 32.9795C17.7402 32.8701 17.7998 32.7598 17.8496 32.6397C17.8994 32.5195 17.9395 32.3897 17.96 32.2598C17.9902 32.1299 18 32 18 31.8701C18 31.3399 17.79 30.8301 17.4102 30.46C17.3193 30.3594 17.2197 30.2803 17.1094 30.21Z'
          fill='currentColor'
        />
      </svg>
    </IconWrapper>
  );
}

export function IcoPayVaccount(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ color: 'var(--colorIco19)', ...style }} {...rest}>
      <svg xmlns='http://www.w3.org/2000/svg' width='2.4em' height='1.8em' viewBox='0 0 48 36' fill='none'>
        <path
          d='M44.5 0H3.5C1.57031 0 0 1.57031 0 3.5V32.4971C0 34.4268 1.57031 35.9971 3.5 35.9971H27C27.8286 35.9971 28.5 35.3252 28.5 34.4971C28.5 33.6689 27.8286 32.9971 27 32.9971H3.5C3.22412 32.9971 3 32.7725 3 32.4971V27.459H24.6299C25.4585 27.459 26.1299 26.7871 26.1299 25.959C26.1299 25.1309 25.4585 24.459 24.6299 24.459H3V3.5C3 3.22461 3.22412 3 3.5 3H44.5C44.7759 3 45 3.22461 45 3.5V14.9707C45 15.7988 45.6714 16.4707 46.5 16.4707C47.3286 16.4707 48 15.7988 48 14.9707V3.5C48 1.57031 46.4297 0 44.5 0Z'
          fill='currentColor'
        />
        <path
          d='M38.5 17.002C33.2617 17.002 29 21.2637 29 26.501C29 31.7383 33.2617 36 38.5 36C43.7383 36 48 31.7383 48 26.501C48 21.2637 43.7383 17.002 38.5 17.002ZM38.5 33C34.916 33 32 30.085 32 26.501C32 22.917 34.916 20.002 38.5 20.002C42.084 20.002 45 22.917 45 26.501C45 30.085 42.084 33 38.5 33Z'
          fill='currentColor'
        />
        <path
          d='M39.75 25.918V23.2305C39.75 22.54 39.1904 21.9805 38.5 21.9805C37.8096 21.9805 37.25 22.54 37.25 23.2305V26.501C37.25 26.8701 37.4131 27.2207 37.6963 27.458L40.8184 30.0801C41.0522 30.2773 41.3379 30.373 41.6216 30.373C41.978 30.373 42.332 30.2217 42.5791 29.9268C43.0234 29.3984 42.9546 28.6094 42.4258 28.166L39.75 25.918Z'
          fill='currentColor'
        />
      </svg>
    </IconWrapper>
  );
}

export function IcoPayCredit(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ color: 'var(--colorIco19)', ...style }} {...rest}>
      <svg xmlns='http://www.w3.org/2000/svg' width='2.4em' height='1.8em' viewBox='0 0 48 36' fill='none'>
        <path
          d='M44.5 0H3.5C1.57031 0 0 1.57031 0 3.5V32.5C0 34.4297 1.57031 36 3.5 36H44.5C46.4297 36 48 34.4297 48 32.5V3.5C48 1.57031 46.4297 0 44.5 0ZM3.5 3H44.5C44.7754 3 45 3.22461 45 3.5V8.53809H3V3.5C3 3.22461 3.22461 3 3.5 3ZM44.5 33H3.5C3.22461 33 3 32.7754 3 32.5V11.5381H45V32.5C45 32.7754 44.7754 33 44.5 33Z'
          fill='currentColor'
        />
        <path
          d='M15 24.4619H10.5C9.67188 24.4619 9 25.1338 9 25.9619C9 26.79 9.67188 27.4619 10.5 27.4619H15C15.8281 27.4619 16.5 26.79 16.5 25.9619C16.5 25.1338 15.8281 24.4619 15 24.4619Z'
          fill='currentColor'
        />
        <path
          d='M29.625 24.4619H20.625C19.7969 24.4619 19.125 25.1338 19.125 25.9619C19.125 26.79 19.7969 27.4619 20.625 27.4619H29.625C30.4531 27.4619 31.125 26.79 31.125 25.9619C31.125 25.1338 30.4531 24.4619 29.625 24.4619Z'
          fill='currentColor'
        />
      </svg>
    </IconWrapper>
  );
}

export function IcoPayBank(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ color: 'var(--colorIco19)', ...style }} {...rest}>
      <svg xmlns='http://www.w3.org/2000/svg' width='2.4em' height='1.8em' viewBox='0 0 48 36' fill='none'>
        <path
          d='M44.5 0H3.5C1.57031 0 0 1.57031 0 3.5V32.5C0 34.4297 1.57031 36 3.5 36H44.5C46.4297 36 48 34.4297 48 32.5V3.5C48 1.57031 46.4297 0 44.5 0ZM3.5 3H44.5C44.7754 3 45 3.22461 45 3.5V8.53809H3V3.5C3 3.22461 3.22461 3 3.5 3ZM44.5 33H3.5C3.22461 33 3 32.7754 3 32.5V11.5381H45V32.5C45 32.7754 44.7754 33 44.5 33Z'
          fill='currentColor'
        />
        <path
          d='M41.3955 22.5337H40.3258L41.3794 18.5772C41.3955 18.5156 41.3816 18.4525 41.3463 18.4028C41.3073 18.3552 41.2495 18.3264 41.187 18.3264H39.826C39.7351 18.3264 39.657 18.3879 39.633 18.4745L38.5974 22.5337H36.5697L35.5514 18.4745C35.5295 18.3879 35.4519 18.3264 35.3589 18.3264H33.7578C33.6675 18.3264 33.5884 18.3879 33.568 18.4745L32.5335 22.5337H30.5022L29.4843 18.4745C29.4634 18.3879 29.3811 18.3264 29.2902 18.3264H27.9463C27.8837 18.3264 27.8249 18.3552 27.788 18.4028C27.7517 18.4525 27.7378 18.5156 27.7533 18.5772L28.792 22.5337H27.7217C27.6095 22.5337 27.5234 22.6266 27.5234 22.7341V23.9529C27.5234 24.0625 27.6095 24.1492 27.7217 24.1492H29.2186L30.6042 29.4314C30.6273 29.5191 30.7064 29.5774 30.793 29.5774H32.2369C32.3283 29.5774 32.4053 29.5165 32.4272 29.4277L33.784 24.1492H35.3177L36.6708 29.4277C36.6954 29.5165 36.7724 29.5774 36.8622 29.5774H38.3029C38.3959 29.5774 38.4734 29.5191 38.4991 29.4314L39.8955 24.1492H41.3955C41.5035 24.1492 41.5933 24.0625 41.5933 23.9529V22.7341C41.5933 22.6266 41.5035 22.5337 41.3955 22.5337ZM31.5163 26.5308L30.9068 24.1492H32.1236L31.5163 26.5308ZM34.2074 22.5337L34.5554 21.1956L34.897 22.5337H34.2074ZM37.5844 26.5308L36.9765 24.1492H38.1964L37.5844 26.5308Z'
          fill='currentColor'
        />
      </svg>
    </IconWrapper>
  );
}

export function IcoPayBankRealTime(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ color: 'var(--colorIco19)', ...style }} {...rest}>
      <svg xmlns='http://www.w3.org/2000/svg' width='2.0em' height='2.0em' viewBox='0 0 40 40' fill='none'>
        <path
          d='M29.0321 20.0015V18.4365C29.0321 18.2986 28.9169 18.1792 28.7782 18.1792H27.4048L28.7576 13.0997C28.7782 13.0207 28.7603 12.9397 28.7151 12.876C28.665 12.8149 28.5908 12.7778 28.5105 12.7778H26.7631C26.6465 12.7778 26.5462 12.8567 26.5154 12.968L25.186 18.1792H22.5828L21.2752 12.968C21.2471 12.8567 21.1476 12.7778 21.0282 12.7778H18.9726C18.8567 12.7778 18.7551 12.8567 18.729 12.968L17.4009 18.1792H14.793L13.4861 12.968C13.4594 12.8567 13.3537 12.7778 13.237 12.7778H11.5116C11.4313 12.7778 11.3558 12.8149 11.3085 12.876C11.2618 12.9397 11.244 13.0208 11.2638 13.0997L12.5974 18.1792H11.2234C11.0792 18.1792 10.9688 18.2986 10.9688 18.4365V20.0015C10.9688 20.1421 11.0792 20.2533 11.2234 20.2533H13.1451L14.924 27.0349C14.9535 27.1473 15.0551 27.2222 15.1663 27.2222H17.02C17.1374 27.2222 17.2362 27.144 17.2644 27.03L19.0063 20.2533H20.9754L22.7124 27.03C22.744 27.144 22.8428 27.2222 22.9581 27.2222H24.8078C24.9272 27.2222 25.0267 27.1473 25.0597 27.0349L26.8524 20.2533H28.7782C28.9169 20.2533 29.0321 20.1421 29.0321 20.0015ZM16.0949 23.3108L15.3124 20.2533H16.8746L16.0949 23.3108ZM19.5498 18.1792L19.9966 16.4613L20.4352 18.1792H19.5498ZM23.8854 23.3108L23.105 20.2533H24.6712L23.8854 23.3108Z'
          fill='currentColor'
        />
        <path
          d='M20 0C8.97217 0 0 8.97168 0 20C0 31.0283 8.97217 40 20 40C20.8286 40 21.5 39.3281 21.5 38.5C21.5 37.6719 20.8286 37 20 37C10.626 37 3 29.374 3 20C3 10.626 10.626 3 20 3C29.374 3 37 10.626 37 20C37 20.8281 37.6714 21.5 38.5 21.5C39.3286 21.5 40 20.8281 40 20C40 8.97168 31.0278 0 20 0Z'
          fill='currentColor'
        />
        <path
          d='M28.3428 31.124H38.1943C38.2067 31.124 38.2169 31.1174 38.2291 31.1169C38.2413 31.1174 38.2529 31.124 38.2652 31.124C38.5723 31.124 38.8794 31.0068 39.1138 30.7725C39.582 30.3037 39.5825 29.5439 39.1138 29.0752L35.3897 25.3506C34.9209 24.8818 34.1611 24.8818 33.6924 25.3506C33.2241 25.8193 33.2236 26.5791 33.6924 27.0479L35.3679 28.7236H28.3428C27.6802 28.7236 27.1426 29.2607 27.1426 29.9238C27.1426 30.5869 27.6802 31.124 28.3428 31.124Z'
          fill='currentColor'
        />
        <path
          d='M38.2649 33.3408H28.4134C28.4011 33.3408 28.3909 33.3474 28.3787 33.3479C28.0594 33.3381 27.7377 33.4487 27.494 33.6924C27.0257 34.1611 27.0252 34.9209 27.494 35.3897L31.2181 39.1143C31.4525 39.3487 31.7596 39.4658 32.0667 39.4658C32.3738 39.4658 32.681 39.3486 32.9153 39.1143C33.3836 38.6455 33.3841 37.8857 32.9153 37.417L31.2398 35.7412H38.2649C38.9275 35.7412 39.4651 35.2041 39.4651 34.541C39.4651 33.8779 38.9275 33.3408 38.2649 33.3408Z'
          fill='currentColor'
        />
      </svg>
    </IconWrapper>
  );
}

export function IcoPayMyBank(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ color: 'var(--colorIco19)', ...style }} {...rest}>
      <svg xmlns='http://www.w3.org/2000/svg' width='2.4em' height='1.8em' viewBox='0 0 48 36' fill='none'>
        <path
          d='M44.5 0H3.5C1.57031 0 0 1.57031 0 3.5V32.5C0 34.4297 1.57031 36 3.5 36H44.5C46.4297 36 48 34.4297 48 32.5V3.5C48 1.57031 46.4297 0 44.5 0ZM3.5 3H44.5C44.7759 3 45 3.22461 45 3.5V24.4619H3V3.5C3 3.22461 3.22412 3 3.5 3ZM44.5 33H3.5C3.22412 33 3 32.7754 3 32.5V27.4619H45V32.5C45 32.7754 44.7759 33 44.5 33Z'
          fill='currentColor'
        />
        <path
          d='M15.3535 19.0225C15.5723 18.875 15.6831 18.6426 15.6831 18.332V10.9385C15.6958 10.9795 15.7085 11.0186 15.7202 11.0566C15.8037 11.3164 15.8823 11.5381 15.9609 11.7344L17.8745 16.5205C18.0127 16.873 18.1646 17.1064 18.3379 17.2344C18.5142 17.3672 18.7647 17.4316 19.104 17.4316C19.3882 17.4316 19.6147 17.3711 19.7764 17.252C19.9419 17.1328 20.0898 16.9082 20.2275 16.5645L22.187 11.7324C22.2671 11.5225 22.3467 11.2949 22.4272 11.0488L22.4355 11.0225V18.332C22.4355 18.6436 22.5464 18.876 22.7641 19.0225C22.9668 19.1602 23.1977 19.2305 23.4502 19.2305C23.7236 19.2305 23.9624 19.1602 24.1582 19.0215C24.3721 18.875 24.4805 18.6426 24.4805 18.332V9.65039C24.4805 9.14453 24.3779 8.79883 24.168 8.5957C23.9595 8.3916 23.6079 8.29199 23.0937 8.29199H22.7827C22.5547 8.29199 22.3525 8.31347 22.1821 8.35547C22.0015 8.39844 21.8349 8.48145 21.687 8.60254C21.542 8.7207 21.4072 8.8877 21.2871 9.09766C21.1709 9.30078 21.0537 9.56446 20.9297 9.90235L19.1016 14.6738L17.1865 9.88477C17.0425 9.53711 16.9165 9.26954 16.8013 9.06739C16.6802 8.85743 16.5508 8.69434 16.417 8.58204C16.2764 8.46388 16.1162 8.38477 15.9404 8.34669C15.7729 8.31056 15.5742 8.292 15.3501 8.292H15.0386C14.5244 8.292 14.1733 8.39161 13.9653 8.59473C13.7549 8.79883 13.6523 9.14356 13.6523 9.65039V18.332C13.6523 18.6426 13.7607 18.874 13.9731 19.0215C14.3745 19.3037 14.9575 19.292 15.3535 19.0225Z'
          fill='currentColor'
        />
        <path
          d='M29.0099 14.8869V18.2883C29.0099 18.6164 29.1227 18.8605 29.3464 19.0158C29.5558 19.1584 29.8044 19.2306 30.0842 19.2306C30.3649 19.2306 30.6135 19.1584 30.8224 19.0148C31.0461 18.8615 31.1594 18.6164 31.1594 18.2883V14.8879L34.1677 9.71404C34.3571 9.39177 34.3967 9.10759 34.2849 8.86834C34.1784 8.64568 33.9968 8.47088 33.7438 8.34881L33.7414 8.34783C33.4802 8.22674 33.2194 8.20037 32.9675 8.2658C32.7106 8.33514 32.5021 8.5158 32.3483 8.80193L30.1276 12.841L27.8649 8.78826C27.7092 8.49822 27.4909 8.32146 27.2175 8.26482C26.9518 8.20818 26.696 8.24334 26.4518 8.36541C26.1764 8.50799 25.9938 8.70428 25.9094 8.94842C25.8229 9.19549 25.8581 9.45819 26.0148 9.72869L29.0099 14.8869Z'
          fill='currentColor'
        />
      </svg>
    </IconWrapper>
  );
}

export function IcoPayGift(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ color: 'var(--colorIco19)', ...style }} {...rest}>
      <svg xmlns='http://www.w3.org/2000/svg' width='2.4em' height='1.8em' viewBox='0 0 48 36' fill='none'>
        <path
          d='M44.4995 0H3.50049C1.57031 0 0 1.57031 0 3.5V32.5C0 34.4297 1.57031 36 3.50049 36H44.4995C46.4297 36 48 34.4297 48 32.5V3.5C48 1.57031 46.4297 0 44.4995 0ZM45 32.5C45 32.7754 44.7754 33 44.4995 33H3.50049C3.22461 33 3 32.7754 3 32.5V3.5C3 3.22461 3.22461 3 3.50049 3H44.4995C44.7754 3 45 3.22461 45 3.5V32.5Z'
          fill='currentColor'
        />
        <path
          d='M15.7847 17.1133H13.4609C13.0679 17.1133 12.8545 17.2939 12.7451 17.4453C12.604 17.6406 12.5322 17.8681 12.5322 18.1221C12.5322 18.3848 12.604 18.6172 12.7451 18.8125C12.8545 18.9639 13.0679 19.1445 13.4609 19.1445H14.9009V21.1113C14.6894 21.1806 14.478 21.2344 14.271 21.2705C14.0078 21.3154 13.6948 21.3388 13.3408 21.3388C12.8223 21.3388 12.3813 21.2861 12.0293 21.1826C11.6953 21.0859 11.4326 20.9258 11.2261 20.6914C11.0185 20.458 10.8618 20.1367 10.7612 19.7373C10.6562 19.3193 10.603 18.7851 10.603 18.1494V17.8486C10.603 17.2139 10.6562 16.6806 10.7607 16.2637C10.8623 15.8633 11.0185 15.542 11.227 15.3076C11.4331 15.0742 11.6909 14.9131 12.0161 14.8164C12.3594 14.7139 12.7744 14.6611 13.25 14.6611C13.6894 14.6611 14.081 14.707 14.4145 14.7959C14.7476 14.8857 15.0542 15.0117 15.3242 15.1699C15.5708 15.3184 15.8335 15.3633 16.1055 15.2988C16.3721 15.2373 16.5962 15.085 16.7705 14.8467C16.9482 14.6055 17.0254 14.3408 17 14.0586C16.9722 13.7627 16.8086 13.5117 16.5098 13.3125C16.1358 13.0703 15.6787 12.8721 15.1514 12.7246C14.6245 12.5752 13.9849 12.5 13.25 12.5C12.4478 12.5 11.7261 12.5928 11.1035 12.7754C10.4707 12.9619 9.92627 13.2685 9.48584 13.6855C9.04688 14.1025 8.71045 14.6523 8.48584 15.3203C8.26709 15.9746 8.15625 16.7773 8.15625 17.707V18.293C8.15625 19.2227 8.26709 20.0254 8.48633 20.6807C8.71045 21.3477 9.04688 21.8975 9.48584 22.3145C9.92529 22.7315 10.4756 23.0381 11.1211 23.2256C11.751 23.4072 12.4775 23.5 13.2808 23.5C13.8135 23.5 14.3486 23.4531 14.8701 23.3594C15.3892 23.2676 15.8652 23.1358 16.2886 22.9649C16.6567 22.8115 16.9233 22.6113 17.0815 22.3692C17.2383 22.128 17.3179 21.7979 17.3179 21.3887V18.5518C17.3179 18.0254 17.2007 17.6602 16.9585 17.4365C16.7227 17.2188 16.3389 17.1133 15.7847 17.1133Z'
          fill='currentColor'
        />
        <path
          d='M20.8496 12.7977C20.3852 12.4969 19.6812 12.4969 19.2197 12.7987C19.0366 12.9178 18.8184 13.1552 18.8184 13.6093V22.3905C18.8184 22.8446 19.0366 23.0819 19.2197 23.202C19.4507 23.3524 19.7251 23.4286 20.0352 23.4286C20.3438 23.4286 20.6177 23.3524 20.8511 23.201C21.0332 23.0819 21.25 22.8436 21.25 22.3905V13.6093C21.25 13.1561 21.0332 12.9178 20.8496 12.7977Z'
          fill='currentColor'
        />
        <path
          d='M29.3828 12.6572H24.2519C23.6982 12.6572 23.3144 12.7637 23.0786 12.9814C22.8364 13.2061 22.7188 13.5703 22.7188 14.0967V22.3906C22.7188 22.8447 22.9365 23.082 23.1196 23.2021C23.3506 23.3525 23.625 23.4287 23.9351 23.4287C24.2437 23.4287 24.5181 23.3525 24.7515 23.2012C24.9336 23.082 25.1504 22.8437 25.1504 22.3906V19.1308H29.0659C29.458 19.1308 29.6709 18.9502 29.7798 18.7998C29.9229 18.6055 29.9951 18.3721 29.9951 18.1074C29.9951 17.8428 29.9229 17.6103 29.7808 17.417C29.6704 17.2646 29.4575 17.084 29.0659 17.084H25.1504V14.7041H29.3828C29.7749 14.7041 29.9883 14.5234 30.0982 14.373C30.2402 14.1777 30.312 13.9453 30.312 13.6816C30.312 13.4189 30.2402 13.1865 30.0977 12.9893C29.9873 12.8379 29.7734 12.6572 29.3828 12.6572Z'
          fill='currentColor'
        />
        <path
          d='M38.9146 12.6572H31.7769C31.3848 12.6572 31.1714 12.8379 31.061 12.9902C30.9194 13.1865 30.8477 13.419 30.8477 13.6817C30.8477 13.9453 30.9194 14.1777 31.0605 14.3721C31.1699 14.5235 31.3828 14.7041 31.7769 14.7041H34.1377V22.3906C34.1377 22.8438 34.3545 23.082 34.5381 23.2022C34.7705 23.3525 35.0449 23.4287 35.353 23.4287C35.6631 23.4287 35.9375 23.3525 36.1689 23.2012C36.3516 23.082 36.5693 22.8447 36.5693 22.3906V14.7041H38.9145C39.3086 14.7041 39.5215 14.5234 39.6304 14.3721C39.772 14.1768 39.8437 13.9443 39.8437 13.6816C39.8437 13.4199 39.772 13.1875 39.6304 12.9902C39.52 12.8379 39.3066 12.6572 38.9146 12.6572Z'
          fill='currentColor'
        />
      </svg>
    </IconWrapper>
  );
}

export function IcoPayPointCard(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ color: 'var(--colorIco19)', ...style }} {...rest}>
      <svg width='2.9em' height='2.0em' viewBox='0 0 58 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M44.3486 35.5056L44.3534 35.5054H44.3438L44.3486 35.5056Z' fill='currentColor' />
        <path d='M44.3578 35.5055L44.3621 35.5051L44.3535 35.5055H44.3578Z' fill='currentColor' />
        <path d='M44.3486 35.5056L44.3534 35.5054H44.3438L44.3486 35.5056Z' fill='currentColor' />
        <path d='M44.3578 35.5057L44.3592 35.5054L44.3535 35.5057H44.3578Z' fill='currentColor' />
        <path
          d='M45.9611 38.5C51.7797 38.5 56.4965 33.7196 56.4965 27.8226C56.4965 21.9257 51.7797 17.1453 45.9611 17.1453C40.1426 17.1453 35.4258 21.9257 35.4258 27.8226C35.4258 33.7196 40.1426 38.5 45.9611 38.5Z'
          stroke='currentColor'
          strokeWidth='3'
          strokeMiterlimit='10'
        />
        <path
          d='M15.0039 24.4619H10.5039C9.67579 24.4619 9.00391 25.1338 9.00391 25.9619C9.00391 26.79 9.67578 27.4619 10.5039 27.4619H15.0039C15.832 27.4619 16.5039 26.79 16.5039 25.9619C16.5039 25.1338 15.832 24.4619 15.0039 24.4619Z'
          fill='currentColor'
        />
        <path
          d='M29.6289 24.4619H20.6289C19.8008 24.4619 19.1289 25.1338 19.1289 25.9619C19.1289 26.79 19.8008 27.4619 20.6289 27.4619H29.6289C30.457 27.4619 31.1289 26.79 31.1289 25.9619C31.1289 25.1338 30.457 24.4619 29.6289 24.4619Z'
          fill='currentColor'
        />
        <path
          d='M30.5797 34.5H3.50391C2.40391 34.5 1.50391 33.6 1.50391 32.5V3.5C1.50391 2.4 2.40391 1.5 3.50391 1.5H44.5039C45.6039 1.5 46.5039 2.4 46.5039 3.5V11.5965'
          stroke='currentColor'
          strokeWidth='3'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M2.08203 10.0483H45.8372'
          stroke='currentColor'
          strokeWidth='3'
          strokeMiterlimit='10'
          strokeLinecap='round'
        />
        <path
          d='M50.5801 26.3794C50.5801 26.8535 50.5049 27.3047 50.3545 27.7329C50.2041 28.1611 49.9873 28.519 49.7051 28.8062C49.5312 28.9839 49.3418 29.148 49.1338 29.2983C48.9267 29.4487 48.6973 29.5762 48.4473 29.6812C48.1963 29.7861 47.9238 29.8682 47.6299 29.9272C47.3359 29.9863 47.0068 30.0161 46.6426 30.0161H45.3027V33.3452H42.7461V23.1665H46.6973C47.2852 23.1665 47.792 23.2202 48.2178 23.3271C48.6445 23.4341 49.0303 23.604 49.377 23.8364C49.7598 24.0918 50.0557 24.4321 50.2656 24.8584C50.4746 25.2847 50.5801 25.7915 50.5801 26.3794ZM47.9551 26.4409C47.9551 26.1538 47.8867 25.9067 47.75 25.6992C47.6133 25.4917 47.4492 25.3496 47.2578 25.272C47.0156 25.167 46.7851 25.1069 46.5635 25.0908C46.3428 25.0747 46.0429 25.0669 45.665 25.0669H45.3027V28.1157H45.4804C45.7217 28.1157 45.9492 28.1133 46.164 28.1089C46.3779 28.1045 46.5644 28.0884 46.7246 28.061C46.8613 28.0381 47.0058 27.9936 47.1582 27.9277C47.3115 27.8618 47.4287 27.7876 47.5107 27.7056C47.6836 27.5371 47.8008 27.3613 47.8623 27.1792C47.9238 26.9971 47.9551 26.751 47.9551 26.4409Z'
          fill='currentColor'
        />
      </svg>
    </IconWrapper>
  );
}

export function PostBookmarkOff(props: any) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ color: '#D7D7D7', ...style }} {...rest}>
      <svg xmlns='http://www.w3.org/2000/svg' width='1em' height='0.95em' viewBox='0 0 40 38' fill='none'>
        <g clipPath='url(#clip0_7055_10269)'>
          <path
            d='M22.3389 1.44258L26.9552 10.7236C27.0493 10.9127 27.2312 11.0438 27.4415 11.0742L37.764 12.5625C39.9033 12.8709 40.7575 15.4794 39.2095 16.9766L31.7401 24.2008C31.5879 24.3481 31.5184 24.5602 31.5543 24.7681L33.3176 34.9689C33.683 37.083 31.4467 38.6951 29.5333 37.697L20.3006 32.8808C20.1124 32.7827 19.8876 32.7827 19.6994 32.8808L10.4667 37.697C8.55328 38.6951 6.31694 37.083 6.68237 34.9689L8.44566 24.7681C8.4816 24.5602 8.41213 24.3481 8.2599 24.2008L0.790489 16.9766C-0.757511 15.4794 0.0966992 12.8709 2.23598 12.5624L12.5585 11.0742C12.7688 11.0438 12.9507 10.9127 13.0448 10.7236L17.6611 1.44258C18.6179 -0.48086 21.3821 -0.48086 22.3389 1.44258Z'
            fill='currentColor'
          />
        </g>
        <defs>
          <clipPath id='clip0_7055_10269'>
            <rect width='40' height='38' fill='white' />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  );
}
export function IcoProfileBan({ style, ...rest }: IconProps) {
  return (
    <IconWrapper
      style={{
        ...style,
      }}
      {...rest}
    >
      <svg width='1em' height='1em' viewBox='0 0 86 86' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_7055_10111)'>
          <path
            d='M43 86C66.7482 86 86 66.7482 86 43C86 19.2518 66.7482 0 43 0C19.2518 0 0 19.2518 0 43C0 66.7482 19.2518 86 43 86Z'
            fill='var(--colorIco30)'
          />
          <path
            d='M43.0002 22.3793C41.0665 22.3793 39.4941 23.9517 39.4941 25.8846V46.8816C39.4941 48.8146 41.0665 50.3869 43.0002 50.3869C44.9331 50.3869 46.5055 48.8146 46.5055 46.8816V25.8846C46.5055 23.9517 44.9331 22.3793 43.0002 22.3793Z'
            fill='var(--colorIco23)'
          />
          <path
            d='M43.0005 63.6207C45.3653 63.6207 47.2823 61.7037 47.2823 59.3389C47.2823 56.9741 45.3653 55.0571 43.0005 55.0571C40.6358 55.0571 38.7188 56.9741 38.7188 59.3389C38.7188 61.7037 40.6358 63.6207 43.0005 63.6207Z'
            fill='var(--colorIco23)'
          />
        </g>
        <defs>
          <clipPath id='clip0_7055_10111'>
            <rect width='86' height='86' fill='white' />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  );
}

export function PostBookmarkOn(props: any) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ color: '#FABB3A', ...style }} {...rest}>
      <svg xmlns='http://www.w3.org/2000/svg' width='1em' height='0.95em' viewBox='0 0 40 38' fill='none'>
        <g clipPath='url(#clip0_7055_10270)'>
          <path
            d='M22.3389 1.44258L26.9552 10.7236C27.0493 10.9127 27.2312 11.0438 27.4415 11.0742L37.764 12.5625C39.9033 12.8709 40.7575 15.4794 39.2095 16.9766L31.7401 24.2008C31.5879 24.3481 31.5184 24.5602 31.5543 24.7681L33.3176 34.9689C33.683 37.083 31.4467 38.6951 29.5333 37.697L20.3006 32.8808C20.1124 32.7827 19.8876 32.7827 19.6994 32.8808L10.4667 37.697C8.55328 38.6951 6.31694 37.083 6.68237 34.9689L8.44566 24.7681C8.4816 24.5602 8.41213 24.3481 8.2599 24.2008L0.790489 16.9766C-0.757511 15.4794 0.0966992 12.8709 2.23598 12.5624L12.5585 11.0742C12.7688 11.0438 12.9507 10.9127 13.0448 10.7236L17.6611 1.44258C18.6179 -0.48086 21.3821 -0.48086 22.3389 1.44258Z'
            fill='currentColor'
          />
        </g>
        <defs>
          <clipPath id='clip0_7055_10270'>
            <rect width='40' height='38' fill='white' />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  );
}

export function IcoPlus(props: any) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ color: '#cccccc', ...style }} {...rest}>
      <svg width='3.6em' height='3.5em' viewBox='0 0 36 35' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g id='ico-my-profile-plus'>
          <g id='Group'>
            <path
              id='Vector'
              d='M32.7525 19.0751H3.24905C2.44914 19.0751 1.80078 18.3697 1.80078 17.5C1.80078 16.6304 2.44914 15.925 3.24905 15.925H32.7525C33.5524 15.925 34.2008 16.6304 34.2008 17.5C34.2008 18.3697 33.5524 19.0751 32.7525 19.0751Z'
              fill='currentColor'
            />
            <path
              id='Vector_2'
              d='M18.0008 33.7001C17.1309 33.7001 16.4258 33.0515 16.4258 32.2518V2.74833C16.4258 1.94863 17.1309 1.30005 18.0008 1.30005C18.8707 1.30005 19.5758 1.94862 19.5758 2.74833V32.2518C19.5758 33.0515 18.8707 33.7001 18.0008 33.7001Z'
              fill='currentColor'
            />
          </g>
        </g>
      </svg>
    </IconWrapper>
  );
}

export function IcoArrowRight(props: any) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ color: 'var(--colorIco25)', ...style }} {...rest}>
      <svg xmlns='http://www.w3.org/2000/svg' width='0.7em' height='1.3em' viewBox='0 0 7 13' fill='none'>
        <g clipPath='url(#clip0_9257_21277)'>
          <path
            d='M6.97799 6.62719C6.97799 6.62719 6.99548 6.54162 6.99548 6.49028C6.99548 6.43893 6.99548 6.4047 6.97799 6.35336C6.97799 6.30201 6.97799 6.25067 6.94302 6.21644C6.92553 6.1651 6.89055 6.13087 6.85558 6.09664C6.83809 6.06241 6.8206 6.01106 6.78562 5.99395L1.25923 0.705487C0.961921 0.414537 0.489729 0.431651 0.209911 0.739717C-0.069906 1.03067 -0.069906 1.50988 0.2274 1.80083L5.15918 6.50739L0.2274 11.1968C-0.069906 11.4878 -0.0873946 11.9499 0.209911 12.258C0.34982 12.412 0.559683 12.4976 0.752058 12.4976C0.944432 12.4976 1.11932 12.4291 1.27672 12.2922L6.76813 7.05506C6.76813 7.05506 6.76813 7.05506 6.78562 7.05506C6.8206 7.02083 6.83809 6.98661 6.85558 6.95238C6.89055 6.91815 6.90804 6.8668 6.94302 6.83257C6.96051 6.78123 6.96051 6.747 6.97799 6.69565V6.62719Z'
            fill='currentColor'
          />
        </g>
        <defs>
          <clipPath id='clip0_9257_21277'>
            <rect width='0.7em' height='1.2em' fill='white' transform='translate(0 0.5)' />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  );
}

export function IcoManyCam(props: any) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ ...style }} {...rest}>
      <svg xmlns='http://www.w3.org/2000/svg' width='25' height='26' viewBox='0 0 25 26' fill='none'>
        <g clipPath='url(#clip0_9257_20907)'>
          <path
            d='M14.2512 4.05674L15.5719 6.46952H18.4302C18.5135 6.46952 18.6014 6.46672 18.6899 6.47556C19.783 6.51778 20.8157 6.81837 21.7034 7.33102L11.9141 1.68604C12.8622 2.24088 13.6654 3.04355 14.2512 4.05674Z'
            fill='#E0A100'
          />
          <path
            d='M4.45685 13.0965L2.90239 10.6057C2.89635 10.5996 2.89635 10.5936 2.89032 10.5876C2.87824 10.5635 2.86615 10.5454 2.85408 10.5212C2.82992 10.479 2.81181 10.4429 2.78765 10.4006L2.76954 10.3644C2.26225 9.39948 2.02673 8.36214 2.02673 7.33691V18.5967C2.03881 17.5111 2.42144 16.5486 3.00724 15.5414L4.45685 13.0965Z'
            fill='#27C300'
          />
          <path
            d='M15.6504 19.5557L14.2916 21.9078C14.2554 21.9681 14.2192 22.0345 14.1829 22.0947C14.1829 22.0947 14.1829 22.1008 14.1769 22.1008C14.1527 22.143 14.1225 22.1852 14.0923 22.2274C14.0802 22.2455 14.0742 22.2576 14.0621 22.2697C14.038 22.3059 14.0198 22.336 13.9957 22.3661C13.9595 22.4204 13.9232 22.4687 13.887 22.523V22.529C13.3314 23.2889 12.643 23.898 11.8639 24.3503L21.6472 18.7114C20.6931 19.2482 19.594 19.5557 18.4284 19.5557L15.6504 19.5557Z'
            fill='#0088DC'
          />
          <path
            d='M24.9879 12.9939V12.8371C24.9879 12.7828 24.9819 12.7286 24.9819 12.6743C24.9819 12.6441 24.9758 12.608 24.9758 12.5778C24.9758 12.5537 24.9758 12.5356 24.9698 12.5114C24.9638 12.4632 24.9638 12.4149 24.9577 12.3667V12.3547C24.9517 12.2762 24.9396 12.1978 24.9275 12.1195C24.9215 12.0953 24.9215 12.0712 24.9154 12.047C24.9034 11.9807 24.8913 11.9083 24.8792 11.842L24.8611 11.7335C24.855 11.6973 24.849 11.6611 24.8369 11.6309C24.6135 10.5876 24.1364 9.63466 23.4841 8.83859C23.46 8.80845 23.4358 8.77826 23.4117 8.75417C23.3875 8.73003 23.3694 8.69989 23.3453 8.67575C23.2969 8.62146 23.2486 8.56719 23.1943 8.51291C23.1459 8.46468 23.0977 8.41041 23.0494 8.36212L23.0312 8.34403C22.989 8.30784 22.9527 8.26566 22.9104 8.22949L22.8742 8.1933C22.8319 8.15106 22.7896 8.11488 22.7474 8.07869C22.7414 8.07264 22.7353 8.07264 22.7353 8.06665C22.687 8.02441 22.6326 7.97619 22.5783 7.93395L22.5662 7.92191C22.5118 7.87967 22.4636 7.83744 22.4092 7.80126H22.4032C22.1797 7.63243 21.9502 7.47559 21.7087 7.3369C20.8149 6.81824 19.7882 6.51065 18.6952 6.46843C18.6348 6.46843 18.5683 6.4624 18.5079 6.4624H11.9736C13.0546 6.47446 14.1537 6.75791 15.1562 7.34289C15.9836 7.81996 17.3981 9.19267 17.8376 10.292C18.2771 11.3914 18.4295 12.0737 18.4295 13.018C18.4295 13.9628 18.0727 15.2389 17.8312 15.744C17.5898 16.2492 16.0962 18.7407 15.5067 19.7235L18.4415 19.5737C19.6131 19.5737 20.7122 19.2661 21.6603 18.7294L21.7207 18.6932C21.7268 18.6871 21.7328 18.6871 21.7389 18.6811L22.0106 18.5182H22.0167C22.0589 18.4941 22.0952 18.464 22.1375 18.4398C22.1556 18.4278 22.1797 18.4097 22.1979 18.3976C22.2159 18.3855 22.234 18.3675 22.2582 18.3554C22.2944 18.3313 22.3307 18.3072 22.3609 18.277C22.3669 18.277 22.3669 18.271 22.373 18.271C23.0131 17.7945 23.5506 17.2095 23.9673 16.5642C23.9794 16.5461 23.9915 16.522 24.0035 16.5039C24.0156 16.4858 24.0277 16.4677 24.0398 16.4436C24.6256 15.4847 24.9758 14.369 24.9999 13.1688V13.0241C24.9919 13.008 24.9879 12.9979 24.9879 12.9939Z'
            fill='#18A7FF'
          />
          <path
            d='M11.9744 6.46312L15.6643 6.46247L14.2753 4.05623C13.6895 3.04304 12.8682 2.24092 11.9261 1.68607L11.8778 1.65591C11.8717 1.64988 11.8657 1.64988 11.8597 1.64385C11.7691 1.5956 11.6785 1.54133 11.5879 1.49911C11.5698 1.49308 11.5577 1.48102 11.5396 1.47498C11.5094 1.46292 11.4852 1.44483 11.455 1.43277L11.3464 1.37848C11.3403 1.37245 11.3343 1.37245 11.3222 1.36642C10.4888 0.986474 9.60709 0.793484 8.73748 0.775391H8.44758C7.57797 0.793484 6.69624 0.986474 5.86889 1.36642L5.83266 1.38452C5.80246 1.39658 5.76623 1.41467 5.73602 1.43277C5.6998 1.45086 5.6696 1.46292 5.63337 1.48102L5.59713 1.49911L5.32537 1.64385C5.30121 1.65591 5.27705 1.67401 5.25289 1.68607C5.18646 1.72226 5.12608 1.76447 5.05965 1.80066C5.02341 1.82479 4.98717 1.84891 4.95698 1.86701C4.90867 1.90319 4.85432 1.93334 4.806 1.96953C4.77581 1.99365 4.74561 2.01174 4.70937 2.03587C4.63086 2.09617 4.55236 2.15046 4.47989 2.21077L4.47385 2.2168L4.36515 2.30726C4.34703 2.32535 4.32892 2.33741 4.3108 2.35551C4.29268 2.3736 4.26852 2.39169 4.25041 2.40979C4.22021 2.43994 4.18398 2.46407 4.15378 2.49422L4.13566 2.51232C4.07527 2.5666 4.02092 2.62087 3.96657 2.67515L3.94845 2.69324C3.8941 2.74753 3.84579 2.8018 3.79144 2.85608L3.7854 2.86211C3.25396 3.42902 2.83726 4.08639 2.54135 4.78598C2.54135 4.79202 2.53531 4.79805 2.53531 4.80408C2.49908 4.88249 2.46888 4.96691 2.43868 5.04532C2.43868 5.05135 2.43264 5.05738 2.43264 5.06341C2.41452 5.11769 2.39641 5.16593 2.37829 5.22021C2.36621 5.25037 2.36017 5.2745 2.34809 5.30465C2.33601 5.33481 2.32996 5.35893 2.32392 5.38909C2.28165 5.51573 2.24541 5.64238 2.21522 5.77507C2.21522 5.78713 2.20918 5.79316 2.20918 5.80522C2.19711 5.85347 2.18502 5.89568 2.17898 5.94394C2.17898 5.94997 2.17294 5.96204 2.17294 5.96807C2.14274 6.10075 2.11859 6.23945 2.10047 6.37214C2.09443 6.39627 2.09443 6.42642 2.0884 6.45055C2.08236 6.4807 2.08236 6.51086 2.07633 6.54101L2.05821 6.68576C2.05821 6.69782 2.05821 6.70385 2.05217 6.71591C2.03406 6.92098 2.02197 7.13205 2.02197 7.33712C2.02197 8.36235 2.26354 9.39968 2.76479 10.3646L2.7829 10.4008C2.80706 10.4431 2.82517 10.4852 2.84933 10.5214C2.86141 10.5456 2.87349 10.5637 2.88557 10.5878C2.89161 10.5938 2.8916 10.5998 2.89764 10.6059L4.28663 13.0062L6.14668 16.2267C5.64925 15.2199 5.31423 14.2347 5.31423 13.0062C5.31423 11.7778 5.65581 10.6168 6.26776 9.60493C6.87972 8.59303 7.95625 7.70105 8.87067 7.2095C9.78501 6.71795 10.8181 6.52248 11.2135 6.48953C11.6088 6.45658 11.7204 6.46312 11.9744 6.46312Z'
            fill='#FEC90D'
          />
          <path
            d='M15.1448 18.6813C14.1234 19.2667 12.7768 19.5751 11.5773 19.5307C10.3778 19.4864 9.22704 19.0946 8.36428 18.5399C7.50152 17.9852 7.03513 17.4719 6.45455 16.6971C5.97061 15.9546 5.00469 14.2395 4.29051 13.0122L2.91563 15.4125C2.33588 16.4197 2.05205 17.5113 2.03394 18.5969V18.9226C2.03998 19.013 2.03998 19.0974 2.04601 19.1819V19.2181C2.04601 19.2543 2.05205 19.2905 2.05808 19.3266C2.06412 19.3628 2.06412 19.393 2.07015 19.4291C2.07015 19.4412 2.07015 19.4533 2.0762 19.4714C2.17886 20.3217 2.44458 21.1239 2.83712 21.8415C2.83712 21.8415 2.83712 21.8476 2.84316 21.8476C2.86732 21.8898 2.88544 21.926 2.90959 21.9682L2.96395 22.0586L2.98206 22.0948C3.38064 22.7522 3.90604 23.3492 4.54014 23.8438C4.57637 23.8739 4.61261 23.8981 4.64884 23.9282C4.66696 23.9403 4.67904 23.9524 4.69715 23.9644C4.72131 23.9825 4.73944 23.9946 4.76359 24.0127C4.79982 24.0368 4.83606 24.067 4.87229 24.0911L4.87832 24.0971C5.11385 24.2599 5.36146 24.4047 5.62114 24.5313L5.65737 24.5494L5.80231 24.6218C5.81438 24.6278 5.82042 24.6338 5.83251 24.6338C5.92309 24.6761 6.01368 24.7183 6.1103 24.7545C6.12841 24.7605 6.1405 24.7665 6.15861 24.7726C6.19484 24.7846 6.23109 24.8027 6.27336 24.8148C6.30959 24.8269 6.34583 24.8389 6.37603 24.8509C6.40623 24.863 6.43641 24.8751 6.46661 24.8811C6.53304 24.9052 6.60551 24.9294 6.67194 24.9475H6.67798C6.72629 24.9595 6.76856 24.9777 6.81687 24.9897C6.83499 24.9958 6.8531 25.0017 6.87726 25.0078C6.90746 25.0138 6.93764 25.0259 6.96784 25.0319C7.00407 25.044 7.04031 25.05 7.07654 25.056C7.08861 25.0621 7.1007 25.0621 7.11277 25.0621C7.18524 25.0802 7.25771 25.0922 7.33622 25.1103L7.42678 25.1284C7.46908 25.1345 7.51736 25.1465 7.55966 25.1525C7.62005 25.1646 7.6865 25.1706 7.74688 25.1767C7.77708 25.1827 7.81332 25.1827 7.84352 25.1887C7.89181 25.1948 7.94009 25.2008 7.98845 25.2008C8.01259 25.2008 8.03674 25.2068 8.06094 25.2068C8.2179 25.2189 8.38098 25.2249 8.53801 25.2249H8.61044C8.70102 25.2249 8.79166 25.2249 8.88225 25.2189H8.92449C9.02718 25.2129 9.1298 25.2068 9.23249 25.1948C9.25663 25.1948 9.27479 25.1887 9.29892 25.1887C9.33517 25.1827 9.37135 25.1827 9.4076 25.1767C9.44385 25.1706 9.48009 25.1706 9.51634 25.1646H9.52838C10.2591 25.0621 10.9476 24.8389 11.5757 24.5133C11.5938 24.5012 11.6179 24.4891 11.636 24.4831C11.6602 24.471 11.6904 24.4529 11.7145 24.4409C11.7629 24.4167 11.8112 24.3866 11.8595 24.3625C11.8595 24.3625 11.8655 24.3625 11.8655 24.3565C12.6446 23.9102 13.3391 23.295 13.8886 22.5351V22.5291C13.9249 22.4808 13.9611 22.4266 13.9973 22.3723C14.0215 22.3421 14.0396 22.306 14.0638 22.2758C14.0759 22.2637 14.0819 22.2456 14.094 22.2336C14.1242 22.1914 14.1483 22.1491 14.1785 22.1069C14.1785 22.1069 14.1785 22.1009 14.1845 22.1009C14.2147 22.0527 14.2389 22.0044 14.2691 21.9562L14.2932 21.9139L15.6521 19.5619L17.5181 16.3293C16.9685 17.2762 16.1654 18.0903 15.1448 18.6813Z'
            fill='#17DE3F'
          />
          <path
            d='M18.4291 13.0062C18.4291 16.6247 15.4941 19.5558 11.8706 19.5558C8.24713 19.5558 5.31213 16.6247 5.31213 13.0062C5.31213 9.38765 8.24712 6.45654 11.8706 6.45654C15.488 6.45654 18.4291 9.38758 18.4291 13.0062Z'
            fill='white'
          />
          <path
            d='M11.8702 17.3543C9.46664 17.3543 7.51599 15.4063 7.51599 13.0061C7.51599 10.6058 9.46663 8.65771 11.8702 8.65771C14.2738 8.65771 16.2244 10.6057 16.2244 13.0061C16.2244 15.4064 14.2677 17.3543 11.8702 17.3543Z'
            fill='#01375F'
          />
          <path
            d='M14.1242 12.8495C12.9647 12.8495 12.0286 11.9087 12.0286 10.7567C12.0286 9.60488 12.9707 8.66406 14.1242 8.66406C15.2836 8.66406 16.2198 9.60488 16.2198 10.7567C16.2198 11.9087 15.2836 12.8495 14.1242 12.8495Z'
            fill='white'
          />
        </g>
        <defs>
          <clipPath id='clip0_9257_20907'>
            <rect width='25' height='25' fill='white' transform='translate(0 0.5)' />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  );
}

export function IcoVote(props: any) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ color: 'var(--colorIco10)', fontSize: 20, ...style }} {...rest}>
      <svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' viewBox='0 0 20 20' fill='none'>
        <path
          d='M15.941 7.25H4.06039C2.95757 7.25 2.06055 8.14704 2.06055 9.24986V16.9166C2.06055 18.0194 2.95757 18.9167 4.06039 18.9167H15.941C17.0438 18.9167 17.9411 18.0194 17.9411 16.9166V9.24986C17.9411 8.14704 17.0438 7.25 15.941 7.25ZM13.0987 12.2935L10.1021 15.4624C9.97861 15.5931 9.80748 15.6682 9.62775 15.671H9.61774C9.44149 15.671 9.27247 15.6012 9.14737 15.4768L7.18399 13.5226C6.92311 13.2628 6.9222 12.8408 7.18192 12.5797C7.44164 12.3188 7.86364 12.3181 8.12476 12.5776L9.60333 14.0494L12.1301 11.3774C12.3835 11.1098 12.8053 11.0984 13.0724 11.3511C13.3401 11.6041 13.3517 12.0259 13.0987 12.2935Z'
          fill='currentColor'
        />
        <path
          d='M13.6792 5.55194C13.6794 5.18939 13.5378 4.84882 13.281 4.59271L10.1572 1.47943C9.62842 0.952574 8.76807 0.953064 8.23926 1.47943L5.83203 3.87884C5.57495 4.1347 5.43359 4.47528 5.43359 4.83782C5.43359 5.20012 5.57496 5.5407 5.83179 5.79656L6.04602 6.01009H13.5948C13.6473 5.86461 13.6792 5.71121 13.6792 5.55194Z'
          fill='currentColor'
        />
      </svg>
    </IconWrapper>
  );
}

export function IcoViewer(props: any) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ color: 'var(--colorIco10)', fontSize: 11, ...style }} {...rest}>
      <svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1.18em' viewBox='0 0 11 13' fill='none'>
        <path
          d='M5.50068 12.35C8.31735 12.35 10.3045 12.0017 10.5656 11.2437C10.8957 10.2856 9.99973 7.2056 7.86167 7.30253C7.07514 7.33819 7.346 7.61023 5.50068 7.73808C3.65535 7.61023 3.92622 7.33819 3.13969 7.30253C1.00164 7.20559 0.105677 10.2856 0.435747 11.2437C0.696867 12.0017 2.68401 12.35 5.50068 12.35Z'
          fill='currentColor'
        />
        <path
          d='M5.50008 6.78678C7.19473 6.78678 8.56852 5.41299 8.56852 3.71834C8.56852 2.02369 7.19473 0.649902 5.50008 0.649902C3.80543 0.649902 2.43164 2.02369 2.43164 3.71834C2.43164 5.41299 3.80543 6.78678 5.50008 6.78678Z'
          fill='currentColor'
        />
      </svg>
    </IconWrapper>
  );
}

export function IcoFile(props: any) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ color: 'var(--colorIco33)', fontSize: 18, ...style }} {...rest}>
      <svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' viewBox='0 0 34 34' fill='none'>
        <path
          d='M28.9825 7.25213H18.9173C18.5088 7.25213 18.1097 7.08437 17.8341 6.79921L14.6936 3.49089C13.9386 2.73841 12.9058 2.34536 11.8597 2.35139H5.01785C2.85742 2.35133 1.09961 4.10915 1.09961 6.26952V27.7305C1.09961 29.891 2.85742 31.6488 5.01785 31.6488H29.0005C31.1598 31.6392 32.9104 29.873 32.9008 27.7185V11.1703C32.9008 9.00989 31.143 7.25213 28.9825 7.25213ZM30.5043 27.7234C30.5079 28.5622 29.8286 29.2487 28.9946 29.2523H5.01787C4.17911 29.2523 3.49612 28.5694 3.49612 27.7306V6.26952C3.49612 5.43076 4.17911 4.74778 5.01787 4.74654H11.9305C12.3307 4.74654 12.7189 4.90592 12.9801 5.16474L16.1039 8.45747C16.8372 9.21474 17.8629 9.64852 18.9173 9.64852H28.9825C29.8213 9.64852 30.5043 10.3315 30.5043 11.1703L30.5043 27.7234Z'
          fill='currentColor'
        />
      </svg>
    </IconWrapper>
  );
}

export function IcoMyPlus(props: any) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ color: 'var(--colorIco33)', fontSize: 16, ...style }} {...rest}>
      <svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' viewBox='0 0 34 33' fill='none'>
        <path
          d='M31.7525 18.0751H2.24905C1.44914 18.0751 0.800781 17.3697 0.800781 16.5C0.800781 15.6304 1.44914 14.925 2.24905 14.925H31.7525C32.5524 14.925 33.2008 15.6304 33.2008 16.5C33.2008 17.3697 32.5524 18.0751 31.7525 18.0751Z'
          fill='currentColor'
        />
        <path
          d='M17.0008 32.7001C16.1309 32.7001 15.4258 32.0515 15.4258 31.2518V1.74833C15.4258 0.948629 16.1309 0.300049 17.0008 0.300049C17.8707 0.300049 18.5758 0.948619 18.5758 1.74833V31.2518C18.5758 32.0515 17.8707 32.7001 17.0008 32.7001Z'
          fill='currentColor'
        />
      </svg>
    </IconWrapper>
  );
}

export function IcoMyMinus(props: any) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ color: 'var(--colorIco33)', fontSize: 16, ...style }} {...rest}>
      <svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' viewBox='0 0 36 34' fill='none'>
        <path
          d='M32.7525 18.575H3.24907C2.44916 18.575 1.80078 17.8697 1.80078 17C1.80078 16.1304 2.44916 15.425 3.24907 15.425H32.7525C33.5524 15.425 34.2008 16.1304 34.2008 17C34.2008 17.8697 33.5524 18.575 32.7525 18.575Z'
          fill='currentColor'
        />
      </svg>
    </IconWrapper>
  );
}

export function IcoMyReset(props: any) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ color: 'var(--colorIco33)', fontSize: 18, ...style }} {...rest}>
      <svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' viewBox='0 0 36 34' fill='none'>
        <path
          d='M15.9892 31.7128C16.0188 31.7146 16.0468 31.7218 16.0768 31.7219C16.9121 31.7245 17.5913 31.0494 17.5939 30.214C17.5965 29.3787 16.9214 28.6994 16.0861 28.6969C16.0114 28.6966 15.9399 28.7079 15.8681 28.7181C15.4304 28.6984 14.9916 28.6596 14.553 28.5891C11.4634 28.0936 8.74909 26.4209 6.9097 23.8787C5.07054 21.3366 4.32984 18.2359 4.82761 15.1459C5.85393 8.75882 11.8853 4.39553 18.2726 5.4198C21.3667 5.91593 24.0822 7.58787 25.9194 10.1276C27.436 12.2246 28.1967 14.677 28.1458 17.2228L27.2411 16.4144L27.2367 16.419C26.9936 16.1822 26.6631 16.0345 26.2969 16.0334C25.5485 16.0311 24.94 16.6359 24.9377 17.3842C24.9365 17.7734 25.1018 18.1223 25.3638 18.3703L25.3579 18.3764L27.755 20.6138L27.7536 20.6146L29.7694 22.546L33.9386 18.1367L33.9375 18.1357C34.1819 17.8898 34.3339 17.5519 34.3351 17.1778C34.3374 16.4237 33.7279 15.8104 32.9738 15.8081C32.5147 15.8067 32.1101 16.0338 31.8615 16.3804L31.1593 17.1671C31.2069 14.0011 30.2412 10.9596 28.3618 8.36052C26.0532 5.16924 22.6398 3.06782 18.75 2.44349C10.7216 1.15609 3.14098 6.63986 1.85132 14.6678C1.72959 15.4282 1.66649 16.2018 1.66413 16.9676C1.64246 24.1506 6.97822 30.4262 14.0757 31.5655C14.714 31.668 15.353 31.7254 15.9892 31.7437L15.9892 31.7128Z'
          fill='currentColor'
        />
      </svg>
    </IconWrapper>
  );
}
export function IcoGradientAlert(props: any) {
  const { style } = props;
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' fill='none'>
      <mask
        id='mask0_9964_60957'
        style={{
          ...style,
          maskType: 'alpha',
        }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='14'
        height='14'
      >
        <path d='M14 0H0V14H14V0Z' fill='white' />
      </mask>
      <g mask='url(#mask0_9964_60957)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M7 1.49987C5.81331 1.49987 4.65327 1.85176 3.66658 2.51105C2.67988 3.17034 1.91085 4.10741 1.45672 5.20377C1.0026 6.30013 0.883776 7.50653 1.11529 8.67041C1.3468 9.8343 1.91824 10.9034 2.75736 11.7425C3.59647 12.5816 4.66557 13.1531 5.82946 13.3846C6.99334 13.6161 8.19974 13.4973 9.2961 13.0431C10.3925 12.589 11.3295 11.82 11.9888 10.8333C12.6481 9.8466 13 8.68656 13 7.49987C13 5.90857 12.3679 4.38245 11.2426 3.25723C10.1174 2.13201 8.5913 1.49987 7 1.49987ZM6.5 3.99987V7.49987C6.5 7.57749 6.51807 7.65405 6.55278 7.72348C6.5875 7.7929 6.6379 7.8533 6.7 7.89987L8.7 9.39987C8.80609 9.47943 8.93944 9.5136 9.07071 9.49484C9.20199 9.47609 9.32043 9.40596 9.4 9.29987C9.47956 9.19378 9.51373 9.06043 9.49497 8.92916C9.47622 8.79788 9.40609 8.67943 9.3 8.59987L7.5 7.24987V3.99987C7.5 3.86726 7.44732 3.74008 7.35355 3.64632C7.25978 3.55255 7.13261 3.49987 7 3.49987C6.86739 3.49987 6.74021 3.55255 6.64645 3.64632C6.55268 3.74008 6.5 3.86726 6.5 3.99987ZM10.18 0.88387L13.18 3.38387C13.2823 3.465 13.4122 3.50293 13.542 3.48956C13.6719 3.47618 13.7913 3.41256 13.8749 3.31228C13.9585 3.212 13.9995 3.08303 13.9892 2.9529C13.979 2.82277 13.9182 2.70182 13.82 2.61587L10.82 0.11587C10.7698 0.0719711 10.7114 0.0385513 10.6481 0.0175763C10.5848 -0.00339876 10.518 -0.0115053 10.4515 -0.00626646C10.385 -0.00102762 10.3203 0.0174508 10.2611 0.0480817C10.2018 0.0787126 10.1494 0.120877 10.1067 0.172095C10.064 0.223313 10.032 0.28255 10.0125 0.346321C9.99308 0.410091 9.98658 0.477108 9.99341 0.543428C10.0002 0.609748 10.0203 0.674031 10.0523 0.732497C10.0844 0.790963 10.1278 0.84243 10.18 0.88387ZM3.18 0.11587L0.179999 2.61587C0.0817571 2.70182 0.0210202 2.82277 0.0107634 2.9529C0.000506653 3.08303 0.0415434 3.212 0.125107 3.31228C0.20867 3.41256 0.328134 3.47618 0.457977 3.48956C0.58782 3.50293 0.717746 3.465 0.819999 3.38387L3.82 0.88387C3.87223 0.84243 3.91564 0.790963 3.94768 0.732497C3.97973 0.674031 3.99975 0.609748 4.00658 0.543428C4.01342 0.477108 4.00692 0.410091 3.98747 0.346321C3.96802 0.28255 3.93601 0.223313 3.89333 0.172095C3.85065 0.120877 3.79815 0.0787126 3.73893 0.0480817C3.67972 0.0174508 3.61497 -0.00102762 3.54851 -0.00626646C3.48204 -0.0115053 3.4152 -0.00339876 3.35191 0.0175763C3.28863 0.0385513 3.23018 0.0719711 3.18 0.11587Z'
          fill='url(#paint0_linear_9964_60957)'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_9964_60957'
          x1='7'
          y1='-0.0078125'
          x2='7'
          y2='13.4999'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FF8543' />
          <stop offset='1' stopColor='#FF375A' />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function IcoDelete(props: any) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ color: 'var(--colorIco01)', fontSize: 24, ...style }} {...rest}>
      <svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' viewBox='0 0 24 24' fill='none'>
        <g clipPath='url(#clip0_3019_9638)'>
          <path
            d='M5.14062 5.10986L5.95062 19.4099C6.03062 20.7899 7.14062 21.8699 8.48062 21.8699H12.0006'
            stroke='currentColor'
            strokeWidth='1.5'
            strokeMiterlimit='10'
          />
          <path
            d='M18.86 5.10986L18.05 19.4099C17.97 20.7899 16.86 21.8699 15.52 21.8699H12'
            stroke='currentColor'
            strokeWidth='1.5'
            strokeMiterlimit='10'
          />
          <path d='M2.14062 5.31006H21.8606' stroke='currentColor' strokeWidth='1.5' strokeMiterlimit='10' />
          <path d='M9.83984 9.37988V17.8599' stroke='currentColor' strokeWidth='1.5' strokeMiterlimit='10' />
          <path d='M14.0996 9.37988V17.8599' stroke='currentColor' strokeWidth='1.5' strokeMiterlimit='10' />
          <path
            d='M8.85938 5.23014V3.69014C8.85938 2.83014 9.57937 2.14014 10.4794 2.14014H12.0594'
            stroke='currentColor'
            strokeWidth='1.5'
            strokeMiterlimit='10'
          />
          <path
            d='M15.2293 5.23014V3.69014C15.2293 2.83014 14.5093 2.14014 13.6093 2.14014H12.0293'
            stroke='currentColor'
            strokeWidth='1.5'
            strokeMiterlimit='10'
          />
        </g>
      </svg>
    </IconWrapper>
  );
}

export function IdentityMobile(props: any) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ color: 'var(--colorIco01)', fontSize: 18, ...style }} {...rest}>
      <svg width='1em' height='1.08em' viewBox='0 0 37 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M30.5 16.6102V3.5C30.5 2.4 29.6 1.5 28.5 1.5H3.5C2.4 1.5 1.5 2.4 1.5 3.5V36.5C1.5 37.6 2.4 38.5 3.5 38.5H14.3219'
          stroke='currentColor'
          strokeWidth='3'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M20.2109 6.14941H11.8906C11.0625 6.14941 10.3906 6.82129 10.3906 7.64941C10.3906 8.47753 11.0625 9.14941 11.8906 9.14941H20.2109C21.0391 9.14941 21.7109 8.47753 21.7109 7.64941C21.7109 6.82129 21.0391 6.14941 20.2109 6.14941Z'
          fill='currentColor'
        />
        <path
          d='M17.1601 30.291C17.0508 30.2207 16.9404 30.1504 16.8203 30.1006C16.6904 30.0508 16.5703 30.0205 16.4404 29.9912C16.1806 29.9404 15.9209 29.9404 15.6601 29.9912C15.5303 30.0205 15.4004 30.0508 15.2803 30.1006C15.1602 30.1504 15.0508 30.2207 14.9404 30.291C14.831 30.3613 14.7305 30.4404 14.6406 30.541C14.2607 30.9111 14.0508 31.4209 14.0508 31.9512C14.0508 32.0811 14.0606 32.211 14.0908 32.3408C14.1104 32.4707 14.1504 32.6006 14.2002 32.7207C14.251 32.8408 14.3106 32.9512 14.3809 33.0605C14.4609 33.1709 14.541 33.2705 14.6406 33.3613C14.8203 33.5508 15.041 33.7012 15.2803 33.8008C15.5303 33.9004 15.7803 33.9512 16.0508 33.9512C16.5811 33.9512 17.0908 33.7412 17.461 33.3613C17.5606 33.2705 17.6406 33.1709 17.711 33.0605C17.791 32.9512 17.8506 32.8408 17.9004 32.7207C17.9502 32.6006 17.9902 32.4707 18.0108 32.3408C18.041 32.211 18.0508 32.0811 18.0508 31.9512C18.0508 31.4209 17.8408 30.9111 17.461 30.541C17.3701 30.4404 17.2705 30.3613 17.1601 30.291Z'
          fill='currentColor'
        />
        <path
          d='M27.7167 31.0929C30.3594 31.0929 32.5017 28.9454 32.5017 26.2964C32.5017 23.6474 30.3594 21.5 27.7167 21.5C25.074 21.5 22.9316 23.6474 22.9316 26.2964C22.9316 28.9454 25.074 31.0929 27.7167 31.0929Z'
          stroke='currentColor'
          strokeWidth='3'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M19.9336 38.5C19.9336 34.3868 23.4181 31.0524 27.7166 31.0524C32.015 31.0524 35.4995 34.3868 35.4995 38.5'
          stroke='currentColor'
          strokeWidth='3'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </IconWrapper>
  );
}

export function IdentityIpin(props: any) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ color: 'var(--colorIco01)', fontSize: 22, ...style }} {...rest}>
      <svg width='1em' height='0.83em' viewBox='0 0 48 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_3019_9313)'>
          <path
            d='M44.5 2H3.5C1.57031 2 0 3.57031 0 5.5V34.4971C0 36.4268 1.57031 37.9971 3.5 37.9971H27C27.8286 37.9971 28.5 37.3252 28.5 36.4971C28.5 35.6689 27.8286 34.9971 27 34.9971H3.5C3.22412 34.9971 3 34.7725 3 34.4971V29.459L27.179 29.5308C28.0076 29.5308 28.679 28.8589 28.679 28.0308C28.679 27.2027 28.0076 26.5308 27.179 26.5308L3 26.459V5.5C3 5.22461 3.22412 5 3.5 5H44.5C44.7759 5 45 5.22461 45 5.5V16.9707C45 17.7988 45.6714 18.4707 46.5 18.4707C47.3286 18.4707 48 17.7988 48 16.9707V5.5C48 3.57031 46.4297 2 44.5 2Z'
            fill='currentColor'
          />
          <path
            d='M35.0078 26.7695V24.7267C35.0078 22.4389 37.0463 20.5845 39.5608 20.5845C42.0757 20.5845 44.1139 22.4389 44.1139 24.7267V26.7695'
            stroke='currentColor'
            strokeWidth='3'
            strokeMiterlimit='10'
            strokeLinecap='round'
          />
          <path
            d='M44.4733 27.6248H34.6484C33.5439 27.6248 32.6484 28.5202 32.6484 29.6248V34.5844C32.6484 35.689 33.5439 36.5844 34.6484 36.5844H44.4733C45.5779 36.5844 46.4733 35.689 46.4733 34.5844V29.6248C46.4733 28.5202 45.5779 27.6248 44.4733 27.6248Z'
            stroke='currentColor'
            strokeWidth='3'
            strokeMiterlimit='10'
            strokeLinecap='round'
          />
        </g>
      </svg>
    </IconWrapper>
  );
}

export function IdentityEasy(props: any) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ color: 'var(--colorIco01)', fontSize: 18, ...style }} {...rest}>
      <svg width='1em' height='1.09em' viewBox='0 0 37 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M35.2102 25.2085L29.2153 22.5311C29.1222 22.4896 29.0166 22.4896 28.9235 22.5311L22.9288 25.2085C22.8082 25.2624 22.7255 25.3782 22.7131 25.5117C22.5692 27.0672 21.9922 36.52 28.9691 38.4862C29.0342 38.5046 29.105 38.5046 29.1699 38.4862C36.1468 36.5198 35.5698 27.0672 35.4259 25.5117C35.4135 25.378 35.3308 25.2622 35.2102 25.2085Z'
          stroke='currentColor'
          strokeWidth='3'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M11.8398 6.06836H20.1602C20.9883 6.06836 21.6602 6.74024 21.6602 7.56836C21.6602 8.39648 20.9883 9.06836 20.1602 9.06836H11.8398C11.0117 9.06836 10.3398 8.39648 10.3398 7.56836C10.3398 6.74024 11.0117 6.06836 11.8398 6.06836Z'
          fill='currentColor'
        />
        <path
          d='M30.5 17.3793V3.5C30.5 2.4 29.6 1.5 28.5 1.5H3.5C2.4 1.5 1.5 2.4 1.5 3.5V36.5C1.5 37.6 2.4 38.5 3.5 38.5H20.1649'
          stroke='currentColor'
          strokeWidth='3'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M20.1602 6.14941H11.8398C11.0117 6.14941 10.3398 6.82129 10.3398 7.64941C10.3398 8.47753 11.0117 9.14941 11.8398 9.14941H20.1602C20.9883 9.14941 21.6602 8.47753 21.6602 7.64941C21.6602 6.82129 20.9883 6.14941 20.1602 6.14941Z'
          fill='currentColor'
        />
        <path
          d='M17.1094 30.291C17 30.2207 16.8896 30.1504 16.7695 30.1006C16.6396 30.0508 16.5195 30.0205 16.3896 29.9912C16.1299 29.9404 15.8701 29.9404 15.6094 29.9912C15.4795 30.0205 15.3496 30.0508 15.2295 30.1006C15.1094 30.1504 15 30.2207 14.8896 30.291C14.7803 30.3613 14.6797 30.4404 14.5898 30.541C14.21 30.9111 14 31.4209 14 31.9512C14 32.0811 14.0098 32.211 14.04 32.3408C14.0596 32.4707 14.0996 32.6006 14.1494 32.7207C14.2002 32.8408 14.2598 32.9512 14.3301 33.0605C14.4102 33.1709 14.4902 33.2705 14.5899 33.3613C14.7695 33.5508 14.9902 33.7012 15.2295 33.8008C15.4795 33.9004 15.7295 33.9512 16 33.9512C16.5303 33.9512 17.04 33.7412 17.4102 33.3613C17.5098 33.2705 17.5899 33.1709 17.6602 33.0605C17.7402 32.9512 17.7998 32.8408 17.8496 32.7207C17.8994 32.6006 17.9395 32.4707 17.96 32.3408C17.9902 32.211 18 32.0811 18 31.9512C18 31.4209 17.79 30.9111 17.4102 30.541C17.3193 30.4404 17.2197 30.3613 17.1094 30.291Z'
          fill='currentColor'
        />
      </svg>
    </IconWrapper>
  );
}

export function IcoMainAlarm(props: any) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ color: 'var(--baseFg)', fontSize: 13, ...style }} {...rest}>
      <svg xmlns='http://www.w3.org/2000/svg' width='1em' height='0.77em' viewBox='0 0 26 20' fill='none'>
        <g clipPath='url(#clip0_3019_9432)'>
          <path
            d='M15.95 20C15.73 20 15.5 19.97 15.27 19.9L2.15 15.99C0.94 15.63 0 14.36 0 13.1V6.89001C0 5.63001 0.95 4.36001 2.15 4.00001L15.28 0.100007C15.96 -0.0999927 16.65 7.27177e-06 17.18 0.390007C17.7 0.780007 18 1.41001 18 2.13001V17.87C18 18.58 17.7 19.21 17.17 19.61C16.82 19.87 16.4 20.01 15.95 20.01V20ZM15.97 1.99001C15.97 1.99001 15.93 1.99001 15.84 2.01001L2.72 5.93001C2.36 6.04001 2 6.52001 2 6.90001V13.11C2 13.49 2.36 13.97 2.72 14.08L15.84 17.99C15.92 18.01 15.97 18.01 15.98 18C15.98 18 15.99 17.96 15.99 17.87V2.13001C15.99 2.05001 15.97 2.00001 15.96 1.99001H15.97Z'
            fill='currentColor'
          />
          <path
            d='M25 9H21C20.4477 9 20 9.44772 20 10C20 10.5523 20.4477 11 21 11H25C25.5523 11 26 10.5523 26 10C26 9.44772 25.5523 9 25 9Z'
            fill='currentColor'
          />
          <path
            d='M23.9089 2.92118L20.5646 5.11558C20.1028 5.41857 19.9741 6.03851 20.2771 6.50027C20.5801 6.96202 21.2 7.09073 21.6618 6.78775L25.0061 4.59334C25.4679 4.29036 25.5966 3.67041 25.2936 3.20866C24.9906 2.7469 24.3707 2.61819 23.9089 2.92118Z'
            fill='currentColor'
          />
          <path
            d='M25.0179 15.4089L21.6735 13.2145C21.2117 12.9116 20.5918 13.0403 20.2888 13.502C19.9858 13.9638 20.1146 14.5837 20.5763 14.8867L23.9207 17.0811C24.3825 17.384 25.0024 17.2553 25.3054 16.7936C25.6084 16.3318 25.4796 15.7118 25.0179 15.4089Z'
            fill='currentColor'
          />
        </g>
      </svg>
    </IconWrapper>
  );
}

export function GenderMale(props: any) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ fontSize: 10, ...style }} {...rest}>
      <svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1.6em' viewBox='0 0 20 32' fill='none'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M10.0004 14.2222C6.07308 14.2222 2.88933 17.406 2.88933 21.3333C2.88933 25.2607 6.07308 28.4444 10.0004 28.4444C13.9278 28.4444 17.1115 25.2607 17.1115 21.3333C17.1115 17.406 13.9278 14.2222 10.0004 14.2222ZM0.222656 21.3333C0.222656 15.9332 4.60032 11.5555 10.0004 11.5555C15.4005 11.5555 19.7782 15.9332 19.7782 21.3333C19.7782 26.7334 15.4005 31.1111 10.0004 31.1111C4.60032 31.1111 0.222656 26.7334 0.222656 21.3333Z'
          fill='#2649CC'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M10.9428 1.27932C11.4635 1.80002 11.4635 2.64424 10.9428 3.16494L4.27615 9.83161C3.75545 10.3523 2.91122 10.3523 2.39052 9.83161C1.86983 9.31091 1.86983 8.46669 2.39052 7.94599L9.05719 1.27932C9.57789 0.758619 10.4221 0.758619 10.9428 1.27932Z'
          fill='#2649CC'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M9.49106 0.990327C9.98929 0.783952 10.5628 0.898027 10.9441 1.27936L17.6108 7.94603C18.1315 8.46673 18.1315 9.31095 17.6108 9.83165C17.0901 10.3523 16.2459 10.3523 15.7252 9.83165L11.3346 5.44112V11.9999C11.3346 12.7363 10.7377 13.3333 10.0013 13.3333C9.26492 13.3333 8.66797 12.7363 8.66797 11.9999V2.22217C8.66797 1.68288 8.99283 1.1967 9.49106 0.990327Z'
          fill='#2649CC'
        />
      </svg>
    </IconWrapper>
  );
}

export function GenderFemale(props: any) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ fontSize: 10, ...style }} {...rest}>
      <svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1.6em' viewBox='0 0 20 32' fill='none'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M10.0004 3.55559C6.07308 3.55559 2.88933 6.73934 2.88933 10.6667C2.88933 14.594 6.07308 17.7778 10.0004 17.7778C13.9278 17.7778 17.1115 14.594 17.1115 10.6667C17.1115 6.73934 13.9278 3.55559 10.0004 3.55559ZM0.222656 10.6667C0.222656 5.26657 4.60032 0.888916 10.0004 0.888916C15.4005 0.888916 19.7782 5.26657 19.7782 10.6667C19.7782 16.0668 15.4005 20.4445 10.0004 20.4445C4.60031 20.4445 0.222656 16.0668 0.222656 10.6667Z'
          fill='#F32845'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M10.0013 18.6667C10.7377 18.6667 11.3346 19.2637 11.3346 20.0001V29.7779C11.3346 30.5142 10.7377 31.1112 10.0013 31.1112C9.26492 31.1112 8.66797 30.5142 8.66797 29.7779V20.0001C8.66797 19.2637 9.26492 18.6667 10.0013 18.6667Z'
          fill='#F32845'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M2 23.5556C2 22.8192 2.59695 22.2223 3.33334 22.2223H16.6667C17.4031 22.2223 18 22.8192 18 23.5556C18 24.292 17.4031 24.889 16.6667 24.889H3.33334C2.59695 24.889 2 24.292 2 23.5556Z'
          fill='#F32845'
        />
      </svg>
    </IconWrapper>
  );
}

export function GenderUnknown(props: any) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ fontSize: 10, ...style }} {...rest}>
      <svg width='1em' height='1em' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_7055_10408)'>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M16.4247 5.06274C13.3632 5.06274 10.8749 6.93282 10.0822 9.35437C9.82453 10.1417 8.97736 10.571 8.19004 10.3133C7.40271 10.0556 6.97337 9.20846 7.23108 8.42114C8.45572 4.67969 12.1599 2.06274 16.4247 2.06274C18.626 2.06274 20.9136 2.66142 22.5863 4.15728C24.4387 5.81396 25.2854 8.28582 24.7026 11.0465C24.4237 12.3677 23.5865 13.3684 22.7512 14.1407C22.1209 14.7234 21.3593 15.289 20.6647 15.8048C20.4556 15.9601 20.2526 16.1109 20.061 16.2563C18.2164 17.6564 17.173 18.7587 17.2094 20.2828L17.2099 20.3007V21.3512C17.2099 22.1796 16.5383 22.8512 15.7099 22.8512C14.8814 22.8512 14.2099 22.1796 14.2099 21.3512V20.3353C14.1431 17.1425 16.4886 15.2015 18.2473 13.8667C18.5016 13.6736 18.745 13.4927 18.9778 13.3197C19.6381 12.8288 20.2137 12.401 20.7146 11.9379C21.3768 11.3256 21.6783 10.8482 21.7673 10.4268C22.1377 8.67244 21.605 7.30445 20.5864 6.39347C19.629 5.53729 18.1448 5.06274 16.4247 5.06274Z'
            fill='#999999'
          />
          <path
            d='M15.6809 28.9755C16.209 28.9755 16.6371 28.5474 16.6371 28.0192C16.6371 27.4911 16.209 27.063 15.6809 27.063C15.1527 27.063 14.7246 27.4911 14.7246 28.0192C14.7246 28.5474 15.1527 28.9755 15.6809 28.9755Z'
            fill='#999999'
          />
          <path
            d='M15.6807 30.0627C14.5537 30.0627 13.6367 29.1463 13.6367 28.0193C13.6367 26.8923 14.5537 25.9758 15.6807 25.9758C16.8076 25.9758 17.7236 26.8923 17.7236 28.0193C17.7236 29.1463 16.8076 30.0627 15.6807 30.0627ZM15.6807 27.0627C15.1533 27.0627 14.7236 27.492 14.7236 28.0193C14.7236 28.5466 15.1533 28.9758 15.6807 28.9758C16.208 28.9758 16.6367 28.5466 16.6367 28.0193C16.6367 27.492 16.208 27.0627 15.6807 27.0627Z'
            fill='#999999'
          />
        </g>
      </svg>
    </IconWrapper>
  );
}

export function GenderMaleGray(props: any) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ fontSize: 10, ...style }} {...rest}>
      <svg xmlns='http://www.w3.org/2000/svg' width='9' height='12' viewBox='0 0 9 12' fill='none'>
        <g clipPath='url(#clip0_7055_10201)'>
          <path
            d='M4.43412 11.419C6.2617 11.419 7.74324 9.92431 7.74324 8.08048C7.74324 6.23666 6.2617 4.74194 4.43412 4.74194C2.60654 4.74194 1.125 6.23666 1.125 8.08048C1.125 9.92431 2.60654 11.419 4.43412 11.419Z'
            stroke='#A5A5A5'
            strokeWidth='1.04962'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M1.82031 3.16047L4.43277 0.52478'
            stroke='#A5A5A5'
            strokeWidth='1.04962'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M4.43359 4.39046V0.52478L7.04605 3.16047'
            stroke='#A5A5A5'
            strokeWidth='1.04962'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
      </svg>
    </IconWrapper>
  );
}

export function GenderFemaleGray(props: any) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ fontSize: 10, ...style }} {...rest}>
      <svg xmlns='http://www.w3.org/2000/svg' width='8' height='12' viewBox='0 0 8 12' fill='none'>
        <g clipPath='url(#clip0_7055_10200)'>
          <path
            d='M3.79948 7.197C5.60987 7.197 7.07748 5.7028 7.07748 3.85961C7.07748 2.01642 5.60987 0.522217 3.79948 0.522217C1.9891 0.522217 0.521484 2.01642 0.521484 3.85961C0.521484 5.7028 1.9891 7.197 3.79948 7.197Z'
            stroke='#A5A5A5'
            strokeWidth='1.04449'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M3.80078 7.54834V11.4127'
            stroke='#A5A5A5'
            strokeWidth='1.04449'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M1.21289 8.95361H6.38867'
            stroke='#A5A5A5'
            strokeWidth='1.04449'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
      </svg>
    </IconWrapper>
  );
}

export function DeviceWebPc(props: any) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ fontSize: 15, ...style }} {...rest}>
      <svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' viewBox='0 0 32 30' fill='none'>
        <path
          d='M29.9007 0.104858H2.0994C0.94 0.104858 0 1.04481 0 2.20426V22.9222C0 24.0816 0.94 25.0215 2.0994 25.0215H29.9007C31.0601 25.0215 32 24.0816 32 22.9222V2.20426C32 1.04481 31.0601 0.104858 29.9007 0.104858ZM29.1113 3.23815V18.7135C29.1113 18.9554 28.9194 19.1533 28.6848 19.1533H3.31565C3.08093 19.1533 2.88911 18.9554 2.88911 18.7135V3.21132C2.88911 2.96942 3.08093 2.77153 3.31565 2.77153H28.6848C28.9194 2.77153 29.1113 2.96943 29.1113 3.21132L29.1113 3.23815Z'
          fill='#777777'
        />
        <path
          d='M10.6582 27.895H21.3423'
          stroke='#777777'
          strokeWidth='2.8'
          strokeMiterlimit='10'
          strokeLinecap='round'
        />
        <path
          d='M9.58244 6.63704C9.72514 6.63704 9.86139 6.68147 9.98935 6.76936C10.1173 6.85725 10.2112 7.0052 10.272 7.21321L11.9346 13.5013L13.5641 7.05696C13.6019 6.88118 13.681 6.76106 13.8016 6.6971C13.9222 6.63314 14.0576 6.62142 14.2085 6.66097C14.3669 6.6932 14.4801 6.76937 14.5483 6.889C14.6164 7.00912 14.6274 7.15316 14.5823 7.32113L12.6251 14.7132C12.5643 14.9212 12.4704 15.0692 12.3424 15.1571C12.2136 15.2455 12.0745 15.2894 11.9236 15.2894C11.7799 15.2894 11.6446 15.243 11.5167 15.1512C11.3878 15.0594 11.2939 14.9095 11.234 14.701L9.57047 8.24496L7.86272 14.7132C7.80196 14.9212 7.70621 15.0692 7.57364 15.1571C7.44199 15.2455 7.3039 15.2894 7.1612 15.2894C7.01022 15.2894 6.87028 15.243 6.74232 15.1512C6.61436 15.0594 6.52045 14.9095 6.45969 14.701L4.52546 7.38119C4.48035 7.1893 4.49508 7.03109 4.57057 6.90707C4.64606 6.78305 4.76298 6.7015 4.92133 6.66098C5.07231 6.62143 5.21317 6.62534 5.34574 6.67319C5.47739 6.72104 5.56577 6.84555 5.61088 7.04526L7.21736 13.513L8.88092 7.21323C8.9334 7.00522 9.02546 6.85727 9.15803 6.76938C9.28968 6.68149 9.43145 6.63704 9.58244 6.63704Z'
          fill='#777777'
        />
        <path
          d='M20.5857 6.84704C20.6501 6.94714 20.6823 7.0653 20.6823 7.20104C20.6823 7.33727 20.6501 7.45543 20.5857 7.55504C20.5222 7.65514 20.4218 7.70543 20.2865 7.70543H16.6666V10.3573H20.06C20.188 10.3573 20.2846 10.4051 20.3482 10.5013C20.4126 10.597 20.4448 10.7132 20.4448 10.849C20.4448 10.9852 20.4126 11.1034 20.3482 11.203C20.2846 11.3036 20.188 11.3534 20.06 11.3534H16.6666V14.2211H20.3657C20.501 14.2211 20.6013 14.2714 20.6649 14.3715C20.7293 14.4716 20.7615 14.5892 20.7615 14.7255C20.7615 14.8612 20.7293 14.9794 20.6649 15.079C20.6013 15.1796 20.501 15.2294 20.3657 15.2294H16.4061C16.0737 15.2294 15.8463 15.1654 15.722 15.037C15.5968 14.9095 15.5352 14.6771 15.5352 14.3412V7.58532C15.5352 7.24938 15.5968 7.01745 15.722 6.88903C15.8463 6.7611 16.0737 6.69714 16.4061 6.69714H20.2865C20.4218 6.69714 20.5222 6.74743 20.5857 6.84704Z'
          fill='#777777'
        />
        <path
          d='M24.5807 6.69714C25.4479 6.69714 26.0896 6.8695 26.5038 7.21325C26.919 7.55749 27.1262 8.09313 27.1262 8.82116V8.98913C27.1262 9.38122 27.0304 9.73913 26.838 10.0634C26.6456 10.3871 26.3078 10.6132 25.8254 10.7411C26.3381 10.8212 26.7451 11.0175 27.047 11.329C27.349 11.641 27.5 12.1053 27.5 12.7211V12.9374C27.5 13.6654 27.2937 14.2294 26.8831 14.6293C26.4716 15.0292 25.8254 15.2294 24.9425 15.2294H22.4881C22.1558 15.2294 21.9284 15.1654 21.8041 15.037C21.6789 14.9095 21.6172 14.6771 21.6172 14.3412V7.58532C21.6172 7.24938 21.6789 7.01745 21.8041 6.88903C21.9284 6.7611 22.1558 6.69714 22.4881 6.69714H24.5807ZM24.2529 10.285C24.8863 10.285 25.3328 10.1913 25.5933 10.0033C25.8539 9.8153 25.9837 9.48522 25.9837 9.01306V8.88122C25.9837 8.44909 25.8456 8.14538 25.5703 7.96911C25.2951 7.79333 24.8338 7.70544 24.1848 7.70544H22.7486V10.285H24.2529ZM24.4564 14.2211C24.7731 14.2211 25.0502 14.2015 25.2877 14.161C25.5252 14.1215 25.7232 14.0472 25.8815 13.9393C26.0399 13.8314 26.1568 13.6893 26.2323 13.5131C26.3078 13.3373 26.3455 13.1093 26.3455 12.829V12.6493C26.3455 12.4174 26.3114 12.2152 26.2442 12.0433C26.1761 11.8715 26.061 11.7274 25.899 11.6112C25.737 11.4955 25.5234 11.4091 25.2601 11.3534C24.9959 11.2972 24.6672 11.2694 24.275 11.2694H22.7486V14.2211H24.4564Z'
          fill='#777777'
        />
      </svg>
    </IconWrapper>
  );
}

export function DeviceWebMobile(props: any) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ fontSize: 15, ...style }} {...rest}>
      <svg width='1em' height='1em' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M24.1874 3.58261V7.85877C24.1874 8.71642 24.8827 9.41173 25.7403 9.41173C26.598 9.41173 27.2933 8.71642 27.2933 7.85877V2.11765C27.2933 0.94813 26.4689 0 25.4519 0H6.54653C5.52953 0 4.70508 0.94813 4.70508 2.11765V7.85877C4.70508 8.71642 5.40039 9.41173 6.25804 9.41173C7.11569 9.41173 7.811 8.71642 7.811 7.85877V3.55503C7.811 3.30744 8.01355 3.10495 8.26114 3.10495H23.7372C23.9848 3.10495 24.1874 3.30744 24.1874 3.55503L24.1874 3.58261Z'
          fill='#777777'
        />
        <path
          d='M23.7565 25.4029C23.7501 25.4044 23.7439 25.4127 23.7372 25.4127H8.26114C8.25528 25.4127 8.24988 25.4052 8.24414 25.4041C8.00333 25.3814 7.81284 25.1853 7.81284 24.9387V24.1401L7.811 24.1155V24.1282C7.811 23.2704 7.11569 22.5752 6.25804 22.5752C5.40039 22.5752 4.70508 23.2705 4.70508 24.1282V29.8824C4.70508 31.052 5.52953 32 6.54653 32H25.4519C26.4689 32 27.2933 31.052 27.2933 29.8824V24.1282C27.2933 23.2704 26.598 22.5752 25.7403 22.5752C24.8827 22.5752 24.1874 23.2705 24.1874 24.1282V24.1155C24.1874 24.1329 24.1842 24.1621 24.1822 24.1868V24.9387C24.1822 25.1834 23.9946 25.3776 23.7565 25.4029Z'
          fill='#777777'
        />
        <path
          d='M9.3035 11.5261C9.4524 11.5261 9.59458 11.5725 9.72811 11.6642C9.86164 11.7559 9.95963 11.9103 10.023 12.1273L11.758 18.6889L13.4584 11.9643C13.4978 11.7808 13.5804 11.6555 13.7062 11.5888C13.8321 11.522 13.9733 11.5098 14.1308 11.5511C14.2961 11.5847 14.4142 11.6642 14.4853 11.789C14.5564 11.9143 14.5679 12.0647 14.5209 12.2399L12.4785 19.9536C12.4151 20.1706 12.3171 20.325 12.1836 20.4167C12.0491 20.5089 11.904 20.5548 11.7465 20.5548C11.5966 20.5548 11.4554 20.5064 11.3219 20.4106C11.1874 20.3148 11.0894 20.1584 11.0269 19.9408L9.29101 13.2039L7.50897 19.9536C7.44557 20.1706 7.34566 20.325 7.20732 20.4167C7.06994 20.5089 6.92584 20.5548 6.77694 20.5548C6.61939 20.5548 6.47337 20.5064 6.33984 20.4106C6.20631 20.3148 6.10832 20.1584 6.04492 19.9408L4.02656 12.3026C3.97949 12.1024 3.99486 11.9373 4.07363 11.8079C4.1524 11.6785 4.27441 11.5934 4.43964 11.5511C4.59719 11.5098 4.74417 11.5139 4.88251 11.5638C5.01989 11.6137 5.11211 11.7437 5.15918 11.9521L6.83554 18.7012L8.57146 12.1273C8.62622 11.9103 8.72228 11.7559 8.86062 11.6642C8.998 11.5725 9.14595 11.5261 9.3035 11.5261Z'
          fill='#777777'
        />
        <path
          d='M20.7859 11.7452C20.8531 11.8496 20.8867 11.973 20.8867 12.1146C20.8867 12.2568 20.8531 12.3801 20.7859 12.484C20.7196 12.5884 20.6149 12.6409 20.4736 12.6409H16.6963V15.4081H20.2373C20.3708 15.4081 20.4717 15.4581 20.538 15.5584C20.6053 15.6583 20.6389 15.7796 20.6389 15.9212C20.6389 16.0634 20.6053 16.1867 20.538 16.2906C20.4717 16.3956 20.3708 16.4476 20.2373 16.4476H16.6963V19.44H20.5563C20.6975 19.44 20.8022 19.4924 20.8685 19.5969C20.9357 19.7013 20.9693 19.8241 20.9693 19.9663C20.9693 20.1079 20.9357 20.2312 20.8685 20.3352C20.8022 20.4401 20.6975 20.4921 20.5563 20.4921H16.4244C16.0776 20.4921 15.8403 20.4254 15.7106 20.2914C15.58 20.1584 15.5156 19.9158 15.5156 19.5653V12.5156C15.5156 12.165 15.58 11.923 15.7106 11.789C15.8403 11.6555 16.0776 11.5887 16.4244 11.5887H20.4736C20.6149 11.5887 20.7196 11.6413 20.7859 11.7452Z'
          fill='#777777'
        />
        <path
          d='M24.9537 11.5888C25.8587 11.5888 26.5283 11.7686 26.9606 12.1273C27.3938 12.4865 27.61 13.0455 27.61 13.8052V13.9804C27.61 14.3896 27.5101 14.7631 27.3093 15.1014C27.1085 15.4392 26.7559 15.6751 26.2526 15.8086C26.7876 15.8922 27.2123 16.097 27.5274 16.4221C27.8425 16.7476 28 17.2322 28 17.8747V18.1004C28 18.8601 27.7848 19.4486 27.3564 19.8659C26.9269 20.2832 26.2525 20.4921 25.3313 20.4921H22.7701C22.4233 20.4921 22.186 20.4254 22.0563 20.2914C21.9257 20.1584 21.8613 19.9158 21.8613 19.5653V12.5156C21.8613 12.165 21.9257 11.923 22.0563 11.789C22.186 11.6555 22.4233 11.5887 22.7701 11.5887L24.9537 11.5888ZM24.6117 15.3327C25.2727 15.3327 25.7386 15.2349 26.0105 15.0387C26.2823 14.8426 26.4178 14.4981 26.4178 14.0054V13.8678C26.4178 13.4169 26.2737 13.1 25.9864 12.9161C25.6992 12.7326 25.2179 12.6409 24.5406 12.6409H23.042V15.3327L24.6117 15.3327ZM24.824 19.44C25.1545 19.44 25.4437 19.4196 25.6915 19.3773C25.9394 19.336 26.1459 19.2586 26.3112 19.146C26.4764 19.0334 26.5984 18.8851 26.6772 18.7012C26.7559 18.5177 26.7953 18.2798 26.7953 17.9873V17.7998C26.7953 17.5578 26.7598 17.3469 26.6897 17.1675C26.6186 16.9882 26.4985 16.8378 26.3294 16.7166C26.1603 16.5958 25.9375 16.5056 25.6627 16.4475C25.387 16.389 25.044 16.3599 24.6348 16.3599H23.042V19.44H24.824Z'
          fill='#777777'
        />
      </svg>
    </IconWrapper>
  );
}

export function DeviceAppPc(props: any) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ fontSize: 15, ...style }} {...rest}>
      <svg width='1em' height='1em' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_7055_10403)'>
          <path
            d='M29.9007 2.10498H2.0994C0.94 2.10498 0 3.04493 0 4.20438V24.9223C0 26.0818 0.94 27.0217 2.0994 27.0217H29.9007C31.0601 27.0217 32 26.0818 32 24.9223V4.20438C32 3.04493 31.0601 2.10498 29.9007 2.10498ZM29.1113 5.23827V20.7152C29.1113 20.9571 28.9194 21.155 28.6848 21.155H3.31565C3.08093 21.155 2.88911 20.9571 2.88911 20.7152V5.21144C2.88911 4.96954 3.08093 4.77165 3.31565 4.77165H28.6848C28.9194 4.77165 29.1113 4.96955 29.1113 5.21144L29.1113 5.23827Z'
            fill='#777777'
          />
          <path
            d='M10.6582 29.895H21.3423'
            stroke='#777777'
            strokeWidth='2.8'
            strokeMiterlimit='10'
            strokeLinecap='round'
          />
          <path
            d='M8.20412 8.24122C8.37888 8.24122 8.5334 8.28278 8.66873 8.36589C8.80406 8.449 8.91595 8.60352 9.00332 8.83049L12.1063 16.8309C12.1756 17.0233 12.1735 17.1911 12.0999 17.335C12.0253 17.4793 11.9049 17.5774 11.7398 17.6296C11.565 17.6823 11.3945 17.6887 11.2293 17.6493C11.0631 17.6099 10.9406 17.4815 10.8628 17.263L9.99859 14.9193H6.37132L5.4805 17.3025C5.41017 17.5033 5.29934 17.6232 5.14696 17.6626C4.99352 17.7015 4.83048 17.6909 4.65572 17.6296C4.48949 17.5689 4.37228 17.4751 4.30195 17.3483C4.23268 17.222 4.23268 17.0622 4.30195 16.8704L7.41879 8.83048C7.50617 8.60351 7.61487 8.449 7.74594 8.36588C7.87701 8.28276 8.02937 8.24122 8.20412 8.24122ZM8.19133 9.85186C8.10396 10.1401 8.01658 10.4129 7.92921 10.6702C7.84183 10.9281 7.7374 11.2227 7.61486 11.5541L6.76345 13.8196H9.60537L8.76676 11.5541C8.64528 11.2227 8.53765 10.9212 8.44601 10.6505C8.35437 10.3804 8.26912 10.114 8.19133 9.85186Z'
            fill='#777777'
          />
          <path
            d='M16.7653 8.30676C17.3067 8.30676 17.7766 8.37016 18.173 8.49697C18.5704 8.62324 18.8997 8.80439 19.1619 9.03989C19.424 9.27592 19.6179 9.55936 19.7447 9.8913C19.8715 10.2232 19.9344 10.5898 19.9344 10.991V11.1876C19.9344 11.5893 19.8694 11.9601 19.7383 12.3006C19.6073 12.6411 19.4091 12.9357 19.1427 13.1845C18.8763 13.4333 18.5449 13.6273 18.1474 13.7669C17.75 13.907 17.2854 13.9768 16.7526 13.9768H14.7365V17.132C14.7365 17.3243 14.6683 17.4639 14.5329 17.5513C14.3976 17.6387 14.2431 17.6824 14.0683 17.6824C13.8936 17.6824 13.7412 17.6387 13.6101 17.5513C13.4791 17.4639 13.4141 17.3243 13.4141 17.132V9.27592C13.4141 8.90936 13.4855 8.65628 13.6304 8.51615C13.7742 8.37656 14.0374 8.30676 14.4221 8.30676H16.7653ZM16.5959 12.8638C17.2768 12.8638 17.7851 12.7284 18.1208 12.4578C18.4575 12.1871 18.6248 11.7593 18.6248 11.1743V11.0171C18.6248 10.4502 18.4639 10.0415 18.141 9.79326C17.8181 9.54444 17.3461 9.41977 16.727 9.41977H14.7365V12.8638H16.5959Z'
            fill='#777777'
          />
          <path
            d='M24.5817 8.30676C25.1231 8.30676 25.593 8.37016 25.9894 8.49697C26.3868 8.62324 26.7161 8.80439 26.9783 9.03989C27.2404 9.27592 27.4343 9.55936 27.5611 9.8913C27.6879 10.2232 27.7508 10.5898 27.7508 10.991V11.1876C27.7508 11.5893 27.6858 11.9601 27.5547 12.3006C27.4237 12.6411 27.2255 12.9357 26.9591 13.1845C26.6927 13.4333 26.3613 13.6273 25.9638 13.7669C25.5664 13.907 25.1018 13.9768 24.569 13.9768H22.5529V17.132C22.5529 17.3243 22.4847 17.4639 22.3493 17.5513C22.214 17.6387 22.0595 17.6824 21.8847 17.6824C21.71 17.6824 21.5576 17.6387 21.4265 17.5513C21.2955 17.4639 21.2305 17.3243 21.2305 17.132V9.27592C21.2305 8.90936 21.3019 8.65628 21.4468 8.51615C21.5906 8.37656 21.8538 8.30676 22.2385 8.30676H24.5817ZM24.4123 12.8638C25.0932 12.8638 25.6015 12.7284 25.9372 12.4578C26.2739 12.1871 26.4412 11.7593 26.4412 11.1743V11.0171C26.4412 10.4502 26.2803 10.0415 25.9574 9.79326C25.6345 9.54444 25.1625 9.41977 24.5434 9.41977H22.5529V12.8638H24.4123Z'
            fill='#777777'
          />
        </g>
      </svg>
    </IconWrapper>
  );
}

export function DeviceAppMobile(props: any) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ fontSize: 15, ...style }} {...rest}>
      <svg width='1em' height='1em' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M24.1874 3.58261V7.85877C24.1874 8.71642 24.8827 9.41173 25.7403 9.41173C26.598 9.41173 27.2933 8.71642 27.2933 7.85877V2.11765C27.2933 0.94813 26.4689 0 25.4519 0H6.54653C5.52953 0 4.70508 0.94813 4.70508 2.11765V7.85877C4.70508 8.71642 5.40039 9.41173 6.25804 9.41173C7.11569 9.41173 7.811 8.71642 7.811 7.85877V3.55503C7.811 3.30744 8.01355 3.10495 8.26114 3.10495H23.7372C23.9848 3.10495 24.1874 3.30744 24.1874 3.55503L24.1874 3.58261Z'
          fill='#777777'
        />
        <path
          d='M23.7565 25.4029C23.7501 25.4044 23.7439 25.4127 23.7372 25.4127H8.26114C8.25528 25.4127 8.24988 25.4052 8.24414 25.4041C8.00333 25.3814 7.81284 25.1853 7.81284 24.9387V24.1401L7.811 24.1155V24.1282C7.811 23.2704 7.11569 22.5752 6.25804 22.5752C5.40039 22.5752 4.70508 23.2705 4.70508 24.1282V29.8824C4.70508 31.052 5.52953 32 6.54653 32H25.4519C26.4689 32 27.2933 31.052 27.2933 29.8824V24.1282C27.2933 23.2704 26.598 22.5752 25.7403 22.5752C24.8827 22.5752 24.1874 23.2705 24.1874 24.1282V24.1155C24.1874 24.1329 24.1842 24.1621 24.1822 24.1868V24.9387C24.1822 25.1834 23.9946 25.3776 23.7565 25.4029Z'
          fill='#777777'
        />
        <path
          d='M8.20412 11.3496C8.37888 11.3496 8.5334 11.3912 8.66873 11.4743C8.80406 11.5574 8.91595 11.7119 9.00332 11.9389L12.1063 19.9393C12.1756 20.1317 12.1735 20.2995 12.0999 20.4433C12.0253 20.5877 11.9049 20.6858 11.7398 20.738C11.565 20.7907 11.3945 20.7971 11.2293 20.7577C11.0631 20.7183 10.9406 20.5899 10.8628 20.3714L9.99859 18.0277H6.37132L5.4805 20.4108C5.41017 20.6117 5.29934 20.7316 5.14696 20.771C4.99352 20.8099 4.83048 20.7993 4.65572 20.738C4.48949 20.6772 4.37228 20.5835 4.30195 20.4567C4.23268 20.3304 4.23268 20.1706 4.30195 19.9787L7.41879 11.9389C7.50617 11.7119 7.61487 11.5574 7.74594 11.4743C7.87701 11.3912 8.02937 11.3496 8.20412 11.3496ZM8.19133 12.9603C8.10396 13.2485 8.01658 13.5213 7.92921 13.7786C7.84183 14.0365 7.7374 14.3311 7.61486 14.6625L6.76345 16.928H9.60537L8.76676 14.6625C8.64528 14.3311 8.53765 14.0296 8.44601 13.7589C8.35437 13.4888 8.26912 13.2224 8.19133 12.9603Z'
          fill='#777777'
        />
        <path
          d='M16.7653 11.4152C17.3067 11.4152 17.7766 11.4786 18.173 11.6054C18.5704 11.7316 18.8997 11.9128 19.1619 12.1483C19.424 12.3843 19.6179 12.6678 19.7447 12.9997C19.8715 13.3316 19.9344 13.6982 19.9344 14.0994V14.296C19.9344 14.6977 19.8694 15.0685 19.7383 15.409C19.6073 15.7495 19.4091 16.0441 19.1427 16.2929C18.8763 16.5417 18.5449 16.7357 18.1474 16.8753C17.75 17.0154 17.2854 17.0852 16.7526 17.0852H14.7365V20.2404C14.7365 20.4327 14.6683 20.5723 14.5329 20.6597C14.3976 20.7471 14.2431 20.7908 14.0683 20.7908C13.8936 20.7908 13.7412 20.7471 13.6101 20.6597C13.4791 20.5723 13.4141 20.4327 13.4141 20.2404V12.3843C13.4141 12.0178 13.4855 11.7647 13.6304 11.6246C13.7742 11.485 14.0374 11.4152 14.4221 11.4152H16.7653ZM16.5959 15.9722C17.2768 15.9722 17.7851 15.8368 18.1208 15.5662C18.4575 15.2955 18.6248 14.8677 18.6248 14.2827V14.1255C18.6248 13.5586 18.4639 13.1499 18.141 12.9017C17.8181 12.6528 17.3461 12.5282 16.727 12.5282H14.7365V15.9722H16.5959Z'
          fill='#777777'
        />
        <path
          d='M24.5817 11.4152C25.1231 11.4152 25.593 11.4786 25.9894 11.6054C26.3868 11.7316 26.7161 11.9128 26.9783 12.1483C27.2404 12.3843 27.4343 12.6678 27.5611 12.9997C27.6879 13.3316 27.7508 13.6982 27.7508 14.0994V14.296C27.7508 14.6977 27.6858 15.0685 27.5547 15.409C27.4237 15.7495 27.2255 16.0441 26.9591 16.2929C26.6927 16.5417 26.3613 16.7357 25.9638 16.8753C25.5664 17.0154 25.1018 17.0852 24.569 17.0852H22.5529V20.2404C22.5529 20.4327 22.4847 20.5723 22.3493 20.6597C22.214 20.7471 22.0595 20.7908 21.8847 20.7908C21.71 20.7908 21.5576 20.7471 21.4265 20.6597C21.2955 20.5723 21.2305 20.4327 21.2305 20.2404V12.3843C21.2305 12.0178 21.3019 11.7647 21.4468 11.6246C21.5906 11.485 21.8538 11.4152 22.2385 11.4152H24.5817ZM24.4123 15.9722C25.0932 15.9722 25.6015 15.8368 25.9372 15.5662C26.2739 15.2955 26.4412 14.8677 26.4412 14.2827V14.1255C26.4412 13.5586 26.2803 13.1499 25.9574 12.9017C25.6345 12.6528 25.1625 12.5282 24.5434 12.5282H22.5529V15.9722H24.4123Z'
          fill='#777777'
        />
      </svg>
    </IconWrapper>
  );
}

export function IcoNew(props: any) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ fontSize: 15, ...style }} {...rest}>
      <svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' viewBox='0 0 16 16' fill='none'>
        <g clipPath='url(#clip0_7055_10382)'>
          <path
            d='M7.99805 16C12.4163 16 15.998 12.4183 15.998 8C15.998 3.58172 12.4163 0 7.99805 0C3.57977 0 -0.00195312 3.58172 -0.00195312 8C-0.00195312 12.4183 3.57977 16 7.99805 16Z'
            fill='#F44336'
          />
          <path
            d='M10.7333 12.3311C10.4718 12.3311 10.2174 12.2151 10.046 12.0047L6.10518 7.16148V11.4455C6.10518 11.9349 5.7087 12.3311 5.21958 12.3311C4.73046 12.3311 4.33398 11.9349 4.33398 11.4455V4.66929C4.33398 4.29429 4.56975 3.96003 4.92299 3.83447C5.27651 3.7117 5.6702 3.81996 5.90653 4.11014L9.84738 8.95333V4.66929C9.84738 4.17989 10.2439 3.78369 10.733 3.78369C11.2221 3.78369 11.6186 4.1799 11.6186 4.66929V11.4455C11.6186 11.8205 11.3828 12.1548 11.0296 12.2803C10.9325 12.3144 10.8323 12.3311 10.7333 12.3311Z'
            fill='white'
          />
        </g>
      </svg>
    </IconWrapper>
  );
}

export function IcoNewRank(props: any) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ fontSize: 12, ...style }} {...rest}>
      <svg xmlns='http://www.w3.org/2000/svg' width='3.77em' height='1em' viewBox='0 0 68 18' fill='none'>
        <path
          d='M15.2818 2.02881L20.6978 11.4268C20.8389 11.6592 20.9965 11.9517 21.1708 12.3066C21.3451 12.6614 21.5153 13.0453 21.6834 13.4583V2.02882H23.4617V15.9711H21.258L15.8442 6.61159C15.701 6.35428 15.5433 6.05132 15.369 5.70271C15.1946 5.35514 15.0245 4.9754 14.8564 4.56246V15.9711H13.0781V2.02881H15.2818Z'
          fill='#FE695D'
        />
        <path
          d='M35.3144 2.02881V3.67329H28.5476V8.00394H34.9077V9.64739H28.5476V14.3277H35.4493V15.9711H26.6323V2.02881H35.3144Z'
          fill='#FE695D'
        />
        <path
          d='M54.9217 2.02881L51.0724 15.9711H49.1592L46.0653 4.58114L42.9133 15.9711H40.9607L37.1509 2.02881H39.1616L42.0231 13.4188L45.1357 2.02881H46.9929L50.1055 13.4188L53.0064 2.02881H54.9217Z'
          fill='#FE695D'
        />
      </svg>
    </IconWrapper>
  );
}

export function IcoBroadcast(props: any) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ fontSize: 20, ...style }} {...rest}>
      <svg xmlns='http://www.w3.org/2000/svg' width='1em' height='0.75em' viewBox='0 0 40 30' fill='none'>
        <path
          d='M37.0566 24.791C36.3564 24.791 35.5986 24.543 34.834 24.0527L27.1621 19.1328L28.1348 17.6172L35.8057 22.5371C36.4844 22.9707 37.1006 23.1016 37.4863 22.8867C37.876 22.6738 38.0986 22.0898 38.0986 21.2832V8.7168C38.0986 7.91016 37.876 7.32618 37.4863 7.11328C37.1006 6.89844 36.4844 7.02734 35.8047 7.46289L28.0977 12.4062L27.125 10.8906L34.833 5.94727C36.1035 5.13282 37.3486 4.98633 38.3506 5.53321C39.3486 6.08009 39.8994 7.21094 39.8994 8.7168V21.2832C39.8994 22.7891 39.3486 23.9199 38.3506 24.4668C37.9531 24.6836 37.5176 24.791 37.0566 24.791Z'
          fill='currentColor'
        />
        <path
          d='M23.8174 29.5H5.37108C2.46483 29.5 0.0996094 27.1348 0.0996094 24.2285V5.77148C0.0996094 2.86523 2.46483 0.5 5.37108 0.5H23.8174C26.7246 0.5 29.0898 2.86523 29.0898 5.77148V24.2285C29.0898 27.1348 26.7246 29.5 23.8174 29.5ZM5.37108 2.30077C3.45702 2.30077 1.90039 3.85741 1.90039 5.77147V24.2285C1.90039 26.1426 3.45702 27.6992 5.37108 27.6992H23.8174C25.7314 27.6992 27.289 26.1426 27.289 24.2285V5.77148C27.289 3.85742 25.7314 2.30078 23.8174 2.30078L5.37108 2.30077Z'
          fill='currentColor'
        />
      </svg>
    </IconWrapper>
  );
}

export function IconAspVote(props: any) {
  const { style, ...rest } = props;

  return (
    <IconWrapper style={{ fontSize: 20, ...style }} {...rest}>
      <svg xmlns='http://www.w3.org/2000/svg' width='21' height='20' viewBox='0 0 21 20' fill='none'>
        <path
          d='M15.0378 10.8005H14.5089L12.9533 12.4004H14.4389L15.8155 14.0003H4.92665L6.31109 12.4004H7.90554L6.34998 10.8005H5.70443L3.37109 13.2003V16.4001C3.37109 16.8244 3.53498 17.2314 3.82671 17.5314C4.11843 17.8314 4.51409 18 4.92665 18H15.8155C16.2281 18 16.6238 17.8314 16.9155 17.5314C17.2072 17.2314 17.3711 16.8244 17.3711 16.4001V13.2003L15.0378 10.8005ZM14.26 6.76071L10.41 10.7205L7.64887 7.88864L11.5066 3.92889L14.26 6.76071ZM10.9622 2.23299L6.00776 7.32867C5.70443 7.64065 5.70443 8.14462 6.00776 8.4566L9.85776 12.4004C10.1611 12.7283 10.6511 12.7283 10.9544 12.4004L15.9011 7.32867C16.2044 7.01669 16.2044 6.51272 15.9011 6.20074L12.0511 2.24099C11.7555 1.92101 11.2655 1.92101 10.9622 2.23299Z'
          fill='currentColor'
        />
      </svg>
    </IconWrapper>
  );
}

export function IconAspMission(props: any) {
  const { style, ...rest } = props;

  return (
    <IconWrapper style={{ fontSize: 20, ...style }} {...rest}>
      <svg xmlns='http://www.w3.org/2000/svg' width='21' height='20' viewBox='0 0 21 20' fill='none'>
        <path
          d='M18.1771 5.64454C18.2567 5.56518 18.3146 5.46684 18.3456 5.35882C18.3765 5.2508 18.3794 5.13667 18.3539 5.02722C18.3285 4.91778 18.2755 4.81664 18.2001 4.73337C18.1247 4.6501 18.0293 4.58745 17.923 4.55135L16.3539 4.01955L15.8224 2.44894C15.7864 2.34247 15.7238 2.24695 15.6406 2.17141C15.5574 2.09587 15.4564 2.04282 15.347 2.01728C15.2376 1.99174 15.1234 1.99455 15.0154 2.02545C14.9074 2.05634 14.8091 2.1143 14.7297 2.19384L13.9168 3.00713C12.2357 2.14515 10.3022 1.91194 8.46451 2.34951C6.62681 2.78708 5.00562 3.86666 3.89285 5.39389C2.78009 6.92111 2.24885 8.79563 2.39481 10.6799C2.54076 12.5642 3.35431 14.3344 4.68897 15.6719C6.02363 17.0094 7.79171 17.8262 9.67486 17.9753C11.558 18.1244 13.4325 17.5959 14.9608 16.4851C16.4891 15.3743 17.5708 13.7541 18.0111 11.9162C18.4514 10.0783 18.2215 8.14354 17.3626 6.46023L18.1771 5.64454ZM14.9119 3.88041L15.2077 4.75288C15.2117 4.76487 15.2181 4.77527 15.2221 4.78646C15.2313 4.80963 15.2417 4.83232 15.2532 4.85444C15.263 4.87233 15.2736 4.88968 15.2852 4.90642C15.298 4.92481 15.31 4.94241 15.3236 4.9592C15.3377 4.97595 15.3526 4.99196 15.3683 5.00718C15.3825 5.02186 15.3974 5.03574 15.4131 5.04877C15.4307 5.06316 15.4499 5.07675 15.4691 5.08955C15.4882 5.10235 15.501 5.11034 15.5178 5.11994C15.5407 5.13189 15.5641 5.14257 15.5882 5.15193C15.5993 5.15593 15.6089 5.16232 15.6201 5.16632L16.4922 5.46221L15.4443 6.51062L14.1054 6.27071L13.8656 4.93041L14.9119 3.88041ZM12.9936 10.0669C12.9948 10.6634 12.7984 11.2436 12.4352 11.7167C12.072 12.1898 11.5624 12.5293 10.9859 12.682C10.4095 12.8347 9.79879 12.7922 9.24912 12.5609C8.69946 12.3297 8.24182 11.9228 7.94771 11.4039C7.65359 10.8849 7.53956 10.2831 7.62343 9.69248C7.70729 9.10184 7.98433 8.55563 8.41127 8.13916C8.83821 7.7227 9.391 7.45944 9.98329 7.3905C10.5756 7.32157 11.174 7.45085 11.6851 7.75815L9.86186 9.58146C9.8005 9.64279 9.75183 9.71561 9.7186 9.79576C9.68538 9.87591 9.66826 9.96183 9.66822 10.0486C9.66818 10.1354 9.68523 10.2213 9.71839 10.3015C9.75154 10.3817 9.80016 10.4545 9.86146 10.5159C9.98526 10.6399 10.1532 10.7096 10.3284 10.7096C10.4151 10.7097 10.501 10.6926 10.5811 10.6594C10.6613 10.6263 10.7341 10.5776 10.7955 10.5163L12.6163 8.69219C12.8646 9.1077 12.9955 9.5828 12.9952 10.0669M14.9727 14.7403C14.1238 15.589 13.0597 16.1903 11.8949 16.4795C10.7302 16.7687 9.50862 16.7349 8.36158 16.3817C7.21454 16.0286 6.18536 15.3694 5.3846 14.4751C4.58385 13.5807 4.04179 12.485 3.81666 11.3056C3.59154 10.1262 3.69185 8.90778 4.10684 7.78116C4.52182 6.65453 5.23579 5.66231 6.17202 4.91112C7.10826 4.15993 8.23138 3.67815 9.42071 3.51754C10.6101 3.35694 11.8206 3.52358 12.9224 3.99956L12.6826 4.23947C12.6071 4.3148 12.551 4.40736 12.5191 4.50919C12.4872 4.61101 12.4805 4.71906 12.4996 4.82405L12.8193 6.61618L12.6307 6.8049C11.8106 6.21832 10.8001 5.96164 9.79963 6.08582C8.79918 6.20999 7.88197 6.70595 7.23002 7.47524C6.57807 8.24454 6.23905 9.23095 6.28023 10.2387C6.3214 11.2465 6.73978 12.2019 7.45232 12.9154C8.16485 13.6289 9.11947 14.0483 10.1267 14.0903C11.1339 14.1324 12.1202 13.794 12.8897 13.1424C13.6591 12.4908 14.1556 11.5736 14.2806 10.5728C14.4056 9.57197 14.1499 8.56073 13.5643 7.73975L13.7529 7.55102L15.5434 7.8709C15.5822 7.87793 15.6215 7.88141 15.6609 7.8813C15.836 7.88118 16.0039 7.81158 16.1277 7.68777L16.3611 7.45426C16.8849 8.66838 17.0322 10.0119 16.7838 11.3108C16.5354 12.6096 15.9027 13.8039 14.9679 14.7387'
          fill='currentColor'
        />
      </svg>
    </IconWrapper>
  );
}
export function IconAspSpon(props: any) {
  const { style, ...rest } = props;

  return (
    <IconWrapper style={{ fontSize: 20, ...style }} {...rest}>
      <svg xmlns='http://www.w3.org/2000/svg' width='21' height='20' viewBox='0 0 21 20' fill='none'>
        <path
          d='M17.0378 6.66602H3.70443C3.24419 6.66602 2.87109 7.03911 2.87109 7.49935V9.16602C2.87109 9.62625 3.24419 9.99935 3.70443 9.99935H17.0378C17.498 9.99935 17.8711 9.62625 17.8711 9.16602V7.49935C17.8711 7.03911 17.498 6.66602 17.0378 6.66602Z'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M10.3711 6.66602V17.4993'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M16.2043 10V15.8333C16.2043 16.2754 16.0287 16.6993 15.7161 17.0118C15.4035 17.3244 14.9796 17.5 14.5376 17.5H6.20426C5.76224 17.5 5.33831 17.3244 5.02575 17.0118C4.71319 16.6993 4.5376 16.2754 4.5376 15.8333V10'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M6.62093 6.66703C6.0684 6.66703 5.53849 6.44754 5.14779 6.05684C4.75709 5.66614 4.5376 5.13623 4.5376 4.5837C4.5376 4.03116 4.75709 3.50126 5.14779 3.11056C5.53849 2.71986 6.0684 2.50036 6.62093 2.50036C7.42484 2.48636 8.21262 2.87641 8.88154 3.61966C9.55047 4.36292 10.0695 5.42487 10.3709 6.66703C10.6724 5.42487 11.1914 4.36292 11.8603 3.61966C12.5292 2.87641 13.317 2.48636 14.1209 2.50036C14.6735 2.50036 15.2034 2.71986 15.5941 3.11056C15.9848 3.50126 16.2043 4.03116 16.2043 4.5837C16.2043 5.13623 15.9848 5.66614 15.5941 6.05684C15.2034 6.44754 14.6735 6.66703 14.1209 6.66703'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </IconWrapper>
  );
}

export function IconAspBookMark(props: any) {
  const { style, ...rest } = props;

  return (
    <IconWrapper style={{ fontSize: 20, ...style }} {...rest}>
      <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M5.37109 5L5.37109 16L10.3711 13L15.3711 16V5C15.3711 4.44772 14.8736 4 14.26 4L6.4822 4C5.86856 4 5.37109 4.44772 5.37109 5Z'
          fill='white'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M5.37109 5L5.37109 16L10.3711 13L15.3711 16V5C15.3711 4.44772 14.8736 4 14.26 4L6.4822 4C5.86856 4 5.37109 4.44772 5.37109 5Z'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinejoin='round'
        />
      </svg>
    </IconWrapper>
  );
}
export function IconAspBookMark_On(props: any) {
  const { style, ...rest } = props;

  return (
    <IconWrapper style={{ fontSize: 20, ...style }} {...rest}>
      <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M5.37109 5L5.37109 16L10.3711 13L15.3711 16V5C15.3711 4.44772 14.8736 4 14.26 4L6.4822 4C5.86856 4 5.37109 4.44772 5.37109 5Z'
          fill='#FFE69B'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M5.37109 5L5.37109 16L10.3711 13L15.3711 16V5C15.3711 4.44772 14.8736 4 14.26 4L6.4822 4C5.86856 4 5.37109 4.44772 5.37109 5Z'
          stroke='#FFB700'
          strokeWidth='1.5'
          strokeLinejoin='round'
        />
      </svg>
    </IconWrapper>
  );
}

export function IconAspRecommand(props: any) {
  const { style, ...rest } = props;

  return (
    <IconWrapper style={{ fontSize: 20, ...style }} {...rest}>
      <svg xmlns='http://www.w3.org/2000/svg' width='21' height='20' viewBox='0 0 21 20' fill='none'>
        <path
          d='M6.66521 8.80237V15.2003C6.66521 15.4124 6.57845 15.6158 6.42401 15.7658C6.26956 15.9158 6.0601 16.0001 5.84168 16.0001H4.19462C3.97621 16.0001 3.76674 15.9158 3.6123 15.7658C3.45786 15.6158 3.37109 15.4124 3.37109 15.2003V9.60211C3.37109 9.39 3.45786 9.18659 3.6123 9.03661C3.76674 8.88662 3.97621 8.80237 4.19462 8.80237H6.66521C7.53887 8.80237 8.51803 8.60255 9.1358 8.00262C9.50676 7.64238 9.95933 7.25156 9.95933 6.40314V5.60339C9.95933 5.17918 10.1329 4.77235 10.4417 4.47238C10.7506 4.17242 11.1696 4.00391 11.6064 4.00391C12.0432 4.00391 12.4622 4.17242 12.771 4.47238C13.0799 4.77235 13.2534 5.17918 13.2534 5.60339V8.80237H15.724C16.1609 8.80237 16.5798 8.97088 16.8887 9.27084C17.1976 9.57081 17.3711 9.97764 17.3711 10.4019L16.5476 14.4006C16.4291 14.8912 16.2045 15.3125 15.9074 15.601C15.6103 15.8894 15.257 16.0295 14.9005 16.0001H9.1358C8.48056 16.0001 7.85216 15.7473 7.38883 15.2973C6.9255 14.8474 6.66521 14.2371 6.66521 13.6008'
          fill='white'
        />
        <path
          d='M6.66521 8.80237V15.2003C6.66521 15.4124 6.57845 15.6158 6.42401 15.7658C6.26956 15.9158 6.0601 16.0001 5.84168 16.0001H4.19462C3.97621 16.0001 3.76674 15.9158 3.6123 15.7658C3.45786 15.6158 3.37109 15.4124 3.37109 15.2003V9.60211C3.37109 9.39 3.45786 9.18659 3.6123 9.03661C3.76674 8.88662 3.97621 8.80237 4.19462 8.80237H6.66521ZM6.66521 8.80237C7.53887 8.80237 8.51803 8.60255 9.1358 8.00262C9.50676 7.64238 9.95933 7.25156 9.95933 6.40314V5.60339C9.95933 5.17918 10.1329 4.77235 10.4417 4.47238C10.7506 4.17242 11.1696 4.00391 11.6064 4.00391C12.0432 4.00391 12.4622 4.17242 12.771 4.47238C13.0799 4.77235 13.2534 5.17918 13.2534 5.60339V8.80237H15.724C16.1609 8.80237 16.5798 8.97088 16.8887 9.27085C17.1976 9.57081 17.3711 9.97764 17.3711 10.4019L16.5476 14.4006C16.4291 14.8912 16.2045 15.3125 15.9074 15.601C15.6103 15.8894 15.257 16.0295 14.9005 16.0001H9.1358C8.48056 16.0001 7.85216 15.7473 7.38883 15.2973C6.9255 14.8474 6.66521 14.2371 6.66521 13.6008'
          stroke='#999999'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </IconWrapper>
  );
}
export function IconAspRecommand_On(props: any) {
  const { style, ...rest } = props;

  return (
    <IconWrapper style={{ fontSize: 20, ...style }} {...rest}>
      <svg xmlns='http://www.w3.org/2000/svg' width='21' height='20' viewBox='0 0 21 20' fill='none'>
        <path
          d='M6.66521 8.80237V15.2003C6.66521 15.4124 6.57845 15.6158 6.42401 15.7658C6.26956 15.9158 6.0601 16.0001 5.84168 16.0001H4.19462C3.97621 16.0001 3.76674 15.9158 3.6123 15.7658C3.45786 15.6158 3.37109 15.4124 3.37109 15.2003V9.60211C3.37109 9.39 3.45786 9.18659 3.6123 9.03661C3.76674 8.88662 3.97621 8.80237 4.19462 8.80237H6.66521C7.53887 8.80237 8.51803 8.60255 9.1358 8.00262C9.50676 7.64238 9.95933 7.25156 9.95933 6.40314V5.60339C9.95933 5.17918 10.1329 4.77235 10.4417 4.47238C10.7506 4.17242 11.1696 4.00391 11.6064 4.00391C12.0432 4.00391 12.4622 4.17242 12.771 4.47238C13.0799 4.77235 13.2534 5.17918 13.2534 5.60339V8.80237H15.724C16.1609 8.80237 16.5798 8.97088 16.8887 9.27084C17.1976 9.57081 17.3711 9.97764 17.3711 10.4019L16.5476 14.4006C16.4291 14.8912 16.2045 15.3125 15.9074 15.601C15.6103 15.8894 15.257 16.0295 14.9005 16.0001H9.1358C8.48056 16.0001 7.85216 15.7473 7.38883 15.2973C6.9255 14.8474 6.66521 14.2371 6.66521 13.6008'
          fill='#CADFFF'
        />
        <path
          d='M6.66521 8.80237V15.2003C6.66521 15.4124 6.57845 15.6158 6.42401 15.7658C6.26956 15.9158 6.0601 16.0001 5.84168 16.0001H4.19462C3.97621 16.0001 3.76674 15.9158 3.6123 15.7658C3.45786 15.6158 3.37109 15.4124 3.37109 15.2003V9.60211C3.37109 9.39 3.45786 9.18659 3.6123 9.03661C3.76674 8.88662 3.97621 8.80237 4.19462 8.80237H6.66521ZM6.66521 8.80237C7.53887 8.80237 8.51803 8.60255 9.1358 8.00262C9.50676 7.64238 9.95933 7.25156 9.95933 6.40314V5.60339C9.95933 5.17918 10.1329 4.77235 10.4417 4.47238C10.7506 4.17242 11.1696 4.00391 11.6064 4.00391C12.0432 4.00391 12.4622 4.17242 12.771 4.47238C13.0799 4.77235 13.2534 5.17918 13.2534 5.60339V8.80237H15.724C16.1609 8.80237 16.5798 8.97088 16.8887 9.27085C17.1976 9.57081 17.3711 9.97764 17.3711 10.4019L16.5476 14.4006C16.4291 14.8912 16.2045 15.3125 15.9074 15.601C15.6103 15.8894 15.257 16.0295 14.9005 16.0001H9.1358C8.48056 16.0001 7.85216 15.7473 7.38883 15.2973C6.9255 14.8474 6.66521 14.2371 6.66521 13.6008'
          stroke='#4F95FF'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </IconWrapper>
  );
}

export function IconArrowLeft(props: any) {
  const { style, ...rest } = props;

  return (
    <IconWrapper style={{ fontSize: 20, ...style }} {...rest}>
      <svg xmlns='http://www.w3.org/2000/svg' width='17' height='16' viewBox='0 0 17 16' fill='none'>
        <path
          d='M10.3711 4L6.37109 8L10.3711 12'
          stroke='#BBBBBB'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </IconWrapper>
  );
}

export function IconArrowHeart(props: any) {
  const { style, ...rest } = props;

  return (
    <IconWrapper style={{ fontSize: 20, ...style }} {...rest}>
      <svg xmlns='http://www.w3.org/2000/svg' width='13' height='12' viewBox='0 0 13 12' fill='none'>
        <g clipPath='url(#clip0_408_21160)'>
          <path d='M12.5376 0H0.537598V12H12.5376V0Z' fill='white' fillOpacity='0.01' />
          <path
            d='M4.2876 2C2.76882 2 1.5376 3.23123 1.5376 4.75C1.5376 7.5 4.7876 10 6.5376 10.5816C8.2876 10 11.5376 7.5 11.5376 4.75C11.5376 3.23123 10.3064 2 8.7876 2C7.85752 2 7.03527 2.46173 6.5376 3.16845C6.03992 2.46173 5.21767 2 4.2876 2Z'
            fill='#FF7679'
          />
        </g>
        <defs>
          <clipPath id='clip0_408_21160'>
            <rect width='12' height='12' fill='white' transform='translate(0.537598)' />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  );
}

export function IconAspReport(props: any) {
  const { style, ...rest } = props;

  return (
    <IconWrapper style={{ fontSize: 20, ...style }} {...rest}>
      <svg xmlns='http://www.w3.org/2000/svg' width='21' height='20' viewBox='0 0 21 20' fill='none'>
        <path
          d='M16.3623 16.0635C16.43 16.5786 16.1005 17 15.63 17H5.11221C4.64172 17 4.31219 16.5786 4.37992 16.0635L4.5281 14.9365C4.59583 14.4214 5.0362 14 5.50667 14H15.2355C15.706 14 16.1464 14.4214 16.2141 14.9365L16.3623 16.0635Z'
          stroke='#999999'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M10.3711 3C7.60966 3 5.37109 5.27301 5.37109 8.07692V14H15.3711V8.07692C15.3711 5.27299 13.1325 3 10.3711 3Z'
          stroke='#999999'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M12.3711 8L12.3711 11'
          stroke='#999999'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </IconWrapper>
  );
}

export function IconAspSmallText(props: any) {
  const { style, ...rest } = props;

  return (
    <IconWrapper style={{ fontSize: 20, ...style }} {...rest}>
      <svg xmlns='http://www.w3.org/2000/svg' width='21' height='20' viewBox='0 0 21 20' fill='none'>
        <path
          d='M7.44263 17H5.37109L9.17139 6H11.5559L15.3711 17H13.2996L12.4054 14.2804H8.33682L7.44263 17ZM8.85843 12.6851H11.8838L10.4084 8.24862H10.3189L8.85843 12.6851Z'
          fill='#999999'
        />
      </svg>
    </IconWrapper>
  );
}

export function IconAspLargeText(props: any) {
  const { style, ...rest } = props;

  return (
    <IconWrapper style={{ fontSize: 20, ...style }} {...rest}>
      <svg xmlns='http://www.w3.org/2000/svg' width='21' height='20' viewBox='0 0 21 20' fill='none'>
        <path
          d='M5.89887 17H3.37109L8.98838 3H11.7322L17.3711 17H14.8433L13.4174 13.3066H7.3248L5.89887 17ZM8.01616 11.5276H12.726L10.4143 5.55249H10.3063L8.01616 11.5276Z'
          fill='#999999'
        />
      </svg>
    </IconWrapper>
  );
}

export function IconAspSendMessage(props: any) {
  const { style, ...rest } = props;

  return (
    <IconWrapper style={{ fontSize: 20, ...style }} {...rest}>
      <svg xmlns='http://www.w3.org/2000/svg' width='21' height='20' viewBox='0 0 21 20' fill='none'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M4.21662 3.06167L17.0481 9.47746C17.3366 9.62174 17.4536 9.97262 17.3093 10.2612C17.2528 10.3742 17.1611 10.4659 17.0481 10.5224L4.21662 16.9382C3.92807 17.0825 3.5772 16.9655 3.43292 16.677C3.36119 16.5335 3.35161 16.3668 3.40642 16.2161L5.12972 11.477C5.19944 11.2853 5.36411 11.1438 5.56413 11.1038L11.0834 9.99994L5.56413 8.89608C5.36411 8.85607 5.19944 8.71462 5.12972 8.52291L3.40642 3.78377C3.29617 3.48058 3.45258 3.14542 3.75576 3.03517C3.90651 2.98035 4.07316 2.98994 4.21662 3.06167Z'
          fill='#BBBBBB'
        />
      </svg>
    </IconWrapper>
  );
}

export function Icon_live_play() {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='15' height='16' viewBox='0 0 15 16' fill='none'>
      <path
        d='M13.6717 6.33252L3.6964 0.294708C3.07698 -0.0798892 2.29649 -0.0990558 1.65742 0.246808C1.01938 0.592754 0.623047 1.25004 0.623047 1.96202V14.0375C0.623047 14.7495 1.01938 15.4069 1.65742 15.7527C1.96196 15.9185 2.29842 16 2.6349 16C3.00381 16 3.37221 15.9013 3.69588 15.7048L13.6717 9.66712C14.2675 9.30778 14.623 8.68393 14.623 7.99981C14.623 7.31557 14.2674 6.69186 13.6717 6.33252Z'
        fill='white'
      />
    </svg>
  );
}

export function Icon_live_stop() {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='15' height='16' viewBox='0 0 15 16' fill='none'>
      <g clipPath='url(#clip0_1761_5415)'>
        <path
          d='M3.2431 0H2.64368C1.52771 0 0.623047 0.904667 0.623047 2.02063V13.9794C0.623047 15.0953 1.52771 16 2.64368 16H3.2431C4.35906 16 5.26373 15.0953 5.26373 13.9794V2.02063C5.26373 0.904667 4.35906 0 3.2431 0Z'
          fill='white'
        />
        <path
          d='M12.6025 0H12.0031C10.8871 0 9.98242 0.904667 9.98242 2.02063V13.9794C9.98242 15.0953 10.8871 16 12.0031 16H12.6025C13.7184 16 14.6231 15.0953 14.6231 13.9794V2.02063C14.6231 0.904667 13.7184 0 12.6025 0Z'
          fill='white'
        />
      </g>
      <defs>
        <clipPath id='clip0_1761_5415'>
          <rect width='14' height='16' fill='white' transform='translate(0.623047)' />
        </clipPath>
      </defs>
    </svg>
  );
}

export function Icon_live_mute() {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='15' viewBox='0 0 20 15' fill='none'>
      <path
        d='M12.0712 1.68405C11.9815 0.520836 11.0971 0 10.2605 0C9.82258 0 9.45509 0.131205 9.35286 0.171528L4.36488 3.80516H2.68254C1.54715 3.80516 0.623047 4.68212 0.623047 5.76014V9.23986C0.623047 10.3179 1.54715 11.1948 2.68254 11.1948H4.36489L9.19497 14.7416L9.34776 14.8265C9.41989 14.8554 9.80214 15 10.2605 15C11.0971 15 11.9815 14.4792 12.0735 13.2623L12.0741 7.50014L12.0712 1.68405Z'
        fill='white'
      />
      <path
        d='M18.7702 9.94513C18.5913 9.94513 18.4129 9.87697 18.2766 9.74066L14.7279 6.19165C14.4553 5.91902 14.4553 5.47713 14.7279 5.2045C15.0017 4.93159 15.4436 4.93272 15.7151 5.2045L19.2638 8.75351C19.5364 9.02614 19.5364 9.46803 19.2638 9.74066C19.1275 9.87698 18.9485 9.94513 18.7702 9.94513Z'
        fill='white'
      />
      <path
        d='M15.2215 9.9451C15.0431 9.9451 14.8642 9.87694 14.7279 9.74063C14.4553 9.468 14.4553 9.02611 14.7279 8.75348L18.2766 5.20447C18.5493 4.93184 18.9911 4.93184 19.2638 5.20447C19.5364 5.4771 19.5364 5.91899 19.2638 6.19162L15.7151 9.74063C15.5787 9.87694 15.3998 9.9451 15.2215 9.9451Z'
        fill='white'
      />
    </svg>
  );
}
export function Icon_live_volum() {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='15' viewBox='0 0 20 15' fill='none'>
      <g clipPath='url(#clip0_1761_5419)'>
        <path
          d='M17.0318 12.9615C16.8552 12.9615 16.6791 12.895 16.5434 12.7616C16.2679 12.4918 16.2639 12.0499 16.5337 11.7747C17.4959 10.7935 18.0707 9.19523 18.0707 7.49982C18.0707 5.80412 17.4959 4.20612 16.5337 3.22522C16.2639 2.95004 16.2679 2.50815 16.5428 2.23836C16.8183 1.96828 17.259 1.97198 17.53 2.24773C18.7608 3.50211 19.4668 5.41647 19.4668 7.49981C19.4668 9.58316 18.7608 11.4975 17.53 12.7522C17.3936 12.8916 17.2125 12.9615 17.0318 12.9615Z'
          fill='white'
        />
        <path
          d='M14.64 11.3439C14.4145 11.3439 14.193 11.2346 14.0584 11.0324C13.8449 10.7115 13.9318 10.2784 14.2527 10.0649C14.7201 9.75388 15.2228 8.81871 15.2228 7.49986C15.2228 6.18102 14.7201 5.24585 14.2532 4.93516C13.9318 4.72189 13.8449 4.28852 14.0584 3.96761C14.272 3.64614 14.7059 3.55952 15.0257 3.77308C15.9935 4.41632 16.6189 5.87943 16.6189 7.49986C16.6189 9.1203 15.9935 10.5831 15.0263 11.2269C14.907 11.3062 14.7729 11.3439 14.64 11.3439Z'
          fill='white'
        />
        <path
          d='M12.0712 1.68405C11.9815 0.520836 11.0971 0 10.2605 0C9.82258 0 9.45509 0.131205 9.35286 0.171528L4.36488 3.80516H2.68254C1.54715 3.80516 0.623047 4.68212 0.623047 5.76014V9.23986C0.623047 10.3179 1.54715 11.1948 2.68254 11.1948H4.36489L9.19497 14.7416L9.34776 14.8265C9.41989 14.8554 9.80214 15 10.2605 15C11.0971 15 11.9815 14.4792 12.0735 13.2623L12.0741 7.50014L12.0712 1.68405Z'
          fill='white'
        />
      </g>
      <defs>
        <clipPath id='clip0_1761_5419'>
          <rect width='18.8438' height='15' fill='white' transform='translate(0.623047)' />
        </clipPath>
      </defs>
    </svg>
  );
}

export function Icon_live_screen_full() {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='17' height='16' viewBox='0 0 17 16' fill='none'>
      <g clipPath='url(#clip0_1761_5502)'>
        <path
          d='M5.16797 16.0005H1.44825C0.992197 16.0005 0.623047 15.6309 0.623047 15.1753V11.4551C0.623047 10.9995 0.992187 10.6299 1.44825 10.6299C1.90431 10.6299 2.27345 10.9995 2.27345 11.4551V14.3501H5.16798C5.62403 14.3501 5.99318 14.7197 5.99318 15.1753C5.99318 15.6309 5.62403 16.0005 5.16797 16.0005Z'
          fill='white'
        />
        <path
          d='M15.7979 5.3711C15.3418 5.3711 14.9727 5.00147 14.9727 4.5459V1.6504H12.0772C11.6211 1.6504 11.252 1.28077 11.252 0.8252C11.252 0.36963 11.6211 0 12.0772 0H15.7979C16.2539 0 16.6231 0.36963 16.6231 0.8252V4.5459C16.6231 5.00147 16.2539 5.3711 15.7979 5.3711Z'
          fill='white'
        />
        <path
          d='M15.7979 16.0005H12.0772C11.6211 16.0005 11.252 15.6309 11.252 15.1753C11.252 14.7197 11.6211 14.3501 12.0772 14.3501H14.9727V11.4551C14.9727 10.9995 15.3418 10.6299 15.7979 10.6299C16.2539 10.6299 16.6231 10.9995 16.6231 11.4551V15.1753C16.6231 15.6309 16.2539 16.0005 15.7979 16.0005Z'
          fill='white'
        />
        <path
          d='M1.44825 5.37109C0.992197 5.37109 0.623047 5.00146 0.623047 4.54589V0.8252C0.623047 0.36963 0.992187 0 1.44825 0H5.16798C5.62403 0 5.99318 0.36963 5.99318 0.8252C5.99318 1.28077 5.62404 1.6504 5.16798 1.6504H2.27344V4.54591C2.27344 5.00148 1.90431 5.37109 1.44825 5.37109Z'
          fill='white'
        />
      </g>
      <defs>
        <clipPath id='clip0_1761_5502'>
          <rect width='16' height='16.0005' fill='white' transform='translate(0.623047)' />
        </clipPath>
      </defs>
    </svg>
  );
}
export function Icon_live_screen_fit() {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='17' height='16' viewBox='0 0 17 16' fill='none'>
      <path
        d='M5.16602 15.9976C4.71094 15.9976 4.34278 15.6289 4.34278 15.1738V12.2773H1.44629C0.991207 12.2773 0.623047 11.9087 0.623047 11.4536C0.623047 10.9985 0.991207 10.6299 1.44629 10.6299H5.16602C5.6211 10.6299 5.98926 10.9985 5.98926 11.4536V15.1738C5.98926 15.6289 5.6211 15.9976 5.16602 15.9976Z'
        fill='white'
      />
      <path
        d='M15.7959 5.36816H12.0752C11.6201 5.36816 11.252 4.99951 11.252 4.54443V0.82373C11.252 0.36865 11.6201 0 12.0752 0C12.5303 0 12.8984 0.36865 12.8984 0.82373V3.7207H15.7959C16.251 3.7207 16.6191 4.08935 16.6191 4.54443C16.6191 4.99951 16.251 5.36816 15.7959 5.36816Z'
        fill='white'
      />
      <path
        d='M12.0752 15.9976C11.6201 15.9976 11.252 15.6289 11.252 15.1738V11.4536C11.252 10.9985 11.6201 10.6299 12.0752 10.6299H15.7959C16.251 10.6299 16.6191 10.9985 16.6191 11.4536C16.6191 11.9087 16.251 12.2773 15.7959 12.2773H12.8984V15.1738C12.8984 15.6289 12.5303 15.9976 12.0752 15.9976Z'
        fill='white'
      />
      <path
        d='M5.16602 5.36816H1.44629C0.991207 5.36816 0.623047 4.99951 0.623047 4.54443C0.623047 4.08935 0.991207 3.7207 1.44629 3.7207H4.34278V0.82373C4.34278 0.36865 4.71094 0 5.16602 0C5.6211 0 5.98926 0.36865 5.98926 0.82373V4.54443C5.98926 4.99951 5.6211 5.36816 5.16602 5.36816Z'
        fill='white'
      />
    </svg>
  );
}

export function Icon_recommand() {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='22' viewBox='0 0 20 22' fill='none'>
      <path
        d='M18.4893 9.49364C18.7037 9.73012 18.8357 10.1866 18.7862 10.5001L17.4993 18.8705C17.4498 19.184 17.2904 19.6514 17.1474 19.8989C17.0044 20.1464 16.1025 20.3499 15.7835 20.3499H6.01069C5.69171 20.3499 5.42773 20.0859 5.42773 19.7669V10.4891C5.42773 10.1701 5.53222 9.66963 5.66421 9.37815L9.01896 1.93166C9.15095 1.64018 9.46443 1.56319 9.71741 1.75567L10.2784 2.19014C10.5314 2.38813 10.7348 2.8061 10.7348 3.12508V8.12974C10.7348 8.44872 10.9933 8.7127 11.3178 8.7127H17.2134C17.5323 8.7127 17.9668 8.90519 18.1813 9.14717L18.4948 9.49915L18.4893 9.49364Z'
        stroke='currentColor'
        strokeWidth='1.65'
        strokeMiterlimit='10'
      />
      <path
        d='M5.4284 9.90601H1.87567C1.5017 9.90601 1.19922 10.2085 1.19922 10.5825V19.6733C1.19922 20.0473 1.5072 20.3498 1.87567 20.3498H6.47425'
        stroke='currentColor'
        strokeWidth='1.65'
        strokeMiterlimit='10'
      />
    </svg>
  );
}

export function IconAspChatClose() {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32' fill='none'>
      <g clipPath='url(#clip0_576_4984)'>
        <path d='M27 16H13' stroke='white' strokeWidth='2.5' strokeLinecap='round' strokeLinejoin='round' />
        <path d='M27 16L21 22' stroke='white' strokeWidth='2.5' strokeLinecap='round' strokeLinejoin='round' />
        <path d='M27 16L21 10' stroke='white' strokeWidth='2.5' strokeLinecap='round' strokeLinejoin='round' />
        <path d='M5 5V27' stroke='white' strokeWidth='2.5' strokeLinecap='round' strokeLinejoin='round' />
      </g>
      <defs>
        <clipPath id='clip0_576_4984'>
          <rect width='32' height='32' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}

export function IconLiveChatModalMore({ style, ...rest }: IconProps) {
  return (
    <IconWrapper style={{ fontSize: 20, ...style }} {...rest}>
      <svg xmlns='http://www.w3.org/2000/svg' width='28' height='10' viewBox='0 0 28 10' fill='none'>
        <g clipPath='url(#clip0_11806_628313)'>
          <path
            opacity='0.502'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M4.9995 0H22.9995C25.761 0 27.9995 2.238 27.9995 4.9995C27.9995 7.761 25.761 9.9995 22.9995 9.9995H4.9995C2.238 9.9995 0 7.761 0 4.9995C0 2.238 2.238 0 4.9995 0Z'
            fill='black'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M7.49951 2.99951H20.4995C20.6321 2.99951 20.7593 3.05219 20.8531 3.14596C20.9468 3.23973 20.9995 3.3669 20.9995 3.49951C20.9995 3.63212 20.9468 3.7593 20.8531 3.85307C20.7593 3.94683 20.6321 3.99951 20.4995 3.99951H7.49951C7.3669 3.99951 7.23973 3.94683 7.14596 3.85307C7.05219 3.7593 6.99951 3.63212 6.99951 3.49951C6.99951 3.3669 7.05219 3.23973 7.14596 3.14596C7.23973 3.05219 7.3669 2.99951 7.49951 2.99951ZM7.49951 5.99951H20.4995C20.6321 5.99951 20.7593 6.05219 20.8531 6.14596C20.9468 6.23973 20.9995 6.3669 20.9995 6.49951C20.9995 6.63212 20.9468 6.7593 20.8531 6.85307C20.7593 6.94683 20.6321 6.99951 20.4995 6.99951H7.49951C7.3669 6.99951 7.23973 6.94683 7.14596 6.85307C7.05219 6.7593 6.99951 6.63212 6.99951 6.49951C6.99951 6.3669 7.05219 6.23973 7.14596 6.14596C7.23973 6.05219 7.3669 5.99951 7.49951 5.99951Z'
            fill='#B3B3B3'
          />
        </g>
        <defs>
          <clipPath id='clip0_11806_628313'>
            <rect width='28' height='10' fill='white' />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  );
}

export function IconNowBubble({ style, ...rest }: IconProps) {
  return (
    <IconWrapper style={{ ...style }} {...rest}>
      <svg width='34' height='18' viewBox='0 0 34 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_14740_778728)'>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M30 0.5C32.1401 0.5 33.8876 2.18095 33.9951 4.29395L34 4.5V13.5C34 15.7091 32.2091 17.5 30 17.5H7.65723C5.44845 17.4997 3.65723 15.7091 3.65723 13.5V12.0547L0.444336 9.91016C0.166558 9.72465 3.08462e-05 9.41216 0 9.07812C-1.07584e-07 8.74406 0.166526 8.43163 0.444336 8.24609L3.65723 6.09961V4.5C3.65758 2.29137 5.44845 0.500251 7.65723 0.5H30ZM7.65723 1.5C6.00069 1.50019 4.65749 2.84349 4.65723 4.5V6.63574L1 9.07812L4.65723 11.5195V13.5C4.65723 15.1567 6.00053 16.4998 7.65723 16.5H30C31.6569 16.5 33 15.1569 33 13.5V4.5C32.9997 2.84337 31.6567 1.5 30 1.5H7.65723Z'
            fill='#1665F5'
          />
          <path
            d='M13.5534 5.54873C13.6929 5.54873 13.8172 5.59011 13.9264 5.67287C14.0355 5.74927 14.0901 5.87342 14.0901 6.04531V11.6224C14.0901 11.9216 14.0325 12.1285 13.9173 12.2431C13.8081 12.3577 13.608 12.415 13.3169 12.415C13.2077 12.415 13.1107 12.4055 13.0258 12.3864C12.9409 12.3673 12.859 12.3259 12.7802 12.2622C12.7013 12.1922 12.6194 12.0935 12.5345 11.9662C12.4496 11.8389 12.3496 11.667 12.2343 11.4505L10.515 8.22267C10.424 8.05077 10.3421 7.87888 10.2694 7.70698C10.1966 7.53508 10.1329 7.3409 10.0783 7.12444V11.9566C10.0783 12.1285 10.0238 12.2559 9.91459 12.3386C9.80542 12.415 9.6811 12.4532 9.54161 12.4532C9.40212 12.4532 9.27779 12.415 9.16863 12.3386C9.05947 12.2559 9.00488 12.1285 9.00488 11.9566V6.37956C9.00488 6.08033 9.05947 5.87342 9.16863 5.75882C9.28386 5.64422 9.48703 5.58692 9.77813 5.58692C9.8873 5.58692 9.98433 5.59647 10.0692 5.61557C10.1541 5.63467 10.236 5.67924 10.3149 5.74927C10.3937 5.81294 10.4756 5.90843 10.5605 6.03577C10.6454 6.1631 10.7454 6.33499 10.8607 6.55145L12.58 9.77928C12.671 9.95118 12.7529 10.1231 12.8256 10.295C12.8984 10.4669 12.9621 10.661 13.0167 10.8775V6.04531C13.0167 5.87342 13.0713 5.74927 13.1804 5.67287C13.2896 5.59011 13.4139 5.54873 13.5534 5.54873Z'
            fill='#1665F5'
          />
          <path
            d='M17.5938 5.50098C18.0365 5.50098 18.4308 5.56464 18.7764 5.69197C19.1221 5.8193 19.4132 6.01667 19.6498 6.28406C19.8863 6.55145 20.0652 6.89525 20.1865 7.31544C20.3138 7.72926 20.3775 8.22585 20.3775 8.80521V9.19675C20.3775 9.7761 20.3138 10.2759 20.1865 10.6961C20.0652 11.1099 19.8863 11.4505 19.6498 11.7179C19.4132 11.9853 19.1221 12.1827 18.7764 12.31C18.4308 12.4373 18.0365 12.501 17.5938 12.501C17.1511 12.501 16.7569 12.4373 16.4112 12.31C16.0655 12.1827 15.7744 11.9853 15.5379 11.7179C15.3014 11.4505 15.1194 11.1099 14.9921 10.6961C14.8708 10.2759 14.8101 9.7761 14.8101 9.19675V8.80521C14.8101 8.22585 14.8708 7.72926 14.9921 7.31544C15.1194 6.89525 15.3014 6.55145 15.5379 6.28406C15.7744 6.01667 16.0655 5.8193 16.4112 5.69197C16.7569 5.56464 17.1511 5.50098 17.5938 5.50098ZM17.5938 6.6183C17.327 6.6183 17.0935 6.6565 16.8934 6.7329C16.6932 6.8093 16.5234 6.93663 16.3839 7.11489C16.2505 7.28679 16.1504 7.51917 16.0837 7.81203C16.017 8.10489 15.9837 8.46778 15.9837 8.9007V9.10125C15.9837 9.53417 16.017 9.89707 16.0837 10.1899C16.1504 10.4828 16.2505 10.7183 16.3839 10.8966C16.5234 11.0685 16.6932 11.1927 16.8934 11.2691C17.0935 11.3455 17.327 11.3837 17.5938 11.3837C17.8607 11.3837 18.0942 11.3455 18.2943 11.2691C18.4944 11.1927 18.6612 11.0685 18.7946 10.8966C18.9341 10.7183 19.0372 10.4828 19.1039 10.1899C19.1706 9.89707 19.204 9.53417 19.204 9.10125V8.9007C19.204 8.46778 19.1706 8.10489 19.1039 7.81203C19.0372 7.51917 18.9341 7.28679 18.7946 7.11489C18.6612 6.93663 18.4944 6.8093 18.2943 6.7329C18.0942 6.6565 17.8607 6.6183 17.5938 6.6183Z'
            fill='#1665F5'
          />
          <path
            d='M24.9094 5.54873C25.0489 5.54873 25.1853 5.59329 25.3188 5.68242C25.4522 5.76519 25.5462 5.91162 25.6008 6.12171L26.7834 10.6101L27.9387 5.96892C27.9812 5.79702 28.063 5.67924 28.1843 5.61557C28.3117 5.55191 28.4512 5.53599 28.6028 5.56782C28.7605 5.59966 28.8727 5.67924 28.9394 5.80657C29.0122 5.92753 29.0243 6.07396 28.9758 6.24586L27.4748 11.8802C27.4202 12.0903 27.3262 12.2399 27.1928 12.3291C27.0593 12.4118 26.9229 12.4532 26.7834 12.4532C26.6439 12.4532 26.5074 12.4118 26.374 12.3291C26.2406 12.2399 26.1466 12.084 26.092 11.8611L24.9003 7.19129L23.654 11.8802C23.5994 12.0903 23.5024 12.2399 23.3629 12.3291C23.2295 12.4118 23.093 12.4532 22.9535 12.4532C22.808 12.4532 22.6685 12.4118 22.5351 12.3291C22.4016 12.2399 22.3076 12.0872 22.2531 11.8707L20.7884 6.30316C20.7399 6.11853 20.7521 5.96255 20.8248 5.83522C20.9037 5.70789 21.025 5.62194 21.1887 5.57737C21.3403 5.53918 21.4828 5.54236 21.6163 5.58692C21.7558 5.63149 21.8498 5.75245 21.8983 5.94982L23.0172 10.6197L24.2089 6.12171C24.2635 5.91162 24.3575 5.76519 24.4909 5.68242C24.6244 5.59329 24.7638 5.54873 24.9094 5.54873Z'
            fill='#1665F5'
          />
        </g>
      </svg>
    </IconWrapper>
  );
}

export function IconHeart({ size = 24 }) {
  return (
    <IconWrapper style={{ width: size, height: size }}>
      <svg xmlns='http://www.w3.org/2000/svg' width={24} height={25} viewBox='0 0 24 25' fill='none'>
        <path
          d='M8.4 5.36621C5.96995 5.36621 4 7.37484 4 9.85258C4 14.3389 9.2 18.4175 12 19.3662C14.8 18.4175 20 14.3389 20 9.85258C20 7.37484 18.03 5.36621 15.6 5.36621C14.1119 5.36621 12.7963 6.11947 12 7.27243C11.2037 6.11947 9.88812 5.36621 8.4 5.36621Z'
          fill='#FF7679'
        />
      </svg>
    </IconWrapper>
  );
}

export function IconArrowDown({ size = 30 }) {
  return (
    <IconWrapper style={{ width: size, height: size }}>
      <svg xmlns='http://www.w3.org/2000/svg' width='31' height='31' viewBox='0 0 31 31' fill='none'>
        <circle cx='15.0535' cy='15.25' r='14.5' fill='white' stroke='black' />
        <line
          y1='-0.5'
          x2='10.3169'
          y2='-0.5'
          transform='matrix(0.704286 0.709916 -0.704286 0.709916 8.11548 13.1914)'
          stroke='black'
        />
        <line
          y1='-0.5'
          x2='10.3169'
          y2='-0.5'
          transform='matrix(0.704286 -0.709916 0.704286 0.709916 15.174 20.5156)'
          stroke='black'
        />
      </svg>
    </IconWrapper>
  );
}

export function IconThreeDots(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ color: 'var(--baseFg)', ...style }} {...rest}>
      <svg width='1em' height='1em' viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg' fill='currentColor'>
        <path d='M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z' />
      </svg>
    </IconWrapper>
  );
}

export function IcoPencil(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ color: 'var(--colorIco01)', ...style }} {...rest}>
      <svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' viewBox='0 0 20 20' fill='none'>
        <path
          d='M17.677 4.40273L12.6769 0.199513C12.3739 -0.104335 11.8183 -0.0536947 11.5153 0.300794L0.858594 12.7585C0.757584 12.8598 0.656577 13.0117 0.656577 13.2143L0 19.0887C0 19.5444 0.303037 19.9496 0.707076 20.0002C0.808087 20.0002 0.959605 20.0002 1.01011 19.9496L6.71725 18.3291C6.86877 18.2784 7.02029 18.1771 7.1213 18.0758L17.7275 5.61812C18.0305 5.21299 17.98 4.70658 17.677 4.40273ZM15.9598 5.16235L13.8385 7.64377L10.0506 4.45337L12.1718 1.92131L15.9598 5.16235ZM1.76768 17.9746L2.27274 13.5688L8.98999 5.66876L12.7779 8.85916L6.06066 16.7592L1.76768 17.9746Z'
          fill='black'
        />
        <path
          d='M19.2424 18.481H10.2019C9.79788 18.481 9.44434 18.8354 9.44434 19.2406C9.44434 19.6457 9.79788 20.0002 10.2019 20.0002H19.2424C19.6465 20.0002 20 19.6457 20 19.2406C19.9495 18.7848 19.6465 18.481 19.2424 18.481Z'
          fill='black'
        />
      </svg>
    </IconWrapper>
  );
}

export function IcoShevron(props: IconProps) {
  const { style, ...rest } = props;
  return (
    <IconWrapper style={{ color: 'var(--colorIco01)', ...style }} {...rest}>
      <svg xmlns='http://www.w3.org/2000/svg' width={32} height={32} viewBox='0 0 32 32' fill='none'>
        <g clipPath='url(#clip0_2079_154162)'>
          <path
            d='M16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0Z'
            fill='white'
            fillOpacity='0.6'
          />
          <mask
            id='mask0_2079_154162'
            style={{ maskType: 'luminance' }}
            maskUnits='userSpaceOnUse'
            x={8}
            y={10}
            width={16}
            height={12}
          >
            <path d='M24 10.5H8V21.5H24V10.5Z' fill='white' />
          </mask>
          <g mask='url(#mask0_2079_154162)'>
            <path
              d='M16 21.5005C15.6021 21.5005 15.2207 21.3423 14.9395 21.061L8.43946 14.561C7.85351 13.9756 7.85351 13.0254 8.43946 12.4399C9.0254 11.854 9.97461 11.854 10.5605 12.4399L16 17.8794L21.4394 12.4395C22.0254 11.8535 22.9746 11.8535 23.5605 12.4395C24.1465 13.0249 24.1465 13.9746 23.5605 14.5605L17.0605 21.061C16.7793 21.3423 16.398 21.5005 16 21.5005Z'
              fill='#555555'
            />
          </g>
        </g>
        <defs>
          <clipPath id='clip0_2079_154162'>
            <rect width={32} height={32} fill='white' />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  );
}
